webpackJsonp([221],[
/* 0 */,
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(13);


/* harmony default export */ __webpack_exports__["a"] = ({
    online: {
        fileUrl: {
            host: 'images.ecsweb.jinyantrip.net',
            proxy: 'images.ecsweb.jinyantrip.net',
            prefix: ''
        }
    },
    isOnline: false,
    isHttps: false,
    isProxy: false,
    getUrl: function getUrl(name, url) {
        var apicfg = this.online[name] || {
            prefix: name
        };
        return '/api'.concat('/', apicfg['prefix'], __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].startWith(url, '/') ? '' : '/', url);
    }
});

/***/ }),
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_cloneUtils_js__ = __webpack_require__(142);








var $http = {};

var tokens = /SfsSes=(\w+)/gi.exec(location.href);

$http.SfsSes = sessionStorage && sessionStorage.getItem("SfsSes");
if (tokens && tokens.length > 1) {
    $http.SfsSes = tokens[1];
    if (sessionStorage) {
        sessionStorage.setItem("SfsSes", $http.SfsSes);
        location.replace(location.href.replace(/&?SfsSes=(\w+)/gi, ''));
    }
}

__WEBPACK_IMPORTED_MODULE_3_axios___default.a.interceptors.request.use(function (config) {
    if (config.loading === undefined || config.loading) {
        config.loading = "loading";
    }
    return config;
}, function (error) {
    if (error.config.loading) {}
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(error);
});

__WEBPACK_IMPORTED_MODULE_3_axios___default.a.interceptors.response.use(function (response) {
    if (response.config.loading) {}
    return response;
}, function (error) {
    if (error.config.loading) {}
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(error);
});
$http.ajax = function (url, data, method, options) {
    if (options === undefined) options = {};
    options.url = url;
    options.data = data;
    options.method = method;
    options.withCredentials = true;
    if ($http.SfsSes != undefined) {
        options.headers = options.headers || {};
        options.headers.SfsSes = $http.SfsSes;
    }
    return __WEBPACK_IMPORTED_MODULE_3_axios___default()(options).catch(function (error) {
        return {
            data: {
                isSucc: false,
                statusCode: 500,
                message: error.message
            }
        };
    }).then(function (response) {
        if (!response.data.isSucc && options.failTips == undefined || options.failTips) {
            if (response.data.statusCode == 511) {
                $(".index_login").click();
                return;
            }
            $utils.fail(response.data.message);
        }
        return response;
    });
};
$http.get = function (url, options) {
    if (options === undefined) options = {};
    return $http.ajax(url, options.data !== undefined ? {
        data: options.data
    } : "", "get", options);
};
$http.post = function (url, data, options) {
    if (options === undefined) options = {};

    for (var d in data) {
        if (data[d] instanceof Date) {
            data[d] = __WEBPACK_IMPORTED_MODULE_5_moment___default()(data[d]).format("YYYY-MM-DD HH:mm:ss");
        }
    }
    return $http.ajax(url, $.param({
        data: (typeof data === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(data)) == "object" ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data) : data
    }), "post", options);
};
/* harmony default export */ __webpack_exports__["a"] = ($http);

/***/ }),
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dateUtils__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stringUtils__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__noticeUtils__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cacheUtils__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cloneUtils__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__regularUtils__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__objectUtils__ = __webpack_require__(302);








__WEBPACK_IMPORTED_MODULE_6__objectUtils__["a" /* default */].extends(__WEBPACK_IMPORTED_MODULE_0__dateUtils__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_6__objectUtils__["a" /* default */].extends(__WEBPACK_IMPORTED_MODULE_1__stringUtils__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_6__objectUtils__["a" /* default */].extends(__WEBPACK_IMPORTED_MODULE_2__noticeUtils__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_6__objectUtils__["a" /* default */].extends(__WEBPACK_IMPORTED_MODULE_3__cacheUtils__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_6__objectUtils__["a" /* default */].extends(__WEBPACK_IMPORTED_MODULE_4__cloneUtils__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_6__objectUtils__["a" /* default */].extends(__WEBPACK_IMPORTED_MODULE_5__regularUtils__["a" /* default */]);
window.$utils = __WEBPACK_IMPORTED_MODULE_6__objectUtils__["a" /* default */];
window.statusCode = {
    Succ: 200,
    Fail: 400,
    Deny: 511,
    Error: 500
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_6__objectUtils__["a" /* default */]);

/***/ }),
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__systemApis__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__policyApis__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__policyApis___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__policyApis__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__orderApis__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__billApis__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tradeApis__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__baseApis__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__tourApis__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__flightApis__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__messageApi__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__tourPolicyApi__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__flightPolicyApi__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__trainApis__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__trainPolicyApi__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__hotelPolicyApi__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__hotelApi__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__btripApi__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__workApis__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__logsApis__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__invoiceApis__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__expressApis__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__insurancePolicyApis__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__insuranceApis__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__chargeapi__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__chargepolicyapi__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__sideapi__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__statisticsApis__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__wechatApi__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__adapterApis__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__mallApis__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__activityApis__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__analyseapi__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__huilianyiapi__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__trafficApi__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__trafficPolicyApi__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__dingdingapi__ = __webpack_require__(264);




































/* harmony default export */ __webpack_exports__["a"] = ({
    system: __WEBPACK_IMPORTED_MODULE_0__systemApis__["a" /* default */],
    policy: __WEBPACK_IMPORTED_MODULE_1__policyApis___default.a,
    order: __WEBPACK_IMPORTED_MODULE_2__orderApis__["a" /* default */],
    bill: __WEBPACK_IMPORTED_MODULE_3__billApis__["a" /* default */],
    trade: __WEBPACK_IMPORTED_MODULE_4__tradeApis__["a" /* default */],
    base: __WEBPACK_IMPORTED_MODULE_5__baseApis__["a" /* default */],
    tour: __WEBPACK_IMPORTED_MODULE_6__tourApis__["a" /* default */],
    flight: __WEBPACK_IMPORTED_MODULE_7__flightApis__["a" /* default */],
    message: __WEBPACK_IMPORTED_MODULE_8__messageApi__["a" /* default */],
    tourpolicy: __WEBPACK_IMPORTED_MODULE_9__tourPolicyApi__["a" /* default */],
    flightpolicy: __WEBPACK_IMPORTED_MODULE_10__flightPolicyApi__["a" /* default */],
    train: __WEBPACK_IMPORTED_MODULE_11__trainApis__["a" /* default */],
    trainpolicy: __WEBPACK_IMPORTED_MODULE_12__trainPolicyApi__["a" /* default */],
    hotelpolicy: __WEBPACK_IMPORTED_MODULE_13__hotelPolicyApi__["a" /* default */],
    hotel: __WEBPACK_IMPORTED_MODULE_14__hotelApi__["a" /* default */],
    btrip: __WEBPACK_IMPORTED_MODULE_15__btripApi__["a" /* default */],
    work: __WEBPACK_IMPORTED_MODULE_16__workApis__["a" /* default */],
    logs: __WEBPACK_IMPORTED_MODULE_17__logsApis__["a" /* default */],
    invoice: __WEBPACK_IMPORTED_MODULE_18__invoiceApis__["a" /* default */],
    express: __WEBPACK_IMPORTED_MODULE_19__expressApis__["a" /* default */],
    insurancepolicy: __WEBPACK_IMPORTED_MODULE_20__insurancePolicyApis__["a" /* default */],
    insurance: __WEBPACK_IMPORTED_MODULE_21__insuranceApis__["a" /* default */],
    charge: __WEBPACK_IMPORTED_MODULE_22__chargeapi__["a" /* default */],
    chargepolicy: __WEBPACK_IMPORTED_MODULE_23__chargepolicyapi__["a" /* default */],
    side: __WEBPACK_IMPORTED_MODULE_24__sideapi__["a" /* default */],
    statistics: __WEBPACK_IMPORTED_MODULE_25__statisticsApis__["a" /* default */],
    wechat: __WEBPACK_IMPORTED_MODULE_26__wechatApi__["a" /* default */],
    adapter: __WEBPACK_IMPORTED_MODULE_27__adapterApis__["a" /* default */],
    mall: __WEBPACK_IMPORTED_MODULE_28__mallApis__["a" /* default */],
    activity: __WEBPACK_IMPORTED_MODULE_29__activityApis__["a" /* default */],
    analyse: __WEBPACK_IMPORTED_MODULE_30__analyseapi__["a" /* default */],
    huilianyi: __WEBPACK_IMPORTED_MODULE_31__huilianyiapi__["a" /* default */],
    traffic: __WEBPACK_IMPORTED_MODULE_32__trafficApi__["a" /* default */],
    trafficpolicy: __WEBPACK_IMPORTED_MODULE_33__trafficPolicyApi__["a" /* default */],
    dingding: __WEBPACK_IMPORTED_MODULE_34__dingdingapi__["a" /* default */],
    getService: function getService(serviceCode) {
        if (serviceCode != undefined) {
            return this[serviceCode.toLowerCase().replace("service", "")];
        }
    }
});

/***/ }),
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */
/***/ (function(module, exports) {

module.exports = Vuex;

/***/ }),
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var data = {
    "CompanyType": [{ "CategoryID": 1100, "CategoryTitle": "企事业单位", "CategoryCode": "EnterprisesUnit" }, { "CategoryID": 1101, "CategoryTitle": "政府机关", "CategoryCode": "GovernmentDepartment" }],
    "CapitalType": [{ "CategoryID": 1102, "CategoryTitle": "民营资产", "CategoryCode": "PeopleEnterprises" }, { "CategoryID": 1103, "CategoryTitle": "国有资产", "CategoryCode": "CountryCapital" }, { "CategoryID": 1104, "CategoryTitle": "中外合资", "CategoryCode": "ChinaOuterJoinCapital" }, { "CategoryID": 1105, "CategoryTitle": "外商独资", "CategoryCode": "ForeignCompany" }],
    "CompanySize": [{ "CategoryID": 1106, "CategoryTitle": "100人以下", "CategoryCode": "CompanySize100" }, { "CategoryID": 1107, "CategoryTitle": "100~499", "CategoryCode": "CompanySize499" }, { "CategoryID": 1108, "CategoryTitle": "500~999", "CategoryCode": "CompanySize999" }, { "CategoryID": 1109, "CategoryTitle": "1000~4999", "CategoryCode": "CompanySize4999" }, { "CategoryID": 1110, "CategoryTitle": "5000以上", "CategoryCode": "CompanySize5kUp" }],
    "ApplyArea": [{ "CategoryID": 1126, "CategoryTitle": "国内", "CategoryCode": "Internal" }, { "CategoryID": 1127, "CategoryTitle": "国际", "CategoryCode": "Overseas" }],
    "CardType": [{ "CategoryID": 1138, "CategoryTitle": "身份证", "CategoryCode": "IDCard" }, { "CategoryID": 1139, "CategoryTitle": "护照", "CategoryCode": "PassportCard" }, { "CategoryID": 1140, "CategoryTitle": "学生证", "CategoryCode": "StudentCard" }, { "CategoryID": 1141, "CategoryTitle": "军人证", "CategoryCode": "OfficerCard" }, { "CategoryID": 1296, "CategoryTitle": "港澳台居民居住证", "CategoryCode": "Residencepermit" }, { "CategoryID": 1297, "CategoryTitle": "外国人永久居留身份证", "CategoryCode": "ForeignResidentIDCard" }, { "CategoryID": 1234, "CategoryTitle": "港澳通行证", "CategoryCode": "HKCompatriotsyndrome" }, { "CategoryID": 1233, "CategoryTitle": "台湾通行证", "CategoryCode": "TaiCompatriotsyndrome" }, { "CategoryID": 1298, "CategoryTitle": "回乡证", "CategoryCode": "HKMpermit" }, { "CategoryID": 1299, "CategoryTitle": "台胞证", "CategoryCode": "TaiWpermit" }],
    "UserStatus": [{ "CategoryID": 1143, "CategoryTitle": "启用", "CategoryCode": "Enable" }, { "CategoryID": 1144, "CategoryTitle": "禁用", "CategoryCode": "UnEnable" }],
    "Sex": [{ "CategoryID": 1145, "CategoryTitle": "男", "CategoryCode": "Male" }, { "CategoryID": 1146, "CategoryTitle": "女", "CategoryCode": "Female" }],
    "YesOrNo": [{ "CategoryID": 1150, "CategoryTitle": "是", "CategoryCode": "Yes" }, { "CategoryID": 1151, "CategoryTitle": "否", "CategoryCode": "No" }],
    "ChinaVoyageType": [{ "CategoryID": 1161, "CategoryTitle": "单程", "CategoryCode": "SingleVoyage" }, { "CategoryID": 1162, "CategoryTitle": "往返", "CategoryCode": "RoundVoyage" }],
    "RoleType": [{ "CategoryID": 1311, "CategoryTitle": "用户", "CategoryCode": "User" }, { "CategoryID": 1312, "CategoryTitle": "职位", "CategoryCode": "Jobs" }, { "CategoryID": 1313, "CategoryTitle": "群组", "CategoryCode": "Group" }, { "CategoryID": 1314, "CategoryTitle": "部门", "CategoryCode": "Department" }, { "CategoryID": 1315, "CategoryTitle": "公司", "CategoryCode": "Company" }, { "CategoryID": 1316, "CategoryTitle": "服务", "CategoryCode": "Service" }, { "CategoryID": 1317, "CategoryTitle": "客户", "CategoryCode": "Customer" }, { "CategoryID": 1318, "CategoryTitle": "权限", "CategoryCode": "Action" }, { "CategoryID": 1319, "CategoryTitle": "成本中心", "CategoryCode": "CostCenter" }],
    "HotelPayType": [{ "CategoryID": 1195, "CategoryTitle": "预付", "CategoryCode": "HotelPrepay" }, { "CategoryID": 1196, "CategoryTitle": "现付", "CategoryCode": "HotelCashPay" }],
    "FlightType": [{ "CategoryID": 1193, "CategoryTitle": "普通航班", "CategoryCode": "CommonFlight" }, { "CategoryID": 1194, "CategoryTitle": "共享航班", "CategoryCode": "ShareFlight" }],
    "ConsumerType": [{ "CategoryID": 1701, "CategoryTitle": "婴儿", "CategoryCode": "Infant" }, { "CategoryID": 1703, "CategoryTitle": "儿童", "CategoryCode": "Enfant" }, { "CategoryID": 1705, "CategoryTitle": "成人", "CategoryCode": "Young" }, { "CategoryID": 1707, "CategoryTitle": "中年", "CategoryCode": "Wrinkly" }, { "CategoryID": 1709, "CategoryTitle": "老年", "CategoryCode": "Elderly" }],
    "BillCycle": [{ "CategoryID": 1260, "CategoryTitle": "月", "CategoryCode": "MonthCycle" }, { "CategoryID": 1261, "CategoryTitle": "周", "CategoryCode": "WeekCycle" }, { "CategoryID": 1262, "CategoryTitle": "日", "CategoryCode": "DayCycle" }],
    "ServiceMode": [{ "CategoryID": 1300, "CategoryTitle": "线上服务", "CategoryCode": "OnlineServiceMode" }, { "CategoryID": 1301, "CategoryTitle": "线下服务", "CategoryCode": "LineServiceMode" }],
    "CalcPriceMode": [{ "CategoryID": 1302, "CategoryTitle": "百分比", "CategoryCode": "PercentageMode" }, { "CategoryID": 1303, "CategoryTitle": "固定金额", "CategoryCode": "FixedPrice" }],
    "CalcBenchmark": [{ "CategoryID": 1304, "CategoryTitle": "票面价", "CategoryCode": "ExpensePrice" }, { "CategoryID": 1305, "CategoryTitle": "票面价+税费", "CategoryCode": "PriceFareAndTax" }],
    "RuntimeEnvironment": [{ "CategoryID": 1320, "CategoryTitle": "服务端", "CategoryCode": "Server" }, { "CategoryID": 1321, "CategoryTitle": "客户端", "CategoryCode": "Client" }],
    "WorkStatus": [{ "CategoryID": 1325, "CategoryTitle": "正常", "CategoryCode": "Normal" }, { "CategoryID": 1326, "CategoryTitle": "变更", "CategoryCode": "Change" }],
    "DataRange": [{ "CategoryID": 1332, "CategoryTitle": "不限制", "CategoryCode": "NoLimit" }, { "CategoryID": 1330, "CategoryTitle": "仅自己", "CategoryCode": "SelfOnly" }, { "CategoryID": 1513, "CategoryTitle": "本部门", "CategoryCode": "Department" }, { "CategoryID": 1514, "CategoryTitle": "本部门及下级", "CategoryCode": "DepartmentLower" }],
    "AuthorizeState": [{ "CategoryID": 1335, "CategoryTitle": "未授权", "CategoryCode": "UnAuthorized" }, { "CategoryID": 1336, "CategoryTitle": "已授权", "CategoryCode": "Authorized" }],
    "RoleCategory": [{ "CategoryID": 1350, "CategoryTitle": "系统角色", "CategoryCode": "SystemRole" }, { "CategoryID": 1351, "CategoryTitle": "用户角色", "CategoryCode": "UserRole" }],
    "EventType": [{ "CategoryID": 1356, "CategoryTitle": "继续之前", "CategoryCode": "ContinueBefore" }, { "CategoryID": 1357, "CategoryTitle": "继续之后", "CategoryCode": "ContinueAfter" }, { "CategoryID": 1358, "CategoryTitle": "退回之前", "CategoryCode": "ReturnBefore" }, { "CategoryID": 1359, "CategoryTitle": "退回之后", "CategoryCode": "ReturnAfter" }, { "CategoryID": 1360, "CategoryTitle": "变更之前", "CategoryCode": "ChangeBefore" }, { "CategoryID": 1361, "CategoryTitle": "变更之后", "CategoryCode": "ChangeAfter" }],
    "InvoiceStatus": [{ "CategoryID": 1362, "CategoryTitle": "需要发票", "CategoryCode": "NeedInvoice" }, { "CategoryID": 1363, "CategoryTitle": "不要发票", "CategoryCode": "NoInvoice" }],
    "CreateMode": [{ "CategoryID": 1364, "CategoryTitle": "网站", "CategoryCode": "WEB" }],
    "UnitPrice": [{ "CategoryID": 1369, "CategoryTitle": "元", "CategoryCode": "RMB" }, { "CategoryID": 1370, "CategoryTitle": "美元", "CategoryCode": "Dollar" }],
    "TradeMode": [{ "CategoryID": 1371, "CategoryTitle": "支付宝", "CategoryCode": "Alipay" }, { "CategoryID": 1372, "CategoryTitle": "微信", "CategoryCode": "WeChat" }, { "CategoryID": 1373, "CategoryTitle": "现金", "CategoryCode": "Cash" }, { "CategoryID": 1374, "CategoryTitle": "月结", "CategoryCode": "Monthly" }, { "CategoryID": 1376, "CategoryTitle": "POS", "CategoryCode": "Pos" }, { "CategoryID": 1483, "CategoryTitle": "转账", "CategoryCode": "Transfer" }],
    "ProductType": [{ "CategoryID": 1375, "CategoryTitle": "旅游", "CategoryCode": "Tour" }, { "CategoryID": 1376, "CategoryTitle": "酒店", "CategoryCode": "Hotel" }, { "CategoryID": 1377, "CategoryTitle": "机票", "CategoryCode": "Flight" }, { "CategoryID": 1484, "CategoryTitle": "火车票", "CategoryCode": "Train" }],
    "FileType": [{ "CategoryID": 1378, "CategoryTitle": "出团通知书", "CategoryCode": "AdviceNote" }, { "CategoryID": 1379, "CategoryTitle": "客人附件", "CategoryCode": "GuestEnclosure" }, { "CategoryID": 1381, "CategoryTitle": "其他", "CategoryCode": "other" }, { "CategoryID": 1382, "CategoryTitle": "电子合同", "CategoryCode": "Electronic" }],
    "MessageType": [{ "CategoryID": 1383, "CategoryTitle": "给客人留言", "CategoryCode": "ClientMessage" }, { "CategoryID": 1384, "CategoryTitle": "给供应留言", "CategoryCode": "SupplyMessage" }, { "CategoryID": 1385, "CategoryTitle": "给同事留言", "CategoryCode": "WorkmateMessage" }],
    "TravelStatus": [{ "CategoryID": 1390, "CategoryTitle": "已出游", "CategoryCode": "Traveled" }, { "CategoryID": 1391, "CategoryTitle": "未出游", "CategoryCode": "NotTravel" }],
    "OrderType": [{ "CategoryID": 1397, "CategoryTitle": "销售", "CategoryCode": "Sell" }, { "CategoryID": 1398, "CategoryTitle": "退款", "CategoryCode": "DrawBack" }],
    "BusinessType": [{ "CategoryID": 1797, "CategoryTitle": "销售", "CategoryCode": "Sales" }, { "CategoryID": 1789, "CategoryTitle": "变更", "CategoryCode": "Change" }, { "CategoryID": 1799, "CategoryTitle": "退废", "CategoryCode": "Amend" }, { "CategoryID": 1791, "CategoryTitle": "账务", "CategoryCode": "Bill" }, { "CategoryID": 1792, "CategoryTitle": "发票", "CategoryCode": "Invoice" }, { "CategoryID": 1793, "CategoryTitle": "公司", "CategoryCode": "Company" }, { "CategoryID": 1795, "CategoryTitle": "产品", "CategoryCode": "Product" }, { "CategoryID": 1801, "CategoryTitle": "个人", "CategoryCode": "People" }],
    "SecurityType": [{ "CategoryID": 1399, "CategoryTitle": "登录密码", "CategoryCode": "PasswordVerify" }, { "CategoryID": 1400, "CategoryTitle": "邮箱验证", "CategoryCode": "EmailVerify" }, { "CategoryID": 1401, "CategoryTitle": "手机验证", "CategoryCode": "PhoneVerify" }, { "CategoryID": 1402, "CategoryTitle": "实名验证", "CategoryCode": "NameVerify" }, { "CategoryID": 1403, "CategoryTitle": "安全问题", "CategoryCode": "SafetyProblem" }],
    "Source": [{ "CategoryID": 1404, "CategoryTitle": "网站", "CategoryCode": "Pc" }, { "CategoryID": 1405, "CategoryTitle": "手机", "CategoryCode": "App" }, { "CategoryID": 1803, "CategoryTitle": "客服", "CategoryCode": "Customer" }, { "CategoryID": 1984, "CategoryTitle": "需求", "CategoryCode": "Demand" }],
    "ServiceType": [{ "CategoryID": 0, "CategoryTitle": "通用服务", "CategoryCode": "CommonService" }, { "CategoryID": 1407, "CategoryTitle": "酒店服务", "CategoryCode": "HotelService" }, { "CategoryID": 1408, "CategoryTitle": "旅游服务", "CategoryCode": "TourService" }, { "CategoryID": 1409, "CategoryTitle": "机票服务", "CategoryCode": "FlightService" }, { "CategoryID": 1470, "CategoryTitle": "火车服务", "CategoryCode": "TrainService" }, { "CategoryID": 1555, "CategoryTitle": "交通服务", "CategoryCode": "TrafficService" }, { "CategoryID": 1406, "CategoryTitle": "商旅服务", "CategoryCode": "BtripService" }, { "CategoryID": 1466, "CategoryTitle": "保险服务", "CategoryCode": "InsuranceService" }, { "CategoryID": 1467, "CategoryTitle": "快递服务", "CategoryCode": "ExpressService" }, { "CategoryID": 1468, "CategoryTitle": "发票服务", "CategoryCode": "InvoiceService" }, { "CategoryID": 1469, "CategoryTitle": "签证服务", "CategoryCode": "VisaService" }, { "CategoryID": 1554, "CategoryTitle": "餐饮服务", "CategoryCode": "CaterService" }, { "CategoryID": 1556, "CategoryTitle": "商城服务", "CategoryCode": "TicketService" }, { "CategoryID": 1557, "CategoryTitle": "基础服务", "CategoryCode": "BaseService" }, { "CategoryID": 1636, "CategoryTitle": "系统服务", "CategoryCode": "SystemService" }, { "CategoryID": 1637, "CategoryTitle": "工作服务", "CategoryCode": "WorkService" }, { "CategoryID": 1638, "CategoryTitle": "订单服务", "CategoryCode": "OrderService" }, { "CategoryID": 1640, "CategoryTitle": "账单服务", "CategoryCode": "BillService" }, { "CategoryID": 1643, "CategoryTitle": "个人服务", "CategoryCode": "UserService" }, { "CategoryID": 1645, "CategoryTitle": "企业服务", "CategoryCode": "CompanyService" }, { "CategoryID": 1410, "CategoryTitle": "增值服务", "CategoryCode": "ChargeService" }],
    "ProblemType": [{ "CategoryID": 1411, "CategoryTitle": "高中班主任是谁", "CategoryCode": "HightDirector" }, { "CategoryID": 1412, "CategoryTitle": "第一次通关的游戏", "CategoryCode": "Firstgame" }],
    "ContactType": [{ "CategoryID": 1413, "CategoryTitle": "手机", "CategoryCode": "PhoneContact" }, { "CategoryID": 1414, "CategoryTitle": "电话", "CategoryCode": "TelephoneContact" }, { "CategoryID": 1415, "CategoryTitle": "邮箱", "CategoryCode": "EmailContact" }, { "CategoryID": 1416, "CategoryTitle": "QQ", "CategoryCode": "QQ" }],
    "SetsType": [{ "CategoryID": 1417, "CategoryTitle": "网上预订须知", "CategoryCode": "OnlineKnow" }, { "CategoryID": 1418, "CategoryTitle": "国内旅游预订须知", "CategoryCode": "TourKnow" }],
    "TeamStatus": [{ "CategoryID": 1419, "CategoryTitle": "启用", "CategoryCode": "Enable" }, { "CategoryID": 1420, "CategoryTitle": "禁用", "CategoryCode": "UnEnable" }],
    "PriceStatus": [{ "CategoryID": 1421, "CategoryTitle": "价格启用", "CategoryCode": "PriceEnable" }, { "CategoryID": 1422, "CategoryTitle": "价格禁用", "CategoryCode": "PriceUnEnable" }, { "CategoryID": 1423, "CategoryTitle": "价格待定", "CategoryCode": "Indeterminate" }],
    "PolicyType": [{ "CategoryID": 1426, "CategoryTitle": "私有政策", "CategoryCode": "PrivatePolicy" }, { "CategoryID": 1427, "CategoryTitle": "公有政策", "CategoryCode": "PublicPolicy" }],
    "TradeType": [{ "CategoryID": 1428, "CategoryTitle": "收款", "CategoryCode": "Receive" }, { "CategoryID": 1429, "CategoryTitle": "付款", "CategoryCode": "Payment" }],
    "TradeStatus": [{ "CategoryID": 1610, "CategoryTitle": "待提交", "CategoryCode": "WaitSubmit" }, { "CategoryID": 1612, "CategoryTitle": "待付款", "CategoryCode": "WaitPayment" }, { "CategoryID": 1614, "CategoryTitle": "未确认", "CategoryCode": "WaitConfirm" }, { "CategoryID": 1616, "CategoryTitle": "已确认", "CategoryCode": "Finished" }, { "CategoryID": 1618, "CategoryTitle": "已取消", "CategoryCode": "Canceled" }, { "CategoryID": 1620, "CategoryTitle": "已退回", "CategoryCode": "Rejected" }],
    "AuditStatus": [{ "CategoryID": 1434, "CategoryTitle": "未审批", "CategoryCode": "Unaudit" }, { "CategoryID": 1435, "CategoryTitle": "已审批", "CategoryCode": "Audited" }, { "CategoryID": 1436, "CategoryTitle": "审批拒绝", "CategoryCode": "AuditRefuse" }],
    "ApplyStatus": [{ "CategoryID": 1432, "CategoryTitle": "未提交", "CategoryCode": "Unsubmit" }, { "CategoryID": 1433, "CategoryTitle": "已提交", "CategoryCode": "Submited" }],
    "RefundStatus": [{ "CategoryID": 1438, "CategoryTitle": "未处理", "CategoryCode": "Untreated" }, { "CategoryID": 1439, "CategoryTitle": "退团失败", "CategoryCode": "RefundeBad" }, { "CategoryID": 1440, "CategoryTitle": "退团处理中", "CategoryCode": "RefundeIng" }, { "CategoryID": 1441, "CategoryTitle": "退团成功", "CategoryCode": "Refunded" }],
    "ZoneType": [{ "CategoryID": 1442, "CategoryTitle": "国家", "CategoryCode": "Country" }, { "CategoryID": 1443, "CategoryTitle": "景区", "CategoryCode": "Scenic" }, { "CategoryID": 1444, "CategoryTitle": "城市", "CategoryCode": "City" }, { "CategoryID": 1445, "CategoryTitle": "省份", "CategoryCode": "Province" }, { "CategoryID": 1446, "CategoryTitle": "区域", "CategoryCode": "Area" }, { "CategoryID": 1447, "CategoryTitle": "机场", "CategoryCode": "Airport" }, { "CategoryID": 1448, "CategoryTitle": "洲际", "CategoryCode": "Continent" }, { "CategoryID": 1449, "CategoryTitle": "区县", "CategoryCode": "District" }, { "CategoryID": 1807, "CategoryTitle": "车站", "CategoryCode": "Station" }, { "CategoryID": 1809, "CategoryTitle": "商圈", "CategoryCode": "Business" }],
    "TicketDelivery": [{ "CategoryID": 1450, "CategoryTitle": "自取", "CategoryCode": "Invite" }, { "CategoryID": 1451, "CategoryTitle": "邮寄", "CategoryCode": "Mail" }],
    "TicketType": [{ "CategoryID": 1164, "CategoryTitle": "BSP", "CategoryCode": "BSP" }, { "CategoryID": 1165, "CategoryTitle": "B2B", "CategoryCode": "B2B" }, { "CategoryID": 1980, "CategoryTitle": "B2C", "CategoryCode": "B2C" }, { "CategoryID": 1982, "CategoryTitle": "B2G", "CategoryCode": "B2G" }, { "CategoryID": 1983, "CategoryTitle": "BSG", "CategoryCode": "BSG" }, { "CategoryID": 1166, "CategoryTitle": "境外电子", "CategoryCode": "OverseasElectronic" }, { "CategoryID": 1981, "CategoryTitle": "销售策略", "CategoryCode": "SAP" }],
    "BackAirportType": [{ "CategoryID": 1180, "CategoryTitle": "同一洲际范围内", "CategoryCode": "WithinIntercontinental" }, { "CategoryID": 1181, "CategoryTitle": "政策始发机场范围", "CategoryCode": "PolicyDepartAirport" }, { "CategoryID": 1184, "CategoryTitle": "必须返回行程出发机场", "CategoryCode": "MustBackAirport" }, { "CategoryID": 1185, "CategoryTitle": "指定返回国家或机场范围", "CategoryCode": "AppointBackAirport" }],
    "ApplicableObject": [{ "CategoryID": 1168, "CategoryTitle": "团队", "CategoryCode": "Team" }, { "CategoryID": 1169, "CategoryTitle": "散客", "CategoryCode": "Fit" }, { "CategoryID": 1170, "CategoryTitle": "不限", "CategoryCode": "Unlimited" }],
    "ApplyPrice": [{ "CategoryID": 1171, "CategoryTitle": "高开", "CategoryCode": "HighOpen" }, { "CategoryID": 1172, "CategoryTitle": "低开", "CategoryCode": "DownOpen" }],
    "ApplyWeek": [{ "CategoryID": 1173, "CategoryTitle": "一", "CategoryCode": "Monday" }, { "CategoryID": 1174, "CategoryTitle": "二", "CategoryCode": "Tuesday" }, { "CategoryID": 1175, "CategoryTitle": "三", "CategoryCode": "Wednesday" }, { "CategoryID": 1176, "CategoryTitle": "四", "CategoryCode": "Thursday" }, { "CategoryID": 1177, "CategoryTitle": "五", "CategoryCode": "Friday" }, { "CategoryID": 1178, "CategoryTitle": "六", "CategoryCode": "Saturday" }, { "CategoryID": 1179, "CategoryTitle": "日", "CategoryCode": "Sunday" }],
    "LimitPassageType": [{ "CategoryID": 1200, "CategoryTitle": "留学生", "CategoryCode": "OverseasStudent" }, { "CategoryID": 1201, "CategoryTitle": "移民", "CategoryCode": "Immigrant" }, { "CategoryID": 1202, "CategoryTitle": "劳工", "CategoryCode": "Worker" }, { "CategoryID": 1203, "CategoryTitle": "海员", "CategoryCode": "Seaman" }, { "CategoryID": 1204, "CategoryTitle": "青年", "CategoryCode": "Youth" }, { "CategoryID": 1205, "CategoryTitle": "港澳台", "CategoryCode": "HkMacaoTw" }, { "CategoryID": 1206, "CategoryTitle": "外籍", "CategoryCode": "ForeignNationality" }, { "CategoryID": 1207, "CategoryTitle": "非汉字姓名", "CategoryCode": "NotChineseName" }, { "CategoryID": 1208, "CategoryTitle": "Add-On", "CategoryCode": "AddOn" }, { "CategoryID": 1209, "CategoryTitle": "老年", "CategoryCode": "OldGge" }, { "CategoryID": 1210, "CategoryTitle": "境外中转", "CategoryCode": "OverseasTransfer" }, { "CategoryID": 1211, "CategoryTitle": "缺口程", "CategoryCode": "NotchRange" }, { "CategoryID": 1212, "CategoryTitle": "OPEN", "CategoryCode": "OPEN" }, { "CategoryID": 1213, "CategoryTitle": "SPA", "CategoryCode": "SPA" }, { "CategoryID": 1214, "CategoryTitle": "Q值", "CategoryCode": "QValue" }, { "CategoryID": 1215, "CategoryTitle": "共享航班", "CategoryCode": "SharedFlight" }, { "CategoryID": 1216, "CategoryTitle": "三方协议", "CategoryCode": "ThreeAgreement" }, { "CategoryID": 1217, "CategoryTitle": "套票", "CategoryCode": "Package" }, { "CategoryID": 1218, "CategoryTitle": "整团", "CategoryCode": "WholeGroup" }, { "CategoryID": 1219, "CategoryTitle": "小团", "CategoryCode": "SmallGroup" }],
    "FreightBasicsRule": [{ "CategoryID": 1182, "CategoryTitle": "无奖励", "CategoryCode": "NoReward" }, { "CategoryID": 1183, "CategoryTitle": "无代理费", "CategoryCode": "AgencyFreeFee" }],
    "ChildrewardRules": [{ "CategoryID": 1220, "CategoryTitle": "奖励与成人一样", "CategoryCode": "RewardsAdults" }, { "CategoryID": 1221, "CategoryTitle": "可无开奖励", "CategoryCode": "NoOpenBonus" }, { "CategoryID": 1463, "CategoryTitle": "可开无代理费", "CategoryCode": "openAgencyFee" }, { "CategoryID": 1464, "CategoryTitle": "不可开", "CategoryCode": "NoWay" }],
    "BabywardRules": [{ "CategoryID": 1222, "CategoryTitle": "可开无奖励", "CategoryCode": "WithoutReward" }, { "CategoryID": 1223, "CategoryTitle": "不可开", "CategoryCode": "NotOpen" }],
    "CodingRule": [{ "CategoryID": 1224, "CategoryTitle": "无需换编码", "CategoryCode": "NoCodingRequired" }, { "CategoryID": 1225, "CategoryTitle": "换编码出票", "CategoryCode": "CodeOut" }, { "CategoryID": 1226, "CategoryTitle": "大编出票（无需换编）", "CategoryCode": "BigTicket" }, { "CategoryID": 1227, "CategoryTitle": "大编出票（需换编）", "CategoryCode": "BigNoTicket" }, { "CategoryID": 1228, "CategoryTitle": "无位不换出票（外放有位时换编）", "CategoryCode": "NoChange" }],
    "InterVoyageType": [{ "CategoryID": 1230, "CategoryTitle": "单程", "CategoryCode": "SingleVoyage" }, { "CategoryID": 1231, "CategoryTitle": "往返", "CategoryCode": "RoundVoyage" }, { "CategoryID": 1232, "CategoryTitle": "单程/往返", "CategoryCode": "SingleRound" }],
    "PointsType": [{ "CategoryID": 1306, "CategoryTitle": "直接修改", "CategoryCode": "DirectUpdate" }, { "CategoryID": 1307, "CategoryTitle": "加点", "CategoryCode": "AddLittle" }, { "CategoryID": 1308, "CategoryTitle": "减点", "CategoryCode": "ReduceLittle" }],
    "AirlineType": [{ "CategoryID": 1452, "CategoryTitle": "国内始发", "CategoryCode": "insideOutside" }, { "CategoryID": 1453, "CategoryTitle": "直飞SOTO程", "CategoryCode": "outsideInside" }, { "CategoryID": 1454, "CategoryTitle": "国内始发Add-On", "CategoryCode": "insideInsideOutside" }, { "CategoryID": 1455, "CategoryTitle": "国外始发Add-On", "CategoryCode": "outsideInsideInside" }, { "CategoryID": 1456, "CategoryTitle": "境外到境外", "CategoryCode": "outsideOutside" }, { "CategoryID": 1457, "CategoryTitle": "国内始发中转", "CategoryCode": "insideOutsideOutside" }, { "CategoryID": 1458, "CategoryTitle": "国外始发中转", "CategoryCode": "outsideOutsideInside" }, { "CategoryID": 1459, "CategoryTitle": "境外境外境外", "CategoryCode": "outsideOutsideOutside" }, { "CategoryID": 1460, "CategoryTitle": "境外境内境外", "CategoryCode": "outsideInsideOutside" }, { "CategoryID": 1461, "CategoryTitle": "全球到全球", "CategoryCode": "globalGlobal" }, { "CategoryID": 1462, "CategoryTitle": "全球中转全球", "CategoryCode": "globalGlobalGlobal" }],
    "InformationsType": [{ "CategoryID": 1471, "CategoryTitle": "预订须知", "CategoryCode": "TravelNotes" }, { "CategoryID": 1472, "CategoryTitle": "费用须知", "CategoryCode": "ExpenseKnowledge" }],
    "NotificationType": [{ "CategoryID": 1473, "CategoryTitle": "短信", "CategoryCode": "ShortMessage" }, { "CategoryID": 1474, "CategoryTitle": "邮件", "CategoryCode": "Mail" }, { "CategoryID": 1475, "CategoryTitle": "微信", "CategoryCode": "Wechat" }],
    "ExamineType": [{ "CategoryID": 1476, "CategoryTitle": "审批订单消息内容", "CategoryCode": "EexamineOrderSms" }, { "CategoryID": 1477, "CategoryTitle": "审批通过消息内容", "CategoryCode": "EexamineApprovalSms" }, { "CategoryID": 1478, "CategoryTitle": "审批拒绝消息内容", "CategoryCode": "EexamineRefuseSms" }, { "CategoryID": 1479, "CategoryTitle": "订单处理完成消息内容", "CategoryCode": "EexamineAccomplishSms" }, { "CategoryID": 1480, "CategoryTitle": "退款完成", "CategoryCode": "Refunds" }],
    "TrainSeatType": [{ "CategoryID": 1485, "CategoryTitle": "商务座", "CategoryCode": "BusinessSeat" }, { "CategoryID": 1486, "CategoryTitle": "特等座", "CategoryCode": "SpecialSeat" }, { "CategoryID": 1487, "CategoryTitle": "一等座", "CategoryCode": "Level1Seat" }, { "CategoryID": 1488, "CategoryTitle": "二等座", "CategoryCode": "Level2Seat" }, { "CategoryID": 1489, "CategoryTitle": "高级软卧", "CategoryCode": "HighGradeSleeper" }, { "CategoryID": 1490, "CategoryTitle": "软卧", "CategoryCode": "CommonSleeper" }, { "CategoryID": 1491, "CategoryTitle": "硬卧", "CategoryCode": "HardSleeper" }, { "CategoryID": 1492, "CategoryTitle": "软座", "CategoryCode": "SoftSeat" }, { "CategoryID": 1493, "CategoryTitle": "硬座", "CategoryCode": "HardSeat" }, { "CategoryID": 1494, "CategoryTitle": "无座", "CategoryCode": "NotHaveSeat" }, { "CategoryID": 1495, "CategoryTitle": "动卧", "CategoryCode": "MotionSupine" }, { "CategoryID": 1497, "CategoryTitle": "一等软卧", "CategoryCode": "Level1Sleeper" }, { "CategoryID": 1499, "CategoryTitle": "二等软卧", "CategoryCode": "Level2Sleeper" }],
    "Cabin": [{ "CategoryID": 1496, "CategoryTitle": "经济舱", "CategoryCode": "Economy" }, { "CategoryID": 1498, "CategoryTitle": "商务舱", "CategoryCode": "Buissenes" }, { "CategoryID": 1500, "CategoryTitle": "头等舱", "CategoryCode": "First" }, { "CategoryID": 1859, "CategoryTitle": "经济舱(9折)", "CategoryCode": "Economy9" }, { "CategoryID": 1857, "CategoryTitle": "经济舱(8折)", "CategoryCode": "Economy8" }, { "CategoryID": 1855, "CategoryTitle": "经济舱(7折)", "CategoryCode": "Economy7" }, { "CategoryID": 1853, "CategoryTitle": "经济舱(6折)", "CategoryCode": "Economy6" }, { "CategoryID": 1851, "CategoryTitle": "经济舱(5折)", "CategoryCode": "Economy5" }],
    "LowestRule": [{ "CategoryID": 0, "CategoryTitle": "无限制", "CategoryCode": "NoLimit" }, { "CategoryID": 1501, "CategoryTitle": "相对最低价", "CategoryCode": "ControLowestPrice" }, { "CategoryID": 1502, "CategoryTitle": "全天最低价", "CategoryCode": "DayLowestPrice" }, { "CategoryID": 1503, "CategoryTitle": "时段最低价", "CategoryCode": "TimeAreaLowestPrice" }, { "CategoryID": 1504, "CategoryTitle": "航班最低价", "CategoryCode": "FlightLowestPrice" }],
    "TrainType": [{ "CategoryID": 1505, "CategoryTitle": "高铁", "CategoryCode": "HighSpeedRail" }, { "CategoryID": 1506, "CategoryTitle": "卧铺", "CategoryCode": "SleepingBerth" }, { "CategoryID": 1507, "CategoryTitle": "普车及其它", "CategoryCode": "Other" }],
    "TrafficGrade": [{ "CategoryID": 2131, "CategoryTitle": "经济型", "CategoryCode": "Economy" }, { "CategoryID": 2133, "CategoryTitle": "舒适型", "CategoryCode": "Comfort" }, { "CategoryID": 2135, "CategoryTitle": "商务型", "CategoryCode": "Business" }, { "CategoryID": 2137, "CategoryTitle": "豪华型", "CategoryCode": "Luxury" }],
    "ServiceSecne": [{ "CategoryID": 2121, "CategoryTitle": "商务用车", "CategoryCode": "Business" }, { "CategoryID": 2123, "CategoryTitle": "加班用车", "CategoryCode": "Work" }, { "CategoryID": 2125, "CategoryTitle": "出差用车", "CategoryCode": "Btrip" }, { "CategoryID": 2127, "CategoryTitle": "其他场景", "CategoryCode": "Other" }],
    "ApplicableCase": [{ "CategoryID": 1508, "CategoryTitle": "全部", "CategoryCode": "Whole" }, { "CategoryID": 1509, "CategoryTitle": "职位", "CategoryCode": "Position" }, { "CategoryID": 1510, "CategoryTitle": "部门", "CategoryCode": "Department" }],
    "CollectFeesType": [{ "CategoryID": 1511, "CategoryTitle": "按固定收费", "CategoryCode": "FlatFeeCharges" }, { "CategoryID": 1512, "CategoryTitle": "按百分比收费", "CategoryCode": "PercentageCostFee" }],
    "TravelReasonType": [{ "CategoryID": 1515, "CategoryTitle": "差旅目的", "CategoryCode": "TravelPurpose" }, { "CategoryID": 1516, "CategoryTitle": "违背原因", "CategoryCode": "PolicyCause" }, { "CategoryID": 1528, "CategoryTitle": "预订须知", "CategoryCode": "BookingInfo" }],
    "FlightRefundReason": [{ "CategoryID": 1517, "CategoryTitle": "我要改变行程,不想飞了", "CategoryCode": "FlightChange" }, { "CategoryID": 1518, "CategoryTitle": "记错行程、日期、时间、姓名", "CategoryCode": "FlightMistaken" }, { "CategoryID": 1519, "CategoryTitle": "航班延误或取消", "CategoryCode": "FlightDelay" }],
    "BookingType": [{ "CategoryID": 1529, "CategoryTitle": "因公", "CategoryCode": "OnBusiness" }, { "CategoryID": 1530, "CategoryTitle": "因私", "CategoryCode": "OnPersonal" }],
    "ApprovalRecordType": [{ "CategoryID": 1531, "CategoryTitle": "订单支付审批", "CategoryCode": "PayApproval" }, { "CategoryID": 1532, "CategoryTitle": "订单改签审批", "CategoryCode": "ChangeApproval" }, { "CategoryID": 1533, "CategoryTitle": "订单退票审批", "CategoryCode": "ReturnTicketApproval" }],
    "ReservationMode": [{ "CategoryID": 1536, "CategoryTitle": "线上预订", "CategoryCode": "OnLineReservation" }, { "CategoryID": 1537, "CategoryTitle": "线下预订", "CategoryCode": "OffLineReservation" }],
    "ServiceTimeType": [{ "CategoryID": 1538, "CategoryTitle": "工作时间", "CategoryCode": "WorkingTime" }, { "CategoryID": 1539, "CategoryTitle": "非工作时间", "CategoryCode": "NonWorkingTime" }],
    "TripApprovalRule": [{ "CategoryID": 1541, "CategoryTitle": "线上预订需要审批", "CategoryCode": "OnlineBookingApproval" }, { "CategoryID": 1542, "CategoryTitle": "线下预订需要审批", "CategoryCode": "OfflineBookingApproval" }, { "CategoryID": 1545, "CategoryTitle": "违背规则需要审批", "CategoryCode": "ViolateRuleApproval" }, { "CategoryID": 1546, "CategoryTitle": "更改行程需要审批", "CategoryCode": "ChangeTripApproval" }, { "CategoryID": 1547, "CategoryTitle": "取消行程需要审批", "CategoryCode": "CancelTripApproval" }, { "CategoryID": 1543, "CategoryTitle": "必需选择成本中心", "CategoryCode": "CostCenterRequire" }, { "CategoryID": 1544, "CategoryTitle": "必需填写项目代码", "CategoryCode": "ProjectCodeRequire" }, { "CategoryID": 1540, "CategoryTitle": "必需填写违背原因", "CategoryCode": "ContraryReasonRequire" }, { "CategoryID": 1580, "CategoryTitle": "必需填写差旅目的", "CategoryCode": "IntentTripApproval" }, { "CategoryID": 1582, "CategoryTitle": "必需填写审批单号", "CategoryCode": "ApprovalNoRequire" }, { "CategoryID": 1584, "CategoryTitle": "允许填写审批单号", "CategoryCode": "ApprovalDisplayOnly" }, { "CategoryID": 1585, "CategoryTitle": "允许代用审批规则", "CategoryCode": "UseSelfApproval" }, { "CategoryID": 1587, "CategoryTitle": "或签可以选审批人", "CategoryCode": "ChooseApprovalOptional" }, { "CategoryID": 1588, "CategoryTitle": "或签必需选审批人", "CategoryCode": "ChooseApprovalRequired" }, { "CategoryID": 1589, "CategoryTitle": "无需填写项目代码", "CategoryCode": "ProjectCodeOptional" }, { "CategoryID": 1591, "CategoryTitle": "禁止预定机票服务", "CategoryCode": "DisableBookingFlight" }, { "CategoryID": 1593, "CategoryTitle": "禁止预定酒店服务", "CategoryCode": "DisableBookingHotel" }, { "CategoryID": 1595, "CategoryTitle": "禁止预定火车服务", "CategoryCode": "DisableBookingTrain" }, { "CategoryID": 1597, "CategoryTitle": "需要验证审批单号", "CategoryCode": "CheckApprovalNo" }, { "CategoryID": 1599, "CategoryTitle": "禁用填写差旅目的", "CategoryCode": "DisableIntentTripApproval" }, { "CategoryID": 1601, "CategoryTitle": "必需选择预算编码", "CategoryCode": "requireBudgetCode" }, { "CategoryID": 1603, "CategoryTitle": "必需上传订单附件", "CategoryCode": "requireOrderAttach" }, { "CategoryID": 1605, "CategoryTitle": "允许上传订单附件", "CategoryCode": "allowOrderAttach" }],
    "FlightTimeStatus": [{ "CategoryID": 1548, "CategoryTitle": "起飞前", "CategoryCode": "Preflight" }, { "CategoryID": 1549, "CategoryTitle": "起飞后", "CategoryCode": "AfterTakeoff" }],
    "RuleType": [{ "CategoryID": 1550, "CategoryTitle": "改签", "CategoryCode": "RuleEndorse" }, { "CategoryID": 1551, "CategoryTitle": "退票", "CategoryCode": "RuleFund" }, { "CategoryID": 1553, "CategoryTitle": "预订", "CategoryCode": "Reserve" }],
    "ExpensesType": [{ "CategoryID": 1534, "CategoryTitle": "按人收费", "CategoryCode": "People" }, { "CategoryID": 1535, "CategoryTitle": "按产品收费", "CategoryCode": "legs" }],
    "DelayType": [{ "CategoryID": 1559, "CategoryTitle": "自愿", "CategoryCode": "Volunteer" }, { "CategoryID": 1561, "CategoryTitle": "航变", "CategoryCode": "FlightChang" }, { "CategoryID": 1563, "CategoryTitle": "重购", "CategoryCode": "BuyAgain" }, { "CategoryID": 1565, "CategoryTitle": "病退", "CategoryCode": "SickAmend" }, { "CategoryID": 1567, "CategoryTitle": "名字错误", "CategoryCode": "NameError" }, { "CategoryID": 1569, "CategoryTitle": "升舱换开", "CategoryCode": "CabinChange" }, { "CategoryID": 1571, "CategoryTitle": "废票", "CategoryCode": "TicketInvalid" }, { "CategoryID": 1573, "CategoryTitle": "其他", "CategoryCode": "Other" }],
    "CompanyCard": [{ "CategoryID": 1720, "CategoryTitle": "营业执照", "CategoryCode": "BusinessLicence" }, { "CategoryID": 1722, "CategoryTitle": "税务登记证", "CategoryCode": "TaxRegistration" }, { "CategoryID": 1730, "CategoryTitle": "其他", "CategoryCode": "Other" }],
    "ActiveStatus": [{ "CategoryID": 1750, "CategoryTitle": "待审批", "CategoryCode": "WaitSubmit" }, { "CategoryID": 1752, "CategoryTitle": "待审批", "CategoryCode": "WaitDispose" }, { "CategoryID": 1754, "CategoryTitle": "暂不能", "CategoryCode": "Cannot" }, { "CategoryID": 1756, "CategoryTitle": "已完成", "CategoryCode": "Finished" }, { "CategoryID": 1758, "CategoryTitle": "已拒绝", "CategoryCode": "Rejected" }],
    "PriceType": [{ "CategoryID": 1672, "CategoryTitle": "房费", "CategoryCode": "HotelFare" }, { "CategoryID": 1674, "CategoryTitle": "团费", "CategoryCode": "TeamFare" }, { "CategoryID": 1660, "CategoryTitle": "票面", "CategoryCode": "TicketFare" }, { "CategoryID": 1662, "CategoryTitle": "机建", "CategoryCode": "BuildFare" }, { "CategoryID": 1664, "CategoryTitle": "燃油", "CategoryCode": "FuelFare" }, { "CategoryID": 1666, "CategoryTitle": "税费", "CategoryCode": "TaxFare" }, { "CategoryID": 1692, "CategoryTitle": "直减", "CategoryCode": "DirectReduction" }, { "CategoryID": 1668, "CategoryTitle": "保险", "CategoryCode": "SafeFare" }, { "CategoryID": 1670, "CategoryTitle": "服务费", "CategoryCode": "ServiceFare" }, { "CategoryID": 1678, "CategoryTitle": "退票", "CategoryCode": "AmendFare" }, { "CategoryID": 1682, "CategoryTitle": "变更", "CategoryCode": "ChangeFare" }, { "CategoryID": 1684, "CategoryTitle": "原价", "CategoryCode": "OldPrice" }, { "CategoryID": 1690, "CategoryTitle": "其它", "CategoryCode": "OtherFare" }, { "CategoryID": 1694, "CategoryTitle": "折扣", "CategoryCode": "ThrowDiscount" }],
    "FlowMode": [{ "CategoryID": 1760, "CategoryTitle": "交易审批", "CategoryCode": "Bill" }],
    "AccountType": [{ "CategoryID": 1765, "CategoryTitle": "余额", "CategoryCode": "Balance" }, { "CategoryID": 1767, "CategoryTitle": "信用", "CategoryCode": "Credit" }, { "CategoryID": 1769, "CategoryTitle": "积分", "CategoryCode": "Integral" }],
    "CreditType": [{ "CategoryID": 1771, "CategoryTitle": "固定授信", "CategoryCode": "FixedCredit" }, { "CategoryID": 1773, "CategoryTitle": "临时授信", "CategoryCode": "InterimCredit" }],
    "BillStatus": [{ "CategoryID": 1777, "CategoryTitle": "待出帐", "CategoryCode": "WaitOutDay" }, { "CategoryID": 1779, "CategoryTitle": "待审核", "CategoryCode": "WaitAudited" }, { "CategoryID": 1781, "CategoryTitle": "待确认", "CategoryCode": "WaitConfirm" }, { "CategoryID": 1783, "CategoryTitle": "待收款", "CategoryCode": "WaitReceive" }, { "CategoryID": 1785, "CategoryTitle": "已关账", "CategoryCode": "Finished" }, { "CategoryID": 1787, "CategoryTitle": "已退回", "CategoryCode": "Rejected" }],
    "PaymentType": [{ "CategoryID": 1195, "CategoryTitle": "预付", "CategoryCode": "Prepay" }, { "CategoryID": 1196, "CategoryTitle": "现付", "CategoryCode": "CashPay" }],
    "HotelRefundReason": [{ "CategoryID": 1805, "CategoryTitle": "行程变更", "CategoryCode": "HotelChange" }, { "CategoryID": 1837, "CategoryTitle": "行程取消", "CategoryCode": "HotelDelay" }],
    "InvoiceRole": [{ "CategoryID": 1813, "CategoryTitle": "公司", "CategoryCode": "Company" }, { "CategoryID": 1815, "CategoryTitle": "个人", "CategoryCode": "People" }],
    "InvoiceType": [{ "CategoryID": 1821, "CategoryTitle": "专用发票", "CategoryCode": "SpecialTicket" }, { "CategoryID": 1823, "CategoryTitle": "普通发票", "CategoryCode": "GeneralTicket" }],
    'TakeType': [{ "CategoryID": 1825, "CategoryTitle": "电子发票", "CategoryCode": "Electronic" }, { "CategoryID": 1827, "CategoryTitle": "纸质发票", "CategoryCode": "Paper" }],
    'NotifyType': [{ "CategoryID": 1865, "CategoryTitle": "短信通知", "CategoryCode": "MessageNotify" }, { "CategoryID": 1867, "CategoryTitle": "邮件通知", "CategoryCode": "MailNotify" }, { "CategoryID": 1869, "CategoryTitle": "微信通知", "CategoryCode": "WechatNotify" }, { "CategoryID": 1871, "CategoryTitle": "App通知", "CategoryCode": "AppNotify" }, { "CategoryID": 1873, "CategoryTitle": "OA通知", "CategoryCode": "OANotify" }],
    'OverdueStatus': [{ "CategoryID": 1890, "CategoryTitle": "待出帐", "CategoryCode": "WaitOutDay" }, { "CategoryID": 1892, "CategoryTitle": "未逾期", "CategoryCode": "OverdueNo" }, { "CategoryID": 1894, "CategoryTitle": "已逾期", "CategoryCode": "OverdueYes" }],
    'SaleRuleType': [{ "CategoryID": 1900, "CategoryTitle": "百分比", "CategoryCode": "Percentage" }, { "CategoryID": 1902, "CategoryTitle": "固定金额", "CategoryCode": "FixMoney" }, { "CategoryID": 1904, "CategoryTitle": "剔除最低舱位", "CategoryCode": "RemovePrice" }],
    'AuthType': [{ "CategoryID": 10220, "CategoryTitle": "邮箱账号", "CategoryCode": "EmailAuth" }, { "CategoryID": 10222, "CategoryTitle": "手机账号", "CategoryCode": "MobileAuth" }, { "CategoryID": 10224, "CategoryTitle": "账号密码", "CategoryCode": "AccountAuth" }, { "CategoryID": 10230, "CategoryTitle": "微信授权", "CategoryCode": "WeixinAuth" }, { "CategoryID": 10250, "CategoryTitle": "动态密码", "CategoryCode": "DynamicAuth" }],
    'NotifyContentType': [{ "CategoryID": 1940, "CategoryTitle": "文本", "CategoryCode": "Text" }, { "CategoryID": 1945, "CategoryTitle": "HTML", "CategoryCode": "Html" }, { "CategoryID": 1950, "CategoryTitle": "链接", "CategoryCode": "Link" }, { "CategoryID": 1955, "CategoryTitle": "插件", "CategoryCode": "Plugin" }],
    'NotifyScope': [{ "CategoryID": 1960, "CategoryTitle": "公司内部", "CategoryCode": "CompanyInternal" }, { "CategoryID": 1962, "CategoryTitle": "当前域名", "CategoryCode": "CurrentDomainName" }, { "CategoryID": 1964, "CategoryTitle": "所有域名", "CategoryCode": "AllDomainName" }],
    'ExpressType': [{ "CategoryID": 1970, "CategoryTitle": "电子邮件", "CategoryCode": "Email" }, { "CategoryID": 1972, "CategoryTitle": "普通地址", "CategoryCode": "OrdinaryAddress" }],

    'ExtraCode_Wechat': [{ "CategoryCode": "wechat_receive_reply", "CategoryTitle": "默认回复" }, { "CategoryCode": "wechat_watch_reply", "CategoryTitle": "关注回复" }],
    'BaggageCode': [{ "CategoryID": 1975, "CategoryCode": "carryon", "CategoryTitle": "手提" }, { "CategoryID": 1976, "CategoryCode": "consign", "CategoryTitle": "托运" }]
};

data["OrderStatus"] = [{ "CategoryID": 10101, "CategoryTitle": "待预订", "CategoryCode": "WaitBooking" }, { "CategoryID": 10105, "CategoryTitle": "待确认", "CategoryCode": "WaitConfirm" }, { "CategoryID": 10107, "CategoryTitle": "待支付", "CategoryCode": "WaitPayment" }, { "CategoryID": 10109, "CategoryTitle": "待处理", "CategoryCode": "WaitDispose" }, { "CategoryID": 10113, "CategoryTitle": "已完成", "CategoryCode": "Finished" }, { "CategoryID": 10115, "CategoryTitle": "已取消", "CategoryCode": "Canceled" }, { "CategoryID": 10117, "CategoryTitle": "已退回", "CategoryCode": "Rejected" }, { "CategoryID": 10121, "CategoryTitle": "暂不能", "CategoryCode": "Cannot" }];

data["DealStatus"] = [{ "CategoryID": 10101, "CategoryTitle": "待预订", "CategoryCode": "WaitBooking" }, { "CategoryID": 10105, "CategoryTitle": "待确认", "CategoryCode": "WaitConfirm" }, { "CategoryID": 10107, "CategoryTitle": "待支付", "CategoryCode": "WaitPayment" }, { "CategoryID": 10109, "CategoryTitle": "待处理", "CategoryCode": "WaitDispose" }, { "CategoryID": 10113, "CategoryTitle": "已完成", "CategoryCode": "Finished" }, { "CategoryID": 10115, "CategoryTitle": "已取消", "CategoryCode": "Canceled" }, { "CategoryID": 10117, "CategoryTitle": "已退回", "CategoryCode": "Rejected" }, { "CategoryID": 10121, "CategoryTitle": "暂不能", "CategoryCode": "Cannot" }];
data["AmendStatus"] = [{ "CategoryID": 10201, "CategoryTitle": "待提交", "CategoryCode": "WaitSubmit" }, { "CategoryID": 10203, "CategoryTitle": "待核价", "CategoryCode": "WaitDispose" }, { "CategoryID": 10205, "CategoryTitle": "待确认", "CategoryCode": "WaitConfirm" }, { "CategoryID": 10209, "CategoryTitle": "待退款", "CategoryCode": "WaitRefund" }, { "CategoryID": 10213, "CategoryTitle": "已完成", "CategoryCode": "Finished" }, { "CategoryID": 10215, "CategoryTitle": "暂不能", "CategoryCode": "Cannot" }, { "CategoryID": 10217, "CategoryTitle": "已退回", "CategoryCode": "Rejected" }, { "CategoryID": 10221, "CategoryTitle": "已取消", "CategoryCode": "Canceled" }];

data["FlightPolicyState"] = [{ "CategoryID": 3070101, "CategoryTitle": "待审批", "CategoryCode": "FlightWaitPolicy" }, { "CategoryID": 3070102, "CategoryTitle": "已上线", "CategoryCode": "FlightOnlinePolicy" }, { "CategoryID": 3070103, "CategoryTitle": "已下线", "CategoryCode": "FlightDownPolicy" }, { "CategoryID": 3070104, "CategoryTitle": "已禁用", "CategoryCode": "FlightDisablePolicy" }];
data["PolicyState"] = [{ "CategoryID": 3010101, "CategoryTitle": "待审批", "CategoryCode": "FlightWaitPolicy" }, { "CategoryID": 3010103, "CategoryTitle": "已上线", "CategoryCode": "FlightOnlinePolicy" }, { "CategoryID": 3010105, "CategoryTitle": "已下线", "CategoryCode": "FlightDownPolicy" }, { "CategoryID": 3010107, "CategoryTitle": "已禁用", "CategoryCode": "FlightDisablePolicy" }];
data["Lang"] = [{ "CategoryID": 'cn', "CategoryTitle": '中文', "CategoryCode": "cn" }, { "CategoryID": 'en', "CategoryTitle": '英文', "CategoryCode": "en" }, { "CategoryID": 'jp', "CategoryTitle": '日文', "CategoryCode": "jp" }];

data["SupplyCode"] = [{ "CategoryTitle": "IBE", "CategoryCode": "IBE" }, { "CategoryTitle": "Qunar", "CategoryCode": "Qunar" }];
data["ChannelCode"] = [{ "CategoryTitle": "网站", "CategoryCode": "web" }, { "CategoryTitle": "手机", "CategoryCode": "app" }, { "CategoryTitle": "微信", "CategoryCode": "h5" }, { "CategoryTitle": "门店", "CategoryCode": "store" }, { "CategoryTitle": "客服", "CategoryCode": "emp" }];
data["Numbers"] = [{ "CategoryID": 1, "CategoryTitle": "单", "CategoryCode": "一" }, { "CategoryID": 2, "CategoryTitle": "双", "CategoryCode": "二" }, { "CategoryID": 3, "CategoryTitle": "三", "CategoryCode": "三" }, { "CategoryID": 4, "CategoryTitle": "四", "CategoryCode": "四" }, { "CategoryID": 5, "CategoryTitle": "五", "CategoryCode": "五" }, { "CategoryID": 6, "CategoryTitle": "六", "CategoryCode": "六" }, { "CategoryID": 7, "CategoryTitle": "七", "CategoryCode": "七" }, { "CategoryID": 8, "CategoryTitle": "八", "CategoryCode": "八" }, { "CategoryID": 9, "CategoryTitle": "九", "CategoryCode": "九" }, { "CategoryID": 0, "CategoryTitle": "无", "CategoryCode": "零" }];
data['FlightChangeStatus'] = [{ "CategoryID": 10301, "CategoryTitle": "待通知", "CategoryCode": "WaitNotify" }, { "CategoryID": 10303, "CategoryTitle": "待确认", "CategoryCode": "WaitConfirm" }, { "CategoryID": 10305, "CategoryTitle": "待处理", "CategoryCode": "WaitDispose" }, { "CategoryID": 10307, "CategoryTitle": "已完成", "CategoryCode": "Finished" }];

data.types = {};
data.codes = {};
for (var key in data) {
    if (data.hasOwnProperty(key)) {
        var eles = data[key];
        var types = {};
        var codes = {};
        data.types[key] = types;
        data.codes[key] = codes;
        for (var i = 0; i < eles.length; i++) {
            types[eles[i].CategoryCode] = eles[i].CategoryID;
            codes[eles[i].CategoryID] = eles[i].CategoryCode;
        }
    }
}

/* harmony default export */ __webpack_exports__["a"] = (data);

/***/ }),
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */
/***/ (function(module, exports) {

module.exports = Vue;

/***/ }),
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */
/***/ (function(module, exports) {

module.exports = moment;

/***/ }),
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);

var utils = {};
utils.extend = function (obj, ext) {
    for (var key in obj) {
        if (obj.hasOwnProperty(key) && obj[key]) {
            ext[key] = obj[key];
        }
    }
    return ext;
};
utils.clone = function (obj) {
    var o;
    switch (typeof obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(obj)) {
        case 'undefined':
            break;
        case 'string':
            o = obj + '';
            break;
        case 'number':
            o = obj - 0;
            break;
        case 'boolean':
            o = obj;
            break;
        case 'object':
            if (obj === null) {
                o = null;
            } else {
                if (obj instanceof Array) {
                    o = [];
                    for (var i = 0, len = obj.length; i < len; i++) {
                        o.push(utils.clone(obj[i]));
                    }
                } else {
                    o = {};
                    for (var k in obj) {
                        o[k] = utils.clone(obj[k]);
                    }
                }
            }
            break;
        default:
            o = obj;
            break;
    }
    return o;
};

/* harmony default export */ __webpack_exports__["a"] = (utils);

/***/ }),
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_categorys_js__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__apis_config_js__ = __webpack_require__(1);





__WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter('ToDateTime', function (value) {
    return __WEBPACK_IMPORTED_MODULE_1_moment___default()(value).format("YYYY-MM-DD HH:mm:ss");
});
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter('ToShortDateTime', function (value) {
    return __WEBPACK_IMPORTED_MODULE_1_moment___default()(value).format("YYYY-MM-DD HH:mm");
});
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter('ToSimpleDateTime', function (value) {
    return __WEBPACK_IMPORTED_MODULE_1_moment___default()(value).format("YY-MM-DD HH:mm");
});
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter('ToMonth', function (value) {
    return __WEBPACK_IMPORTED_MODULE_1_moment___default()(value).format("MM月DD日 HH:mm");
});
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter('ToDate', function (value) {
    return __WEBPACK_IMPORTED_MODULE_1_moment___default()(value).format("YYYY-MM-DD");
});
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter('ToMonthDay', function (value) {
    return __WEBPACK_IMPORTED_MODULE_1_moment___default()(value).format("MM-DD");
});
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter('ToTime', function (value) {
    return __WEBPACK_IMPORTED_MODULE_1_moment___default()(value).format("HH:mm");
});
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter('ToMonthTime', function (value) {
    return __WEBPACK_IMPORTED_MODULE_1_moment___default()(value).format("MM-DD HH:mm");
});
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter('DateFormat', function (value, DateFormat) {
    return __WEBPACK_IMPORTED_MODULE_1_moment___default()(value).format(DateFormat);
});
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter('DiffTime', function (value, end, unit) {
    var startDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()(value);
    var endDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()(end);
    var diffDate = endDate.diff(startDate);
    var dayS = 1000 * 60 * 60 * 24;

    var times = __WEBPACK_IMPORTED_MODULE_1_moment___default.a.utc(diffDate % dayS).format("HH:mm");
    var howDay = parseInt(diffDate / dayS);
    if (howDay > 0) {
        return howDay + "d " + times;
    } else {
        return times;
    }
});

__WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter('ToImgUrl', function (value) {
    var url = __WEBPACK_IMPORTED_MODULE_3__apis_config_js__["a" /* default */].getUrl("fileUrl", "");
    url = url.substring(0, url.length - 1);
    if (value.indexOf('/') == 0) {
        return url + value;
    }
    return value;
});

function mapCategory(value, categoryName) {
    var category = _.find(__WEBPACK_IMPORTED_MODULE_2__utils_categorys_js__["a" /* default */][categoryName], function (o) {
        return o.CategoryID == value;
    });
    if (category != null) {
        return category;
    }
    return {};
}
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter('mapName', function (value, categoryName, defaultResult) {
    var category = mapCategory(value, categoryName);
    var mapResult = category["CategoryName"];
    if (mapResult) {
        return mapResult;
    }
    return defaultResult || value;
});
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter('mapCode', function (value, categoryName) {
    var category = mapCategory(value, categoryName);
    var mapResult = category["CategoryCode"];
    if (mapResult) {
        return mapResult;
    }
    return value;
});
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter('mapTitle', function (value, categoryName, defaultResult) {
    var category = mapCategory(value, categoryName);
    var mapResult = category["CategoryTitle"];
    if (mapResult) {
        return mapResult;
    }
    return defaultResult || value;
});
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter('CategoryTitle', function (value, categoryName) {
    var category = mapCategory(value, categoryName);
    var mapResult = category["CategoryTitle"];
    if (mapResult) {
        return mapResult;
    }
    return value;
});
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter('ToWeek', function (value) {
    var lang = window.localStorage.getItem('lang');
    if (lang == 'en') {
        __WEBPACK_IMPORTED_MODULE_1_moment___default.a.lang('en', {
            weekdays: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
        });
    } else {
        __WEBPACK_IMPORTED_MODULE_1_moment___default.a.lang('cn', {
            weekdays: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"]
        });
    }
    return __WEBPACK_IMPORTED_MODULE_1_moment___default()(value).format('dddd');
});
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter('TrainCodes', function (value) {
    return value.replace(/,/g, '');
});
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter('filterSeatType', function (value) {
    switch (value) {
        case 'edz':
            return value = '二等座';
        case 'ydz':
            return value = '一等座';
        case 'tdz':
            return value = '特等座';
        case 'swz':
            return '商务座';
        case 'rw':
            return value = '软卧';
        case 'dw':
            return value = '动卧';

        case 'yw':
            return value = '硬卧';
        case 'yz':
            return value = '硬座';

    }
});
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter('arriveDate', function (value) {
    switch (value) {
        case 0:
            return value = '当日到达';
        case 1:
            return value = '次日到达';
        case 2:
            return value = '第二日到达';
        case 3:
            return '第三日到达';
        case 4:
            return value = '第四日到达';
        case 5:
            return value = '第五日到达';
        case 6:
            return value = '第六日到达';
        case 7:
            return value = '第七日到达';
        case 8:
            return value = '第八日到达';
    }
});
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter('filterLine', function (value) {
    if (value != undefined) {
        return value.replace(/\\n/g, '');
    }
});
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter('filterImgFile', function (value) {
    return value.split('/').pop();
});
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter('default', function (value, defaultValue) {
    if (value && /[^\s]/.test(value)) {
        return value;
    }
    return defaultValue;
});
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter('DurationTime', function (value) {
    var Hours = parseInt(value / 60);
    var minutes = value % 60;
    return Hours + 'h' + minutes + 'm';
});

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);


var _order, _system, _mall, _webdata, _category;

/* harmony default export */ __webpack_exports__["a"] = ({
  statistics: {
    servicetype: "服务类型",
    search: "查询",
    exportfile: "导出",
    submit: "提交",
    createdate: "创建日期",
    orderno: "订单号",
    businestype: "业务类型",
    payment: "应付(含保险、服务费)",
    insufee: "保险费",
    servicefee: "服务费",
    productname: "产品名称",
    total: "合计",
    departmentname: "部门名称",
    selectdepart: "请选择部门",
    costcenter: "成本中心",
    expenseDepartment: "费用负担部门",
    selectcostcenter: "请选择成本中心",
    selectExpenseDepartment: "请选择费用负担部门",
    projectcode: "项目代码",
    startdate: "开始日期",
    enddate: "截止日期",
    paytotalmoney: "消费总额",
    avgticketprice: "平均票价",
    avgroomfee: "平均房费",
    avgdiscount: "平均折扣",
    breakbtrip: "违背政策",
    advdayinfo: "提前预订天数情况",
    day: "天",
    departpaysort: "各部门消费排名",
    costpaysort: "各成本中心排名",
    expenseDepartmentRanking: "各费用负担部门排名",
    projectcodepaysort: "各项目代码排名",
    arrpaysort: "各目的地排名",
    tonglist: "统计列表",
    tongview: "统计视图"
  },
  order: (_order = {
    ordertip: "您可以在线查看近一年的订单。如果需询看更久之前的订单，请致电：400-088-8020（免长话费）。",
    allorder: "所有订单",
    startdate: "开始日期",
    endadte: "结束日期",
    orderstatus: "订单状态",
    ordertype: "订单类型",
    searchkey: "输入商品名称或订单号进行搜索",
    search: "查询",
    number: "数量",
    orderdetail: "订单详情",
    ordertotalmoney: "订单总额",
    dealoperation: "交易操作",
    submit: "立即提交",
    approval: "立即审批",
    payment: "立即支付",
    createorder: "再次下单",
    oldsystem: "老系统",
    rejectReason: "审批备注",
    reapproval: "审批拒绝",
    approvalsucc: "审批通过",
    selectvoy: "请选择您需要退票的航程！",
    selectpass: "请选择您需要退票的旅客！",
    selectreason: "请选择您需要退票的理由！",
    amendsucc: "退票申请提交成功",
    flightchange: "机票改签",
    selectchangepass: "需要改签的旅客",
    oldvoyageinfo: "原航班信息",
    selectedflight: "已选航班",
    policyok: "符合规则",
    policyno: "违背规则",
    build: "机建",
    fuel: "燃油",
    changeflight: "修改航班",
    flightlist: "航班列表",
    changefee: "改签费用",
    changefeetip: "以下费用仅供参考，如有疑问请拨打客服电话",
    changefeeabout: "预计改签费(改签预订)",
    upcabinfeeabout: "预计升舱费",
    changeservicefee: "改签服务费",
    totalfee: "合计",
    changereason: "改签原因",
    changedetreason: "请输入改签详细原因(可不填)",
    back: "<<返回",
    submitapply: "提交申请"
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "selectchangepass", "请选择旅客！"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "flightsearchfail", "未查询到符合条件的航班信息！"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "flightchangereason", "请选择改签原因"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "losesource", "Please check flights"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "flightchangesucc", "改签申请提交成功！"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "orderdetail", "订单信息"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "voyageinfo", "行程信息"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "flightpass", "出游人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "contactpeople", "联系人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "costcenter", "成本中心"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "expenseDepartment", "费用负担部门"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "policynoreason", "违背政策原因"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "demandremark", "需求备注"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "fujianxinxi", "附件信息"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "btripinfo", "商旅信息"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "procode", "项目代码"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "btripaim", "差旅目的"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "btripMatter", "出差事由"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "approvalstatus", "审批状态"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "violate", "违背了"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "policydetail", "的政策"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "vioreason", "违背原因"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "reasondetail", "详细原因"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "order", "订单"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "bookingdate", "预订日期"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "orderid", "订单编号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "oldorderid", "原始订单号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "bookingway", "预订方式"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "paymentway", "支付方式"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "totalmoney", "总金额"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "submitorder", "提交订单"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "cancelorder", "取消订单"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "ordervoyage", "行程"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "realtake", "实际乘坐"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "share", "共享"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "orderchange", "我要改签"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "orderamend", "我要退票"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "departcity", "出发城市"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "arrivecity", "到达城市"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "departdate", "出发时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "arrivedate", "到达时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "hotelname", "酒店名称"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "hotelphone", "酒店电话"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "hoteladdress", "酒店地址"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "roomtype", "房间类型"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "cityname", "城市名称"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "arrivedate", "入住日期"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "departdate", "离店日期"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "startstation", "始发车站"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "endstation", "到达车站"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "seattype", "座位类型"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "tourpeople", "出游人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "sequence", "序号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "name", "姓名"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "cardno", "证件号码"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "birthday", "出生日期"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "phoneno", "手机号码"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "invoiceinfo", "凭证信息"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "invoiceid", "凭证编码"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "passname", "旅客名称"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "invoiceno", "凭证号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "seatno", "座位号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "tradeinfo", "交易信息"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "tradepeople", "交易人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "tradeway", "交易方式"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "tradetype", "交易类型"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "trademoney", "交易金额"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "createtime", "创建时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "email", "邮箱"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "phone", "手机"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "applyamend", "退票申请"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "selectordervoyage", "选择行程"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "selectorderpass", "选择旅客"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "selectorderreason", "选择原因"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "cancel", "取 消"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "changeapply", "改签申请"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "adultticket", "成人票"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "amendfee", "退票费"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "samechangefee", "同舱改期费"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "changecondition", "签转条件"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "changeadopt", "允许转签"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "people", "人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "completechange", "已变更完成"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "reimburseinfo", "报销信息"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "travleorderinfo", "可提供全额行程单"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "bagkg", "行李额"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "forfeebagkg", "免费托运行李额20KG"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "loading", "加载中......"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "endststion", "到达车站"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "waitapprove", "待审批"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "changeamendrule", "退改规则"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "trainamendrule", "对开车前8天(不含)以上退票的，不收取退票费。票面乘车站开车前48小时以上的，退票时收取票价5%的退票费;开车前24小时以上、不足48小时的，退票时收取票价10%的退票费;开车前不足24小时的，退票时收取票价20%退票费。"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "touramendrule", "已签订合同为准"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "selectPassengersChange", "请选择需要改签的旅客"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "fillFlight", "填写航班信息"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "depart", "出发"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "arrive", "到达"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "date", "日期"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "changereason", "请输入改签原因"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "dueTo", "预订于"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "for", "为"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "ChangeTo", "改签于"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "WasteBack", "退废于"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "ExpectedRefundFee", "预计退票费"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "reasonRejection", "请输入拒绝原因"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "ordeCancel", "订单取消"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "isCancel", "是否确认取消订单"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "confirm", "确 定"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "BusinessType", "业务类型"), _order),
  system: (_system = {
    clear: "清除",
    combtripmemberlogin: "企业商旅会员登录",
    lchbtrip: "力程商旅",
    simple: "越简单",
    free: "越自由",
    lowermoney: "越省钱",
    prebtrip: "完美的差旅服务",
    unyouneed: "理解您的需求",
    servicenotime: "服务全面无时差",
    costcenlower: "差旅成本直降30%",
    peoplecenter: "个人中心",
    ri: "日",
    trtavleregtips: "金额为0表示不限制金额,机票舱位火车座位勾选为可用",
    firstcity: "一级城市",
    seccity: "二级城市",
    thrcity: "三级城市",
    none: "无",
    allmoney: "全价",
    discountdown: "折以下",
    deletefiletips: "确认执行删除操作？",
    tips: "提示",
    cancel: "取消",
    usericon: "头像",
    uploadusericon: "头像上传",
    changusericon: "头像更换",
    bangemail: "绑定邮箱",
    bangphone: "绑定手机号",
    orderid: "订单编号",
    ordervoyageinfo: "行程信息",
    bookingdate: "预订日期",
    orderstatus: "订单状态",
    bookinguser: "预订人",
    btriprule: "差旅规则",
    btripaim: "差旅目的",
    policyreason: "政策原因",
    bookinginfo: "预订须知",
    btripflow: "差旅审批",
    search: "查询",
    add: "添加",
    name: "名称",
    number: "编号",
    servicetype: "服务类型",
    chinese: "中文",
    english: "英文",
    operation: "操作",
    copy: "复制",
    update: "修改",
    delete: "删除",
    delsucc: "删除成功",
    inputcontent: "请输入内容",
    selectcustomers: "选择客户",
    zhdescribe: "中文描述",
    rule: "规则",
    ruleid: "规则编号",
    rulename: "规则名称",
    travelregulations: "差旅管控规则",
    endescribe: "英文描述",
    btripflowname: "差旅审批名称",
    btripflowrule: "差旅审批规则",
    selectbtriprule: "选择差旅规则",
    selectbtripflow: "选择审批流程",
    needflow: "差旅审批配置",
    roleapplybtrip: "规则适用角色",
    departrole: "部门角色",
    jobrole: "职位角色",
    employeeandcustomer: "员工常客",
    btripflowid: "差旅审批编号",
    btriprulename: "差旅规则名称",
    approvalfloename: "审批流程名称",
    flowid: "流程编号",
    back: "<< 返回",
    save: "保存",
    savesucc: "保存成功",
    operlogs: "操作日志",
    addsucc: "添加成功",
    updatesucc: "修改成功",
    businessname: "企业名称",
    businessmanage: "企业管理",
    servicemanage: "服务管理",
    reportsmanage: "报表管理",
    pleaseselect: "请选择",
    pleasewrite: "请填写",
    companyinfo: "公司信息",
    companyname: "公司名称",
    city: "城市",
    profession: "行业",
    contactname: "联系人姓名",
    selectcycle: "请选择周期",
    selectdate: "请选择日期",
    selecttrade: "请选择交易",
    phonenoerror: "手机格式错误",
    emailerror: "邮编格式错误",
    contactnameerror: "收件人名称不能为空",
    deliverymanage: "配送管理",
    addcontact: "新增地址",
    contactpeople: "收货人",
    address: "详细地址",
    remark: "备注",
    postcode: "邮政编码",
    contactphone: "联系手机",
    contactnickname: "地址简称",
    contactemail: "联系邮箱",
    defaultaddress: "默认地址",
    setdefaultaddress: "设为默认",
    addressinfo: "地址信息",
    peoplemanage: "个人管理",
    lasterorder: "近期订单",
    voyagesdate: "行程日历",
    voyagesremark: "行程备注",
    welcomelogin: "欢迎登陆",
    login: "登录",
    registernow: "企业注册",
    register: "注册",
    loginbyaccount: "账号密码登录",
    loginbyphone: "手机动态码登录",
    loginbyother: "您还可以使用以下方式登录",
    wechat: "微信",
    pleaseinputvalcode: "请输入验证码",
    loginredittips: "秒后将跳转到主页......",
    accountinfo: "账户信息",
    peopleregister: "个人用户",
    companyregister: "企业客户注册",
    kefucenter: "客服中心",
    loginout: "退出",
    account: "账号",
    pwd: "密码",
    pwdtips: "请输入密码",
    forgetpassword: "忘记密码?",
    saveloginstats: "记住登录状态",
    accounttips: "请输入手机号码或邮箱",
    password: "登录密码",
    passwordtips: "请输入8~16位",
    passwordfirstlevel: "弱",
    passwordfirstleveltips: "包含英文字母和数字",
    passwordsecleveltips: "包含英文字母、数字和特殊符号",
    passwordseclevel: "中",
    passwordlastleveltips: "包含大小写英文字母、数字和特殊符号",
    passwordlastlevel: "强",
    confirmpassword: "确认密码",
    validecode: "验证码",
    validecodeignorecase: "不区分大小写",
    changevalidecode: "换一张",
    dynavalidecode: "动态验证码",
    dynavalidecodetips: "请输入动态验证码",
    loginedregistertips: "你已登录力程商旅账户，若要注册个人账户请先退出!",
    agreeprotocol: "同意《服务协议》",
    reset: "重置",
    registeproblem: "注册遇到问题？",
    inputpwdagain: "请再次输入密码",
    notsamepwd: "两次输入密码不一致!",
    emailaccounttips: "发送邮箱验证码",
    phoneaccounttips: "发送手机验证码",
    sendvalidecode: "发送验证码",
    registersucc: "注册成功",
    registersucctips: "注册成功,请登录",
    companyaccounttips: "该账号已是公司账号,若要注册公司账号,请退出重新注册",
    codesendtips: "已发送",
    codeagain: "获取验证码",
    resetaccountback: "返回上一步",
    resetaccountfirst: "填写账号",
    resetaccountsec: "身份验证",
    resetaccountthr: "设置新密码",
    resetaccountlast: "完成",
    submit: "提交",
    resetphoneaccounttips: "您可以通过有效的绑定手机重置登录密码。",
    resetaccountbyphone: "手机验证重置",
    resetemailaccounttips: "您可以通过有效的绑定邮箱重置登录密码。",
    resetaccountbyemail: "邮箱验证重置",
    resetpwdbyvalide: "验证重置登录密码",
    sendresetpwdcodetips: "力程网已向您绑定的(手机或邮箱)发送了验证码，请查看并输入校验码。",
    resetpwdcodename: "您收到的校验码",
    confirm: "确定",
    invoiceinfo: "",
    yes: "是",
    no: "否",
    invoicemanage: "发票管理",
    invoicerole: "发票角色",
    invoicetype: "发票类型",
    invoicename: "发票抬头",
    identifynumber: "纳税人识别号",
    invoicebankname: "开户银行名称",
    invoicebankaccount: "开户银行账号",
    invoicecompanyadsress: "注册地址",
    invoicecompanyphone: "注册电话",
    invoicelistlefttitle: "已保存",
    invoicelistrighttitle: "条地址",
    updatedate: "修改数据",
    invoicetypetips: "请选择发票类型",
    invoicenametips: "请输入发票抬头",
    identifynumbertips: "请输入纳税人识别号",
    invoicebanknametips: "请输入开户银行名称",
    invoicebankaccounttips: "请输入开户银行账号",
    invoicecompanyadsresstips: "请输入注册地址",
    invoicecompanyphonetips: "请输入注册电话",
    messagetemplatelist: "短信模板列表",
    messagename: "短信名称",
    messagetype: "短信类型",
    messagetemplatename: "短信模板名称",
    messagetemplatetype: "短信模板类型",
    messagetemplatecontent: "短信模板内容",
    updateuser: "修改人",
    disables: "禁用",
    enable: "启用",
    managesetting: "管理设置",
    messagetemplatestatus: "状态",
    addmessagetemplate: "短信模板修改",
    username: "姓     名",
    cardno: "证件号码",
    cardvaliditydate: "有效日期",
    cardincountry: "发证机构",
    cardimg: "证件图片",
    reproveimg: "正面图片",
    deleteimg: "删除图片",
    reverseimg: "反面图片",
    uploadimg: "上传图片"
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "companyinfo", "基本信息"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "cardinfo", "证件信息"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "contactinfo", "联系信息"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "customermanage", "客户经理"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "companyname", "公司名称"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "companynickname", "公司简称"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "englishcompanyname", "英文名称"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "companyemail", "公司邮箱"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "companyaddress", "公司地址"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "companytype", "公司类型"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "capitaltype", "资本类型"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "companysize", "公司规模"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "companyprofession", "从事行业"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "companyremark", "备注信息"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "rolecontactpeople", "联系人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "rolecontactpeoplename", "联系人名称"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "importcontact", "地址导入"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "phoneareacode", "手机区号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "contactaddress", "联系地址"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "province", "省份"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "city", "城市"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "district", "县区"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "changecompanypeopletips", "提示：接管人接收公司权限后，你将不再具备管理员权限"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "companypeople", "接管人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "regularcard", "常客卡"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "regularcardno", "卡号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "disclaimer", "免责"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "fullname", "全称"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "nickname", "简称"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "sex", "性别"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "country", "国籍"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "name", "名称"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "charge", "主管"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "selectcharge", "选择主管"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "companyorgan", "组织结构"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "actionupdatetips", "若不需要设置权限，可以点击保存进入下一步设置,"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "roleaction", "角色权限"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "allemployee", "所有员工"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "roleemployee", "所属员工"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "roleemployeetips", "此员工已在当前部门"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "setmanage", "配置管理"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "workcity", "工作城市"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "workjob", "工作职务"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "workname", "工作用名"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "worktime", "工作时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "workdatarang", "查看范围"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "birthday", "出生日期"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "list", "列表"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "createtime", "创建时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "startdate", "开始日期"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "enddate", "结束日期"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "sequence", "序号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "supername", "上级名称"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "updatetime", "修改日期"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "detail", "详细"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "setting", "配置"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "serviceinfo", "服务信息"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "servicename", "服务名称"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "publishname", "发布名称"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "applyarea", "适用区域"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "servicepublic", "是否公开"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "publishservice", "发布服务"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "publishedservice", "服务已发布"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "advancetime", "提前预订时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "workperiod", "周期"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "publishsave", "确认发布"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "servicefarelist", "服务费列表"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "servicefarename", "服务费名称"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "servicefareid", "服务费编号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "companyid", "公司编号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "servicefarestatus", "服务费状态"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "policystatus", "政策状态"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "customername", "客户名称"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "bookingway", "预订方式"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "workingtime", "工作时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "servicefarebyworkingtime", "是否按照工作时间计算"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "money", "元"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "other", "其他"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "fare", "费用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "roles", "角色"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "jobs", "职称"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "departments", "部门"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "companys", "公司"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "customers", "级别"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "role", "角色"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "job", "职称"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "employee", "员工"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "user", "用户"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "guest", "常客"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "customer", "客户"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "costcenters", "成本中心"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "expenseDepartments", "费用负担部门"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "flowid", "流程编号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "flowname", "流程名称"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "flowmanage", "流程管理"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "dealpeople", "处理人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "up", "上移"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "down", "下移"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "langsetting", "语言设置"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "english", "英文"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "japan", "日文"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "china", "中文"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "opened", "已开通"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "closed", "未开通"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "expired", "已过期"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "disable", "已禁止"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "systemsafe", "安全设置"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "downloadtemplate", "下载模板"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "PermissionEmployees", "权限员工"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "GrantDate", "授予日期"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "ExpirationDate", "过期日期"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "saveInfo", "保存信息"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "approvalList", "审批列表"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "StaffName", "员工名称"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "detail", "详情"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "CompanyPage", "公司主页"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "selectCityAgain", "请再选择城市"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "ChooseShipCompany", "选择航司"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "FutureGenerations", "全选"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "TheSelected", "反选"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "QuickFindSelection", "快速查找选择:在此处支持输入多个航司 使用/分割 按Ctrl+Enter键选中"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "shipCompany", "适用航司"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "shipSpace", "选择舱位"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "applySpace", "适用舱位"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "AsOfTheDate", "截止日期"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "AddLevel", "添加级别"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "LevelNames", "级别名称"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "LevelCode", "级别代码"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "RetentionSet", "留扣设置和客户配置"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "LeaveSome", "留点"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "keepMoney", "留钱"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "ServiceLevelAdd", "服务级别添加"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "ProductCategory", "产品类别"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "SubscribeCustomer", "订阅客户"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "SaveButtonSet", "留扣设置"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "localChineseName", "请输入地区中文名称"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "localEnglishName", "请输入地区英文名称"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "PreviewPicture", "图片预览"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "keywordsFilter", "输入关键字进行过滤"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "DataIntegrity", "资料完整度"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "PerfectInformation", "完善资料"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "AuthorizationState", "授权状态"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "accountNumber", "请输入账号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "DynamicCode", "动态码"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "congratulations", "恭喜"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "ClickNoResponse", "正在跳转至力程商旅平台，6秒内无反应，请点击"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "Here", "这里"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "PasswordChangedSucc", "修改密码成功"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "selectParentDirectory", "请选择上级目录"), _system),
  mall: (_mall = {
    one: "一",
    two: "二",
    three: "三",
    four: "四",
    five: "五",
    six: "六",
    seven: "七",
    eight: "八",
    nine: "九",
    ten: "十",
    contactUs: "联系我们",
    adequateTxt: "充足",
    sheet: "张",
    Remaining: "仅剩",
    ReElectionFlight: "重选航班",
    TaxExclusive: "不含税",
    notificationMessageFlight: "通知：若有需要，可点此进入国际需求单，更多更低价国际机票。满足您的任何差旅需求也可致电：",
    Hotline: "热线咨询。",
    EnfantYears: "2-14岁",
    InfantYears: "两岁以下",
    budget: "经费预算",
    Mylicheng: "我的力程",
    SupportChinese: "支持中文/拼音/简拼输入",
    SupportCode: "支持中文/拼音/简拼/城市代码输入",
    hotCity: "热门城市",
    attendance: "参会人数",
    hostPlace: "举办地点",
    activityBudget: "活动预算",
    PartyNumber: "参加人数",
    internationalHotel: "国际酒店需求单",
    pay: "付",
    NextPage: "下一页",
    PreviousPage: "上一页",
    selected: "已选",
    data: "数据",
    strip: "条",
    paginal: "每页",
    page: "页",
    AuxiliaryWord: "第",
    searchName: "输入名称搜索(点击右侧按钮可添加为临客)",
    keywordsPlaceholder: "输入关键字进行搜索",
    selectName: "选中名称",
    Station: "经停站点",
    TotalAmount: "应付总额",
    checkIn: "入住",
    Broadband: "宽带",
    AttentionPlease: "(特别提醒：请填写违背原因，以便更好的通过审核)",
    TripAgainst: "行程违背了",
    DetailReason: "详情原因",
    ContraryReason: "违背原因",
    Sex: "旅客性别",
    Nationality: "国籍",
    Birthdate: "出生日期",
    Mobile: "联系号码",
    ID: "证件信息",
    PassengerName: "旅客姓名",
    Policy: "差标",
    price: "价格",
    BedType: "床型",
    Window: "窗型",
    ViewsMore: "查看更多",
    durationTime: "历时",
    flightInfo: "航班信息",
    next: "下一步",
    destination: "目的地",
    NoTrainSearch: "当前时段不提供车次查询服务",
    selectedconsumer: "已选旅客",
    btripflow: "差旅审批",
    bookingcenter: "预订中心",
    demandorder: "需求订单",
    selectcompany: "公司选择",
    costcenter: "成本中心",
    expenseDepartment: "费用负担部门",
    approvalpolicy: "审批政策",
    bookinguser: "预订员工",
    pleaseselect: "请选择",
    bookingsearch: "查询预订",
    btripaim: "差旅目的",
    budgetCode: "预算编码",
    budgetIntro: "预算描述",
    projectcode: "项目代码",
    bookingtype: "因公因私",
    applyarea: "适用区域",
    serviceset: "服务费配置",
    flowinfo: "审批流程",
    name: "名称",
    flowname: "审批人信息",
    btriprule: "差旅规则",
    priority: "协议优先",
    pricelimit: "价格限制",
    bookinginfo: "预订须知",
    zhtips: "中文提示",
    entips: "英文提示",
    updateorder: "修改订单",
    submitorder: "提交订单",
    tourpasstips: "旅游订单不支持此乘客类型",
    createsucc: "订单创建成功",
    orderapprovalsucc: "订单审核成功",
    pnr: "编码导入",
    flightno: "航班号",
    flightdate: "航班日期",
    airportinfo: "机场信息",
    cabin: "舱位",
    realflight: "实际承运",
    depairportcode: "出发机场三字码",
    arrairportcode: "到达机场三字码",
    hotelname: "酒店名称",
    hotelphone: "酒店电话",
    hoteladdress: "酒店地址",
    hotelarrivedate: "入住日期",
    hoteldepartdate: "离开日期",
    hotelamenddate: "退房日期",
    roomnum: "房间数量",
    roomtype: "房间类型",
    roombedtype: "房间床型",
    breakfast: "早餐",
    consumerDate: "入住时间",
    finishedDate: "离店时间",
    changeamendrule: "退改规则",
    aimcity: "目的城市",
    selectdate: "选择日期",
    keywords: "关键词",
    hotelkeywords: "(选项)酒店名/地标/商圈",
    search: "查询",
    qi: "起",
    searchdetail: "查看详情",
    notReserve: "无可预订房型",
    traffmap: "交通地图",
    sheetzone: "周边街景",
    btripno: "违背规则",
    btripyes: "符合规则",
    room: "房间",
    spec: "平米",
    live: "可住",
    floor: "楼层",
    layer: "层",
    productname: "产品名称",
    averagerate: "日均价",
    breakfastInfos: "餐食信息",
    breakfastyes: "含早",
    breakfastno: "不含早",
    cancelno: "不可取消",
    timecancel: "限时取消",
    plenty: "充足",
    select: "选择",
    hotelfacilities: "酒店设施",
    wifi: "网络连接",
    none: "无",
    parking: "停车场",
    allfacilities: "通用设施",
    activefacilities: "活动设施",
    serviceproject: "服务项目",
    hotelpolicy: "酒店政策",
    depandarr: "入住和离店",
    chdpolicy: "儿童政策",
    mealment: "膳食安排",
    apartment: "公寓",
    theinn: "客栈",
    familyhotel: "家庭旅馆",
    youthhostel: "青年旅舍",
    coupleshotel: "情侣酒店",
    gardencourtyard: "园林庭院",
    seaview: "海景",
    generated: "农家乐",
    hotspringshotel: "温泉酒店",
    golfhotel: "高尔夫酒店",
    siheyuan: "四合院",
    villa: "别墅",
    cookingdinnerparty: "聚会做饭",
    businesstriphome: "商旅之家",
    recreationalfeeling: "休闲情调",
    hospital: "看病就医",
    holidayleisure: "度假休闲",
    traininglearn: "培训学习",
    party: "聚会",
    honeymoontrip: "蜜月出行",
    boutiquehotel: "精品酒店",
    indoorswimmingpool: "室内游泳池",
    outdoorswimmingpool: "室外游泳池",
    gym: "健身房",
    businesscenter: "商务中心",
    meetingroom: "会议室",
    hotelrestaurant: "酒店餐厅",
    wakeupcall: "叫醒服务",
    luggage: "行李寄存",
    doublebed: "双床",
    bigbed: "大床",
    pickupservice: "接机服务",
    pet: "宠物",
    creditcard: "信用卡",
    username: "姓名",
    usersex: "性别",
    PassengerType: "旅客类型",
    cardtype: "证件类型",
    cardno: "证件号码",
    contactphone: "联系电话",
    birthday: "出生日期",
    usercountry: "国籍",
    cardvaliditydate: "证件有效期",
    add: "添加",
    delete: "删除",
    passselect: "选择旅客",
    contactpeople: "联系名称",
    contactemail: "联系邮箱",
    salesprice: "销售价",
    marketprice: "市场价",
    supplyprice: "结算价",
    tourdepcity: "出发地",
    tourarrcity: "目的地",
    teamno: "团号",
    tourdepdate: "出游日期",
    remark: "备注",
    traininfo: "车次信息",
    trainno: "车次号码",
    trainseattype: "座位等级",
    traindepdatetime: "发车时间",
    trainarrdatetime: "到达时间",
    traindepdate: "出发日期",
    amendtime: "退改签时限",
    moneysourceairway: "以航空公司最新规定为准，可咨询客服电话",
    amendruletips: "以上成人退改签规则及费用标准，仅供参考，实际需以航司为准",
    adultticket: "成人票",
    amendfee: "退票费",
    samechangefee: "同舱改期费",
    changecondition: "签转条件",
    changeadopt: "允许转签",
    people: "人",
    completechange: "已变更完成",
    reimburseinfo: "报销信息",
    travleorderinfo: "可提供全额行程单",
    travleinvoince: "提供差额发票和行程单",
    bagkg: "行李额",
    forfeebagkg: "免费托运行李额20KG",
    realtake: "实际乘坐",
    realtaketips: "请按实际乘坐航班办理值机。",
    share: "共享",
    airplanemodel: "机型",
    isstop: "经停",
    allprice: "全价",
    discount: "折",
    protocolprice: "商务推荐",
    build: "机建",
    fuel: "燃油",
    booking: "预订",
    flightok: "确定",
    allprices: "更多价格",
    flightnum: "张",
    flightnumtips: "仅剩",
    flightgo: "去程",
    flightback: "回程",
    flightdetail: "航班详情",
    totalmoney: "总金额",
    flightticket: "国内机票",
    iflightticket: "国际机票",
    screening: "筛选条件",
    clear: "清空",
    flightvuelo: "直飞/中转",
    flightdeptimes: "起飞时段",
    airways: "航空公司",
    depairport: "起飞机场",
    arriveairport: "到达机场",
    checkflightgo: "已选去程",
    changeflight: "修改航班",
    flightlisttips: "条航班信息",
    flightdeptime: "起飞时间",
    flightarrtime: "到达时间",
    flightprice: "价格",
    nostop: "直飞",
    transfer: "中转{city}（等待：{time}）",
    TransferVoyage: "中转",
    NostopOrTransfer: "直飞/中转",
    ShareFlight: "共享航班",
    HideShareFlight: "隐藏共享航班",
    am: "上午",
    noon: "中午",
    pm: "下午",
    firstcabin: "头等舱",
    businesscabin: "商务舱",
    economycabin: "经济舱",
    createflightorder: "确认，下一步",
    loading: "加载中......",
    flightpricechange: "航班价格有变动请确认后下单！",
    tips: "提示",
    confirm: "确认",
    flightbookingtitel: "我的力程",
    flightbooking: "机票预订",
    orderdetail: "订单信息",
    contactinfo: "联系人信息",
    taketicketway: "取票方式",
    departcity: "出发城市",
    arrivecity: "到达城市",
    departdate: "出发时间",
    arrivedate: "到达时间",
    backdate: "返程时间",
    loginuser: "当前用户",
    priceway: "报价方式",
    pricestips: "本页面提供的机票为净价,不含服务费。",
    firtransfer: "1程中转",
    sectransfer: "2程中转及以上",
    transfercitys: "中转城市",
    economy: "经济舱",
    business: "商务舱",
    first: "头等舱",
    premiumecon: "超级经济舱",
    premiumebus: "超级商务舱",
    premiumefirst: "超级头等舱",
    iflightcitytips: "请选择国际城市！",
    approvalSelectCitytips: "起飞到达城市要有一项所属审批单航程！",
    approvalDepartDatetips: "出发日期要符合审批单日期区间！",
    approvalArriveDatetips: "出发/返程日期要符合审批单日期区间！",
    approvalSelectHotelCitytips: "目的城市要所属审批单行程！",
    iflightbookingtips: "您选定的航班机票仅剩",
    policyyes: "符合规则",
    policyno: "违背规则",
    priceandtax: "含税",
    stoptime: "经停时间",
    hotel: "酒店",
    hotelpeoplenum: "入住人数",
    hoteldeskphone: "前台电话",
    hotelleveltitle: "星级从高到低排序",
    hotelpricetitle: "价格从高到低排序",
    below: "以下",
    above: "以上",
    hotelstart: "二星及以下",
    threehotelstart: "三星级/舒适",
    fourhotelstart: "四星级/高档",
    fivehotelstart: "五星级/豪华",
    position: "位置",
    nolimit: "不限",
    adminregion: "行政区",
    businesszone: "商业区",
    startlevel: "星级",
    contractHotel: "协议酒店",
    huazhuHotel: "华住酒店",
    feature: "特色",
    facilities: "设施",
    service: "服务",
    hotelcounttips: "家酒店",
    hotelcountall: "共",
    hotelinfoorstart: "酒店信息/星级",
    hotelinfo: "酒店信息",
    referprice: "参考价",
    reselect: "重新选择",
    chinahotel: "国内酒店",
    interhotel: "国际酒店",
    bookinghotel: "酒店预订",
    hotelbookinginfo: "预订信息",
    depandarrdate: "入离日期",
    night: "晚",
    insure: "保险",
    hotelroomtype: "房型",
    hotelproductcount: "更多产品",
    chinatrain: "国内火车",
    trainbooking: "火车票预订",
    trainusernametip: "姓名不能为空",
    trainusercardtip: "请完善证件信息",
    trainrecard: "身份证不能重复",
    trainseatin: "预订成功，正在占座",
    selectseatfree: "免费选座",
    selectedseat: "已选座",
    noselectseat: "未选座",
    trainwindow: "窗",
    aisie: "过道",
    trainseattips: "优先按指定坐席出票，若所选坐席无票时，将转购其他坐席",
    change: "换",
    timelength: "时长",
    trainticketnum: "余票数",
    trainchangamendinfo: "退改签说明",
    traindepandarrstation: "发/到站",
    traindepandarrtime: "发/到时间",
    trainlogin12306tip: "关联12306账号，直连铁路官方系统，出票更快速！",
    login: "登陆",
    account: "账号",
    login12306user: "12306用户名",
    login12306pwd: "请输入密码",
    loginerror: "用户名或密码错误",
    loginout: "退出",
    logintip: "已登录",
    btripinfo: "商旅信息",
    shenpipingzheng: "审批凭证",
    youshenpipingzheng: "有审批凭证",
    wushenpipingzheng: "无审批凭证",
    shenpizhuangtai: "审批状态",
    chuchaishenqingiworkyishenpi: "出差申请Iworker已审批",
    shangweishenpi: "尚未审批",
    shenpidanhao: "审批单号",
    yijishenpi: "级审批",
    shangchuanfujian: "上传附件",
    fujianliebiao: "附件列表",
    inputcontent: "请输入内容",
    btripordertip: "以下行程违背差旅政策,需补充违背原因",
    btriporderttip: "(特别提醒：请填写违背原因，以便更好的通过审核)",
    ordervoyage: "行程",
    violate: "违背了",
    policydetail: "的政策",
    policynoreason: "违背政策原因",
    policyreasondetail: "详细违背原因",
    consumerinfo: "旅客信息",
    consumernametip: "姓名，请与登机证件保持一致",
    phoneareano: "中国大陆区号",
    phonenotips: "乘机人手机号，用于接收航班动态信息",
    saveconsumer: "保存为常客",
    selectconsumer: "选择乘客",
    addconsumer: "添加乘客",
    consumertip: "重要提醒：为了确保出行，请准确填写证件号以及有效期，旅行结束日比证件到期日须至少早6个月。",
    writeinfomation: "填写说明",
    demandremark: "需求备注",
    welcomelogin: "欢迎登陆",
    registernow: "企业注册",
    loginbyaccount: "账号密码登录",
    loginbyphone: "手机动态码登录",
    loginbyother: "您还可以使用以下方式登录",
    wechat: "微信",
    addressinfo: "地址信息",
    Add: "添加",
    defaultcontact: "默认地址",
    settingdefaultcontact: "设为默认地址",
    edit: "编辑"
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "contactpeople", "联系姓名"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "contactphone", "联系手机"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "contactemail", "联系邮箱"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "adddemand", "需求录入"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "voyagetype", "航程类型"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "consumertype", "乘客类型"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "adult", "成人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "child", "儿童"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "infant", "婴儿"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "firstflightsearchtips", "乘客总数（不含婴儿）多于9人，请填写"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "flightdemandorder", "机票需求单"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "lastflightsearchtips", "进行预订。"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "firstiflightsearchtips", "每名成人最多可携带2名儿童和1名婴儿乘机，如有特殊需求，请至"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "adminregionhotel", "港澳台"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "unsubmit", "未提交"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "submited", "已提交"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "chenking", "审核中"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "paymoney", "已付款"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "etdzticket", "已出票"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "directclose", "成交"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "searchtrainbytraintype", "只搜高铁动车"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "selectfrequent", "选择常客"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "frequent", "常客"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "addtemporaryconsumer", "添加临客"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "home", "首页"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "tour", "旅游"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "train", "火车"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "flight", "机票"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "car", "租车"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "food", "美食"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "btripplateform", "差旅平台"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "comcoop", "企业合作"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "appdownload", "App下载"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "meeting", "会展"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "visa", "签证"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "tourism", "会议旅游"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "stationname", "车站名"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "trainstoptime", "停留时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "stopstationname", "经停站"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "soldout", "售完"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "start", "始"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "over", "过"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "end", "终"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "yu", "余"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "trainbatch", "车型"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "startorvoer", "始发过路"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "startstation", "始发车站"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "endstation", "到达车站"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "changeticket", "车票改签"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "pleasepasstochange", "请选择需要改签的乘客"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "pleaseselectnewdate", "请选择改签日期"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "oldtraininfo", "原车次信息"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "gctrain", "G/C高铁"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "dtrain", "D动车"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "ptrain", "普通"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "traindeptime", "出发时段"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "trainarrtime", "到达时段"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "trainstart", "始发"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "trainover", "过路"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "hour", "小时"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "minute", "分钟"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "trainchangeinfo", "改签车次信息"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "changetrain", "更改车次"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "changefee", "改签费用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "changeservicefee", "改签服务费"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "totalfee", "合计"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "changereason", "改签原因"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "checking", "待审核"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "boyin", "波音"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "kongke", "空客"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "zhuanxiangjia", "专享价"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "analysis", "旅客解析"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "contact", "联系人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "bigcus", "大客户"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "airway", "航司"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "selectcom", "请先选择公司"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "nameisetm", "旅客名称不能空"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "writenametype", "请输入正确的姓名(Chen/Wenjun)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "baoxianset", "保险配置"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "saleandcus", "销售/客服代表"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "recommendair", "推荐航班"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "more", "更多"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "hide", "隐藏"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "triprulename", "差旅政策"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "hightsearch", "高级搜索"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "cabinlevel", "舱位等级"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "submitapply", "提交申请"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "interdemand", "国际及港澳台航班需求单"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "alltotal", "共有"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "demandcus", "如有疑问，您可联系客服。我们会及时为您解决相关问题。"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "voyageinfos", "航程信息"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "addvoyage", "添加航程"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "passinfos", "乘客信息"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "passnum", "乘客人数"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "sui", "岁"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "twosui", "两岁以下"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "firstairway", "首选航空公司"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "phoneno", "手机号码"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "email", "邮箱"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "submit", "提交"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "demandprobtip", "如提交出现问题请咨询："), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "normal", "普通"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "student", "学生"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "newimmigrant", "新移民"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "worker", "劳务"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "submitordersucc", "订单提交成功"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "hotelfare", "房费"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "contservicefee", "含服务费"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "hotelinfoimp", "酒店导入"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "addhotel", "添加酒店"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "inputprice", "请输入正确的金额"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "inputpriceerror", "最大金额不能小于或等于最小金额"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "starrankdesc", "星级按推荐排序"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "starrank", "星级从高到低排序"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "starrankasc", "星级从低到高排序"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "pricesort", "价格从高到低排序"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "pricesortdesc", "价格从低到高排序"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "clickrecomend", "点击按推荐"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "caclhotelprice", "正在核算价格......"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "none", "无"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "freebroadbang", "免费宽带"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "broadband", "收费宽带"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "freewifi", "免费WIFI"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "wifi", "收费WIFI"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "imgshow", "图片显示"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "additinfos", "附加信息"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "insurinfos", "保险信息"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "surname", "姓"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "givenname", "名"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "orderpassup", "单张订单旅客上限为"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "orderpassupend", "人,需更多请联系客服！"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "cabintype", "舱位类型"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "selectcabin", "选择舱位"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "safetrip", "安心出行,"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "downloadapp", "下载力程商旅APP"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "selectchangepass", "请选择旅客！"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "searchpassup", "最多只能9个旅客！"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "selectcontact", "选择联系人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "cancel", "取消"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "tourindextip", "满足您的商旅服务需求，并致力于为商旅客户提供全方位的服务解决方案。"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "tourdetailcall", "详情咨询"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "yearmeet", "年会"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "yearmeettips", "全程跟踪服务打造最高端的企业年会"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "comyearmeet", "公司年会"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "comtourtips", "针对企业需求定制最舒适的旅游行程"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "comtour", "公司旅游"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "teambuild", "团建"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "teambuildtips", "为企业提供个性化定制户外团建服务"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "createteambuild", "团建策划"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "exhibit", "会展"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "exhibittips", "为客户提供一站式会议策划执行服务"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "comexhibit", "会务会展"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "trainordercretips", "一张订单最多添加5名乘客，如有更多人出行，请联系客服或另行下单预订。"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "trainpassrepeat", "乘客名不能重复。"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "trianorderpassup", "最多只能选择5个乘客。"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "inputpassgivenname", "请输入乘客名。"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "inputpasssurname", "请输入乘客姓。"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "trainpassseattips", "乘客人数超过选择座位数"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "aisle", "过道"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "NeedInvoice", "需要发票"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "NoInvoice", "不要发票"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "delway", "配送方式："), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "exprefee", "快递费用："), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "addresspass", "收件人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "postcode", "邮政编码"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "deladdress", "配送地址"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "inputphoneno", "请输入手机号码"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "inputphonerealno", "请输入正确的手机号码"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "inputtickettitle", "请输入发票抬头"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "inputaddresspass", "请输入收件人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "inputdeladdress", "请输入收件地址"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "Invite", "自取"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "Mail", "邮件"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "nothing", "不需要"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "parper", "纸质发票"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "tourservicefee", "旅游服务费"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "express", "快递"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "ticketfare", "票面"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "trainnamecardtips", "姓名，请与乘车证件姓名保持一致"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "phonecountry", "中国大陆区号86"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "phoneinfotips", "乘车人手机号，需要接受手机短信号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "savecuspass", "保存为常旅客"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "triprulemanage", "差旅管理"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "trainorderseat", "请为已选择的旅客选择座位"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "createordernow", "立即预订"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "parenter", "合作伙伴"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "aboutus", "关于我们"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "companyinfo", "力程商旅是中国领先的差旅管理公司，隶属于力程集团，十年来，依靠强大的资源、先进的技术、优质的服务和专业的管理，为包括120余家世界五百强和100余家中国五百强在内的6000多家中大型企业提供服务。"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "companywechat", "关注力程商旅公众号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "companyname", "力程商旅"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "simple", "越简单"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "free", "越自由"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "lowermoney", "越省钱"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "traintuiinfo", "退票说明"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "traintuiinfo1", "1：代购成功，未取票且发车前时间大于35分钟，可进入“我的订单”，点击火车订单根据提示申请退票；发车前8天以内的退票，铁路局将对每张车票按梯次收取退票手续费。"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "traintuiinfo2", "2：代购成功，已取票或发车前时间小于35分钟，需您自行携带购票时所使用的乘车人有效证件原件和火车票在发车前去火车站退票窗口办理退票。"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "trainchanginfo", "改签说明"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "trainchanginfo1", "1：未取纸质票，且离发车时间大于35分钟，可改签等于或低于原车票票价的车次。其他不能在线改签的情况需在发车前至火车站窗口办理。"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "trainchanginfo2", "2：开车前48小时以上，可改签预售期内的车次。开车前48小时以内，可改签至票面当天24：00之前任意车次，不办理票面日期次日及以后的改签"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "trainchanginfo3", "3：新车票票价低于原车票的，退还差额，对差额部分核收退票费并执行现行退票费标准。"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "datetimenotrain", "当前日期车票未开售"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "ReserveHint", "当前为非联程航班，如遇其中一程航班变动，另一程若需办理退改乘客需自行承担相应退改费用。"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "chailvguize", "差旅规则名称"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "guonei", "国内"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "guojie", "国际"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "jipiao", "机票"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "jiudianguize", "酒店规则"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "huoche", "火车"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "guize", "规则"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "zuidijiajizhun", "最低价格基准"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "wuxianzhi", "无限制"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "xiangduizuidijia", "相对最低价"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "quantianzuidijia", "全天最低价"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "shiduanzuidijia", "时段最低价"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "hangbanzuidijia", "航班最低价"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "shishihangbanguankong", "实时航班管控"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "tiqianyudingshijian", "提前预订时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "kedingcangweijibie", "可订舱位级别"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "kedingzuoweijibie", "可订座位级别"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "xieyijipiaoyouxian", "协议机票优先"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "xieyijiudianyouxian", "协议酒店优先"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "xiaofeijineshangxian", "消费金额上限"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "dangdizhusubiaozhunshangxian", "当地住宿费标准上限"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "yudingxuzhi", "预订须知"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "dingpiao", "订票"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "tuipiaochongkai", "退票重开"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "xuanweiqucheng", "选为去程"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "yes", "是"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "no", "否"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "firstcity", "1级城市"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "seccity", "2级城市"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "thrcity", "3级城市"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "within", "以内"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "qxzhsrxmdm", "请选择或输入项目代码"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "qxzxmdm", "请选择项目代码"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "weibeixiaofeijineshangxian", "消费金额上限"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "dangdizhusubiaozhun", "当地住宿费标准"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "youchuang", "有窗"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "weichuang", "无窗"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "qianmianfeiquxiao", "前免费取消，"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "zhihoubukequxiao", "之后不可取消"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "wuzao", "不含早"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "nights", "共{number}晚"), _mall),
  manage: {},
  bill: {
    bankaccount: "银行账户",
    acronym: "简称",
    select: "请选择",
    query: "查询",
    added: "添加",
    export: "导出",
    companyname: "公司名称",
    inorout: "收支类型",
    accountstatus: "账户状态",
    operation: "操作",
    enable: "启用",
    disable: "禁用",
    update: "修改",
    content: "请输入内容",
    cancel: "取消",
    save: "保存",
    confirm: "确定",
    accountadded: "账户添加",
    accountupdate: "账户修改",
    enableordisableprompt: "此操纵用于禁用或启用, 是否继续?",
    prompt: "提示",
    receivebill: "应收账期",
    bill: "账期",
    closeaccountprofit: "关账毛利",
    comparisonsales: "销量对比",
    closeaccountstarttime: "关账开始日期",
    starttime: "开始日期",
    closeaccountendtime: "关账截至日期",
    endtime: "截至日期",
    clientname: "客户名称",
    customerservicerepresentative: "客服代表",
    salesrepresentative: "销售代表",
    number: "条数",
    closeaccountprofittotel: "关账毛利合计",
    inadditioninterestprofit: "除利息后毛利",
    receiveprice: "应收金额",
    actualprofit: "实际毛利",
    profitrate: "毛利率",
    interest: "利息",
    additioninterestprofit: "利息后毛利",
    additioninterestprofitrate: "利息后毛利率",
    profitprecent: "毛利占比",
    back: "<<返回",
    Internationalflight: "国际机票",
    internalflight: "国内机票",
    Internationalhotel: "国际酒店",
    internalhotel: "国内酒店",
    internaltrain: "国内火车",
    selectyearmonth: "选择年月",
    tradebill: "交易账期",
    agreedpaystarttime: "约定结账开始日",
    agreedpayendtime: "约定结账结束日",
    billdate: "账单日期",
    billdateend: "截至日期",
    agreedpaydate: "约定结账日",
    waitoutday: "未出帐",
    waitaudited: "未审核",
    waitconfirm: "未确认",
    amountshouldbeclosed: "应结金额",
    detail: "详细",
    total: "合计",
    createtime: "创建日期",
    orderid: "订单编号",
    businesstype: "业务类型",
    servicetype: "服务类型",
    paymentincludinginsurancecharge: "应付(含服务/保险费)",
    passengername: "旅客名称",
    bookingname: "预订人",
    productname: "产品名称",
    billaggregate: "账期汇总",
    billdetail: "账期明细",
    size: "大小",
    amountreceivable: "未收金额",
    allstatus: "所有状态",
    billname: "账期名称",
    expiretime: "到期日期",
    overdueday: "逾期(天数)",
    receivable: "应收",
    havebeentaken: "已收",
    notreceive: "未收",
    profit: "毛利",
    totalaccountingperiod: "账期外总额",
    invoicestatus: "发票状态",
    statusdetail: "状态(明细数)",
    Updates: "更新",
    receivedetail: "应收明细",
    createstarttime: "创建开始日期",
    createendtime: "创建截至日期",
    receivestarttime: "收款开始日期",
    receiveendtime: "收款截至日期",
    paymentstarttime: "付款开始日期",
    paymentendtime: "付款截至日期",
    applyarea: "区域类型",
    supplyid: "供应单号",
    supplyname: "供应名称",
    voucherno: "凭证号",
    intentname: "差旅目的",
    projectcode: "项目代码",
    invoiceid: "发票编号",
    template: "模板",
    templatemanager: "模板管理",
    fullscreen: "全屏显示",
    quanping: "退出全屏",
    orderselect: "订单勾选",
    receivestatus: "收款状态",
    invoiceapplication: "发票申请",
    receiveaudit: "收款审核",
    receiveconfirm: "收款确认",
    losstreatment: "亏损处理",
    receivefinished: "收款关账",
    receiveaudited: "收款退回",
    costcenter: "成本中心",
    expenseDepartment: "费用负担部门",
    supplyName: "供应名称",
    bulkEditingSupplyName: "批量修改供应名称",
    all: "全部",
    paymentstatus: "付款状态",
    obligation: "待付款",
    paymentaudit: "付款审核",
    paymentconfirm: "付款确认",
    paymentfinished: "收款关账",
    paymentaudited: "收款退回",
    orderselecttext: "请输入需要勾选的订单号码(用空格、换行或逗号分隔)",
    receivefaila: "请先进行客户查询在进行该操作",
    receivefailb: "请勾选需要操作的明细",
    receivefailc: "请选择正确的数据",
    receivefaild: "请先预设供应名称",
    invoiceapplyfaila: "请选择没有提交发票申请的数据",
    order: "订单",
    losstreatmentfail: "。关账毛利超过10%或低于10%,请先进行亏损处理。",
    loading: "正在执行操作......",
    orderselectfail: "请输入您要勾选明细的订单号码",
    tradedetail: "交易明细",
    templatename: "模板名称",
    rightmove: "右移",
    leftmove: "左移",
    topmove: "上移",
    bottommove: "下移",
    rightfaila: "请选择要右移的数据",
    leftfaila: "请选择要左移的数据",
    topfaila: "该数据不能进行上移操作",
    bottomfaila: "该数据不能进行下移操作",
    templatfaila: "请选择一条数据进行上下移动",
    costcenternamesearch: "成本名称搜索",
    expenseDepartmentNameSearch: "费用负担部门名称搜索",
    supplyNamesearch: "供应名称搜索",
    billnamesearch: "账期名称搜索",
    receivetablefaila: "请选择成本中心",
    selectExpenseDepartment: "请选择费用负担部门",
    receivetablefailb: "请先退出重新修改",
    receivetablefailc: "请选择账期",
    receivetablefaild: "请选择供应名称",
    profitandlossreasons: "盈亏原因",
    lossreasons: "亏损原因",
    profitreasons: "盈利原因",
    reakeven: "无亏损",
    losscausefaila: "请选择亏损原因",
    invoiceitemname: "项目名称",
    invoiceitemmodel: "规格型号",
    invoiceitemunitname: "单位",
    invoiceitemnum: "数量",
    invoiceitemfare: "单价",
    invoiceitemcost: "成本",
    invoiceitemamount: "金额",
    invoiceitemrate: "税率",
    invoiceitemtax: "税额",
    delete: "删除",
    invoicetitle: "发票抬头",
    invoicetype: "发票类型",
    clientadress: "客户地址",
    clientemail: "客户邮箱",
    remark: "备注",
    invoiceapplyfailb: "请输入正确的单价",
    invoiceapplyfailc: "请输入正确的税率",
    invoiceapplyfaild: "提交发票价格不能大于原发票价格",
    invoiceapplyfaile: "发票申请成功",
    accountname: "账户名称",
    accounttype: "账户类型",
    tradeaccountlistfaila: "请输入正确的金额",
    tradeaccountlistfailb: "充值录入成功",
    tradeaccountlist: "账户列表",
    availablebalance: "可用余额",
    accountbalance: "账户余额",
    creditbalance: "信用额度",
    blockedamount: "冻结金额",
    flow: "流水",
    recharge: "充值",
    blockedtransactions: "交易冻结",
    tradename: "交易名称",
    freezingtime: "冻结时间",
    creditline: "授信额度",
    contractdate: "合同日期",
    creditaddedprompt: "固定授信额度有效期以合同日期为准,如过期请续约",
    provisionalcredit: "临时授信",
    effectivedate: "生效日期",
    expirydate: "失效日期",
    lodamt: "充值金额",
    transactionflowing: "交易流水",
    tradedate: "交易日期",
    flowtype: "流水类型",
    transactionamount: "交易金额"
  },
  webdata: (_webdata = {
    interfaceManage: "配置管理",
    ChangeCheckPNR: "编码检验",
    insuranceamend: "退款处理",
    orderlist: "订单列表",
    mallservice: "商城服务",
    wechat: "微信管理",
    dealwarranty: "保单处理",
    insuranceorder: "保险订单",
    insuranceservice: "保险服务",
    insurancepolicy: "保险政策",
    changruletime: "变更时限",
    baggagerule: "行李额规则",
    departmanage: "部门管理",
    see: "查看",
    oftenconsumermanage: "常客管理",
    oftenconsumer: "常用旅客",
    costcenter: "成本中心",
    expenseDepartment: "费用负担部门",
    deal: "处理",
    waitdispos: "待处理",
    waitdispose: "待处理",
    waitpayment: "待付款",
    waitconfirm: "待确认",
    waitthrowin: "待审核",
    waitapprove: "待审批",
    waitsubmit: "待提交",
    waitrefund: "待退款",
    waitbooking: "待预订",
    addressmanage: "地址管理",
    dealorder: "订单处理",
    ordermanage: "订单管理",
    subservice: "订阅服务",
    dealinvoice: "发票处理",
    inviceservice: "发票服务",
    invoicemanage: "发票管理",
    servicefeesetting: "服务费设置",
    servicemanage: "服务管理",
    serviceinfo: "服务信息",
    interfaceinfo: "接口配置",
    payment: "付款",
    dealpayment: "付款处理",
    peoplemanage: "个人管理",
    companysetting: "公司配置",
    internationflight: "国际机票",
    internationhotel: "国际酒店",
    internationaltour: "国际旅游",
    chinatraffic: "国内用车",
    chinatrain: "国内火车",
    chinaflight: "国内机票",
    chinahotel: "国内酒店",
    chinatravel: "国内旅游",
    trainorder: "火车订单",
    flightorder: "机票订单",
    trafficorder: "订单处理",
    basedata: "基础数据",
    transaction: "交易明细",
    tradereceive: "应收明细",
    tradepayment: "交易明细",
    smstemplate: "短信模板",
    datastatistics: "数据统计",
    tradeweek: "交易账期",
    billreceive: "应收账期",
    billpayment: "交易账期",
    hotelorder: "酒店订单",
    customermanage: "客户管理",
    customerlevel: "客户级别",
    dealdelivery: "快递处理",
    deliveryservice: "快递服务",
    deliverypolicy: "快递政策",
    flowmanage: "流程管理",
    tourorder: "旅游订单",
    companymanage: "企业管理",
    companyinfo: "企业信息",
    companyhome: "企业主页",
    visaorder: "签证订单",
    visaservice: "签证服务",
    allorder: "全部订单",
    purviewmanage: "权限管理",
    purviewcontrol: "权限控制",
    approve: "审批",
    dealmoneyin: "收款处理",
    moneynandoutmanage: "收支管理",
    authorizemanage: "授权管理",
    amendorder: "退改订单",
    changeamendrule: "退改规则",
    clientuser: "大客户",
    domainmanage: "域名管理",
    notifymanage: "通知管理",
    dealrefund: "退款处理",
    dealamend: "退票处理",
    dealamendorder: "退票处理",
    dealamendtour: "退团处理",
    webmanage: "网站管理",
    mineinfo: "我的信息",
    usermain: "我的主页",
    systemmanage: "系统管理",
    discrete: "已拆分",
    forbiddened: "已禁用",
    canceled: "已取消",
    throwined: "已上线",
    rejected: "已退回",
    rejectes: "已退回",
    finished: "已完成",
    finishes: "已完成",
    hanguped: "已下线",
    bankaccount: "银行账户",
    coupon: "优惠券",
    employeemanage: "员工管理",
    cannnot: "暂不能",
    cannot: "暂不能",
    accountsafe: "配置管理",
    accountmanage: "账户管理",
    tradeaccount: "企业账户",
    financemanage: "账务管理",
    policymanage: "政策管理",
    policymangage: "政策管理",
    jobmanage: "职位管理",
    businessservice: "商旅服务",
    chargeservice: "增值服务",
    chargepolicy: "服务政策",
    feedback: "意见反馈"
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_webdata, "mallservice", "商城服务"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_webdata, "orderlist", "订单列表"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_webdata, "sharelist", "活动管理"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_webdata, "orderchange", "航变列表"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_webdata, "smsnotify", "通知列表"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_webdata, "supplylist", "供应管理"), _webdata),
  category: (_category = {
    AmendingFlight: "部分退票中",
    ChangeingFlight: "部分改签中",
    AmendingTrain: "部分退票中",
    ChangeingTrain: "部分改签中",
    AmendingHotel: "部分退房中",
    ChangeingHotel: "部分改签中",
    AmendingTour: "部分退团中",
    ChangeingTour: "部分改签中",
    AmendedFlight: "部分退票",
    ChangeedFlight: "部分改签",
    AmendedTrain: "部分退票",
    ChangeedTrain: "部分改签",
    AmendedHotel: "部分退房",
    ChangeedHotel: "部分改签",
    AmendedTour: "部分退团",
    ChangeedTour: "部分改签",
    AllAmendingFlight: "退票中",
    AllChangeingFlight: "改签中",
    AllBookingFlight: "购票中",
    AllAmendingTrain: "退票中",
    AllChangeingTrain: "改签中",
    AllBookingTrain: "购票中",
    AllAmendingHotel: "退房中",
    AllChangeingHotel: "改签中",
    AllBookingHotel: "预订中",
    AllAmendingTour: "退团中",
    AllChangeingTour: "改签中",
    AllBookingTour: "预订中",
    AllAmendedFlight: "退票成功",
    AllChangeedFlight: "改签成功",
    AllBookedFlight: "购票成功",
    AllAmendedTrain: "退票成功",
    AllChangeedTrain: "改签成功",
    AllBookedTrain: "购票成功",
    AllAmendedHotel: "退房成功",
    AllChangeedHotel: "改签成功",
    AllBookedHotel: "预订成功",
    AllAmendedTour: "退团成功",
    AllChangeedTour: "改签成功",
    AllBookedTour: "预订成功",
    "1672category": "房费",
    "1674category": "团费",
    "1660category": "票面",
    "1662category": "机建",
    "1664category": "燃油",
    "1666category": "税费",
    "1692category": "直减",
    "1668category": "保险",
    "1670category": "服务费",
    "1678category": "退票",
    "1682category": "变更",
    "1684category": "原价",
    "1690category": "其它",
    "1694category": "折扣",
    Conference: "会议",
    EnterprisesUnit: "企事业单位",
    GovernmentDepartment: "政府机关",
    PeopleEnterprises: "民营资产",
    CountryCapital: "国有资产",
    ChinaOuterJoinCapital: "中外合资",
    ForeignCompany: "外商独资",
    CompanySize100: "100人以下",
    CompanySize499: "100~499",
    CompanySize999: "500~999",
    CompanySize4999: "1000~4999",
    CompanySize5kUp: "5000以上",
    Internal: "国内",
    Overseas: "国际",
    IDCard: "身份证",
    PassportCard: "护照",
    StudentCard: "学生证",
    OfficerCard: "军人证",
    OtherCard: "其它",
    Residencepermit: "港澳台居民居住证",
    ForeignResidentIDCard: "外国人永久居留身份证",
    HKCompatriotsyndrome: "港澳通行证",
    TaiCompatriotsyndrome: "台湾通行证",
    Enable: "启用",
    UnEnable: "禁用",
    Male: "男",
    Female: "女",
    Yes: "是",
    No: "否",
    SingleVoyage: "单程",
    RoundVoyage: "往返",
    ReturnVoyage: "回程",
    MultiVoyage: "多程",
    TransferVoyage: "中转",
    BSP: "BSP",
    B2B: "B2B",
    OverseasElectronic: "境外电子 ",
    ConnectVoyage: "联程 ",
    Team: "团队",
    Fit: "散客",
    Unlimited: "不限",
    HighOpen: "高开",
    DownOpen: "低开",
    Monday: "星期一",
    Tuesday: "星期二",
    Wednesday: "星期三",
    Thursday: "星期四",
    Friday: "星期五",
    Saturday: "星期六",
    Sunday: "星期日",
    WithinIntercontinental: "同一洲际范围内",
    PolicyDepartAirport: "政策始发机场范围",
    NoReward: "无奖励 ",
    AgencyFreeFee: "无代理费",
    MustBackAirport: "必须返回行程出发机场",
    AppointBackAirport: "指定返回国家或机场范围",
    CommonFlight: "普通航班",
    ShareFlight: "共享航班",
    Prepay: "预付",
    CashPay: "现付",
    OverseasStudent: "留学生 ",
    Immigrant: "移民",
    Worker: "劳工",
    Seaman: "海员",
    Youth: "青年",
    HkMacaoTw: "港澳台",
    ForeignNationality: "外籍 ",
    NotChineseName: "非汉字姓名",
    AddOn: "Add-On",
    OldGge: "老年 ",
    OverseasTransfer: "境外中转 ",
    NotchRange: "缺口程 ",
    OPEN: "OPEN",
    SPA: "SPA",
    QValue: "Q值",
    SharedFlight: "共享航班 ",
    ThreeAgreement: "三方协议 ",
    Package: "套票",
    WholeGroup: "整团",
    SmallGroup: "小团 ",
    RewardsAdults: "奖励与成人一样",
    NoOpenBonus: "可无开奖励 ",
    WithoutReward: "可开无奖励",
    NotOpen: "不可开 ",
    NoCodingRequired: "无需还编码 ",
    CodeOut: "换编码出票 ",
    BigTicket: "大编出票（ 无需换编） ",
    BigNoTicket: "大编出票（需换编）",
    NoChange: "无位不换出票（外放有位时换编）",

    SingleRound: "单程/往返",
    MonthCycle: "月",
    WeekCycle: "周",
    DayCycle: "日",
    HKMpermit: "回乡证",
    TaiWpermit: "台胞证",
    OnlineServiceMode: "线上服务",
    LineServiceMode: "线下服务",
    PercentageMode: "百分比",
    FixedPrice: "固定金额",
    ExpensePrice: "票面价",
    PriceFareAndTax: "票面价+税费",
    DirectUpdate: "直接修改",
    AddLittle: "加点",
    ReduceLittle: "减点",
    User: "用户",
    Jobs: "职称",
    Group: "群组",
    Department: "部门",
    Company: "公司",
    Service: "服务",
    Customer: "客户",
    Actions: "权限",
    CostCenter: "成本中心",
    ExpenseDepartment: "费用负担部门",
    Server: "服务端",
    Client: "客户端",
    Normal: "正常",
    Change: "变更",
    SelfOnly: "仅自己",
    SelfLower: "自己及下级",
    NoLimit: "不限制",
    UnAuthorized: "未授权",
    Authorized: "已授权",
    SystemRole: "系统角色",
    UserRole: "用户角色",
    ContinueBefore: "继续之前",
    ContinueAfter: "继续之后",
    ReturnBefore: "退回之前",
    ReturnAfter: "退回之后",
    ChangeBefore: "变更之前",
    ChangeAfter: "变更之后",
    NeedInvoice: "需要发票",
    NoInvoice: "不要发票",
    WEB: "网站",
    RMB: "元",
    Dollar: "美元",
    Alipay: "支付宝",
    WeChat: "微信",
    Cash: "现金",
    Monthly: "月结",
    Tour: "旅游",
    Hotel: "酒店",
    Flight: "机票",
    AdviceNote: "出团通知书",
    GuestEnclosure: "客人附件",
    other: "其他",
    Electronic: "电子合同",
    ClientMessage: "给客人留言",
    SupplyMessage: "给供应留言",
    WorkmateMessage: "给同事留言",
    Traveled: "已出游",
    NotTravel: "未出游"
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Change", "变更"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Sales", "销售"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Refund", "退款"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "PasswordVerify", "登录密码"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "EmailVerify", "邮箱验证"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "PhoneVerify", "手机验证"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "NameVerify", "实名验证"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "SafetyProblem", "安全问题"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "WEB", "网站"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "APP", "手机"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "BtripService", "商旅服务"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "HotelService", "酒店服务"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "TourService", "旅游服务"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "FlightService", "机票服务"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "ChargeService", "增值服务"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "HightDirector", "高中班主任是谁"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Firstgame", "第一次通关的游戏"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "PhoneContact", "手机"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "TelephoneContact", "电话"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "EmailContact", "邮箱"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "QQ", "QQ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "OnlineKnow", "网上预订须知"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "TourKnow", "国内旅游预订须知"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Enable", "启用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "UnEnable", "禁用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "PriceEnable", "价格启用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "PriceUnEnable", "价格禁用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Indeterminate", "价格待定"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "PrivatePolicy", "私有政策"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "PublicPolicy", "公有政策"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Receive", "收款"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Payment", "付款"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Unsubmit", "未提交"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Submited", "已提交"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Unaudit", "未审批"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Audited", "已审批"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "AuditRefuse", "审批拒绝"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Untreated", "未处理"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "RefundeBad", "退团失败"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "RefundeIng", "退团处理中"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Refunded", "退团成功"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Country", "国家"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Scenic", "景区"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "City", "城市"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Province", "省"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Area", "区域"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Airport", "机场"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Continent", "洲"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "District", "区"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Invite", "自取"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Mail", "邮寄"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "insideOutside", "国内始发"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "outsideInside", "直飞SOTO程"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "insideInsideOutside", "国内始发Add-On"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "outsideInsideInside", "国外始发Add-On"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "outsideOutside", "境外到境外"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "insideOutsideOutside", "国内始发中转"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "outsideOutsideInside", "国外始发中转"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "outsideOutsideOutside", "境外境外境外"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "outsideInsideOutside", "境外境内境外"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "globalGlobal", "全球到全球"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "globalGlobalGlobal", "全球中转全球"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "openAgencyFee", "可开无代理费"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "NoWay", "不可开"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "InsuranceService", "保险服务"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "ExpressService", "快递服务"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "InvoiceService", "发票服务"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "VisaService", "签证服务"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "TrainService", "火车服务"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "TravelNotes", "预订须知"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "ExpenseKnowledge", "费用须知"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "ShortMessage", "短信"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Mail", "邮件"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Wechat", "微信"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "EexamineOrderSms", "审批订单消息内容"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "EexamineApprovalSms", "审批通过消息内容"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "EexamineRefuseSms", "审批拒绝消息内容"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "EexamineAccomplishSms", "订单处理完成消息内容"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Refunds", "退款完成"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Transfer", "转账"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Train", "火车票"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "BusinessSeat", "商务座"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "SpecialSeat", "特等座"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Level1Seat", "一等座"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Level2Seat", "二等座"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "HighGradeSleeper", "高级软卧"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "CommonSleeper", "软卧"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "HardSleeper", "硬卧"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "SoftSeat", "软座"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "HardSeat", "硬座"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "NotHaveSeat", "无座"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Economy", "经济舱"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Buissenes", "公务舱"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "First", "头等舱"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "DayLowestPrice", "全天最低价"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "FlightLowestPrice", "全航班最低价"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "HighSpeedRail", "高铁"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "SleepingBerth", "卧铺"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Other", "普车及其它"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Whole", "全部"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Position", "职位"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Department", "部门"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "FlatFeeCharges", "按固定收费"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "PercentageCostFee", "按百分比收费"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Department", "本部门"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "DepartmentLower", "本部门及下级"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "TravelPurpose", "差旅目的"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "PolicyCause", "政策原因"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "FlightChange", "我要改变行程,不想飞了"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "FlightMistaken", "记错行程、日期、时间、姓名"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "FlightDelay", "航班延误或取消"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "OnBusiness", "因公"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "OnPersonal", "因私"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "PayApproval", "订单支付审批"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "ChangeApproval", "订单改签审批"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "ReturnTicketApproval", "订单退票审批"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "People", "按人收费"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "legs", "按航段收费"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "OnLineReservation", "线上预订"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "OffLineReservation", "线下预订"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "WorkingTime", "工作时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "NonWorkingTime", "非工作时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "OnlineBookingApproval", "线上预订需要审批"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "OfflineBookingApproval", "线下预订需要审批"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "ViolateRuleApproval", "违背规则需要审批"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "ChangeTripApproval", "更改行程需要审批"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "CancelTripApproval", "取消行程需要审批"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Preflight", "起飞前"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "AfterTakeoff", "起飞后"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "RuleEndorse", "改签"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "RuleFund", "退票"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Reserve", "预订"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "CaterService", "餐饮服务"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "TrafficService", "交通服务"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "TicketService", "门票服务"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "BaseService", "基础服务"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Volunteer", "自愿"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "FlightChang", "航变"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "BuyAgain", "重购"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "SickAmend", "病退"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "NameError", "名字错误"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "CabinChange", "升舱换开"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "TicketInvalid", "废票"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Other", "其他"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "WaitSubmit", "待提交"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "WaitPayment", "待付款"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "WaitConfirm", "未确认"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Finished", "已确认"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Canceled", "已取消"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Rejected", "已退回"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "SystemService", "系统服务"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "WorkService", "工作服务"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "OrderService", "订单服务"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "BillService", "账单服务"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "UserService", "个人服务"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "CompanyService", "企业服务"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "TicketFare", "票面"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "BuildFare", "机建"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "FuelFare", "燃油"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "TaxFare", "税费"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "SafeFare", "保险"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "ServiceFare", "服务"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "HotelFare", "房费"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "TeamFare", "团费"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "AmendFare", "退票"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "ChangeFare", "变更"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "OtherFare", "其它"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "DirectReduction", "直减"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "ThrowDiscount", "折扣"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Infant", "婴儿"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Enfant", "儿童"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Young", "成人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Wrinkly", "中年"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Elderly", "老年"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "BusinessLicence", "营业执照"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "TaxRegistration", "税务登记证"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Other", "其他"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "WaitSubmit", "待提交"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "WaitDispose", "待处理"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Cannot", "暂不能"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Finished", "已完成"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Rejected", "已拒绝"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Bill", "审批"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Balance", "余额"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Credit", "信用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Integral", "积分"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "FixedCredit", "固定授信"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "InterimCredit", "临时授信"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "WaitOutDay", "待出帐"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "WaitAudited", "待审核"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "WaitConfirm", "待确认"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "WaitReceive", "待收款"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Finished", "已关账"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Rejected", "已退回"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Change", "改签"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Bill", "账务"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Company", "公司"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Product", "产品"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Sales", "销售"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Amend", "退费"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "People", "个人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Customer", "客服"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "HotelChange", "行程变更"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Station", "车站"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "CompanyID", "公司"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "People", "个人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "SpecialTicket", "专票"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "GeneralTicket", "普票"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Electronic", "电子发票"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Paper", "纸质发票"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "HotelDelay", "行程取消"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Economy5", "5折经济舱"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Economy6", "6折经济舱"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Economy7", "7折经济舱"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Economy8", "8折经济舱"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Economy9", "9折经济舱"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "MessageNotify", "短信通知"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "MailNotify", "邮件通知"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "WechatNotify", "微信通知"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "AppNotify", "App通知"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "WaitOutDay", "待出帐"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "OverdueNo", "未逾期"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "OverdueYes", "已逾期"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Percentage", "百分比"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "FixMoney", "固定金额"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "RemovePrice", "剔除价格"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Creater", "创建者"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Member", "参与者"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Watcher", "关注者"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Text", "文本"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Html", "HTML"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Link", "链接"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Plugin", "插件"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "CompanyInternal", "公司内部"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "CurrentDomainName", "当前域名"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "AllDomainName", "所有域名"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Email", "电子邮件"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "OrdinaryAddress", "普通地址"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "B2C", "B2C"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "B2G", "B2G"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Demand", "需求"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "WaitBooking", "待预订"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "WaitApprove", "待审批"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "WaitConfirm", "待确认"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "WaitPayment", "待支付"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "WaitDispose", "待处理"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Finished", "已完成"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Canceled", "已取消"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Rejected", "已退回"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Discrete", "已拆分"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Cannot", "暂不能"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "EmailAuth", "邮箱账号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "MobileAuth", "手机账号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "AccountAuth", "用户账号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "WeixinAuth", "微信授权"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "DynamicAuth", "动态验证"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "BookingInfo", "预订须知"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "PolicyCause", "违背原因"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "TravelPurpose", "差旅目的"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "WaitRefund", "待退款"), _category)
});

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);


var _order, _system, _mall, _bill, _webdata, _category;

/* harmony default export */ __webpack_exports__["a"] = ({
  statistics: {
    servicetype: "Service type",
    search: "search",
    exportfile: "export",
    submit: "submit",
    createdate: "created on",
    orderno: "order No.",
    businestype: "busines type",
    payment: "payment (including insurance and seervice fees)",
    insufee: "insurance fee",
    servicefee: "service fee",
    productname: "product name",
    total: "total",
    departmentname: "department name",
    selectdepart: "select dept.",
    costcenter: "cost center",
    expenseDepartment: "expense bearing department",
    selectcostcenter: "select cost center",
    selectExpenseDepartment: "select expense bearing department",
    projectcode: "project code",
    startdate: "started on",
    enddate: "ended on",
    paytotalmoney: "total consumption",
    avgticketprice: "avg ticket price",
    avgroomfee: "avg room fee",
    avgdiscount: "avg discount",
    breakbtrip: "violation policy",
    advdayinfo: "adv day info",
    day: "day",
    departpaysort: "dept. consumption ranking",
    costpaysort: "cost center ranking",
    expenseDepartmentRanking: "expense bearing department ranking",
    projectcodepaysort: "project code ranking",
    arrpaysort: "destination ranking",
    tonglist: "statistics list",
    tongview: "statistical view"
  },

  order: (_order = {
    ordertip: "You can view orders within one year online. If you need to check the order before, please call: 400-088-8020 (free toll call).",
    allorder: "all orders",
    startdate: "started on",
    endadte: "ended on",
    orderstatus: "order status",
    ordertype: "order type",
    searchkey: "enter product name or order No. to search",
    search: "search",
    number: "number",
    orderdetail: "order detail",
    ordertotalmoney: "total order amount",
    dealoperation: "deal operation",
    submit: "submit immediately",
    approval: "approve immediately",
    payment: "pay immediately",
    createorder: "re-order",
    oldsystem: "old system",
    rejectReason: "rejecting reason",
    reapproval: "reject in examination",
    approvalsucc: "pass the examination",
    selectvoy: "select the voyage you need to refund!",
    selectpass: "select the passenger you need to refund!",
    selectreason: "select reason for refunding",
    amendsucc: "succeed in submitting refunding application",
    flightchange: "flight change",
    selectchangepass: "select changing passenger",
    oldvoyageinfo: "ooriginal voyage info",
    selectedflight: "selected flight",
    policyok: "Conform rules",
    policyno: "Violate rules",
    build: "airrax",
    fuel: "fuel charge",
    changeflight: "change flight",
    flightlist: "flight list",
    changefee: "changing fee",
    changefeetip: "(The following fees are for reference only. The final amount is subject to the review of the airline company. If you have any questions, please call customer service:---)",
    changefeeabout: "estimated changing fee",
    upcabinfeeabout: "estimated upgrading fee",
    changeservicefee: "service fee for change",
    totalfee: "total",
    changereason: "reason for changing",
    changedetreason: "pls enter the detailed reason for changing (not required)",
    back: "back",
    submitapply: "submit application"
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "selectchangepass", "select passenger!"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "flightsearchfail", "fail to search the conforming flight info!"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "flightchangereason", "pls select the reason for changing"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "losesource", " Please check flights"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "flightchangesucc", "succeed in applying for changing!"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "orderdetail", "Order Info"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "voyageinfo", "Voyage Info"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "flightpass", "passenger"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "contactpeople", "Name"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "costcenter", "cost center"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "expenseDepartment", "expense bearing department"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "policynoreason", "reason for violating policy"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "demandremark", "demand remark"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "fujianxinxi", "attachment info"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "btripinfo", "business trip info"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "procode", "project code"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "btripaim", "business trip purpose"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "btripMatter", "business trip matter"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "approvalstatus", "approval status"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "violate", "Violate"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "policydetail", "policy"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "vioreason", "reason for violating"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "reasondetail", "detailed reason"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "order", "order"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "bookingdate", "booking date"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "orderid", "order No."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "oldorderid", "original order No."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "bookingway", "booking way"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "paymentway", "payment way"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "totalmoney", "total"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "submitorder", "submit order"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "cancelorder", "cancel order"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "ordervoyage", "voyage"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "realtake", "actually take"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "share", "Share"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "orderchange", "change"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "orderamend", "refund"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "departcity", "depart from"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "arrivecity", "arrivie in"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "departdate", "depart on"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "arrivedate", "arrive on"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "hotelname", "hotel name"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "hotelphone", "hotel phone"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "hoteladdress", "hotel address"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "roomtype", "room type"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "cityname", "city name"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "arrivedate", "Check-in Date"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "departdate", "leave on"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "startstation", "start station"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "endstation", "end station"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "seattype", "seat type"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "tourpeople", "traveller"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "sequence", "sequence"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "name", "name"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "cardno", "card No."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "birthday", "birthday"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "phoneno", "phone number"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "invoiceinfo", "invoice info"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "invoiceid", "invoice code"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "passname", "passenger name"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "invoiceno", "invoice no"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "seatno", "seat no"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "tradeinfo", "trade info"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "tradepeople", "trade person"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "tradeway", "trade way"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "tradetype", "trade type"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "trademoney", "trade amount"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "createtime", "created on"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "email", "email"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "phone", "phone"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "applyamend", "apply for refund"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "selectordervoyage", "select voyage"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "selectorderpass", "select passenger"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "selectorderreason", "select reason"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "cancel", "cancel"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "changeapply", "apply for changing"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "adultticket", "adult ticket"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "amendfee", "fee for refund"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "samechangefee", "fee for changing"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "changecondition", "condition for changing "), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "changeadopt", "allow to change"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "people", "people"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "completechange", "complete change"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "reimburseinfo", "Reimbursement info"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "travleorderinfo", "can provide complete schedule"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "bagkg", "baggage allowance"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "forfeebagkg", "free baggage allowance  20KG"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "loading", "loading"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "endststion", "arriving ststion"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "waitapprove", "to be approved"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "changeamendrule", "Refund/Change"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "trainamendrule", "There is no fee for refund 15 days (excluding) before departing. A fee for refunding at 5% of the ticket fare is charged for refund more than 48 hours before departing from the departing station; a fee for refund at 10% of the ticket fare is charged for refund 24 hours~48 hours before departing, and a fee for refund at 20% of the ticket fare is charged for refund less than 24 hours before departing."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "touramendrule", "subject to the signed contract"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "selectPassengersChange", "select changing passenger"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "fillFlight", "fill in the fight info"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "depart", "depart"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "arrive", "arrive"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "date", "date"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "changereason", "pls enter the reason for changing"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "dueTo", "due on"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "for", "into"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "ChangeTo", "Changed to"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "WasteBack", "cancalled on"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "ExpectedRefundFee", "etsimated fee for refund"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "reasonRejection", "plas enter the reason for rejection"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "ordeCancel", "Cancel orde"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "isCancel", "confirm to cancel the order"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "confirm", "confirm"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "BusinessType", "BusinessType"), _order),
  system: (_system = {
    clear: "Clear",
    combtripmemberlogin: "company business trip member login in",
    lchbtrip: "Licheng business btrip",
    simple: "simpler",
    free: "freer",
    lowermoney: "cheaper",
    prebtrip: "perfect business trip",
    unyouneed: "undestand your need",
    servicenotime: "comprehensive service with no time difference",
    costcenlower: "business trip cost lower by 30%",
    peoplecenter: "personal center",
    ri: "day",
    trtavleregtips: "If the amount is 0, it means no limit of amount, tick available for ticket, class and train seat ",
    firstcity: "first-class city",
    seccity: "second-class city",
    thrcity: "third-class city",

    none: "none",
    allmoney: "full price",
    discountdown: "below _ discount",
    deletefiletips: "confirm to delete the operation?",
    tips: "tips",
    cancel: "cancel",
    usericon: "usericon",
    uploadusericon: "upload usericon",
    changusericon: "change usericon",
    bangemail: "bind email",
    bangphone: "bind phone number",
    orderid: "order No.",
    ordervoyageinfo: "voyage info",
    bookingdate: "booking date",
    orderstatus: "order status",
    bookinguser: "booking user",
    btriprule: "Business trip rule",
    btripaim: "Business trip purpose",
    policyreason: "policy reason",
    bookinginfo: "booking Info",
    btripflow: "business trip approval",
    search: "search",
    add: "add",
    name: "name",
    number: "number",
    servicetype: "service type",
    chinese: "Chinese",
    english: "English",
    operation: "operation",
    copy: "Copy",
    update: "revise",
    delete: "Delete",
    delsucc: "succeed in deleting",
    inputcontent: "pls enter content",
    selectcustomers: "select customers",
    zhdescribe: "describe in Chinese",
    rule: "rule",
    ruleid: "rule No.",
    rulename: "rule name",
    travelregulations: "travel regulations",
    endescribe: "describe in Eng",
    btripflowname: "business trip approval name",
    btripflowrule: "business trip approval rule",
    selectbtriprule: "select business trip rule",
    selectbtripflow: "select business trip flow",
    needflow: "need approval",
    roleapplybtrip: "role applying rules",
    departrole: "dept. role",
    jobrole: "job role",
    employeeandcustomer: "employee customer",
    btripflowid: "business trip approval No.",
    btriprulename: "Business trip rule name",
    approvalfloename: "approval flow name",
    flowid: "flow No.",
    back: "back",
    save: "save",
    savesucc: "succeed in saving",
    operlogs: "operation logs",
    addsucc: "succeed in adding",
    updatesucc: "succeed in revising",

    businessname: "enterprise name",
    businessmanage: "business management",
    servicemanage: "service management",
    reportsmanage: "report management",
    pleaseselect: "pls select",
    pleasewrite: "pls fill in",
    companyinfo: "company info",
    companyname: "company name",
    city: "city",
    profession: "profession",
    contactname: "contact person's name",
    selectcycle: "select cycle",
    selectdate: "select date",
    selecttrade: "select trade",
    phonenoerror: "phone format error",
    emailerror: "email format error",
    contactnameerror: "contact person's name can't be blank",
    deliverymanage: "delivery management",
    addcontact: "new address",
    contactpeople: "consignee",
    address: "address",
    remark: "remark",
    postcode: "post code",
    contactphone: "contact phone",
    contactnickname: "simple address",
    contactemail: "contacting email",
    defaultaddress: "default address",
    setdefaultaddress: "SetDefault",
    addressinfo: "address info",
    peoplemanage: "personal management",
    lasterorder: "recent order",
    voyagesdate: "voyage canlendar",
    voyagesremark: "voyage remark",
    welcomelogin: "welcome to login",
    login: "Login",
    registernow: "Register",
    loginbyaccount: "Login by account",
    loginbyphone: "Login by dynamic code",
    loginbyother: "you can also login in other ways",
    wechat: "wechat",
    pleaseinputvalcode: "pleaseenter verification code",
    loginredittips: "skip to home page in X seconds...",
    accountinfo: "account info",
    peopleregister: "personal user",
    companyregister: "company register",
    kefucenter: "customer service center",
    loginout: "Logout",
    account: "account",
    pwd: "pwd",
    pwdtips: "pls enter pwd",
    forgetpassword: "forget pwd?",
    saveloginstats: "save login status",
    accounttips: "pls enter phone number or email",
    password: "Login pwd",
    passwordtips: "pls enter 8-16 digits",
    passwordfirstlevel: "weak",
    passwordfirstleveltips: "include Eng letters and numbers",
    passwordsecleveltips: "include Eng letters, numbers and special symbols",
    passwordseclevel: "medium",
    passwordlastleveltips: "include capital and lowercase Eng letters, numbers and special symbols",
    passwordlastlevel: "strong",
    confirmpassword: "confirm pwd",
    validecode: "verification code",
    validecodeignorecase: "case-insensitive",
    changevalidecode: "change another one",
    dynavalidecode: "dynamic verification code",
    dynavalidecodetips: "pls enter dynamic verification code",
    loginedregistertips: "You have already logged in to Licheng business travel account, if you want to register your personal account, please quit first!",
    agreeprotocol: 'Agree to "Service Agreement"',
    reset: "reset",
    registeproblem: "register problem?",
    inputpwdagain: "enter pwd again",
    notsamepwd: "not the same pwd",
    emailaccounttips: "send verification code to email ",
    phoneaccounttips: "send verification code to phone",
    sendvalidecode: "send verification code ",
    registersucc: "succeed in registering",
    registersucctips: "succeed in registering, pls log in",
    companyaccounttips: "This account is already a company account. To register a company account, please quit and re-register.",
    codesendtips: "already sent",
    codeagain: "acquire verification code",
    resetaccountback: "back to the last step",
    resetaccountfirst: "fill in the account",
    resetaccountsec: "ID verification",
    resetaccountthr: "set new pwd",
    resetaccountlast: "complete",
    submit: "submit",
    resetphoneaccounttips: "you can reset pwd by valid bond email",
    resetaccountbyphone: "reset by phone verification",
    resetemailaccounttips: "you can reset pwd by valid bond email",
    resetaccountbyemail: "reset by email verification",
    resetpwdbyvalide: "reset pwd",
    sendresetpwdcodetips: "Licheng Network has sent a verification code to your bond (phone or mailbox), pls check and enter the code",
    resetpwdcodename: "The verification code you received",
    confirm: "confirm",
    invoiceinfo: "",
    yes: "yes",
    no: "no",
    invoicemanage: "invoice management",
    invoicerole: "invoice role",
    invoicetype: "invoice type",
    invoicename: "invoice name",
    identifynumber: "taxpayer identification number",
    invoicebankname: "bank name",
    invoicebankaccount: "bank account",
    invoicecompanyadsress: "registered adsress",
    invoicecompanyphone: "registered phone",
    invoicelistlefttitle: "saved",
    invoicelistrighttitle: "address",
    updatedate: "update data",
    invoicetypetips: "pls select invoice type",
    invoicenametips: "pls enter invoice title",
    identifynumbertips: "pls enter taxpayer identification number",
    invoicebanknametips: "pls enter bank name",
    invoicebankaccounttips: "pls enter bank account",
    invoicecompanyadsresstips: "pls enter registered adsress",
    invoicecompanyphonetips: "pls enter registered phone",
    messagetemplatelist: "message template list",
    messagename: "message name",
    messagetype: "message type",
    messagetemplatename: "message template name",
    messagetemplatetype: "message template type",
    messagetemplatecontent: "message template content",
    updateuser: "updated by",
    disables: "disable",
    enable: "enable",
    managesetting: "management setting",
    messagetemplatestatus: "status",
    addmessagetemplate: "update message template",
    username: "username",
    cardno: "card No.",
    cardvaliditydate: "validity date",
    cardincountry: "card issued by",
    cardimg: "card img",
    reproveimg: "positive img",
    deleteimg: "delete img",
    reverseimg: "reverse img",
    uploadimg: "upload img"
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "companyinfo", "basic info"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "cardinfo", "card info"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "contactinfo", "contact info"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "customermanage", "customer manager"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "companyname", "company name"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "companynickname", "company's short name"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "englishcompanyname", "english name"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "companyemail", "company email"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "companyaddress", "company address"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "companytype", "company type"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "capitaltype", "capital type"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "companysize", "company size"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "companyprofession", "company profession"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "companyremark", "remark"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "rolecontactpeople", "contact person"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "rolecontactpeoplename", "contact person's name"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "importcontact", "import address"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "phoneareacode", "phone area code"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "contactaddress", "contact address"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "province", "province"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "city", "city"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "district", "district"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "changecompanypeopletips", "Tip: You will no longer have admin rights after the receiver receives the company authority"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "companypeople", "receiver"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "regularcard", "regular card"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "regularcardno", "card No."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "disclaimer", "disclaimer"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "fullname", "full name"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "nickname", "short name"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "sex", "sex"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "country", "nationality"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "name", "name"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "charge", "supervisor"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "selectcharge", "select supervisor"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "companyorgan", "institutional framework "), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "actionupdatetips", "If you do not need to set authority, you can click Save to go to the next step."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "roleaction", "role authority"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "allemployee", "all employees"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "roleemployee", "role employee"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "roleemployeetips", "the employee has been in the current dept."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "setmanage", "set management"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "workcity", "work city"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "workjob", "job"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "workname", "work name"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "worktime", "work time"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "workdatarang", "checking range"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "birthday", "birthday"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "list", "list"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "createtime", "created on"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "startdate", "start on"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "enddate", "end on"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "sequence", "sequence"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "supername", "superior name"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "updatetime", "update on"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "detail", "detail"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "setting", "setting"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "serviceinfo", "service info"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "servicename", "service name"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "publishname", "publishing name"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "applyarea", "applicable area"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "servicepublic", "public or not"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "publishservice", "publish service"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "publishedservice", "service has been published"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "advancetime", "advance time"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "workperiod", "cycle"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "publishsave", "confirm to publish"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "servicefarelist", "service fare list"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "servicefarename", "service fare name"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "servicefareid", "service fare No."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "companyid", "company No."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "servicefarestatus", "service fare status"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "policystatus", "policy status"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "customername", "customer name"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "bookingway", "booking way"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "workingtime", "working time"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "servicefarebyworkingtime", "Is it calculated according to working hours?"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "money", "yuan"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "other", "other"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "fare", "fare"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "roles", "role"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "jobs", "job"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "departments", "dept."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "companys", "company"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "customers", "level "), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "role", "role"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "job", "job"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "employee", "employee"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "user", "user"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "guest", "frequent customer"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "customer", "customer"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "costcenters", "cost center"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "expenseDepartments", "expense bearing department"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "flowid", "flow No."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "flowname", "flow name"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "flowmanage", "flow management"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "dealpeople", "handled by"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "up", "Up"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "down", "Down"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "langsetting", "Language"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "japan", "Japanese"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "english", "English"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "china", "Chinese"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "opened", "Opened"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "closed", "not opened"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "expired", "expired"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "disable", "disable"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "systemsafe", "safety setting"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "downloadtemplate", "download template"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "PermissionEmployees", "Permission employee"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "GrantDate", "Grant on"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "ExpirationDate", "Expire on"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "saveInfo", "Save info"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "approvalList", "Approval list"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "StaffName", "Staff Name"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "detail", "Detail"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "CompanyPage", "Company Page"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "selectCityAgain", "Select city again"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "ChooseShipCompany", "Select airline"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "FutureGenerations", "SelectAll"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "TheSelected", "Invert Selection "), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "QuickFindSelection", "Quickly find and select"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "shipCompany", "Applicable airline"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "shipSpace", "Select shipping space"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "applySpace", "Appliable shipping space"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "AsOfTheDate", "Deadline"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "AddLevel", "Add Level"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "LevelNames", "Level Name"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "LevelCode", "Level Code"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "RetentionSet", "Retention setting and customer configuration"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "LeaveSome", "Leave some"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "keepMoney", "Leave money"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "ServiceLevelAdd", "add service level"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "ProductCategory", "Product category"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "SubscribeCustomer", "SubscribeCustomer"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "SaveButtonSet", "Retention setting "), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "localChineseName", "enter the Chinese name of the area"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "localEnglishName", "enter the Eng name of the area"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "PreviewPicture", "Preview Picture"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "keywordsFilter", "enter key words to filter"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "DataIntegrity", "Data integrity"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "PerfectInformation", "complete information"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "AuthorizationState", "Authorization state"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "accountNumber", "pls enter account number"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "DynamicCode", "Dynamic Code"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "congratulations", "congratulations"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "ClickNoResponse", "Skipping to Licheng Business Travel Platform, if there is no response within 6 seconds, please click"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "Here", "Here"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "PasswordChangedSucc", "succeed in changing pwd"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "selectParentDirectory", "select parent directory"), _system),
  mall: (_mall = {
    one: "one",
    two: "two",
    three: "three",
    four: "four",
    five: "five",
    six: "six",
    seven: "seven",
    eight: "eight",
    nine: "nine",
    ten: "ten",
    contactUs: "Contact Us",
    adequateTxt: "Sufficient",
    sheet: "pcs",
    Remaining: "Only left",
    Amended: "Amended",
    Changeed: "Changeed",
    Amending: "Amending",
    Changeing: "Changeing",
    Booking: "Booking"

  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "Changeed", "Changeed"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "Booked", "Booked"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "AllAmending", "Pend AllAmending"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "AllChangeing", "Pend AllChangeing"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "AllBooking", "Pend AllBooking"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "AllAmended", "AllAmended"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "AllChangeed", "AllChangeed"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "AllBooked", "AllBooked"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "hotelinfo", "Hotel Info"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "ReElectionFlight", "Re-election flight"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "TaxExclusive", "tax-exclusive"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "notificationMessageFlight", "Notice: if you need, you can click here to enter the international demand list.To meet any of your travel needs You may also call:"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "Hotline", "Hotline consultation."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "EnfantYears", "2-14 year"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "InfantYears", "under two"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "budget", "budget"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "Mylicheng", "My licheng"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "SupportChinese", "Support Chinese/pinyin/Jane spell input"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "SupportCode", "Support Chinese/pinyin/jianpin/city code input"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "hotCity", "hot"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "attendance", "Attendance"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "hostPlace", "Host place"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "activityBudget", "Activity budget"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "PartyNumber", "Party Nums"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "internationalHotel", "Inter hotel demand"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "pay", "pay"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "NextPage", "NextPage"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "PreviousPage", "PreviousPage"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "selected", "selected"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "data", "data"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "strip", "strip"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "paginal", "paginal"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "page", "page"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "AuxiliaryWord", "The"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "searchName", "Enter name search (click the right button to add it as temporary passenger train)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "keywordsPlaceholder", "Enter keywords to search"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "selectName", "select Name"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "Station", "Station"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "TotalAmount", "Total Amount"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "checkIn", "check-in"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "Broadband", "Broadband"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "AttentionPlease", "(Special reminder: please fill in the reasons for violation, so as to better pass the audit)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "TripAgainst", "The trip is against"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "ContraryReason", "Reason"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "DetailReason", "DetailReason"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "Sex", "Gender on ID"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "Nationality", "Nationality"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "Birthdate", "Date of birth"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "Mobile", "Mobile"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "ID", "ID"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "PassengerName", "Name"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "Policy", "Policy"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "price", "Price"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "BedType", "Bed Type"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "Window", "WINDOW"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "feature", "Feature"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "ViewsMore", "Views more"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "durationTime", "Duration"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "flightInfo", "Flight information"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "next", "Next"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "selectedconsumer", "selected customer"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "btripflow", "business trip approval"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "bookingcenter", "Booking"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "demandorder", "demand order"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "selectcompany", "select company"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "costcenter", "CostCenter"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "expenseDepartment", "Expense Bearing Department"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "approvalpolicy", "approval policy"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "bookinguser", "booking staff"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "pleaseselect", "please select"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "bookingsearch", "booking search"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "btripaim", "Purpose"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "budgetCode", "BudgetCode"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "budgetIntro", "BudgetIntro"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "projectcode", "ProjectCode"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "bookingtype", "booking type"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "applyarea", "appliable area"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "serviceset", "service fee setting"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "flowinfo", "approval flow "), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "name", "name"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "flowname", "approver's name"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "btriprule", "Business trip rule"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "priority", "priority"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "pricelimit", "price limit"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "bookinginfo", "Booking Info"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "zhtips", "Chinese tips"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "entips", "eng tips"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "updateorder", "update order"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "submitorder", "submit order"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "tourpasstips", "Travel order does not support this passenger type"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "createsucc", "succeed in creating order"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "orderapprovalsucc", "succeed in approving order"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "pnr", "import code"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "flightno", "flight No."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "flightdate", "flight date"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "airportinfo", "airport info"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "cabin", "cabin"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "realflight", "actual carrier"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "depairportcode", "dep airport code"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "arrairportcode", "arr airport code"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "hotelname", "hotel name"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "hotelphone", "hotel phone"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "hoteladdress", "hotel address"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "hotelarrivedate", "Check-in Date"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "hoteldepartdate", "leave on"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "hotelamenddate", "Check-out Date"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "roomnum", "room num"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "roomtype", "room type"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "roombedtype", "room bed type"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "breakfast", "Breakfast"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "consumerDate", "Check-in"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "finishedDate", "Check-out"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "changeamendrule", "Refund/Change"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "aimcity", "destination city"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "selectdate", "Select date"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "keywords", "Keywords"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "hotelkeywords", "(option) hotel name / landmark / business district"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "search", "Search"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "qi", "start "), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "searchdetail", "View Details"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "notReserve", "No available room types"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "traffmap", "traffic map"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "sheetzone", "street zone"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "btripno", "Violate"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "btripyes", "Conform"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "room", "room"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "spec", "Square meter"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "live", "Tenantable"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "floor", "Floor"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "layer", "Layer"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "productname", "Product name"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "averagerate", "Average daily"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "breakfastInfos", "Breakfast information"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "breakfastyes", "Including"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "breakfastno", "Excluding"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "cancelno", "Non-Refundable"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "timecancel", "Refundable"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "plenty", "Enough"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "select", "Select"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "hotelfacilities", "hotel facilities"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "wifi", "wifi"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "none", "none"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "parking", "parking lot"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "allfacilities", "all facilities"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "activefacilities", "activity facilities"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "serviceproject", "service project"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "hotelpolicy", "hotel policy"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "depandarr", "check in and out"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "chdpolicy", "chd policy"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "mealment", "mealment"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "apartment", "apartment"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "theinn", "inn"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "familyhotel", "family hotel"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "youthhostel", "youth hostel"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "coupleshotel", "love hotel"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "gardencourtyard", "garden courtyard"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "seaview", "seaview"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "generated", "agritainment"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "hotspringshotel", "hot spring hotel"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "golfhotel", "golf hotel"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "siheyuan", "quadrangle courtyard"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "villa", "villa"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "cookingdinnerparty", "cooking party"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "businesstriphome", "business trip home"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "recreationalfeeling", "recreational feeling"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "hospital", "hospital"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "holidayleisure", "holiday leisure"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "traininglearn", "training and learning"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "party", "party"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "honeymoontrip", "honeymoon trip"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "boutiquehotel", "boutique hotel"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "indoorswimmingpool", "indoor swimming pool"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "outdoorswimmingpool", "outdoor swimming pool"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "gym", "gym"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "businesscenter", "business center"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "meetingroom", "meeting room"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "hotelrestaurant", "hotel restaurant"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "wakeupcall", "wakeup call"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "luggage", "luggage deposit"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "doublebed", "double bed"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "bigbed", "big bed"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "pickupservice", "pickup service"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "pet", "pet"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "creditcard", "credit card"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "username", "user name"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "usersex", "sex"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "PassengerType", "Type"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "cardtype", "card type"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "cardno", "card No."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "contactphone", "contact phone"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "birthday", "Date of birth"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "usercountry", "nationality"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "cardvaliditydate", "card validity date"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "add", "add"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "delete", "Delete"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "passselect", "select passenger"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "contactpeople", "contact people's name"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "contactphone", "contact phone"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "contactemail", "contact email"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "salesprice", "Sales price"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "marketprice", "Market price"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "supplyprice", "Settlement price"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "tourdepcity", "Departure City"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "tourarrcity", "Arrival City"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "teamno", "Group No."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "tourdepdate", "Travel date"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "remark", "Remark"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "traininfo", "Train info"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "trainno", "Train No."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "trainseattype", "Train seat type"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "traindepdatetime", "Depart Time"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "trainarrdatetime", "Arrival Time"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "traindepdate", "Departure Date"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "amendtime", "time limit for changing and refunding"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "moneysourceairway", "The actual amount is subject to the review of the airline"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "amendruletips", "The above adult refunding and changing rules and fee standards are for reference only, subject to the airline"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "adultticket", "adult ticket"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "amendfee", "fee for refunding"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "samechangefee", "fee for chaning"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "changecondition", "condition for changing"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "changeadopt", "allow to change"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "people", "people"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "completechange", "complete changing"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "reimburseinfo", "Reimbursement info"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "travleorderinfo", "can provide complete schedule"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "travleinvoince", "Provide difference invoices and itineraries"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "bagkg", "baggage allowance"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "forfeebagkg", "free baggage allowance  20KG"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "realtake", "acually take"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "realtaketips", "Please check in according to the actual flight."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "share", "Share"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "airplanemodel", "Airplane"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "isstop", "Stops"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "allprice", "full price"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "discount", "Dis"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "protocolprice", "Negotiate"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "build", "airrax"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "fuel", "fuel charge"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "booking", "Book"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "flightok", "confirm"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "allprices", "More"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "flightnum", "pcs"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "flightnumtips", "__ left nly"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "flightgo", "flight go"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "flightback", "flight back"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "flightdetail", "Flight detail"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "totalmoney", "total amount"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "flightticket", "domestic flight ticket"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "iflightticket", "international flight ticket"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "screening", "Filter"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "clear", "Clear"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "flightvuelo", "non-stop/transit"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "flightdeptimes", "Departure time"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "airways", "Airline"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "depairport", "Departure airport"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "arriveairport", "Arrival Airport"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "checkflightgo", "selected flight go"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "changeflight", "change flight"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "flightlisttips", "flight info"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "flightdeptime", "Departure time"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "flightarrtime", "arr time"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "flightprice", "Flight price"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "nostop", "Nostop"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "transfer", "{time} in {city}"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "NostopOrTransfer", "Nostop/Transit"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "ShareFlight", "sharing flight"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "HideShareFlight", "Hide shared flight"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "TransferVoyage", "Transit"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "am", "Morning"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "noon", "Noon"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "pm", "Afternoon"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "firstcabin", "First calss"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "businesscabin", "Business class"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "economycabin", "Economy Class"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "createflightorder", "confirm the next step"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "loading", "loading"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "flightpricechange", "The flight price has changed, please confirm the order!"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "tips", "tips"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "confirm", "cofir"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "flightbookingtitel", "my Licheng "), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "flightbooking", "flight booking"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "orderdetail", "order info"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "contactinfo", "Contact details"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "taketicketway", "Delivery"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "departcity", "Departure City"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "arrivecity", "Arrival City"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "destination", "Destination"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "departdate", "Departure time"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "arrivedate", "arr time"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "backdate", "Return Date"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "loginuser", "Current user"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "priceway", "Price terms"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "pricestips", "The ticket provided on this page is in net price and does not include service charge."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "firtransfer", "1 transition"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "sectransfer", "2 transition and above"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "transfercitys", "Transit city"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "economy", "economic class"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "business", "business class"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "first", "first calss"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "premiumecon", "super economic class"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "premiumebus", "super business class"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "premiumefirst", "super first class"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "iflightcitytips", "Please slect an international city!"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "approvalSelectCitytips", "To arrive at the destination city, there must be an approved itinerary for the flight!"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "approvalDepartDatetips", "The departure date must fall within the date range specified in the approval form!"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "approvalArriveDatetips", "The return date must fall within the approved date range!"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "approvalSelectHotelCitytips", "The destination city must have the approval form for the entire journey!"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "iflightbookingtips", "There are only __ ticket left for the flight you select"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "policyyes", "Conform"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "policyno", "Violating policy"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "priceandtax", "Tax included"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "stoptime", "Stop time"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "hotel", "Hotel"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "hotelpeoplenum", "number of people living "), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "hoteldeskphone", "reception phone"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "hotelleveltitle", "Stars from high to low"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "hotelpricetitle", "Price from high to low"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "below", "above"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "above", "below"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "hotelstart", "2-Star & Below / Budget"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "threehotelstart", "3-Star / Comfort"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "fourhotelstart", "4-Star / Upscale"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "fivehotelstart", "5-Star / Luxury"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "position", "location"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "nolimit", "Unlimited"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "adminregion", "District"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "businesszone", "Business district"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "startlevel", "Star Rating"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "contractHotel", "Contract Hotel"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "huazhuHotel", "Huazhu Hotel"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "facilities", "Facility"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "service", "service"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "hotelcounttips", "hotels"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "hotelcountall", "Total"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "hotelinfoorstart", "Hotel Infon / Star Rating"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "referprice", "Reference Price"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "reselect", "Reselect"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "chinahotel", "Domestic hotel"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "interhotel", "international Hotel"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "bookinghotel", "hotel reservation"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "hotelbookinginfo", "Booking Info"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "depandarrdate", "check-in-out"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "night", "nights"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "insure", "Insurance"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "hotelroomtype", "Room type"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "hotelproductcount", "More Products"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "chinatrain", "Domestic train"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "trainbooking", "Train ticket reservation"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "trainusernametip", "Name cannot be blank"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "trainusercardtip", "Please complete the certificate information"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "trainrecard", "ID card cannot be repeated"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "trainseatin", "succeed in booking, occupying seat"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "selectseatfree", "Free Selection"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "selectedseat", "Select"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "trainwindow", "Window"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "aisie", "Aisle"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "trainseattips", "Priority is given to designated seat. If there is no ticket for the selected seat, it will turn to other seats."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "noselectseat", "Unselect"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "change", "Change"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "timelength", "Duration"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "trainticketnum", "Number"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "trainchangamendinfo", "Refund/Change explain"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "traindepandarrstation", "dep/arr station"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "traindepandarrtime", "dep/arr time"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "trainlogin12306tip", "Log in to 12306 account to directly link to the railway official system, issuing tickets faster!"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "login", "Log in"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "account", "account number"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "login12306user", "12306 username"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "login12306pwd", "Please enter your password"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "loginerror", "wrong user name or password"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "loginout", "quit"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "logintip", "logged"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "btripinfo", "Business Info"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "shenpipingzheng", "Certificate Of Approval"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "youshenpipingzheng", "Within Certificate Of Approval"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "wushenpipingzheng", "Without Certificate Of Approval"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "shenpizhuangtai", "Status Of Approval"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "chuchaishenqingiworkyishenpi", "Travel application iworker Approved"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "shangweishenpi", "Not Approved"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "shenpidanhao", "Approval Number"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "yijishenpi", "Primary Approval"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "shangchuanfujian", "Upload Attachment"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "fujianliebiao", "Attachment List"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "inputcontent", "Please enter content"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "btripordertip", "The following trip violates the business trip policy and needs to supplement the reason for violation"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "btriporderttip", "(Special reminder: Please fill in the reasons for violation to better pass the review)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "ordervoyage", "trip"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "violate", "Violate"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "policydetail", "Policy"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "policynoreason", "reason for violating the policy "), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "policyreasondetail", "Detailed reason for violation "), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "consumerinfo", "Passenger Info"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "consumernametip", "Name should be consistent with the boarding pass"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "phoneareano", "area code ofMainland China"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "phonenotips", "The passenger's mobile phone number is used to receive flight dynamic information."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "saveconsumer", "Save as a frequent passenger"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "selectconsumer", "select passenger"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "addconsumer", "Add passenger"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "consumertip", "Important reminder: In order to ensure the trip, pls fill in the ID number accurately and the ending date of the trip must be at least 6 months earlier than the expiration date of the document."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "writeinfomation", "Filling explanation"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "demandremark", "Demand note"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "welcomelogin", "Welcome to login"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "registernow", "Sign up now"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "register", "Registered"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "loginbyaccount", "Login by account"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "loginbyphone", "Login by dynamic code"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "loginbyother", "You can also log in in the following ways"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "wechat", "WeChat"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "addressinfo", "Address"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "Add", "Add"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "defaultcontact", "Default"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "settingdefaultcontact", "set as the default address"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "edit", "Edit"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "contactpeople", "Name"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "contactphone", "Mobile"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "contactemail", "Email"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "adddemand", "Demand"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "voyagetype", "Voyage type"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "consumertype", "Passenger Type"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "adult", "adult"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "child", "child"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "infant", "baby"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "firstflightsearchtips", "Ifthe total number of passengers (excluding babies) is more than 9 people, please fill out"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "flightdemandorder", "Ticket demand list"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "lastflightsearchtips", "Make a reservation."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "firstiflightsearchtips", "A maximum of 2 children and 1 baby can be taken by per adult. If there are special demands, pls"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "adminregionhotel", "Hong Kong, Macao and Taiwan"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "unsubmit", "Unsubmitted"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "submited", "submitted"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "chenking", "under review"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "paymoney", "Paid"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "etdzticket", "Ticket issued"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "directclose", "deal done"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "searchtrainbytraintype", "Search only for high-speed trains"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "selectfrequent", "select frequent passengers"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "frequent", "frequent passengers"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "addtemporaryconsumer", "Add temporary passenger"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "home", "Home"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "tour", "Tour"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "train", "Train"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "flight", "Flight"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "car", "Car rental"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "food", "Food"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "btripplateform", "Platform"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "comcoop", "Cooperation"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "appdownload", "AppDownload"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "meeting", "Exhibition"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "visa", "visa"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "tourism", "ConferenceTravel"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "stationname", "Station name"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "trainstoptime", "Staying time"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "stopstationname", "transit stop"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "soldout", "Book"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "start", "Depart"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "over", "Passing"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "end", "Arrival"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "yu", "remain"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "trainbatch", "Train type"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "startorvoer", "Depart/ Stop"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "startstation", "Depart Station"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "endstation", "Arrival Station"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "changeticket", "Ticket change"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "pleasepasstochange", "Please select the passengers who need to change"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "pleaseselectnewdate", "Please select the changed date"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "oldtraininfo", "Original train information"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "gctrain", "G/C high-speed rail"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "dtrain", "D EMU"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "ptrain", "ordinary"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "traindeptime", "Departure time"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "trainarrtime", "Arrival time"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "trainstart", "Depart"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "trainover", "Stop"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "hour", "hour"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "minute", "minute"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "trainchangeinfo", "Changed train information"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "changetrain", "Changed to"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "changefee", "fee for changing"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "changeservicefee", "service fee for changing"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "totalfee", "total"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "changereason", "Reason for change"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "checking", "to be reviewed"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "boyin", "Boeing"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "kongke", "Airbus"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "zhuanxiangjia", "Exclusive"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "analysis", "Passenger analysis"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "contact", "Contact person"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "bigcus", "Big customer"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "airway", "Airline"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "selectcom", "Please select a company first"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "nameisetm", "Passenger name cannot be blank"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "writenametype", "Please enter the correct name (Chen/Wenjun)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "baoxianset", "Insurance configuration"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "saleandcus", "Sales / Customer Service Representative"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "recommendair", "Recommended flight"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "more", "More"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "hide", "hide"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "triprulename", "business trip policy"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "hightsearch", "Advanced Search"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "cabinlevel", "Class of cabin"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "submitapply", "submit application"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "interdemand", "demand orders of international and Hong Kong, Macao and Taiwan flight "), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "alltotal", "Total"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "demandcus", "If you have any questions, you can contact customer service. We will solve the problem in time for you."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "voyageinfos", "flight information"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "addvoyage", "Add flight"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "passinfos", "Passenger information"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "passnum", "Number of passengers"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "sui", "year old"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "twosui", "Under two years old"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "firstairway", "Preferred airline"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "phoneno", "Mobile"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "email", "Email"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "submit", "Submit"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "demandprobtip", "If you have a problem with the submission, please consult:"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "normal", "ordinary"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "student", "student"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "newimmigrant", "New immigrants"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "worker", "laborservice"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "submitordersucc", "succeed in submittingorder "), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "hotelfare", "Room rate"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "contservicefee", "inclduingservice fee"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "hotelinfoimp", "Hotel import"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "addhotel", "Add hotel"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "inputprice", "Please enter the correct amount"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "inputpriceerror", "The maximum amount cannot be less than or equal to the minimum amount"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "starrankdesc", "Stars sorted by recommendation"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "starrank", "Stars sorted from high to low"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "starrankasc", "Stars sorted from low to high"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "pricesort", "prices from high to low"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "pricesortdesc", "PriceS from low to high"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "clickrecomend", "Click to recommend"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "caclhotelprice", "Accounting for price..."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "none", "no"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "freebroadbang", "Free broadband"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "broadband", "Charged broadband"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "freewifi", "Free WIFI"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "wifi", "Charged WIFI"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "imgshow", "Image display"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "additinfos", "Extra Info"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "insurinfos", "Insurance Info"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "surname", "last name"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "givenname", "first name"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "orderpassup", "The upper limit for passengers on a single order"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "orderpassupend", "For more people, please contact customer service!"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "cabintype", "Class type"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "selectcabin", "select class"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "safetrip", "safet travel"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "downloadapp", "download Licheng app"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "selectchangepass", "Please select a passenger!"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "searchpassup", "9 passengers at most!"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "selectcontact", "Select contact person"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "cancel", "cancel"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "tourindextip", "Meet your business trip needs and provide a full range of service solutions for business travellers."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "tourdetailcall", "For details, pls consult"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "yearmeet", "Annual meeting"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "yearmeettips", "Full-process tracking service to create the highest-end corporate annual meeting"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "comyearmeet", "Company Annual Meeting"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "comtourtips", "Customize the most comfortable travel itinerary for company needs"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "comtour", "Company Travel"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "teambuild", "team building"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "teambuildtips", "Provide customized outdoor team building services for enterprises"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "createteambuild", "team building planning"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "exhibit", "Exhibition"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "exhibittips", "Provide one-stop conference planning and execution services for customers"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "comexhibit", "Conference exhibition"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "trainordercretips", "The upper limit for passengers on a single order is 5. If there are more people traveling, please contact customer service or make another order."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "trainpassrepeat", "The passenger name cannot be repeated."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "trianorderpassup", "You can only select up to 5 passengers."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "inputpassgivenname", "Please enter the passenger first name."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "inputpasssurname", "Please enter the passenger's last name."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "trainpassseattips", "The number of passengers exceeds the number of seats selected"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "aisle", "aisle"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "NeedInvoice", "need invoice"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "NoInvoice", "Do not need invoice"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "delway", "Delivery Method:"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "exprefee", "Courier fees:"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "addresspass", "Recipient"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "postcode", "Postal code"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "deladdress", "delivery address"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "inputphoneno", "Please enter the phone number"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "inputphonerealno", "Please enter the correct phone number"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "inputtickettitle", "Please enter the invoice title"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "inputaddresspass", "Please enter the recipient"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "inputdeladdress", "Please enter the recipient address"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "Invite", "Pick up"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "Mail", "mail"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "nothing", "No need"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "parper", "Paper invoice"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "tourservicefee", "Travel service fee"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "express", "express delivery"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "ticketfare", "Ticket face"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "trainnamecardtips", "thename should be consistent with the name of the travel document"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "phonecountry", " Area Code ofMainland China: 86"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "phoneinfotips", "The passenger's mobile phone number is for receiving short message on the mobile phone"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "savecuspass", "Save as a frequent passenger"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "triprulemanage", "Travel management"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "trainorderseat", "Please select a seat for the selected passenger"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "createordernow", "Booking"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "parenter", "Partner"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "aboutus", "about us"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "companyinfo", "Licheng Business Trip is China's leading travel management company. It is affiliated to Licheng Group. Over the past ten years, it has relied on strong resources, advanced technology, excellent service and professional management, and provided services for more than 6,000 medium and large enterprises, including more than 120 Fortune Global 500 companies and more than 100 Chinese Fortune 500 companies."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "companywechat", "Follow the Official Account of Licheng Business Trip"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "companyname", "Licheng Business Trip"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "simple", "simpler"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "free", "Freer"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "lowermoney", "chepaer"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "traintuiinfo", "instructions for refunding"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "traintuiinfo1", "1: Once the purchase agent is successful and the ticket is not picked up, you can enter “My Order” and click the train order to apply for refundinh according to the prompt more than 35 minutes before the departure; the railway administration charges fee for refunding within 15 days before the departure  according to the echelon."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "traintuiinfo2", "2: Once the purchase agent is successful and the ticker has been picked up, or it is less than 35 min before the departure, you need to bring the original valid certificate of the passenger and the train ticket to the ticket refund window of the train station before the departure."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "trainchanginfo", "instructions for changing"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "trainchanginfo1", "1: If the paper ticket is not picked up and it is more than 35min before the departure, you can change to trains with price equal to or lower than the original ticket fare. In other conditions that it cannot be changed online, it is required to go to the train station window before departure."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "trainchanginfo2", "2: more than 48 hours before the departure, you can change to trains within the pre-sale period. Within 48 hours before departure, you can change to the trains before 24:00 on the date of the ticket, and change to trains after the date of the ticket will not be processed."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "trainchanginfo3", "3: If the fare of the new ticket that is lower than the original ticket, the difference is partially refunded and the current refund fee is imposed."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "datetimenotrain", "ticket for thecurrent date is not sold now"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "NoTrainSearch", "No train inquiry service is available during the current time"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "ReserveHint", "It is a non-connecting flight. If one of the flights is changed, the passenger who needs to cancel the other flight will bear the corresponding cancellation fee."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "chailvguize", "Travel Policy Name"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "guonei", "Domestic"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "guojie", "International"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "jipiao", "Flight"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "jiudianguize", "Hotel Policy"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "huoche", "Train"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "guize", "Rules"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "zuidijiajizhun", "Lowest Price"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "wuxianzhi", "Unlimited"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "xiangduizuidijia", "Lowest Relative Price"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "quantianzuidijia", "Lowest Day  Price"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "shiduanzuidijia", "Lowest Time Slot Price"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "hangbanzuidijia", "Lowest Available Fare"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "shishihangbanguankong", "Real-time Flight Control"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "tiqianyudingshijian", "Advance booking time"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "kedingcangweijibie", "Allowed Booking Class"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "kedingzuoweijibie", "Allowed Seat Class"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "xieyijipiaoyouxian", "Preferred Agreement Flights"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "xieyijiudianyouxian", "Preferred Hotel Priority"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "xiaofeijineshangxian", "Spending Limit"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "dangdizhusubiaozhunshangxian", "Local Accommodation Standard Limit"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "yudingxuzhi", "Booking Regulations"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "dingpiao", "Book"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "tuipiaochongkai", "Refund Reissue"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "xuanweiqucheng", "Choose to go"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "yes", "Yes"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "no", "No"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "firstcity", "Tier 1 City"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "seccity", "Tier 2 City"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "thrcity", "Tier 3 City"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "within", "Within"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "qxzhsrxmdm", "Please select or input the project code"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "qxzxmdm", "Please select the project code"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "weibeixiaofeijineshangxian", "Maximum Spending Amount"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "dangdizhusubiaozhun", "Local Accommodation Standard"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "youchuang", "Has Window"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "weichuang", "No windos"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "qianmianfeiquxiao", "Free cancellation before，After"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "zhihoubukequxiao", "non-Refundable"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "wuzao", "Room Only"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "nights", "{number}Nights"), _mall),
  manage: {},
  bill: (_bill = {
    bankaccount: "Bank Account",
    acronym: "Abbreviation",
    select: "please choose",
    query: "Inquire",
    added: "Add",
    export: "Export",
    companyname: "company name",
    inorout: "Income and expenditure type",
    accountstatus: "Account Status",
    operation: "operation",
    enable: "Enable",
    disable: "Disable",
    update: "modify",
    content: "Please enter content",
    cancel: "cancel",
    save: "save",
    confirm: "confirm",
    accountadded: "Account addition",
    accountupdate: "Account modification",
    enableordisableprompt: "Is this action used to disable or enable, continue?",
    prompt: "prompt",
    receivebill: "Account receivable period",
    bill: "Account period",
    closeaccountprofit: "Closing gross profit",
    comparisonsales: "Sales comparison",
    closeaccountstarttime: "start date of closing ",
    starttime: "start date",
    closeaccountendtime: "Closing deadline",
    endtime: "Deadline",
    clientname: "client's name",
    customerservicerepresentative: "Customer Service Representative",
    salesrepresentative: "Sales Representative",
    number: "Number of items",
    closeaccountprofittotel: "Closing gross profit",
    inadditioninterestprofit: "Gross profit after interest",
    receiveprice: "Receivable amount",
    actualprofit: "Actual gross profit",
    profitrate: "Gross profit margin",
    interest: "interest",
    additioninterestprofit: "gross profit after interest",
    additioninterestprofitrate: "Gross profit margin after interest",
    profitprecent: "Gross profit ratio",
    back: "<<Back",
    Internationalflight: "International Ticket",
    internalflight: "Domestic ticket",
    Internationalhotel: "international Hotel",
    internalhotel: "Domestic hotel",
    internaltrain: "Domestic train",
    selectyearmonth: "Choose year and month",
    tradebill: "Transaction period",
    agreedpaystarttime: "start date of appointment checkout ",
    agreedpayendtime: "ending date of appointment checkout ",
    billdate: "Billing date",
    billdateend: "Deadline",
    agreedpaydate: "Appointment closing date",
    waitoutday: "Unregistered",
    waitaudited: "Unreviewed",
    waitconfirm: "unconfirmed",
    amountshouldbeclosed: "Amount due",
    detail: "detail",
    total: "total",
    createtime: "Create on",
    orderid: "Order number",
    businesstype: "business type",
    servicetype: "Service type",
    paymentincludinginsurancecharge: "Payable (including service fee /insurance fee)",
    passengername: "Passenger name",
    bookingname: "booked by",
    productname: "product name",
    billaggregate: "Summary of accounts",
    billdetail: "Account period details",
    size: "size",
    amountreceivable: "Uncollected amount",
    allstatus: "All states",
    billname: "Account period name",
    expiretime: "Date of Expiry",
    overdueday: "Days Overdue)",
    receivable: "Receivable",
    havebeentaken: "received",
    notreceive: "unreceived",
    profit: "gross profit",
    totalaccountingperiod: "Total amount outside the account period",
    invoicestatus: "Invoice status",
    statusdetail: "Status (details)",
    Updates: "Update",
    receivedetail: "Receivable details",
    createstarttime: "Creation start date",
    createendtime: "Creation deadline",
    receivestarttime: "Collection start date",
    receiveendtime: "Collection deadline",
    paymentstarttime: "Payment start date",
    paymentendtime: "Payment deadline",
    applyarea: "Area type",
    supplyid: "Supply order number",
    supplyname: "Supply name",
    voucherno: "Document number",
    intentname: "Travel purpose",
    projectcode: "Project code",
    invoiceid: "Invoice number",
    template: "template",
    templatemanager: "Template management",
    fullscreen: "full-screen display",
    quanping: "Exit Full Screen",
    orderselect: "Order select",
    receivestatus: "Collection status",
    invoiceapplication: "Invoice application",
    receiveaudit: "Collection review",
    receiveconfirm: "Receipt confirmation",
    losstreatment: "Loss processing",
    receivefinished: "Collection and closing",
    receiveaudited: "Return of payment",
    costcenter: "Cost Center",
    expenseDepartment: "Expense Bearing Department",
    supplyName: "Supply Name",
    bulkEditingSupplyName: "Bulk Editing Supply Name",
    all: "All",
    paymentstatus: "payment status",
    obligation: "to be paid",
    paymentaudit: "Payment review",
    paymentconfirm: "Payment confirmation",
    paymentfinished: "Collection and closing",
    paymentaudited: "Return of payment",
    orderselecttext: "Please enter the order number to be selected (separated by space, line feed or comma)",
    receivefaila: "Please conduct customer inquiry first.",
    receivefailb: "Please tick the details you need to operate.",
    receivefailc: "Please select the correct data",
    receivefaild: "Please first set the supply name",
    invoiceapplyfaila: "Please select data that has not submitted an invoice request",
    order: "Order",
    losstreatmentfail: "If the closing margin is more than 10% or less than 10%, please first deal with the loss.",
    loading: "Executing operation...",
    orderselectfail: "Please enter the order number for which you want to tick the details.",
    tradedetail: "Transaction details",
    templatename: "Template name",
    rightmove: "move to the right",
    leftmove: "move to the left",
    topmove: "Move up",
    bottommove: "Move down",
    rightfaila: "Please select the data to be moved to the right",
    leftfaila: "Please select the data to be moved to the left",
    topfaila: "This data cannot be moved up",
    bottomfaila: "This data cannot be moved down",
    templatfaila: "Please select a piece of data to move up and down",
    costcenternamesearch: "Cost name search",
    expenseDepartmentNameSearch: "Expense bearing department name search",
    supplyNamesearch: "Supply name search",
    billnamesearch: "Account name search",
    receivetablefaila: "Please select a cost center",
    selectExpenseDepartment: "Please select an expense bearing department",
    receivetablefailb: "Please quit and re-edit first",
    receivetablefailc: "Please select the account period",
    receivetablefaild: "Please select a supply name",
    billownername: "No account period is set, review in advance",
    profitandlossreasons: "Cause of profit and loss",
    lossreasons: "Reason for loss",
    profitreasons: "Reason for profit",
    reakeven: "No loss",
    losscausefaila: "Please choose the cause of the loss",
    invoiceitemname: "project name",
    invoiceitemmodel: "Specification model",
    invoiceitemunitname: "unit",
    invoiceitemnum: "Quantity",
    invoiceitemfare: "unit price",
    invoiceitemcost: "cost",
    invoiceitemamount: "Amount",
    invoiceitemrate: "tax rate",
    invoiceitemtax: "tax",
    delete: "Delete",
    invoicetitle: "Invoice title",
    invoicetype: "invoice type",
    clientadress: "customer address",
    clientemail: "Customer mailbox",
    remark: "Remarks"
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_bill, "invoiceapplyfaila", "Please enter the correct quantity"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_bill, "invoiceapplyfailb", "Please enter the correct unit price"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_bill, "invoiceapplyfailc", "Please enter the correct tax rate"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_bill, "invoiceapplyfaild", "The submitted invoice price cannot be greater than the original invoice price"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_bill, "invoiceapplyfaile", "Successful invoice application"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_bill, "accountname", "account name"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_bill, "accounttype", "account type"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_bill, "tradeaccountlistfaila", "Please enter the correct amount"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_bill, "tradeaccountlistfailb", "Recharge successfully entered"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_bill, "tradeaccountlist", "Account list"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_bill, "availablebalance", "Available Balance"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_bill, "accountbalance", "Account Balance"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_bill, "creditbalance", "credits"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_bill, "blockedamount", "Frozen amount"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_bill, "flow", "account statement "), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_bill, "recharge", "Recharge"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_bill, "blockedtransactions", "Transaction freezing"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_bill, "tradename", "Name of Trade"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_bill, "freezingtime", "Freezing time"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_bill, "creditline", "credit line"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_bill, "contractdate", "Contract date"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_bill, "creditaddedprompt", "The fixed credit line is valid according to the contract date. If it is expired, please renew it."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_bill, "provisionalcredit", "Temporary credit"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_bill, "effectivedate", "effective date"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_bill, "expirydate", "Expiration date"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_bill, "lodamt", "Recharge amount"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_bill, "transactionflowing", "Trading log"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_bill, "tradedate", "transaction date"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_bill, "flowtype", "account statement type"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_bill, "transactionamount", "The transaction amount"), _bill),
  webdata: (_webdata = {
    interfaceManage: "interfaceManage",
    ChangeCheckPNR: "ChangeCheckPNR",
    insuranceamend: "refund processing",
    supplylist: "supplylist",
    orderlist: "Order list",
    mallservice: "Mall service",
    wechat: "webdata",
    dealwarranty: "Policy processing",
    insuranceorder: "Insurance order",
    insuranceservice: "Insurance service",
    insurancepolicy: "Insurance policy",
    changruletime: "Change time limit",
    baggagerule: "Baggage Rule",
    departmanage: "Department management",
    see: "View",
    oftenconsumermanage: "Frequent passenger management",
    oftenconsumer: "Common passengers",
    costcenter: "Cost Center",
    expenseDepartment: "Expense Bearing Department",
    deal: "prccess",
    waitdispos: "To be processed",
    waitdispose: "To be processed",
    waitpayment: "to be paid",
    waitconfirm: "to be confirmed",
    waitthrowin: "to be reviewed",
    waitapprove: "to be approved",
    waitsubmit: "to be submitted",
    waitrefund: "to be refunded",
    waitbooking: "to be reserved ",
    addressmanage: "Address management",
    dealorder: "Order processing",
    ordermanage: "Order management",
    subservice: "Subscription service",
    dealinvoice: "Invoice processing",
    inviceservice: "Invoice service",
    invoicemanage: "Invoice management",
    servicefeesetting: "Service fee setting",
    servicemanage: "Service management",
    serviceinfo: "Service Information",
    interfaceinfo: "Interface Information",
    payment: "payment",
    dealpayment: "Payment processing",
    peoplemanage: "Personal management",
    companysetting: "Company configuration",
    internationflight: "International Ticket",
    internationhotel: "international Hotel",
    internationaltour: "international travel",
    chinatraffic: "Domestic traffic",
    chinatrain: "Domestic train",
    chinaflight: "Domestic ticket",
    chinahotel: "Domestic hotel",
    chinatravel: "Domestic travel",
    trainorder: "Train order",
    flightorder: "Ticket order",
    trafficorder: "Order processing",
    basedata: "Basic data",
    transaction: "Transaction details",
    tradereceive: "Receivable details",
    tradepayment: "Transaction details",
    smstemplate: "SMS template",
    datastatistics: "Data statistics",
    tradeweek: "Transaction period",
    billreceive: "Account receivable period",
    billpayment: "Transaction period",
    hotelorder: "hotel order",
    customermanage: "Customer management",
    customerlevel: "Customer level",
    dealdelivery: "Express processing",
    deliveryservice: "Delivery Service",
    deliverypolicy: "Express policy",
    flowmanage: "Process management",
    tourorder: "Travel order",
    companymanage: "Company management",
    companyinfo: "Company Information",
    companyhome: "Business homepage",
    visaorder: "Visa order",
    visaservice: "Visa service",
    allorder: "All orders",
    purviewmanage: "authority management",
    purviewcontrol: "authority control",
    approve: "Approval",
    dealmoneyin: "Collection processing",
    moneynandoutmanage: "Income and expenditure management",
    authorizemanage: "Authorization management",
    amendorder: "Refunded and changed order",
    changeamendrule: "refunding and changing rules",
    clientuser: "Big customer",
    domainmanage: "Domain management",
    notifymanage: "Notification management",
    dealrefund: "Refund processing",
    dealamend: "Refund processing",
    dealamendorder: "Refund processing",
    dealamendtour: "group refund processing",
    webmanage: "Website management",
    mineinfo: "my information",
    usermain: "my home page",
    systemmanage: "System Management",
    discrete: "Split",
    forbiddened: "disabled",
    canceled: "Cancelled",
    throwined: "Go online",
    rejected: "Returned",
    rejectes: "Returned",
    finished: "completed",
    finishes: "completed",
    hanguped: "Go offline",
    bankaccount: "Bank Account",
    coupon: "coupon",
    employeemanage: "Employee management",
    cannnot: "Temporarily can't",
    cannot: "Temporarily can't",
    accountsafe: "configurat management",
    accountmanage: "Account management",
    tradeaccount: "Trade Account",
    financemanage: "Accounting management",
    policymanage: "Policy management",
    policymangage: "Policy management",
    jobmanage: "Position management",
    businessservice: "Business trip service",
    chargeservice: "Value-added services",
    chargepolicy: "Service Policy",
    feedback: "Feedback"
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_webdata, "mallservice", "Mall service"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_webdata, "orderchange", "Flight Change"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_webdata, "smsnotify", "Notification"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_webdata, "orderlist", "Orders"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_webdata, "sharelist", "MG active"), _webdata),
  category: (_category = {
    AmendingFlight: "Part Amending",
    ChangeingFlight: "Part Changeing",
    AmendingTrain: "Part Amending",
    ChangeingTrain: "Part Changeing",
    AmendingHotel: "Part Amending",
    ChangeingHotel: "Part Changeing",
    AmendingTour: "Part Amending",
    ChangeingTour: "Part Changeing",
    AmendedFlight: "Part Amended",
    ChangeedFlight: "Part Changeed",
    AmendedTrain: "Part Amended",
    ChangeedTrain: "Part Changeed",
    AmendedHotel: "Part Amended",
    ChangeedHotel: "Part Changeed",
    AmendedTour: "Part Amended",
    ChangeedTour: "Part Changeed",
    AllAmendingFlight: "Amending",
    AllChangeingFlight: "Changeing",
    AllBookingFlight: "Booking",
    AllAmendingTrain: "Amending",
    AllChangeingTrain: "Changeing",
    AllBookingTrain: "Booking",
    AllAmendingHotel: "Amending",
    AllChangeingHotel: "Changeing",
    AllBookingHotel: "Booking",
    AllAmendingTour: "Amending",
    AllChangeingTour: "Changeing",
    AllBookingTour: "Booking",
    AllAmendedFlight: "Amended",
    AllChangeedFlight: "Changeed",
    AllBookedFlight: "Booked",
    AllAmendedTrain: "Amended",
    AllChangeedTrain: "Changeed",
    AllBookedTrain: "Booked",
    AllAmendedHotel: "Amended",
    AllChangeedHotel: "Changeed",
    AllBookedHotel: "Booked",
    AllAmendedTour: "Amended",
    AllChangeedTour: "Changeed",
    AllBookedTour: "Booked",

    "1672category": "HotelFare",
    "1674category": "TeamFare",
    "1660category": "TicketFare",
    "1662category": "BuildFare",
    "1664category": "FuelFare",
    "1666category": "TaxFare",
    "1692category": "DirectReduction",
    "1668category": "SafeFare",
    "1670category": "ServiceFare",
    "1678category": "AmendFare",
    "1682category": "ChangeFare",
    "1684category": "OldPrice",
    "1690category": "OtherFare",
    "1694category": "ThrowDiscount",
    Conference: "Conference",
    EnterprisesUnit: "Enterprises and institutions",
    GovernmentDepartment: "Government agencies",
    PeopleEnterprises: "Private assets",
    CountryCapital: "State-owned Assets",
    ChinaOuterJoinCapital: "Sino-foreign joint venture",
    ForeignCompany: "Foreign-owned",
    CompanySize100: "Less than 100 people",
    CompanySize499: "100~499",
    CompanySize999: "500~999",
    CompanySize4999: "1000~4999",
    CompanySize5kUp: "More than 5000",
    Internal: "Domestic",
    Overseas: "International",
    IDCard: "ID card",
    PassportCard: "passport",
    StudentCard: "Student card",
    OfficerCard: "Military officer card",
    OtherCard: "other",

    Residencepermit: "Residence permit for Hong Kong, Macao and Taiwan residents",
    ForeignResidentIDCard: "Foreign Permanent Resident ID Card",
    HKCompatriotsyndrome: "Hong Kong and Macau Exit-Entry Permit",
    TaiCompatriotsyndrome: "Taiwan travel permit",

    Enable: "Enable",
    UnEnable: "Disable",
    Male: "male",
    Female: "Female",
    Yes: "Yes",
    No: "no",
    SingleVoyage: "One Way",
    RoundVoyage: "Round Trip",
    ReturnVoyage: "Return journey",
    MultiVoyage: "Multi journey",
    TransferVoyage: "Transfer journey",
    BSP: "BSP",
    B2B: "B2B",
    OverseasElectronic: "Overseas electronics",
    ConnectVoyage: "Interconnection",
    Team: "group ",
    Fit: "Individual",
    Unlimited: "Unlimited",
    HighOpen: "open high",
    DownOpen: "open low",
    Monday: "Monday",
    Tuesday: "Tuesday",
    Wednesday: "Wednesday",
    Thursday: "Thursday",
    Friday: "Friday",
    Saturday: "Saturday",
    Sunday: "Sunday",
    WithinIntercontinental: "Within the same intercontinental range",
    PolicyDepartAirport: "range of the policy originating airport ",
    NoReward: "No reward",
    AgencyFreeFee: "No agency fee",
    MustBackAirport: "Must return to the airport with same trip",
    AppointBackAirport: "Specify return country or airport range",
    CommonFlight: "Ordinary flight",
    ShareFlight: "Shared flight",
    Prepay: "Prepaid",
    CashPay: "by cash",
    OverseasStudent: "International student",
    Immigrant: "Immigration",
    Worker: "labor",
    Seaman: "sailor",
    Youth: "youth",
    HkMacaoTw: "Hong Kong, Macao and Taiwan",
    ForeignNationality: "Foreign nationality",
    NotChineseName: "Non-Chinese character name",
    AddOn: "Add-On",
    OldGge: "Old people",
    OverseasTransfer: "Transit abroad",
    NotchRange: "Flight schedule with land transport",
    OPEN: "OPEN",
    SPA: "SPA",
    QValue: "Q value",
    SharedFlight: "Shared flight",
    ThreeAgreement: "Tripartite agreement ",
    Package: "Package",
    WholeGroup: "Whole group",
    SmallGroup: "Small group",
    RewardsAdults: "Reward is the same as adults",
    NoOpenBonus: "No reward",
    WithoutReward: "Can be opened, no reward",
    NotOpen: "can't be opened",
    NoCodingRequired: "No need to return code",
    CodeOut: "Change code for ticketing",
    BigTicket: "ticketing with big number (no need to change)",
    BigNoTicket: "ticketing with big number (need to change)",
    NoChange: "No seat, no change of ticket (change when there is seat)",

    SingleRound: "One way / round trip",
    MonthCycle: "month",
    WeekCycle: "week",
    DayCycle: "day",
    HKMpermit: "Exit-Entry Permit for Travelling to and from Hong Kong and Macao ",
    TaiWpermit: "Travel Permit for Mainlanders to Enter and Exit Taiwan",
    OnlineServiceMode: "Online service",
    LineServiceMode: "Offline service",
    PercentageMode: "percentage",
    FixedPrice: "fixed amount",
    ExpensePrice: "Ticket price",
    PriceFareAndTax: "Ticket price + tax",
    DirectUpdate: "Direct modification",
    AddLittle: "add a little",
    ReduceLittle: "reduce a little",
    User: "user",
    Jobs: "job title",
    Group: "Group",
    Department: "department",
    Company: "company",
    Service: "service",
    Customer: "client",
    Actions: "Permission",
    CostCenter: "Cost Center",
    ExpenseDepartment: "Expense Bearing Department",
    Server: "Server-side",
    Client: "Client-side",
    Normal: "normal",
    Change: "change",
    SelfOnly: "Only yourself",
    SelfLower: "yourself and subordinate",
    NoLimit: "not limited",
    UnAuthorized: "unauthorized",
    Authorized: "Authorized",
    SystemRole: "System role",
    UserRole: "User role",
    ContinueBefore: "Before continuing",
    ContinueAfter: "After continuing",
    ReturnBefore: "Before returning",
    ReturnAfter: "After returning",
    ChangeBefore: "Before change",
    ChangeAfter: "After change",
    NeedInvoice: "Need invoice",
    NoInvoice: "Do not need invoice",
    WEB: "website",
    RMB: "yuan",
    Dollar: "Dollar",
    Alipay: "Alipay",
    WeChat: "WeChat",
    Cash: "cash",
    Monthly: "Monthly statement",
    Tour: "Tour",
    Hotel: "Hotel",
    Flight: "Flight",
    AdviceNote: "Group notice",
    GuestEnclosure: "Guest attachment",
    other: "Other",
    Electronic: "Electronic contract",
    ClientMessage: "Leave a message to guest",
    SupplyMessage: "Leva a message to supplier",
    WorkmateMessage: "Leave a message to colleague",
    Traveled: "Traveled",
    NotTravel: "Have not traveled"
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Change", "change"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Sales", "Sales"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Refund", "Refund"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "PasswordVerify", "Login password"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "EmailVerify", "E-mail verification"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "PhoneVerify", "Phone verification"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "NameVerify", "Real name verification"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "SafetyProblem", "safety question"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "WEB", "website"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "APP", "Mobile phone"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "BtripService", "Business trip service"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "HotelService", "hotel service"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "TourService", "Travel services"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "FlightService", "Ticket service"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "ChargeService", "Value-added services"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "HightDirector", "Who is my class teacher in high school?"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Firstgame", "First game accomplished"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "PhoneContact", "Mobile phone"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "TelephoneContact", "phone"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "EmailContact", "Email"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "QQ", "QQ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "OnlineKnow", "Online booking instructions"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "TourKnow", "Domestic travel booking instructions"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Enable", "Enable"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "UnEnable", "Disable"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "PriceEnable", "Price enabled"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "PriceUnEnable", "Price disabled"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Indeterminate", "Price to be determined"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "PrivatePolicy", "Private policy"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "PublicPolicy", "Public policy"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Receive", "Receive"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Payment", "pay"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Unsubmit", "Unsubmitted"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Submited", "Submitted"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Unaudit", "Not approved"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Audited", "Approved"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "AuditRefuse", "Approval rejection"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Untreated", "Unprocessed"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "RefundeBad", "Fail to withdraw"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "RefundeIng", "Withdrawal processing"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Refunded", "Successfully wirhdraw"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Country", "Country"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Scenic", "Scenic spot"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "City", "city"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Province", "province"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Area", "Region"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Airport", "Airport"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Continent", "Continent"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "District", "District"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Invite", "Pick up"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Mail", "Mailing"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "insideOutside", "Domestic origin"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "outsideInside", "Direct flight SOTO"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "insideInsideOutside", "Domestic originating Add-On"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "outsideInsideInside", "Foreign originating Add-On"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "outsideOutside", "Overseas to overseas"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "insideOutsideOutside", "Domestic originating transit"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "outsideOutsideInside", "Foreign originating transit"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "outsideOutsideOutside", "Overseas overseas overseas"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "outsideInsideOutside", "Overseas domestic overseas"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "globalGlobal", "Global to global"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "globalGlobalGlobal", "Global transit global"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "openAgencyFee", "Can invoice with no agency fee"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "NoWay", "Cannot invoice"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "InsuranceService", "Insurance service"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "ExpressService", "Delivery Service"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "InvoiceService", "Invoice service"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "VisaService", "Visa service"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "TrainService", "Train service"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "TravelNotes", "Booking instructions"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "ExpenseKnowledge", "Fee instrucitons"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "ShortMessage", "SMS"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Mail", "mail"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Wechat", "WeChat"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "EexamineOrderSms", "Approve order message content"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "EexamineApprovalSms", "Message content approved"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "EexamineRefuseSms", "Message content rejected "), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "EexamineAccomplishSms", "Order processing, complete message content"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Refunds", "Refund completed"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Transfer", "Transfer"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Train", "Train ticket"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "BusinessSeat", "Business class"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "SpecialSeat", "special class"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Level1Seat", "First-class seat"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Level2Seat", "second class seat"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "HighGradeSleeper", "Senior soft sleeper"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "CommonSleeper", "Soft sleeper"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "HardSleeper", "Hard sleeper"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "SoftSeat", "Soft seat"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "HardSeat", "Hard seat"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "NotHaveSeat", "No seat"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Economy", "Economic class"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Buissenes", "Business class"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "First", "First class"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "DayLowestPrice", "Lowest price throughout the day"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "FlightLowestPrice", "Lowest price of the whole flight"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "HighSpeedRail", "High-speed rail"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "SleepingBerth", "Sleeper"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Other", "fast passenger train and other"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Whole", "All"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Position", "position"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Department", "department"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "FlatFeeCharges", "Fixed charge"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "PercentageCostFee", "Charge by percentage"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Department", "This department"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "DepartmentLower", "This department and subordinates"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "TravelPurpose", "Travel purpose"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "PolicyCause", "Policy reason"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "FlightChange", "I have to change my itinerary and don't want to fly"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "FlightMistaken", "Wrong trip, date, time, name"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "FlightDelay", "Flight delay or cancellation"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "OnBusiness", "Business"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "OnPersonal", "Personal"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "PayApproval", "Order payment approval"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "ChangeApproval", "Order change approval"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "ReturnTicketApproval", "Order refund approval"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "People", "Charge by person"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "legs", "Charge by segment"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "OnLineReservation", "Online booking"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "OffLineReservation", "Offline booking"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "WorkingTime", "working time"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "NonWorkingTime", "Non-working time"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "OnlineBookingApproval", "Online booking needs approval"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "OfflineBookingApproval", "Offline booking needs approval"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "ViolateRuleApproval", "Violation of rules needs approval"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "ChangeTripApproval", "Change of the trip needs approval"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "CancelTripApproval", "Cancellation of the trip needs approval"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Preflight", "Before takeoff"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "AfterTakeoff", "After takeoff"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "RuleEndorse", "Change"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "RuleFund", "Refund"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Reserve", "Book"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "CaterService", "Catering Services"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "TrafficService", "Transportation service"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "TicketService", "Ticket service"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "BaseService", "Basic services"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Volunteer", "Volunteer"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "FlightChang", "Flight change"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "BuyAgain", "Repurchase"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "SickAmend", "Refund due to sickness"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "NameError", "Wrong name"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "CabinChange", "Upgrade"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "TicketInvalid", "invalid ticket"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Other", "other"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "WaitSubmit", "To be submitted"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "WaitPayment", "To be paid"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "WaitConfirm", "unconfirmed"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Finished", "confirmed"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Canceled", "Cancelled"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Rejected", "Returned"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "SystemService", "system service"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "WorkService", "Work service"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "OrderService", "Order service"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "BillService", "Billing service"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "UserService", "Personal service"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "CompanyService", "Corporate Service"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "TicketFare", "Ticket face"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "BuildFare", "airrax"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "FuelFare", "Fuel"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "TaxFare", "Tax"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "SafeFare", "Insurance"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "ServiceFare", "service"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "HotelFare", "Room rate"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "TeamFare", "Group fee"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "AmendFare", "Refund"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "ChangeFare", "change"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "OtherFare", "other"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "DirectReduction", "Direct reduction"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "ThrowDiscount", "discount"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Infant", "baby"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Enfant", "child"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Young", "adult"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Wrinkly", "middle aged"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Elderly", "elderly"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "BusinessLicence", "business license"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "TaxRegistration", "Tax registration certificate"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Other", "other"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "WaitSubmit", "To be submitted"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "WaitDispose", "To be processed"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Cannot", "Temporarily cannot"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Finished", "Completed"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Rejected", "Rejected"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Bill", "Approval"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Balance", "Balance"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Credit", "Credit"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Integral", "Integral"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "FixedCredit", "Fixed credit"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "InterimCredit", "Temporary credit"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "WaitOutDay", "To be billed"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "WaitAudited", "To be reviewed"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "WaitConfirm", "To be confirmed"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "WaitReceive", "To be paid"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Finished", "Closed"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Rejected", "Returned"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Change", "Change"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Bill", "Accounting"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Company", "Company"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Product", "product"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Sales", "Sales"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Amend", "Refund"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "People", "personal"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Customer", "Customer service"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "HotelChange", "Change of trip"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Station", "station"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "CompanyID", "Company"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "People", "personal"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "SpecialTicket", "Special ticket"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "GeneralTicket", "General ticket"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Electronic", "Electronic invoice"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Paper", "Paper invoice"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "HotelDelay", "Tripcancelled"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Economy5", "50% off economic class"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Economy6", "60% off economic class"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Economy7", "30% off economic class"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Economy8", "20% off economic class"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Economy9", "10% off economic class"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "MessageNotify", "SMS notification"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "MailNotify", "E-mail notification"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "WechatNotify", "WeChat notification"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "AppNotify", "App notification"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "WaitOutDay", "To be billed"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "OverdueNo", "Not overdue"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "OverdueYes", "Overdue"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Percentage", "percentage"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "FixMoney", "fixed amount"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "RemovePrice", "Excluding price"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Creater", "creator"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Member", "Participant"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Watcher", "Follower"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Text", "text"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Html", "HTML"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Link", "link"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Plugin", "Plugin"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "CompanyInternal", "inside company"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "CurrentDomainName", "Current domain name"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "AllDomainName", "All domain names"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Email", "e-mail"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "OrdinaryAddress", "Ordinary address"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "B2C", "B2C"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "B2G", "B2G"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Demand", "demand"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "WaitBooking", "Reserved"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "WaitApprove", "Approved"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "WaitConfirm", "Confirmed"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "WaitPayment", "To be paid"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "WaitDispose", "Processed"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Finished", "Completed"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Canceled", "Cancelled"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Rejected", "Returned"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Discrete", "Split"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Cannot", "Temporarily cannot"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "EmailAuth", "email address"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "MobileAuth", "phone account"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "AccountAuth", "user account"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "WeixinAuth", "WeChat authorization"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "DynamicAuth", "Dynamic verification"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "BookingInfo", "Booking notice"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "PolicyCause", "Violation reason"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "TravelPurpose", "Travel purpose"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "WaitRefund", "To be refunded"), _category)
});

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);


var _order, _system, _mall, _webdata, _category;

/* harmony default export */ __webpack_exports__["a"] = ({
  statistics: {
    servicetype: "サービスタイプ",
    search: "検索",
    exportfile: "エクスポート",
    submit: "提出",
    createdate: "作成日",
    orderno: "注文番号",
    businestype: "業務タイプ",
    payment: "支払金額(保険、サービス料含む)",
    insufee: "保険料",
    servicefee: "サービス料",
    productname: "製品名",
    total: "合計",
    departmentname: "部門名",
    selectdepart: "部門を選択してください",
    costcenter: "コストセンター",
    expenseDepartment: "費用負担部門",
    selectcostcenter: "コストセンターを選択してください",
    selectExpenseDepartment: "費用負担部門を選択してください",
    projectcode: "プロジェクトコード",
    startdate: "開始日",
    enddate: "締切日",
    paytotalmoney: "合計金額",
    avgticketprice: "チケット均等額",
    avgroomfee: "宿泊費均等額",
    avgdiscount: "割引",
    breakbtrip: "ポリシー違反",
    advdayinfo: "事前予約日数状況",
    day: "日",
    departpaysort: "各部門消費ランキング",
    costpaysort: "各コストセンターランキング",
    expenseDepartmentRanking: "各費用負担部門ランキング",
    projectcodepaysort: "各プロジェクトコードランキング",
    arrpaysort: "各目的地ランキング",
    tonglist: "統計リスト",
    tongview: "統計ビュー"
  },
  order: (_order = {
    ordertip: "オンラインで過去1年分のご注文を確認できます。それ以前のご注文を確認する必要がある場合は、400-088-8020（長距離通話料無料）までお電話ください。",
    allorder: "すべての注文",
    startdate: "開始日",
    endadte: "終了日",
    orderstatus: "ステータス",
    ordertype: "タイプ",
    searchkey: "商品名または注文番号を入力し、検索",
    search: "検索",
    number: "数",
    orderdetail: "発注情報",
    ordertotalmoney: "発注総額",
    dealoperation: "取引操作",
    submit: "今すぐ提出",
    approval: "今すぐ承認",
    payment: "今すぐ支払い",
    createorder: "再度注文",
    oldsystem: "旧システム",
    rejectReason: "承認備考",
    reapproval: "承認拒否",
    approvalsucc: "承認",
    selectvoy: "キャンセル必要なフライトを選択してください！",
    selectpass: "キャンセル必要な乗客を選択してください！",
    selectreason: "キャンセルの理由を選択してください！",
    amendsucc: "キャンセル申請提出済み",
    flightchange: "航空券変更",
    selectchangepass: "渡航者を選択してください！",
    oldvoyageinfo: "元のフライト情報",
    selectedflight: "選択済みフライト",
    policyok: "ルール適用",
    policyno: "ルール違反",
    build: "空港使用料",
    fuel: "燃油サーチャージ",
    changeflight: "フライト変更",
    flightlist: "フライトリスト",
    changefee: "変更手数料",
    changefeetip: "以下の費用は参考値です。ご不明な点がございましたら、カスタマーサービスまでお電話ください。",
    changefeeabout: "変更手数料見込み（変更予約）",
    upcabinfeeabout: "アップグレード料金見込み",
    changeservicefee: "変更手数料",
    totalfee: "合計",
    changereason: "変更申請理由を入力してください",
    changedetreason: "変更の詳細理由を入力してください（任意）",
    back: "<<戻る",
    submitapply: "申請を送信",
    flightsearchfail: "条件に合致するフライト情報が見つかりませんでした！",
    flightchangereason: "変更理由を選択してください",
    losesource: "フライト情報をご確認ください",
    flightchangesucc: "変更申請が送信されました！"
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "orderdetail", "注文情報"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "voyageinfo", "旅程情報"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "flightpass", "渡航者"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "contactpeople", "連絡先"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "costcenter", "コストセンター"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "expenseDepartment", "費用負担部門"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "policynoreason", "ポリシー違反の理由"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "demandremark", "備考"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "fujianxinxi", "添付情報"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "btripinfo", "ビジネス旅行情報"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "procode", "プロジェクトコード"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "btripaim", "出張目的"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "btripMatter", "出張理由"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "approvalstatus", "承認ステータス"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "violate", "違反しました"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "policydetail", "のポリシー"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "vioreason", "違反理由"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "reasondetail", "詳細理由"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "order", "注文"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "bookingdate", "予約日"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "orderid", "注文番号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "oldorderid", "元の注文番号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "bookingway", "予約方法"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "paymentway", "支払い方法"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "totalmoney", "合計金額"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "submitorder", "注文を送信"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "cancelorder", "注文をキャンセル"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "ordervoyage", "旅程"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "realtake", "実際利用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "share", "共有"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "orderchange", "変更したい"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "orderamend", "キャンセルしたい"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "departcity", "出発先"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "arrivecity", "到着先"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "departdate", "チェックアウト"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "arrivedate", "チェックイン"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "hotelname", "ホテル名"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "hotelphone", "ホテル電話番号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "hoteladdress", "ホテル住所"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "roomtype", "部屋タイプ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "cityname", "都市名"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "startstation", "出発駅"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "endstation", "到着駅"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "seattype", "座席タイプ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "tourpeople", "渡航者"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "sequence", "番号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "name", "氏名"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "cardno", "旅券番号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "birthday", "生年月日"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "phoneno", "携帯電話番号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "invoiceinfo", "証憑情報"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "invoiceid", "証憑コード"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "passname", "渡航者名"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "invoiceno", "証憑番号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "seatno", "座席番号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "tradeinfo", "取引情報"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "tradepeople", "取引人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "tradeway", "取引方法"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "tradetype", "取引タイプ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "trademoney", "取引金額"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "createtime", "作成日時"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "email", "メールアドレス"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "phone", "携帯"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "applyamend", "払い戻し申請"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "selectordervoyage", "旅程を選択"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "selectorderpass", "旅客を選択"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "selectorderreason", "理由を選択"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "cancel", "キャンセル"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "changeapply", "変更申請"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "adultticket", "大人用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "amendfee", "キャンセル料"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "samechangefee", "同クラス変更手数料"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "changecondition", "変更条件"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "changeadopt", "変更可"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "people", "人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "completechange", "変更済み"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "reimburseinfo", "経費精算情報"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "travleorderinfo", "全額分の旅程表を提供可能"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "bagkg", "手荷物許容量"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "forfeebagkg", "無料受託手荷物許容量20KG"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "loading", "読み込み中......"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "endststion", "到着駅"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "waitapprove", "承認待ち"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "changeamendrule", "払戻・変更規則"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "trainamendrule", "出発8日前（含まない）までの払戻には、払戻手数料はかかりません。乗車駅出発時刻の48時間前までの払戻には、運賃の5%の払戻手数料がかかります。出発24時間前から48時間前までの払戻には、運賃の10%の払戻手数料がかかります。出発24時間前を切った払戻には、運賃の20%の払戻手数料がかかります。"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "touramendrule", "締結された契約を基準とします"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "selectPassengersChange", "変更する旅客を選択してください"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "fillFlight", "フライト情報を入力"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "depart", "出発"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "arrive", "到着"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "date", "日付"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "dueTo", "予約日"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "for", "～に"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "ChangeTo", "変更日"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "WasteBack", "払戻・廃票日"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "ExpectedRefundFee", "払戻手数料（見込み）"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "reasonRejection", "拒否理由を入力してください"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "ordeCancel", "注文キャンセル"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "isCancel", "注文をキャンセルしてもよろしいですか"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "confirm", "確認"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_order, "BusinessType", "業務タイプ"), _order),
  system: (_system = {
    clear: "クリア",
    combtripmemberlogin: "企業ビジネス旅行会員ログイン",
    lchbtrip: "力程商旅",
    simple: "シンプルであればあるほど",
    free: "自由であればあるほど",
    lowermoney: "さらにお得に",
    prebtrip: "完璧な出張サービス",
    unyouneed: "お客様のニーズを理解する",
    servicenotime: "時差のない総合サービス",
    costcenlower: "出張コストを30%削減",
    peoplecenter: "マイページ",
    ri: "日",
    trtavleregtips: "金額が0の場合は金額制限なし、航空券の座席クラスと鉄道の座席がチェックされている場合は利用可能",
    firstcity: "一級都市",
    seccity: "二級都市",
    thrcity: "三級都市",
    none: "なし",
    allmoney: "定価",
    discountdown: "割引以下",
    deletefiletips: "削除操作を実行してもよろしいですか？",
    tips: "ヒント",
    cancel: "キャンセル",
    usericon: "アバター",
    uploadusericon: "アバターアップロード",
    changusericon: "アバター変更",
    bangemail: "メールアドレスを紐付け",
    bangphone: "携帯電話番号をバインド",
    orderid: "注文番号",
    ordervoyageinfo: "旅程情報",
    bookingdate: "予約日",
    orderstatus: "注文ステータス",
    bookinguser: "予約者",
    btriprule: "出張規定",
    btripaim: "出張目的",
    policyreason: "ポリシー上の理由",
    bookinginfo: "予約注意事項",
    btripflow: "出張承認",
    search: "検索",
    add: "追加",
    name: "名称",
    number: "番号",
    servicetype: "サービスタイプ",
    chinese: "中国語",
    english: "英語",
    operation: "操作",
    copy: "コピー",
    update: "修正",
    delete: "削除",
    delsucc: "削除成功",
    inputcontent: "内容を入力してください",
    selectcustomers: "顧客を選択",
    zhdescribe: "中国語説明",
    rule: "ルール",
    ruleid: "ルール番号",
    rulename: "ルール名",
    travelregulations: "出張管理ルール",
    endescribe: "英語説明",
    btripflowname: "出張承認名",
    btripflowrule: "出張承認ルール",
    selectbtriprule: "出張ルールを選択",
    selectbtripflow: "承認フローを選択",
    needflow: "出張承認設定",
    roleapplybtrip: "ルール適用ロール",
    departrole: "部門ロール",
    jobrole: "役職ロール",
    employeeandcustomer: "従業員マイレージ会員",
    btripflowid: "出張承認番号",
    btriprulename: "出張ルール名",
    approvalfloename: "承認フロー名",
    flowid: "フロー番号",
    back: "<< 戻る",
    save: "保存",
    savesucc: "保存成功",
    operlogs: "操作ログ",
    addsucc: "追加成功",
    updatesucc: "変更成功",
    businessname: "企業名",
    businessmanage: "企業管理",
    servicemanage: "サービス管理",
    reportsmanage: "レポート管理",
    pleaseselect: "選択してください",
    pleasewrite: "入力してください",
    companyinfo: "基本情報",
    companyname: "会社名",
    city: "都市",
    profession: "業界",
    contactname: "連絡先担当者名",
    selectcycle: "期間を選択してください",
    selectdate: "日付を選択してください",
    selecttrade: "取引を選択してください",
    phonenoerror: "携帯電話番号の形式が正しくありません",
    emailerror: "郵便番号の形式が正しくありません",
    contactnameerror: "受取人名は必須です",
    deliverymanage: "配送管理",
    addcontact: "新しい住所を追加",
    contactpeople: "受取人",
    address: "詳細住所",
    remark: "備考",
    postcode: "郵便番号",
    contactphone: "連絡先携帯電話",
    contactnickname: "住所略称",
    contactemail: "連絡先メールアドレス",
    defaultaddress: "デフォルト住所",
    setdefaultaddress: "デフォルトに設定",
    addressinfo: "住所情報",
    peoplemanage: "個人管理",
    lasterorder: "最近の注文",
    voyagesdate: "旅程カレンダー",
    voyagesremark: "旅程備考",
    welcomelogin: "ログインを歓迎",
    login: "ログイン",
    registernow: "企業登録",
    register: "登録",
    loginbyaccount: "アカウントパスワードログイン",
    loginbyphone: "携帯動的コードログイン",
    loginbyother: "以下の方法でもログインできます",
    wechat: "微信",
    pleaseinputvalcode: "認証コードを入力してください",
    loginredittips: "秒後にホームページに移動します......",
    accountinfo: "アカウント情報",
    peopleregister: "個人ユーザー",
    companyregister: "企業顧客登録",
    kefucenter: "カスタマーセンター",
    loginout: "ログアウト",
    account: "アカウント",
    pwd: "パスワード",
    pwdtips: "パスワードを入力してください",
    forgetpassword: "パスワードをお忘れですか?",
    saveloginstats: "ログイン状態を記憶する",
    accounttips: "携帯電話番号またはメールアドレスを入力してください",
    password: "ログインパスワード",
    passwordtips: "8～16桁を入力してください",
    passwordfirstlevel: "弱",
    passwordfirstleveltips: "英字と数字を含む",
    passwordsecleveltips: "英字、数字、特殊記号を含む",
    passwordseclevel: "中",
    passwordlastleveltips: "大文字と小文字の英字、数字、特殊記号を含む",
    passwordlastlevel: "強",
    confirmpassword: "パスワード確認",
    validecode: "認証コード",
    validecodeignorecase: "大文字と小文字を区別しない",
    changevalidecode: "別の画像に変更",
    dynavalidecode: "動的認証コード",
    dynavalidecodetips: "動的認証コードを入力してください",
    loginedregistertips: "力程商旅アカウントにログインしています。個人アカウントを登録するには、まずログアウトしてください！",
    agreeprotocol: "「サービス利用規約」に同意する",
    reset: "リセット",
    registeproblem: "登録で問題が発生しましたか？",
    inputpwdagain: "パスワードをもう一度入力してください",
    notsamepwd: "2回入力したパスワードが一致しません！",
    emailaccounttips: "メール認証コードを送信",
    phoneaccounttips: "SMS認証コードを送信",
    sendvalidecode: "認証コードを送信",
    registersucc: "登録成功",
    registersucctips: "登録に成功しました。ログインしてください",
    companyaccounttips: "このアカウントは既に企業アカウントです。企業アカウントを登録するには、ログアウトして再度登録してください。",
    codesendtips: "送信済み",
    codeagain: "認証コードを取得",
    resetaccountback: "前のステップに戻る",
    resetaccountfirst: "アカウントを入力",
    resetaccountsec: "本人確認",
    resetaccountthr: "新しいパスワードを設定",
    resetaccountlast: "完了",
    submit: "提出",
    resetphoneaccounttips: "有効な登録済み携帯電話番号でログインパスワードをリセットできます。",
    resetaccountbyphone: "携帯電話認証でリセット",
    resetemailaccounttips: "有効な登録済みメールアドレスでログインパスワードをリセットできます。",
    resetaccountbyemail: "メール認証でリセット",
    resetpwdbyvalide: "ログインパスワードのリセットを確認",
    sendresetpwdcodetips: "力程網は、ご登録の（携帯電話またはメールアドレス）に認証コードを送信しました。ご確認の上、認証コードを入力してください。",
    resetpwdcodename: "受信した認証コード",
    confirm: "確定",
    invoiceinfo: "証憑情報",
    yes: "はい",
    no: "いいえ",
    invoicemanage: "請求書管理",
    invoicerole: "請求書ロール",
    invoicetype: "請求書の種類",
    invoicename: "請求書の宛名",
    identifynumber: "納税者識別番号",
    invoicebankname: "口座開設銀行名",
    invoicebankaccount: "口座開設銀行口座番号",
    invoicecompanyadsress: "登録住所",
    invoicecompanyphone: "登録電話番号",
    invoicelistlefttitle: "保存済み",
    invoicelistrighttitle: "件の住所",
    updatedate: "データを変更",
    invoicetypetips: "請求書の種類を選択してください",
    invoicenametips: "請求書の宛名を入力してください",
    identifynumbertips: "納税者識別番号を入力してください",
    invoicebanknametips: "口座開設銀行名を入力してください",
    invoicebankaccounttips: "口座開設銀行口座番号を入力してください",
    invoicecompanyadsresstips: "登録住所を入力してください",
    invoicecompanyphonetips: "登録電話番号を入力してください",
    messagetemplatelist: "SMSテンプレート一覧",
    messagename: "SMS名",
    messagetype: "SMSの種類",
    messagetemplatename: "SMSテンプレート名",
    messagetemplatetype: "SMSテンプレートタイプ",
    messagetemplatecontent: "SMSテンプレート内容",
    updateuser: "更新者",
    disables: "無効",
    enable: "有効",
    managesetting: "管理設定",
    messagetemplatestatus: "ステータス",
    addmessagetemplate: "SMSテンプレート編集",
    username: "氏名",
    cardno: "身分証明書番号",
    cardvaliditydate: "有効期限",
    cardincountry: "発行機関",
    cardimg: "証明書画像",
    reproveimg: "表面画像",
    deleteimg: "画像を削除",
    reverseimg: "裏面画像",
    uploadimg: "画像をアップロード"
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "companyinfo", "基本情報"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "cardinfo", "証明書情報"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "contactinfo", "連絡先情報"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "customermanage", "カスタマーマネージャー"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "companynickname", "会社略称"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "englishcompanyname", "英語名"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "companyemail", "会社メールアドレス"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "companyaddress", "会社住所"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "companytype", "会社種別"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "capitaltype", "資本タイプ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "companysize", "会社規模"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "companyprofession", "業種"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "companyremark", "備考情報"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "rolecontactpeople", "連絡先"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "rolecontactpeoplename", "連絡先担当者名"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "importcontact", "住所インポート"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "phoneareacode", "携帯電話の市外局番"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "contactaddress", "連絡先住所"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "province", "省"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "district", "県・区"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "changecompanypeopletips", "注意：引継ぎ担当者が会社の権限を受け取った後、あなたは管理者権限を失います"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "companypeople", "引継ぎ担当者"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "regularcard", "常連カード"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "regularcardno", "カード番号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "disclaimer", "免責事項"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "fullname", "正式名称"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "nickname", "略称"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "sex", "性別"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "country", "国籍"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "charge", "管理者"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "selectcharge", "管理者を選択"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "companyorgan", "組織構造"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "actionupdatetips", "権限を設定する必要がない場合は、「保存」をクリックして次の設定に進んでください。"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "roleaction", "ロール権限"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "allemployee", "全従業員"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "roleemployee", "所属従業員"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "roleemployeetips", "この従業員は既に現在の部門に所属しています"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "setmanage", "構成管理"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "workcity", "勤務都市"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "workjob", "職務"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "workname", "通称名"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "worktime", "勤務時間"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "workdatarang", "表示範囲"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "birthday", "生年月日"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "list", "リスト"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "createtime", "作成日時"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "startdate", "開始日"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "enddate", "終了日"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "sequence", "番号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "supername", "上位名称"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "updatetime", "変更日"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "detail", "詳細"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "setting", "設定"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "serviceinfo", "サービス情報"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "servicename", "サービス名"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "publishname", "リリース名"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "applyarea", "適用エリア"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "servicepublic", "公開するかどうか"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "publishservice", "サービスを公開"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "publishedservice", "サービスは公開済み"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "advancetime", "事前予約時間"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "workperiod", "周期"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "publishsave", "公開を確認"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "servicefarelist", "サービス料リスト"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "servicefarename", "サービス料名"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "servicefareid", "サービス料番号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "companyid", "会社番号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "servicefarestatus", "サービス料ステータス"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "policystatus", "ポリシーステータス"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "customername", "顧客名"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "bookingway", "予約方法"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "workingtime", "勤務時間"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "servicefarebyworkingtime", "勤務時間に基づいて計算するかどうか"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "money", "元"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "other", "その他"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "fare", "費用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "roles", "役割"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "jobs", "職位"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "departments", "部門"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "companys", "会社"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "customers", "レベル"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "role", "役割"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "job", "職位"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "employee", "従業員"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "user", "ユーザー"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "guest", "常連客"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "customer", "顧客"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "costcenters", "コストセンター"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "expenseDepartments", "費用負担部門"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "flowid", "フロー番号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "flowname", "プロセス名"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "flowmanage", "プロセス管理"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "dealpeople", "処理担当者"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "up", "上へ移動"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "down", "下へ移動"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "langsetting", "言語設定"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "english", "英語"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "japan", "日本語"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "china", "中国語"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "opened", "開通済み"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "closed", "未開通"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "expired", "期限切れ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "disable", "禁止済み"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "systemsafe", "セキュリティ設定"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "downloadtemplate", "テンプレートをダウンロード"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "PermissionEmployees", "権限従業員"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "GrantDate", "付与日"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "ExpirationDate", "有効期限"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "saveInfo", "情報を保存"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "approvalList", "承認リスト"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "StaffName", "従業員名"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "detail", "詳細"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "CompanyPage", "会社ホームページ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "selectCityAgain", "都市を再選択してください"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "ChooseShipCompany", "航空会社を選択"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "FutureGenerations", "すべて選択"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "TheSelected", "選択を反転"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "QuickFindSelection", "クイック検索選択：ここで複数の航空会社を入力できます。/で区切り、Ctrl+Enterキーで選択します"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "shipCompany", "適用航空会社"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "shipSpace", "クラスを選択"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "applySpace", "適用クラス"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "AsOfTheDate", "締切日"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "AddLevel", "レベル追加"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "LevelNames", "レベル名"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "LevelCode", "レベルコード"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "RetentionSet", "留保設定と顧客設定"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "LeaveSome", "ポイント留保"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "keepMoney", "金額留保"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "ServiceLevelAdd", "サービスレベル追加"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "ProductCategory", "製品カテゴリ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "SubscribeCustomer", "サブスクリプション顧客"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "SaveButtonSet", "留保設定"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "localChineseName", "地域の中国語名を入力してください"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "localEnglishName", "地域の英語名を入力してください"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "PreviewPicture", "画像プレビュー"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "keywordsFilter", "キーワードを入力してフィルタリング"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "DataIntegrity", "資料の完全度"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "PerfectInformation", "資料を充実させる"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "AuthorizationState", "認証状態"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "accountNumber", "アカウントを入力してください"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "DynamicCode", "動的コード"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "congratulations", "おめでとうございます"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "ClickNoResponse", "力程商旅プラットフォームに移動しています。6秒以内に反応がない場合は、クリックしてください"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "Here", "こちら"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "PasswordChangedSucc", "パスワードの変更に成功しました"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "selectParentDirectory", "上位ディレクトリを選択してください"), _system),
  mall: (_mall = {
    one: "一",
    two: "二",
    three: "三",
    four: "四",
    five: "五",
    six: "六",
    seven: "七",
    eight: "八",
    nine: "九",
    ten: "十",
    contactUs: "お問い合わせ",
    adequateTxt: "十分",
    sheet: "枚",
    Remaining: "残りわずか",
    ReElectionFlight: "フライトを再選択",
    TaxExclusive: "税抜き",
    notificationMessageFlight: "通知：必要に応じて、こちらをクリックして国際リクエストシートにアクセスすると、より多くのより安い国際航空券をご利用いただけます。あらゆる出張ニーズに対応するため、お電話でも承ります：",
    Hotline: "ホットラインでお問い合わせください。",
    EnfantYears: "2～14歳",
    InfantYears: "2歳未満",
    budget: "予算",
    Mylicheng: "マイ旅程",
    SupportChinese: "中国語/ピンイン/略称入力対応",
    SupportCode: "中国語/ピンイン/略称/都市コード入力対応",
    hotCity: "人気都市",
    attendance: "参加人数",
    hostPlace: "開催場所",
    activityBudget: "イベント予算",
    PartyNumber: "参加人数",
    internationalHotel: "国際ホテルリクエストシート",
    pay: "支払う",
    NextPage: "次のページ",
    PreviousPage: "前のページ",
    selected: "選択済み",
    data: "データ",
    strip: "条",
    paginal: "ページごと",
    page: "ページ",
    AuxiliaryWord: "第",
    searchName: "名称を入力して検索（右側のボタンをクリックして臨時ゲストとして追加可能）",
    keywordsPlaceholder: "キーワードを入力して検索",
    selectName: "選択した名称",
    Station: "経由駅",
    TotalAmount: "支払総額",
    checkIn: "チェックイン",
    Broadband: "ブロードバンド",
    AttentionPlease: "（特別注意：審査を通過しやすくするため、違反理由を記入してください）",
    TripAgainst: "行程が違反しました",
    DetailReason: "詳細理由",
    ContraryReason: "違反理由",
    Sex: "旅客性別",
    Nationality: "国籍",
    Birthdate: "生年月日",
    Mobile: "連絡先番号",
    ID: "証明書情報",
    PassengerName: "旅客氏名",
    Policy: "出張規定",
    price: "価格",
    BedType: "ベッドタイプ",
    Window: "窓タイプ",
    ViewsMore: "もっと見る",
    durationTime: "所要時間",
    flightInfo: "フライト情報",
    next: "次へ",
    destination: "目的地",
    NoTrainSearch: "現在の時間帯は列車検索サービスを提供していません",
    selectedconsumer: "選択済み旅客",
    btripflow: "出張承認",
    bookingcenter: "予約センター",
    demandorder: "需要オーダー",
    selectcompany: "会社選択",
    costcenter: "コストセンター",
    expenseDepartment: "費用負担部門",
    approvalpolicy: "承認ポリシー",
    bookinguser: "従業員予約",
    pleaseselect: "選択してください",
    bookingsearch: "予約照会",
    btripaim: "出張目的",
    budgetCode: "予算コード",
    budgetIntro: "予算説明",
    projectcode: "プロジェクトコード",
    bookingtype: "公用・私用",
    applyarea: "適用エリア",
    serviceset: "サービス料設定",
    flowinfo: "承認フロー",
    name: "名称",
    flowname: "承認者情報",
    btriprule: "出張規定",
    priority: "プロトコル優先",
    pricelimit: "価格制限",
    bookinginfo: "予約注意事項",
    zhtips: "中国語のヒント",
    entips: "英語のヒント",
    updateorder: "注文を変更する",
    submitorder: "注文を送信",
    tourpasstips: "旅行注文はこの乗客タイプをサポートしていません",
    createsucc: "注文が正常に作成されました",
    orderapprovalsucc: "注文の審査が成功しました",
    pnr: "コードインポート",
    flightno: "便名",
    flightdate: "フライト日付",
    airportinfo: "空港情報",
    cabin: "座席クラス",
    realflight: "実際の運送",
    depairportcode: "出発空港の3レターコード",
    arrairportcode: "到着空港の3レターコード",
    hotelname: "ホテル名",
    hotelphone: "ホテル電話番号",
    hoteladdress: "ホテル住所",
    hotelarrivedate: "チェックイン日",
    hoteldepartdate: "出発日",
    hotelamenddate: "チェックアウト日",
    roomnum: "部屋数",
    roomtype: "部屋タイプ",
    roombedtype: "部屋のベッドタイプ",
    breakfast: "朝食",
    consumerDate: "チェックイン時間",
    finishedDate: "チェックアウト時間",
    changeamendrule: "払戻・変更規則",
    aimcity: "目的地の都市",
    selectdate: "日付を選択",
    keywords: "キーワード",
    hotelkeywords: "(オプション)ホテル名/ランドマーク/商業エリア",
    search: "検索",
    qi: "から",
    searchdetail: "詳細を見る",
    notReserve: "予約可能な部屋タイプはありません",
    traffmap: "交通地図",
    sheetzone: "周辺のストリートビュー",
    btripno: "ルールに違反",
    btripyes: "ルールに合致",
    room: "部屋",
    spec: "平方メートル",
    live: "宿泊可能人数",
    floor: "階数",
    layer: "階",
    productname: "製品名",
    averagerate: "日平均価格",
    breakfastInfos: "食事情報",
    breakfastyes: "朝食付き",
    breakfastno: "朝食なし",
    cancelno: "キャンセル不可",
    timecancel: "期間限定キャンセル",
    plenty: "十分",
    select: "選択",
    hotelfacilities: "ホテル施設",
    wifi: "有料Wi-Fi",
    none: "なし",
    parking: "駐車場",
    allfacilities: "一般施設",
    activefacilities: "アクティビティ施設",
    serviceproject: "サービス項目",
    hotelpolicy: "ホテルポリシー",
    depandarr: "チェックイン/チェックアウト",
    chdpolicy: "お子様ポリシー",
    mealment: "お食事の手配",
    apartment: "アパートメント",
    theinn: "民宿",
    familyhotel: "ファミリーゲストハウス",
    youthhostel: "ユースホステル",
    coupleshotel: "カップルホテル",
    gardencourtyard: "庭園付きホテル",
    seaview: "海の景色",
    generated: "農家楽",
    hotspringshotel: "温泉ホテル",
    golfhotel: "ゴルフホテル",
    siheyuan: "四合院",
    villa: "別荘",
    cookingdinnerparty: "パーティー料理",
    businesstriphome: "ビジネス旅行の家",
    recreationalfeeling: "リラックスした雰囲気",
    hospital: "診察・治療",
    holidayleisure: "休暇・レジャー",
    traininglearn: "研修・学習",
    party: "パーティー",
    honeymoontrip: "ハネムーン旅行",
    boutiquehotel: "ブティックホテル",
    indoorswimmingpool: "屋内プール",
    outdoorswimmingpool: "屋外プール",
    gym: "ジム",
    businesscenter: "ビジネスセンター",
    meetingroom: "会議室",
    hotelrestaurant: "ホテルレストラン",
    wakeupcall: "モーニングコール",
    luggage: "手荷物預かり",
    doublebed: "ツインベッド",
    bigbed: "ダブルベッド",
    pickupservice: "送迎サービス",
    pet: "ペット",
    creditcard: "クレジットカード",
    username: "氏名",
    usersex: "性別",
    PassengerType: "旅行者タイプ",
    cardtype: "身分証明書の種類",
    cardno: "身分証明書番号",
    contactphone: "連絡先携帯電話",
    birthday: "生年月日",
    usercountry: "国籍",
    cardvaliditydate: "身分証明書の有効期限",
    add: "追加",
    delete: "削除",
    passselect: "旅客を選択",
    contactpeople: "連絡先氏名",
    contactemail: "連絡先メールアドレス",
    salesprice: "販売価格",
    marketprice: "市場価格",
    supplyprice: "決済価格",
    tourdepcity: "出発地",
    tourarrcity: "目的地",
    teamno: "団体番号",
    tourdepdate: "旅行日",
    remark: "備考",
    traininfo: "列車情報",
    trainno: "列車番号",
    trainseattype: "座席クラス",
    traindepdatetime: "出発時間",
    trainarrdatetime: "到着時間",
    traindepdate: "出発日",
    amendtime: "変更・キャンセル期限",
    moneysourceairway: "航空会社の最新規定に準じます。カスタマーサービスまでお問い合わせください。",
    amendruletips: "上記の大人変更・キャンセル規則及び料金基準は参考用であり、実際は航空会社の規定に準じます。",
    adultticket: "大人券",
    amendfee: "払戻手数料",
    samechangefee: "同クラス変更手数料",
    changecondition: "変更条件",
    changeadopt: "変更許可",
    people: "人",
    completechange: "変更完了",
    reimburseinfo: "経費精算情報",
    travleorderinfo: "全額分の旅程表を提供可能",
    travleinvoince: "差額領収書と旅程表を提供します。",
    bagkg: "手荷物許容量",
    forfeebagkg: "無料受託手荷物許容量20KG",
    realtake: "実際の乗車",
    realtaketips: "実際に搭乗する便でチェックインを行ってください。",
    share: "共有",
    airplanemodel: "機種",
    isstop: "経由",
    allprice: "定価",
    discount: "割引",
    protocolprice: "ビジネスおすすめ",
    build: "空港使用料",
    fuel: "燃油サーチャージ",
    booking: "予約",
    flightok: "確定",
    allprices: "その他の料金",
    flightnum: "枚",
    flightnumtips: "残りわずか",
    flightgo: "往路",
    flightback: "復路",
    flightdetail: "フライト詳細",
    totalmoney: "合計金額",
    flightticket: "国内航空券",
    iflightticket: "国際航空券",
    screening: "絞り込み条件",
    clear: "クリア",
    flightvuelo: "直行便/乗り継ぎ",
    flightdeptimes: "出発時間帯",
    airways: "航空会社",
    depairport: "出発空港",
    arriveairport: "到着空港",
    checkflightgo: "選択済み往路",
    changeflight: "フライト変更",
    flightlisttips: "件のフライト情報",
    flightdeptime: "出発時間",
    flightarrtime: "到着時間",
    flightprice: "価格",
    nostop: "直行便",
    transfer: "{city}経由（待ち時間：{time}）",
    TransferVoyage: "乗り継ぎ",
    NostopOrTransfer: "直行便/乗り継ぎ",
    ShareFlight: "コードシェア便",
    HideShareFlight: "コードシェア便を非表示",
    am: "午前",
    noon: "正午",
    pm: "午後",
    firstcabin: "ファーストクラス",
    businesscabin: "ビジネスクラス",
    economycabin: "エコノミークラス",
    createflightorder: "確認、次へ",
    loading: "読み込み中......",
    flightpricechange: "航空券の価格が変更されました。確認後にご注文ください！",
    tips: "ヒント",
    confirm: "確認",
    flightbookingtitel: "マイ旅程",
    flightbooking: "航空券の予約",
    orderdetail: "注文情報",
    contactinfo: "連絡先情報",
    taketicketway: "チケット受取方法",
    departcity: "出発都市",
    arrivecity: "到着都市",
    departdate: "出発時間",
    arrivedate: "到着時間",
    backdate: "帰りの時間",
    loginuser: "現在のユーザー",
    priceway: "見積もり方法",
    pricestips: "このページで提供される航空券はネット価格であり、サービス料は含まれておりません。",
    firtransfer: "1回乗り継ぎ",
    sectransfer: "2回以上の乗り継ぎ",
    transfercitys: "乗り継ぎ都市",
    economy: "エコノミークラス",
    business: "ビジネスクラス",
    first: "ファーストクラス",
    premiumecon: "プレミアムエコノミークラス",
    premiumebus: "プレミアムビジネスクラス",
    premiumefirst: "プレミアムファーストクラス",
    iflightcitytips: "国際都市を選択してください！",
    approvalSelectCitytips: "出発地と到着地のいずれかが、承認された旅程に含まれている必要があります！",
    approvalDepartDatetips: "出発日は承認書の日付範囲に準拠する必要があります！",
    approvalArriveDatetips: "出発/帰着日は承認書の日付範囲に準拠する必要があります！",
    approvalSelectHotelCitytips: "目的都市は承認書の旅程に属している必要があります！",
    iflightbookingtips: "選択されたフライトの航空券は残り",
    policyyes: "ルールに合致",
    policyno: "ルールに違反",
    priceandtax: "税込",
    stoptime: "経由時間",
    hotel: "ホテル",
    hotelpeoplenum: "宿泊人数",
    hoteldeskphone: "フロント電話番号",
    hotelleveltitle: "星評価を高い順に並べ替え",
    hotelpricetitle: "価格を高い順に並べ替え",
    below: "以下",
    above: "以上",
    hotelstart: "二つ星以下",
    threehotelstart: "三つ星/快適",
    fourhotelstart: "四つ星/高級",
    fivehotelstart: "五つ星/ラグジュアリー",
    position: "位置",
    nolimit: "制限なし",
    adminregion: "行政区",
    businesszone: "商業地区",
    startlevel: "星ランク",
    contractHotel: "提携ホテル",
    huazhuHotel: "華住酒店",
    feature: "特色",
    facilities: "施設",
    service: "サービス",
    hotelcounttips: "軒のホテル",
    hotelcountall: "合計",
    hotelinfoorstart: "ホテル情報/星ランク",
    hotelinfo: "ホテル情報",
    referprice: "参考価格",
    reselect: "再選択",
    chinahotel: "国内ホテル",
    interhotel: "国際ホテル",
    bookinghotel: "ホテル予約",
    hotelbookinginfo: "予約情報",
    depandarrdate: "チェックイン/チェックアウト日",
    night: "泊",
    insure: "保険",
    hotelroomtype: "部屋タイプ",
    hotelproductcount: "その他の商品",
    chinatrain: "国内列車",
    trainbooking: "列車の予約",
    trainusernametip: "名前は必須です",
    trainusercardtip: "身分証明書情報を入力してください",
    trainrecard: "身分証番号が重複しています",
    trainseatin: "予約成功、座席確保中",
    selectseatfree: "無料座席指定",
    selectedseat: "座席指定済み",
    noselectseat: "座席未指定",
    trainwindow: "窓側",
    aisie: "通路側",
    trainseattips: "指定座席での発券を優先しますが、指定座席に空きがない場合は、他の座席に変更されます",
    change: "乗換",
    timelength: "所要時間",
    trainticketnum: "残席数",
    trainchangamendinfo: "払戻・変更について",
    traindepandarrstation: "出発/到着駅",
    traindepandarrtime: "出発/到着時間",
    trainlogin12306tip: "12306アカウントと連携し、鉄道公式システムに直接接続することで、より迅速に発券できます！",
    login: "ログイン",
    account: "アカウント",
    login12306user: "12306ユーザー名",
    login12306pwd: "パスワードを入力してください",
    loginerror: "ユーザー名またはパスワードが間違っています",
    loginout: "ログアウト",
    logintip: "ログイン済み",
    btripinfo: "ビジネス旅行情報",
    shenpipingzheng: "承認証憑",
    youshenpipingzheng: "承認証憑あり",
    wushenpipingzheng: "承認証憑なし",
    shenpizhuangtai: "承認ステータス",
    chuchaishenqingiworkyishenpi: "出張申請Iworker承認済み",
    shangweishenpi: "未承認",
    shenpidanhao: "承認番号",
    yijishenpi: "段階承認",
    shangchuanfujian: "添付ファイルをアップロード",
    fujianliebiao: "添付ファイル一覧",
    inputcontent: "内容を入力してください",
    btripordertip: "以下の旅程は出張ポリシーに違反しているため、違反理由を補足する必要があります",
    btriporderttip: "（特別注意：審査を通過しやすくするため、違反理由を記入してください）",
    ordervoyage: "旅程",
    violate: "違反しました",
    policydetail: "のポリシー",
    policynoreason: "ポリシー違反の理由",
    policyreasondetail: "詳細な違反理由",
    consumerinfo: "旅客情報",
    consumernametip: "氏名、搭乗証明書と一致させてください",
    phoneareano: "中国本土の市外局番",
    phonenotips: "搭乗者の携帯電話番号、フライト情報の受信用",
    saveconsumer: "常連客として保存",
    selectconsumer: "乗客を選択",
    addconsumer: "乗客を追加",
    consumertip: "重要なお知らせ：旅行を確実にするため、証明書番号と有効期限を正確にご記入ください。旅行終了日は証明書の有効期限より少なくとも6ヶ月以上前である必要があります。",
    writeinfomation: "記入説明",
    demandremark: "リクエスト備考",
    welcomelogin: "ログインを歓迎",
    registernow: "企業登録",
    loginbyaccount: "アカウントパスワードログイン",
    loginbyphone: "携帯動的コードログイン",
    loginbyother: "以下の方法でもログインできます",
    wechat: "微信",
    addressinfo: "住所情報",
    Add: "追加",
    defaultcontact: "デフォルト住所",
    settingdefaultcontact: "デフォルト住所に設定",
    edit: "編集"
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "contactpeople", "連絡者名"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "contactphone", "連絡用携帯電話"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "contactemail", "連絡用メール"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "adddemand", "リクエスト入力"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "voyagetype", "フライトタイプ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "consumertype", "乗客タイプ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "adult", "大人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "child", "子供"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "infant", "幼児"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "firstflightsearchtips", "乗客総数（幼児を除く）が9名を超える場合は、ご記入ください"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "flightdemandorder", "航空券リクエストシート"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "lastflightsearchtips", "予約を行います。"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "firstiflightsearchtips", "大人1名につき、最大2名の子供と1名の幼児を同伴できます。特別なご要望がある場合は、こちらまで"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "adminregionhotel", "香港・マカオ・台湾"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "unsubmit", "未提出"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "submited", "提出済み"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "chenking", "審査中"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "paymoney", "支払い済み"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "etdzticket", "発券済み"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "directclose", "成約"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "searchtrainbytraintype", "高速鉄道・新幹線のみ検索"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "selectfrequent", "常連客を選択"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "frequent", "常連客"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "addtemporaryconsumer", "臨時列車を追加"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "home", "ホーム"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "tour", "旅行"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "train", "鉄道"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "flight", "航空券"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "car", "レンタカー"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "food", "グルメ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "btripplateform", "出張プラットフォーム"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "comcoop", "企業提携"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "appdownload", "アプリダウンロード"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "meeting", "展示会"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "visa", "ビザ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "tourism", "会議旅行"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "stationname", "駅名"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "trainstoptime", "滞在時間"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "stopstationname", "経由駅"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "soldout", "売り切れ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "start", "始発"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "over", "経由"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "end", "終点"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "yu", "残り"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "trainbatch", "車両タイプ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "startorvoer", "始発経由"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "startstation", "出発駅"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "endstation", "到着駅"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "changeticket", "乗車券変更"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "pleasepasstochange", "変更する乗客を選択してください"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "pleaseselectnewdate", "変更日を選択してください"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "oldtraininfo", "元の列車情報"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "gctrain", "G/C高速鉄道"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "dtrain", "D動車"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "ptrain", "普通"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "traindeptime", "出発時間帯"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "trainarrtime", "到着時間帯"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "trainstart", "始発"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "trainover", "経由"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "hour", "時間"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "minute", "分"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "trainchangeinfo", "変更列車情報"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "changetrain", "列車変更"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "changefee", "変更手数料"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "changeservicefee", "変更サービス料"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "totalfee", "合計"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "changereason", "変更理由"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "checking", "審査待ち"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "boyin", "ボーイング"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "kongke", "エアバス"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "zhuanxiangjia", "専用価格"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "analysis", "旅客分析"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "contact", "連絡先"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "bigcus", "大口顧客"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "airway", "航空会社"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "selectcom", "最初に会社を選択してください"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "nameisetm", "旅客名は必須です"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "writenametype", "正しい名前を入力してください(Chen/Wenjun)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "baoxianset", "保険設定"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "saleandcus", "販売/カスタマーサービス担当者"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "recommendair", "おすすめフライト"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "more", "もっと見る"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "hide", "非表示"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "triprulename", "出張ポリシー"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "hightsearch", "詳細検索"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "cabinlevel", "座席クラス"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "submitapply", "申請を送信"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "interdemand", "国際線・香港/マカオ/台湾線リクエストフォーム"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "alltotal", "共有"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "demandcus", "ご不明な点がございましたら、カスタマーサービスまでお問い合わせください。関連する問題を迅速に解決いたします。"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "voyageinfos", "フライト情報"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "addvoyage", "フライトを追加"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "passinfos", "乗客情報"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "passnum", "乗客人数"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "sui", "歳"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "twosui", "2歳未満"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "firstairway", "優先航空会社"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "phoneno", "携帯電話番号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "email", "メールアドレス"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "submit", "提出"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "demandprobtip", "送信に問題がある場合は、こちらにお問い合わせください："), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "normal", "普通"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "student", "学生"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "newimmigrant", "新移民"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "worker", "労務"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "submitordersucc", "注文の送信に成功しました"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "hotelfare", "宿泊料金"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "contservicefee", "サービス料込み"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "hotelinfoimp", "ホテルインポート"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "addhotel", "ホテルを追加"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "inputprice", "正しい金額を入力してください"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "inputpriceerror", "最大金額は最小金額以下にできません"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "starrankdesc", "星評価をおすすめ順に並べ替え"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "starrank", "星評価を高い順に並べ替え"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "starrankasc", "星評価を低い順に並べ替え"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "pricesort", "価格を高い順に並べ替え"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "pricesortdesc", "価格を低い順に並べ替え"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "clickrecomend", "クリックしておすすめ順"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "caclhotelprice", "価格を計算中......"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "none", "なし"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "freebroadbang", "無料ブロードバンド"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "broadband", "有料ブロードバンド"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "freewifi", "無料Wi-Fi"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "wifi", "有料WIFI"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "imgshow", "画像表示"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "additinfos", "追加情報"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "insurinfos", "保険情報"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "surname", "姓"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "givenname", "名"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "orderpassup", "1件の注文あたりの乗客上限は"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "orderpassupend", "人です。それ以上の場合はカスタマーサービスまでご連絡ください！"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "cabintype", "座席クラスタイプ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "selectcabin", "クラスを選択"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "safetrip", "安心してご旅行を、"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "downloadapp", "力程商旅アプリをダウンロード"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "selectchangepass", "乗客を選択してください！"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "searchpassup", "最大9名様までです！"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "selectcontact", "連絡先を選択"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "cancel", "キャンセル"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "tourindextip", "お客様のビジネストラベルサービスニーズを満たし、ビジネストラベルユーザーに包括的なサービスソリューションを提供することに尽力しています。"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "tourdetailcall", "詳細を問い合わせる"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "yearmeet", "年次総会"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "yearmeettips", "トータルサポートで最高峰の企業年次総会を創出"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "comyearmeet", "会社年次総会"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "comtourtips", "企業のニーズに合わせて最適な旅行行程をカスタマイズ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "comtour", "社員旅行"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "teambuild", "チームビルディング"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "teambuildtips", "企業向けにパーソナライズされたアウトドアチームビルディングサービスを提供"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "createteambuild", "チームビルディング企画"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "exhibit", "展示会"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "exhibittips", "お客様にワンストップの会議企画・運営サービスを提供"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "comexhibit", "会議・展示会"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "trainordercretips", "1回のご注文につき最大5名様まで追加可能です。それ以上の人数でご旅行の場合は、カスタマーサービスまでお問い合わせいただくか、別途ご注文ください。"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "trainpassrepeat", "乗客名は重複できません。"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "trianorderpassup", "最大5名様まで選択可能です。"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "inputpassgivenname", "乗客名を入力してください。"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "inputpasssurname", "乗客の姓を入力してください。"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "trainpassseattips", "乗客数が選択座席数を超えています"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "aisle", "通路側"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "NeedInvoice", "領収書が必要"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "NoInvoice", "領収書不要"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "delway", "配送方法："), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "exprefee", "配送料："), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "addresspass", "受取人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "postcode", "郵便番号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "deladdress", "配送先住所"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "inputphoneno", "携帯電話番号を入力してください"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "inputphonerealno", "正しい携帯電話番号を入力してください"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "inputtickettitle", "請求書の宛名を入力してください"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "inputaddresspass", "受取人を入力してください"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "inputdeladdress", "受取住所を入力してください"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "Invite", "直接受け取り"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "Mail", "メール"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "nothing", "不要"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "parper", "紙の領収書"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "tourservicefee", "旅行サービス料"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "express", "宅配便"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "ticketfare", "券面"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "trainnamecardtips", "氏名、乗車証明書の氏名と一致させてください"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "phonecountry", "中国本土 市外局番 86"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "phoneinfotips", "乗車者の携帯電話番号、SMS認証コードを受信する必要があります"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "savecuspass", "常連旅客として保存"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "triprulemanage", "出張管理"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "trainorderseat", "選択した旅客の座席を選択してください"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "createordernow", "今すぐ予約"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "parenter", "パートナー"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "aboutus", "会社概要"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "companyinfo", "力程商旅は中国をリードする出張管理会社であり、力程グループに属しています。10年来、強力なリソース、先進的な技術、質の高いサービス、専門的な管理に支えられ、フォーチュン・グローバル500の120社以上、中国企業トップ500の100社以上を含む、6000社を超える中堅・大企業にサービスを提供しています。"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "companywechat", "力程商旅の公式アカウントをフォロー"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "companyname", "力程商旅"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "simple", "シンプルであればあるほど"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "free", "自由であればあるほど"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "lowermoney", "さらにお得に"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "traintuiinfo", "払い戻し説明"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "traintuiinfo1", "1：購入代行が成功し、未発券かつ発車時刻の35分前までであれば、「マイオーダー」から鉄道の注文をクリックし、案内に従って払い戻しを申請できます。発車8日前までの払い戻しについては、鉄道局が各乗車券に対し段階的に払い戻し手数料を徴収します。"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "traintuiinfo2", "2：購入代行が成功し、発券済み、または発車時刻の35分前を切っている場合は、お客様ご自身で、乗車券購入時に使用した乗車者の有効な身分証明書原本と鉄道乗車券を携行し、発車前に駅の払い戻し窓口で払い戻し手続きを行ってください。"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "trainchanginfo", "変更説明"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "trainchanginfo1", "1：紙の乗車券を未発券で、かつ発車時刻の35分前までであれば、元の乗車券の運賃と同額またはそれ以下の列車に変更できます。その他、オンラインで変更できない場合は、発車前に駅の窓口で手続きを行う必要があります。"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "trainchanginfo2", "2：発車48時間前までであれば、予約販売期間内の列車に変更できます。発車48時間前を切っている場合は、乗車券記載の日付の24:00までの任意の列車に変更できます。乗車券記載の日付の翌日以降への変更はできません。"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "trainchanginfo3", "3：新しい乗車券の運賃が元の乗車券より安い場合、差額を返金します。差額分に対しては払い戻し手数料が発生し、現行の払い戻し手数料基準が適用されます。"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "datetimenotrain", "本日の日付の乗車券は未発売です"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "ReserveHint", "現在、非連絡（乗り継ぎ）フライトです。いずれかの区間のフライトに変更が生じた場合、もう一方の区間の払い戻しや変更が必要となった際は、お客様ご自身で相応の払い戻し・変更手数料を負担いただく必要があります。"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "chailvguize", "出張ルール名"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "guonei", "国内"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "guojie", "国際"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "jipiao", "航空券"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "jiudianguize", "ホテル規則"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "huoche", "鉄道"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "guize", "ルール"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "zuidijiajizhun", "最低価格基準"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "wuxianzhi", "無制限"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "xiangduizuidijia", "相対最低価格"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "quantianzuidijia", "終日最低価格"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "shiduanzuidijia", "時間帯最低価格"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "hangbanzuidijia", "フライト最低価格"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "shishihangbanguankong", "リアルタイムフライト管理"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "tiqianyudingshijian", "事前予約時間"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "kedingcangweijibie", "予約可能クラス"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "kedingzuoweijibie", "予約可能座席クラス"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "xieyijipiaoyouxian", "契約航空券優先"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "xieyijiudianyouxian", "契約ホテル優先"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "xiaofeijineshangxian", "利用金額上限"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "dangdizhusubiaozhunshangxian", "現地宿泊料基準上限"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "yudingxuzhi", "予約注意事項"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "dingpiao", "チケット予約"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "tuipiaochongkai", "払い戻し再発行"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "xuanweiqucheng", "往路に選択"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "yes", "はい"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "no", "いいえ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "firstcity", "1級都市"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "seccity", "2級都市"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "thrcity", "3級都市"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "within", "以内"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "qxzhsrxmdm", "プロジェクトコードを選択または入力してください"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "qxzxmdm", "プロジェクトコードを選択してください"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "weibeixiaofeijineshangxian", "利用金額上限"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "dangdizhusubiaozhun", "現地宿泊料基準"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "youchuang", "窓あり"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "weichuang", "窓なし"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "qianmianfeiquxiao", "前無料キャンセル、"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "zhihoubukequxiao", "以降キャンセル不可"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "wuzao", "朝食なし"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "nights", "合計{number}泊"), _mall),
  manage: {},
  bill: {
    bankaccount: "銀行口座",
    acronym: "略称",
    select: "選択してください",
    query: "検索",
    added: "追加",
    export: "エクスポート",
    companyname: "会社名",
    inorout: "収支タイプ",
    accountstatus: "口座ステータス",
    operation: "操作",
    enable: "有効",
    disable: "無効",
    update: "修正",
    content: "内容を入力してください",
    cancel: "キャンセル",
    save: "保存",
    confirm: "確定",
    accountadded: "口座追加",
    accountupdate: "口座修正",
    enableordisableprompt: "この操作は無効化または有効化に使用されます、続行しますか？",
    prompt: "ヒント",
    receivebill: "売掛期間",
    bill: "会計期間",
    closeaccountprofit: "決算粗利",
    comparisonsales: "販売数量比較",
    closeaccountstarttime: "決算開始日",
    starttime: "開始日",
    closeaccountendtime: "決算締切日",
    endtime: "締切日",
    clientname: "顧客名",
    customerservicerepresentative: "カスタマーサービス担当者",
    salesrepresentative: "営業担当者",
    number: "件数",
    closeaccountprofittotel: "締め後粗利合計",
    inadditioninterestprofit: "利息控除後粗利",
    receiveprice: "受取金額",
    actualprofit: "実際粗利",
    profitrate: "粗利率",
    interest: "利息",
    additioninterestprofit: "利息後粗利",
    additioninterestprofitrate: "利息後粗利率",
    profitprecent: "粗利構成比",
    back: "<<戻る",
    Internationalflight: "国際航空券",
    internalflight: "国内航空券",
    Internationalhotel: "国際ホテル",
    internalhotel: "国内ホテル",
    internaltrain: "国内列車",
    selectyearmonth: "年月を選択",
    tradebill: "取引支払サイト",
    agreedpaystarttime: "約定決済開始日",
    agreedpayendtime: "約定決済終了日",
    billdate: "請求日",
    billdateend: "締切日",
    agreedpaydate: "約定決済日",
    waitoutday: "未請求",
    waitaudited: "未審査",
    waitconfirm: "未確認",
    amountshouldbeclosed: "決済予定金額",
    detail: "詳細",
    total: "合計",
    createtime: "作成日",
    orderid: "注文番号",
    businesstype: "業務タイプ",
    servicetype: "サービスタイプ",
    paymentincludinginsurancecharge: "支払額(サービス/保険料含む)",
    passengername: "旅客名",
    bookingname: "予約者",
    productname: "製品名",
    billaggregate: "支払期間サマリー",
    billdetail: "支払期間明細",
    size: "サイズ",
    amountreceivable: "未収金額",
    allstatus: "すべてのステータス",
    billname: "支払期間名",
    expiretime: "期日",
    overdueday: "延滞(日数)",
    receivable: "売掛金",
    havebeentaken: "入金済",
    notreceive: "未収",
    profit: "粗利",
    totalaccountingperiod: "支払期間外総額",
    invoicestatus: "請求書ステータス",
    statusdetail: "ステータス(明細数)",
    Updates: "更新",
    receivedetail: "売掛金明細",
    createstarttime: "作成開始日",
    createendtime: "作成終了日",
    receivestarttime: "入金開始日",
    receiveendtime: "入金終了日",
    paymentstarttime: "支払開始日",
    paymentendtime: "支払終了日",
    applyarea: "エリアタイプ",
    supplyid: "供給伝票番号",
    supplyname: "供給名",
    voucherno: "証憑番号",
    intentname: "出張目的",
    projectcode: "プロジェクトコード",
    invoiceid: "請求書番号",
    template: "テンプレート",
    templatemanager: "テンプレート管理",
    fullscreen: "全画面表示",
    quanping: "全画面終了",
    orderselect: "注文チェック",
    receivestatus: "入金ステータス",
    invoiceapplication: "請求書申請",
    receiveaudit: "入金審査",
    receiveconfirm: "入金確認",
    losstreatment: "欠損処理",
    receivefinished: "入金締め",
    receiveaudited: "入金返戻",
    costcenter: "コストセンター",
    expenseDepartment: "費用負担部門",
    supplyName: "供給名",
    bulkEditingSupplyName: "供給名称の一括変更",
    all: "全て",
    paymentstatus: "支払状況",
    obligation: "支払待ち",
    paymentaudit: "支払審査",
    paymentconfirm: "支払確認",
    paymentfinished: "入金締め",
    paymentaudited: "入金返戻",
    orderselecttext: "チェックを入れる注文番号を入力してください（スペース、改行、またはカンマで区切ってください）",
    receivefaila: "この操作を行う前に、まず顧客検索を行ってください",
    receivefailb: "操作する明細にチェックを入れてください",
    receivefailc: "正しいデータを選択してください",
    receivefaild: "最初に供給名称をプリセットしてください",
    invoiceapplyfaila: "請求書申請が未提出のデータを選択してください",
    order: "注文",
    losstreatmentfail: "。締め処理の粗利率が10%を超えるか、10%を下回る場合は、まず欠損処理を行ってください。",
    loading: "操作を実行中です......",
    orderselectfail: "明細にチェックを入れる注文番号を入力してください",
    tradedetail: "取引明細",
    templatename: "テンプレート名",
    rightmove: "右へ移動",
    leftmove: "左へ移動",
    topmove: "上へ移動",
    bottommove: "下へ移動",
    rightfaila: "右に移動するデータを選択してください",
    leftfaila: "左に移動するデータを選択してください",
    topfaila: "このデータは上に移動できません",
    bottomfaila: "このデータは下に移動できません",
    templatfaila: "上下に移動するデータを1つ選択してください",
    costcenternamesearch: "コスト名検索",
    expenseDepartmentNameSearch: "費用負担部門名検索",
    supplyNamesearch: "供給名検索",
    billnamesearch: "会計期間名検索",
    receivetablefaila: "コストセンターを選択してください",
    selectExpenseDepartment: "費用負担部門を選択してください",
    receivetablefailb: "先に終了してから再編集してください",
    receivetablefailc: "会計期間を選択してください",
    receivetablefaild: "供給名を選択してください",
    profitandlossreasons: "損益原因",
    lossreasons: "損失原因",
    profitreasons: "利益原因",
    reakeven: "損失なし",
    losscausefaila: "損失原因を選択してください",
    invoiceitemname: "プロジェクト名",
    invoiceitemmodel: "規格型番",
    invoiceitemunitname: "単位",
    invoiceitemnum: "数量",
    invoiceitemfare: "単価",
    invoiceitemcost: "原価",
    invoiceitemamount: "金額",
    invoiceitemrate: "税率",
    invoiceitemtax: "税額",
    delete: "削除",
    invoicetitle: "請求書の宛名",
    invoicetype: "請求書の種類",
    clientadress: "顧客住所",
    clientemail: "顧客メールアドレス",
    remark: "備考",
    invoiceapplyfailb: "正しい単価を入力してください",
    invoiceapplyfailc: "正しい税率を入力してください",
    invoiceapplyfaild: "提出する請求書の金額は元の請求書の金額を超えることはできません",
    invoiceapplyfaile: "請求書の申請が成功しました",
    accountname: "口座名義",
    accounttype: "口座タイプ",
    tradeaccountlistfaila: "正しい金額を入力してください",
    tradeaccountlistfailb: "チャージ登録が成功しました",
    tradeaccountlist: "口座一覧",
    availablebalance: "利用可能残高",
    accountbalance: "口座残高",
    creditbalance: "与信限度額",
    blockedamount: "凍結金額",
    flow: "取引明細",
    recharge: "チャージ",
    blockedtransactions: "取引凍結",
    tradename: "取引名",
    freezingtime: "凍結時間",
    creditline: "与信限度額",
    contractdate: "契約日",
    creditaddedprompt: "固定与信限度額の有効期限は契約日を基準とします。期限切れの場合は更新してください。",
    provisionalcredit: "臨時与信",
    effectivedate: "発効日",
    expirydate: "失効日",
    lodamt: "チャージ金額",
    transactionflowing: "取引明細",
    tradedate: "取引日",
    flowtype: "明細タイプ",
    transactionamount: "取引金額"
  },
  webdata: (_webdata = {
    interfaceManage: "構成管理",
    ChangeCheckPNR: "コード検証",
    insuranceamend: "返金処理",
    orderlist: "注文リスト",
    mallservice: "モールサービス",
    wechat: "WeChat管理",
    dealwarranty: "保険証券処理",
    insuranceorder: "保険注文",
    insuranceservice: "保険サービス",
    insurancepolicy: "保険政策",
    changruletime: "変更期限",
    baggagerule: "手荷物許容量ルール",
    departmanage: "部門管理",
    see: "閲覧",
    oftenconsumermanage: "常連客管理",
    oftenconsumer: "よく利用する旅客",
    costcenter: "コストセンター",
    expenseDepartment: "費用負担部門",
    deal: "処理",
    waitdispos: "処理待ち",
    waitdispose: "処理待ち",
    waitpayment: "支払待ち",
    waitconfirm: "確認待ち",
    waitthrowin: "審査待ち",
    waitapprove: "承認待ち",
    waitsubmit: "提出待ち",
    waitrefund: "返金待ち",
    waitbooking: "予約待ち",
    addressmanage: "住所管理",
    dealorder: "注文処理",
    ordermanage: "注文管理",
    subservice: "サブスクリプションサービス",
    dealinvoice: "請求書処理",
    inviceservice: "請求書サービス",
    invoicemanage: "請求書管理",
    servicefeesetting: "サービス料設定",
    servicemanage: "サービス管理",
    serviceinfo: "サービス情報",
    interfaceinfo: "インターフェース設定",
    payment: "支払い",
    dealpayment: "支払い処理",
    peoplemanage: "個人管理",
    companysetting: "会社設定",
    internationflight: "国際航空券",
    internationhotel: "国際ホテル",
    internationaltour: "海外旅行",
    chinatraffic: "国内送迎",
    chinatrain: "国内列車",
    chinaflight: "国内航空券",
    chinahotel: "国内ホテル",
    chinatravel: "国内旅行",
    trainorder: "鉄道注文",
    flightorder: "航空券注文",
    trafficorder: "注文処理",
    basedata: "基本データ",
    transaction: "取引明細",
    tradereceive: "売掛金明細",
    tradepayment: "取引明細",
    smstemplate: "SMSテンプレート",
    datastatistics: "データ統計",
    tradeweek: "取引支払サイト",
    billreceive: "売掛期間",
    billpayment: "取引支払サイト",
    hotelorder: "ホテル注文",
    customermanage: "顧客管理",
    customerlevel: "顧客レベル",
    dealdelivery: "宅配便処理",
    deliveryservice: "宅配便サービス",
    deliverypolicy: "宅配便ポリシー",
    flowmanage: "プロセス管理",
    tourorder: "旅行注文",
    companymanage: "企業管理",
    companyinfo: "企業情報",
    companyhome: "企業ホームページ",
    visaorder: "ビザ注文",
    visaservice: "ビザサービス",
    allorder: "すべての注文",
    purviewmanage: "権限管理",
    purviewcontrol: "権限制御",
    approve: "承認",
    dealmoneyin: "入金処理",
    moneynandoutmanage: "収支管理",
    authorizemanage: "認可管理",
    amendorder: "変更・キャンセル注文",
    changeamendrule: "払戻・変更規則",
    clientuser: "大口顧客",
    domainmanage: "ドメイン管理",
    notifymanage: "通知管理",
    dealrefund: "返金処理",
    dealamend: "払い戻し処理",
    dealamendorder: "払い戻し処理",
    dealamendtour: "ツアーキャンセル処理",
    webmanage: "ウェブサイト管理",
    mineinfo: "マイ情報",
    usermain: "マイページ",
    systemmanage: "システム管理",
    discrete: "分割済み",
    forbiddened: "無効化済み",
    canceled: "キャンセル済み",
    throwined: "公開済み",
    rejected: "返却済み",
    rejectes: "返却済み",
    finished: "完了済み",
    finishes: "完了済み",
    hanguped: "非公開済み",
    bankaccount: "銀行口座",
    coupon: "クーポン",
    employeemanage: "従業員管理",
    cannnot: "一時不可",
    cannot: "一時不可",
    accountsafe: "構成管理",
    accountmanage: "アカウント管理",
    tradeaccount: "企業アカウント",
    financemanage: "会計管理",
    policymanage: "ポリシー管理",
    policymangage: "ポリシー管理",
    jobmanage: "役職管理",
    businessservice: "ビジネストラベルサービス",
    chargeservice: "付加価値サービス",
    chargepolicy: "サービス方針",
    feedback: "フィードバック"
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_webdata, "mallservice", "モールサービス"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_webdata, "orderlist", "注文リスト"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_webdata, "sharelist", "イベント管理"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_webdata, "orderchange", "フライト変更一覧"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_webdata, "smsnotify", "通知一覧"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_webdata, "supplylist", "供給管理"), _webdata),
  category: (_category = {
    AmendingFlight: "一部払い戻し中",
    ChangeingFlight: "一部変更中",
    AmendingTrain: "一部払い戻し中",
    ChangeingTrain: "一部変更中",
    AmendingHotel: "一部キャンセル中",
    ChangeingHotel: "一部変更中",
    AmendingTour: "一部ツアーキャンセル中",
    ChangeingTour: "一部変更中",
    AmendedFlight: "一部払い戻し",
    ChangeedFlight: "一部変更",
    AmendedTrain: "一部払い戻し",
    ChangeedTrain: "一部変更",
    AmendedHotel: "一部キャンセル",
    ChangeedHotel: "一部変更",
    AmendedTour: "一部ツアーキャンセル",
    ChangeedTour: "一部変更",
    AllAmendingFlight: "払い戻し中",
    AllChangeingFlight: "変更中",
    AllBookingFlight: "購入中",
    AllAmendingTrain: "払い戻し中",
    AllChangeingTrain: "変更中",
    AllBookingTrain: "購入中",
    AllAmendingHotel: "キャンセル中",
    AllChangeingHotel: "変更中",
    AllBookingHotel: "予約中",
    AllAmendingTour: "ツアーキャンセル中",
    AllChangeingTour: "変更中",
    AllBookingTour: "予約中",
    AllAmendedFlight: "払い戻し成功",
    AllChangeedFlight: "変更成功",
    AllBookedFlight: "購入成功",
    AllAmendedTrain: "払い戻し成功",
    AllChangeedTrain: "変更成功",
    AllBookedTrain: "購入成功",
    AllAmendedHotel: "チェックアウト成功",
    AllChangeedHotel: "変更成功",
    AllBookedHotel: "予約成功",
    AllAmendedTour: "ツアーキャンセル成功",
    AllChangeedTour: "変更成功",
    AllBookedTour: "予約成功",
    "1672category": "ホテル料金",
    "1674category": "ツアー料金",
    "1660category": "券面金額",
    "1662category": "空港施設料",
    "1664category": "燃料費",
    "1666category": "税費",
    "1692category": "直接割引",
    "1668category": "保険料",
    "1670category": "サービス料",
    "1678category": "返金",
    "1682category": "変更",
    "1684category": "元価",
    "1690category": "その他",
    "1694category": "割引",
    Conference: "会議",
    EnterprisesUnit: "企業・事業体",
    GovernmentDepartment: "政府機関",
    PeopleEnterprises: "民間資産",
    CountryCapital: "国有資産",
    ChinaOuterJoinCapital: "中外合弁",
    ForeignCompany: "外資独資",
    CompanySize100: "100人以下",
    CompanySize499: "100～499",
    CompanySize999: "500～999",
    CompanySize4999: "1000～4999",
    CompanySize5kUp: "5000以上",
    Internal: "国内",
    Overseas: "国際",
    IDCard: "身分証明書",
    PassportCard: "パスポート",
    StudentCard: "学生証",
    OfficerCard: "軍人証",
    OtherCard: "その他",
    Residencepermit: "香港・マカオ・台湾居民居住証",
    ForeignResidentIDCard: "外国人永久居留身分証",
    HKCompatriotsyndrome: "香港・マカオ通行証",
    TaiCompatriotsyndrome: "台湾通行証",
    Enable: "有効",
    UnEnable: "無効",
    Male: "男性",
    Female: "女性",
    Yes: "はい",
    No: "いいえ",
    SingleVoyage: "片道",
    RoundVoyage: "往復",
    ReturnVoyage: "復路",
    MultiVoyage: "複数回",
    TransferVoyage: "乗り継ぎ",
    BSP: "BSP",
    B2B: "B2B",
    OverseasElectronic: "海外電子",
    ConnectVoyage: "連絡便",
    Team: "団体",
    Fit: "個人客",
    Unlimited: "制限なし",
    HighOpen: "高開",
    DownOpen: "低開",
    Monday: "月曜日",
    Tuesday: "火曜日",
    Wednesday: "水曜日",
    Thursday: "木曜日",
    Friday: "金曜日",
    Saturday: "土曜日",
    Sunday: "日曜日",
    WithinIntercontinental: "同一大陸内",
    PolicyDepartAirport: "ポリシー出発空港範囲",
    NoReward: "報酬なし",
    AgencyFreeFee: "代理店手数料なし",
    MustBackAirport: "旅程出発空港に戻る必要あり",
    AppointBackAirport: "指定帰国国または空港範囲",
    CommonFlight: "普通便",
    ShareFlight: "コードシェア便",
    Prepay: "前払い",
    CashPay: "現払い",
    OverseasStudent: "留学生",
    Immigrant: "移民",
    Worker: "労働者",
    Seaman: "船員",
    Youth: "青年",
    HkMacaoTw: "香港・マカオ・台湾",
    ForeignNationality: "外国籍",
    NotChineseName: "非漢字氏名",
    AddOn: "Add-On",
    OldGge: "高齢者",
    OverseasTransfer: "海外経由",
    NotchRange: "ギャップ旅程",
    OPEN: "OPEN",
    SPA: "SPA",
    QValue: "Q値",
    SharedFlight: "コードシェア便",
    ThreeAgreement: "三者間協定",
    Package: "セット券",
    WholeGroup: "団体全体",
    SmallGroup: "小団体",
    RewardsAdults: "報酬は大人と同じ",
    NoOpenBonus: "報酬なしでも可",
    WithoutReward: "報酬ありでも可",
    NotOpen: "不可",
    NoCodingRequired: "コード返却不要",
    CodeOut: "コード変更して発券",
    BigTicket: "大口コード発券（コード変更不要）",
    BigNoTicket: "大口コード発券（コード変更必要）",
    NoChange: "空席なし変更不可発券（外部に空席がある場合コード変更）",
    SingleRound: "片道/往復",
    MonthCycle: "月",
    WeekCycle: "週",
    DayCycle: "日",
    HKMpermit: "帰郷証",
    TaiWpermit: "台湾同胞証",
    OnlineServiceMode: "オンラインサービス",
    LineServiceMode: "オフラインサービス",
    PercentageMode: "パーセンテージ",
    FixedPrice: "固定金額",
    ExpensePrice: "券面額",
    PriceFareAndTax: "券面額+税金",
    DirectUpdate: "直接修正",
    AddLittle: "ポイント加算",
    ReduceLittle: "ポイント減算",
    User: "ユーザー",
    Jobs: "職位",
    Group: "グループ",
    Department: "自部門",
    Company: "会社",
    Service: "サービス",
    Customer: "カスタマーサービス",
    Actions: "権限",
    CostCenter: "コストセンター",
    ExpenseDepartment: "費用負担部門",
    Server: "サーバーサイド",
    Client: "クライアントサイド",
    Normal: "正常",
    Change: "変更",
    SelfOnly: "自分のみ",
    SelfLower: "自分と配下",
    NoLimit: "制限なし",
    UnAuthorized: "未認証",
    Authorized: "認証済み",
    SystemRole: "システムロール",
    UserRole: "ユーザーロール",
    ContinueBefore: "続行前",
    ContinueAfter: "続行後",
    ReturnBefore: "戻る前",
    ReturnAfter: "戻った後",
    ChangeBefore: "変更前",
    ChangeAfter: "変更後",
    NeedInvoice: "領収書が必要",
    NoInvoice: "領収書不要",
    WEB: "ウェブサイト",
    RMB: "元",
    Dollar: "米ドル",
    Alipay: "アリペイ",
    WeChat: "微信",
    Cash: "現金",
    Monthly: "月次決済",
    Tour: "旅行",
    Hotel: "ホテル",
    Flight: "航空券",
    AdviceNote: "出発通知書",
    GuestEnclosure: "ゲスト添付ファイル",
    other: "その他",
    Electronic: "電子領収書",
    ClientMessage: "ゲストへのメッセージ",
    SupplyMessage: "サプライヤーへのメッセージ",
    WorkmateMessage: "同僚へのメッセージ",
    Traveled: "旅行済み",
    NotTravel: "未旅行"
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Change", "変更"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Sales", "販売"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Refund", "返金"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "PasswordVerify", "ログインパスワード"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "EmailVerify", "メール認証"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "PhoneVerify", "携帯電話認証"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "NameVerify", "実名認証"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "SafetyProblem", "セキュリティ質問"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "APP", "携帯電話"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "BtripService", "ビジネストラベルサービス"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "HotelService", "ホテルサービス"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "TourService", "旅行サービス"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "FlightService", "航空券サービス"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "ChargeService", "付加価値サービス"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "HightDirector", "高校の担任の先生は誰ですか"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Firstgame", "初めてクリアしたゲーム"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "PhoneContact", "携帯電話"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "TelephoneContact", "電話"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "EmailContact", "メールアドレス"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "QQ", "QQ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "OnlineKnow", "オンライン予約注意事項"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "TourKnow", "国内旅行予約注意事項"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Enable", "有効"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "UnEnable", "無効"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "PriceEnable", "価格有効化"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "PriceUnEnable", "価格無効化"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Indeterminate", "価格未定"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "PrivatePolicy", "プライベートポリシー"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "PublicPolicy", "パブリックポリシー"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Receive", "入金"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Payment", "支払い"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Unsubmit", "未提出"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Submited", "提出済み"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Unaudit", "未承認"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Audited", "承認済み"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "AuditRefuse", "承認拒否"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Untreated", "未処理"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "RefundeBad", "退団失敗"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "RefundeIng", "退団処理中"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Refunded", "ツアーキャンセル成功"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Country", "国"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Scenic", "景勝地"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "City", "都市"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Province", "省"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Area", "エリア"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Airport", "空港"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Continent", "州"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "District", "区"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Invite", "直接受け取り"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Mail", "メール"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "insideOutside", "国内出発"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "outsideInside", "直行SOTO区間"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "insideInsideOutside", "国内出発アドオン"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "outsideInsideInside", "海外出発アドオン"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "outsideOutside", "海外から海外"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "insideOutsideOutside", "国内出発経由"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "outsideOutsideInside", "海外出発経由"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "outsideOutsideOutside", "海外海外海外"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "outsideInsideOutside", "海外国内海外"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "globalGlobal", "グローバルからグローバル"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "globalGlobalGlobal", "グローバル中継グローバル"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "openAgencyFee", "代理手数料なしで開設可能"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "NoWay", "開設不可"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "InsuranceService", "保険サービス"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "ExpressService", "宅配便サービス"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "InvoiceService", "請求書サービス"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "VisaService", "ビザサービス"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "TrainService", "鉄道サービス"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "TravelNotes", "予約注意事項"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "ExpenseKnowledge", "費用に関する注意事項"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "ShortMessage", "SMS"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Mail", "郵便"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Wechat", "微信"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "EexamineOrderSms", "承認依頼メッセージ内容"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "EexamineApprovalSms", "承認完了メッセージ内容"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "EexamineRefuseSms", "承認拒否メッセージ内容"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "EexamineAccomplishSms", "注文処理完了メッセージ内容"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Refunds", "返金完了"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Transfer", "振込"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Train", "鉄道チケット"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "BusinessSeat", "ビジネス席"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "SpecialSeat", "特等席"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Level1Seat", "一等席"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Level2Seat", "二等席"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "HighGradeSleeper", "高級軟臥"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "CommonSleeper", "軟臥"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "HardSleeper", "硬臥"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "SoftSeat", "軟座"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "HardSeat", "硬座"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "NotHaveSeat", "立席"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Economy", "エコノミークラス"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Buissenes", "ファーストクラス"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "First", "ファーストクラス"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "DayLowestPrice", "終日最低価格"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "FlightLowestPrice", "全便最安値"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "HighSpeedRail", "高速鉄道"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "SleepingBerth", "寝台"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Other", "その他"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Whole", "全て"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Position", "役職"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Department", "部署"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "FlatFeeCharges", "固定料金で請求"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "PercentageCostFee", "パーセンテージで請求"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Department", "自部署"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "DepartmentLower", "本部門及び下位組織"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "TravelPurpose", "出張目的"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "PolicyCause", "違反理由"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "FlightChange", "旅程を変更したいので、飛行機に乗りたくありません"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "FlightMistaken", "旅程、日付、時間、名前を間違えました"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "FlightDelay", "フライトの遅延または欠航"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "OnBusiness", "公用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "OnPersonal", "私用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "PayApproval", "注文支払い承認"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "ChangeApproval", "注文変更承認"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "ReturnTicketApproval", "注文払い戻し承認"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "People", "個人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "legs", "区間別課金"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "OnLineReservation", "オンライン予約"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "OffLineReservation", "オフライン予約"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "WorkingTime", "勤務時間"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "NonWorkingTime", "営業時間外"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "OnlineBookingApproval", "オンライン予約は承認が必要"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "OfflineBookingApproval", "オフライン予約は承認が必要"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "ViolateRuleApproval", "ルール違反は承認が必要"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "ChangeTripApproval", "旅程変更は承認が必要"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "CancelTripApproval", "旅程キャンセルは承認が必要"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Preflight", "出発前"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "AfterTakeoff", "出発後"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "RuleEndorse", "変更"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "RuleFund", "払い戻し"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Reserve", "予約"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "CaterService", "飲食サービス"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "TrafficService", "交通サービス"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "TicketService", "入場券サービス"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "BaseService", "基本サービス"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Volunteer", "任意"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "FlightChang", "フライト変更"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "BuyAgain", "再購入"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "SickAmend", "病気による払い戻し"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "NameError", "名前が間違っています"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "CabinChange", "アップグレード交換"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "TicketInvalid", "払い戻し"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Other", "その他"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "WaitSubmit", "提出待ち"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "WaitPayment", "支払い待ち"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "WaitConfirm", "確認待ち"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Finished", "完了済み"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Canceled", "キャンセル済み"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Rejected", "返却済み"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "SystemService", "システムサービス"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "WorkService", "業務サービス"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "OrderService", "注文サービス"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "BillService", "請求書サービス"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "UserService", "個人サービス"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "CompanyService", "法人サービス"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "TicketFare", "券面"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "BuildFare", "空港使用料"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "FuelFare", "燃油サーチャージ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "TaxFare", "税金・手数料"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "SafeFare", "保険"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "ServiceFare", "サービス"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "HotelFare", "宿泊料金"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "TeamFare", "ツアー代金"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "AmendFare", "払い戻し"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "ChangeFare", "変更"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "OtherFare", "その他"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "DirectReduction", "直接割引"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "ThrowDiscount", "割引"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Infant", "幼児"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Enfant", "子供"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Young", "大人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Wrinkly", "中年"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Elderly", "高齢者"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "BusinessLicence", "営業許可証"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "TaxRegistration", "税務登記証"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Other", "その他"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "WaitSubmit", "提出待ち"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "WaitDispose", "処理待ち"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Cannot", "一時不可"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Finished", "完了済み"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Rejected", "拒否済み"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Bill", "会計"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Balance", "残高"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Credit", "クレジット"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Integral", "ポイント"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "FixedCredit", "固定与信"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "InterimCredit", "臨時与信"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "WaitOutDay", "出金待ち"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "WaitAudited", "審査待ち"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "WaitConfirm", "確認待ち"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "WaitReceive", "入金待ち"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Finished", "決算済み"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Rejected", "返却済み"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Change", "変更"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Bill", "財務"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Company", "会社"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Product", "商品"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Sales", "販売"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Amend", "返金"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "People", "個人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Customer", "顧客"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "HotelChange", "旅程変更"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Station", "駅"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "CompanyID", "会社"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "People", "個人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "SpecialTicket", "専用請求書"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "GeneralTicket", "普通請求書"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Electronic", "電子請求書"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Paper", "紙の領収書"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "HotelDelay", "旅程キャンセル"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Economy5", "5割引エコノミークラス"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Economy6", "6割引エコノミークラス"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Economy7", "7割引エコノミークラス"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Economy8", "8割引エコノミークラス"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Economy9", "9割引エコノミークラス"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "MessageNotify", "SMS通知"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "MailNotify", "メール通知"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "WechatNotify", "WeChat通知"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "AppNotify", "アプリ通知"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "WaitOutDay", "計上待ち"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "OverdueNo", "期限前"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "OverdueYes", "期限切れ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Percentage", "パーセンテージ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "FixMoney", "固定金額"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "RemovePrice", "価格除外"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Creater", "作成者"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Member", "参加者"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Watcher", "フォロワー"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Text", "テキスト"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Html", "HTML"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Link", "リンク"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Plugin", "プラグイン"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "CompanyInternal", "社内"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "CurrentDomainName", "現在のドメイン"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "AllDomainName", "すべてのドメイン"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Email", "メール"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "OrdinaryAddress", "一般アドレス"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "B2C", "B2C"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "B2G", "B2G"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Demand", "要件"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "WaitBooking", "予約待ち"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "WaitApprove", "承認待ち"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "WaitConfirm", "確認待ち"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "WaitPayment", "支払い待ち"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "WaitDispose", "処理待ち"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Finished", "完了済み"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Canceled", "キャンセル済み"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Rejected", "返却済み"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Discrete", "分割済み"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "Cannot", "一時不可"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "EmailAuth", "メールアカウント"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "MobileAuth", "携帯電話アカウント"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "AccountAuth", "ユーザーアカウント"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "WeixinAuth", "WeChat認証"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "DynamicAuth", "動的検証"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "BookingInfo", "予約注意事項"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "PolicyCause", "違反理由"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "TravelPurpose", "出張目的"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_category, "WaitRefund", "返金待ち"), _category)
});

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_system_router__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_order_router__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_trade_router__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_manage_flightCN_router__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_manage_flight_router__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_mall_flightCN_router__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_mall_flightGJ_router__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_mall_hotelCN_router__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_mall_hotelGJ_router__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_mall_train_router__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_base_router__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_mall_router__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_btrip_platform_router__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_meeting_router__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_bill_router__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_mall_demand_router__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__views_mall_newdemand_router__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__views_manage_router__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__views_invoice_router__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__views_express_router__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__views_insurance_router__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__views_admin_router__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__views_statistics_router__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__views_manage_policy_router__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__views_btrip_router__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__views_adapter_router__ = __webpack_require__(305);

















var dashboard = function dashboard(resolve) {
  return __webpack_require__.e/* require */(5).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(217)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var fullscreen = function fullscreen(resolve) {
  return __webpack_require__.e/* require */(109).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(660)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var index = function index(resolve) {
  return __webpack_require__.e/* require */(108).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(661)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var p404 = function p404(resolve) {
  return __webpack_require__.e/* require */(214).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(584)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

















__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vue_router___default.a);
var routeCache = {};

function fnMergeRoute(route) {
  if (route.name == undefined || route.name == "") {
    routes.push(route);
    return;
  }
  var cache = routeCache[route.name];
  if (!cache) {
    cache = route;
    routeCache[route.name] = route;
    routes.push(route);
    return;
  }
  cache.children = _.union(cache.children, route.children);
}

var routes = [];
$utils.each([{
  path: "/fullscreen",
  name: "fullscreen",
  component: fullscreen,
  meta: {
    requiresAuth: true
  },
  children: []
}], fnMergeRoute);
$utils.each(__WEBPACK_IMPORTED_MODULE_2__views_system_router__["a" /* default */], fnMergeRoute);

$utils.each(__WEBPACK_IMPORTED_MODULE_3__views_order_router__["a" /* default */], fnMergeRoute);


$utils.each(__WEBPACK_IMPORTED_MODULE_4__views_trade_router__["a" /* default */], fnMergeRoute);

$utils.each(__WEBPACK_IMPORTED_MODULE_5__views_manage_flightCN_router__["a" /* default */], fnMergeRoute);
$utils.each(__WEBPACK_IMPORTED_MODULE_6__views_manage_flight_router__["a" /* default */], fnMergeRoute);
$utils.each(__WEBPACK_IMPORTED_MODULE_7__views_mall_flightCN_router__["a" /* default */], fnMergeRoute);
$utils.each(__WEBPACK_IMPORTED_MODULE_8__views_mall_flightGJ_router__["a" /* default */], fnMergeRoute);
$utils.each(__WEBPACK_IMPORTED_MODULE_9__views_mall_hotelCN_router__["a" /* default */], fnMergeRoute);
$utils.each(__WEBPACK_IMPORTED_MODULE_10__views_mall_hotelGJ_router__["a" /* default */], fnMergeRoute);
$utils.each(__WEBPACK_IMPORTED_MODULE_11__views_mall_train_router__["a" /* default */], fnMergeRoute);

$utils.each(__WEBPACK_IMPORTED_MODULE_12__views_base_router__["a" /* default */], fnMergeRoute);
$utils.each(__WEBPACK_IMPORTED_MODULE_13__views_mall_router__["a" /* default */], fnMergeRoute);
$utils.each(__WEBPACK_IMPORTED_MODULE_16__views_bill_router__["a" /* default */], fnMergeRoute);
$utils.each(__WEBPACK_IMPORTED_MODULE_27__views_adapter_router__["a" /* default */], fnMergeRoute);

$utils.each(__WEBPACK_IMPORTED_MODULE_18__views_mall_newdemand_router__["a" /* default */], fnMergeRoute);
$utils.each(__WEBPACK_IMPORTED_MODULE_17__views_mall_demand_router__["a" /* default */], fnMergeRoute);
$utils.each(__WEBPACK_IMPORTED_MODULE_19__views_manage_router__["a" /* default */], fnMergeRoute);
$utils.each(__WEBPACK_IMPORTED_MODULE_20__views_invoice_router__["a" /* default */], fnMergeRoute);
$utils.each(__WEBPACK_IMPORTED_MODULE_21__views_express_router__["a" /* default */], fnMergeRoute);
$utils.each(__WEBPACK_IMPORTED_MODULE_22__views_insurance_router__["a" /* default */], fnMergeRoute);
$utils.each(__WEBPACK_IMPORTED_MODULE_23__views_admin_router__["a" /* default */], fnMergeRoute);
$utils.each(__WEBPACK_IMPORTED_MODULE_24__views_statistics_router__["a" /* default */], fnMergeRoute);
$utils.each(__WEBPACK_IMPORTED_MODULE_25__views_manage_policy_router__["a" /* default */], fnMergeRoute);
$utils.each(__WEBPACK_IMPORTED_MODULE_26__views_btrip_router__["a" /* default */], fnMergeRoute);
$utils.each(__WEBPACK_IMPORTED_MODULE_14__views_btrip_platform_router__["a" /* default */], fnMergeRoute);
$utils.each(__WEBPACK_IMPORTED_MODULE_15__views_meeting_router__["a" /* default */], fnMergeRoute);

routes.push({
  path: "/",
  component: index
});
routes.push({
  path: "*",
  component: p404
});
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router___default.a({
  mode: "history",
  routes: routes,
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return {
        x: 0,
        y: 0
      };
    }
  }
}));

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ticketStore_js__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actionStore_js__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__previewStore_js__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__siteStore_js__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__viaList_js__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__categoryStore_js__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__conferService_js__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__workTaskStore_js__ = __webpack_require__(299);













/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex___default.a.Store({
    strict: "production" !== 'production',
    modules: {
        ticketStore: __WEBPACK_IMPORTED_MODULE_3__ticketStore_js__["a" /* default */],

        actionStore: __WEBPACK_IMPORTED_MODULE_4__actionStore_js__["a" /* default */],
        previewStore: __WEBPACK_IMPORTED_MODULE_5__previewStore_js__["a" /* default */],
        siteStore: __WEBPACK_IMPORTED_MODULE_6__siteStore_js__["a" /* default */],
        viaList: __WEBPACK_IMPORTED_MODULE_7__viaList_js__["a" /* default */],
        categoryStore: __WEBPACK_IMPORTED_MODULE_8__categoryStore_js__["a" /* default */],
        conferService: __WEBPACK_IMPORTED_MODULE_9__conferService_js__["a" /* default */],
        workTaskStore: __WEBPACK_IMPORTED_MODULE_10__workTaskStore_js__["a" /* default */]
    }
}));

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = installCostCenterI18n;
var COST_CENTER_RENAME_COMPANY = '旭化成塑料';

var COST_CENTER_I18N_KEY_MAP = {
    'statistics.costcenter': 'statistics.expenseDepartment',
    'statistics.selectcostcenter': 'statistics.selectExpenseDepartment',
    'statistics.costpaysort': 'statistics.expenseDepartmentRanking',
    'order.costcenter': 'order.expenseDepartment',
    'system.costcenters': 'system.expenseDepartments',
    'mall.costcenter': 'mall.expenseDepartment',
    'bill.costcenter': 'bill.expenseDepartment',
    'bill.costcenternamesearch': 'bill.expenseDepartmentNameSearch',
    'bill.receivetablefaila': 'bill.selectExpenseDepartment',
    'webdata.costcenter': 'webdata.expenseDepartment',
    'category.CostCenter': 'category.ExpenseDepartment',
    'mall.xiaofeijineshangxian': 'mall.dangdizhusubiaozhunshangxian'
};

function isCostCenterRenameCompany(store) {
    var ticketInfo = store.getters.ticketInfo || {};
    return ticketInfo.CompanyName && ticketInfo.CompanyName.indexOf(COST_CENTER_RENAME_COMPANY) > -1;
}

function costCenterI18nKey(key, store) {
    if (!isCostCenterRenameCompany(store) || typeof key !== 'string') {
        return key;
    }
    return COST_CENTER_I18N_KEY_MAP[key] || key;
}

function costCenterText(value, store) {
    if (!isCostCenterRenameCompany(store) || typeof value !== 'string') {
        return value;
    }
    return value.replace(/成本名称搜索/g, '费用负担部门名称搜索').replace(/成本中心/g, '费用负担部门').replace(/消费金额/g, '当地住宿费标准');
}

function installCostCenterI18n(Vue, i18n, store) {
    var i18nT = i18n._t.bind(i18n);
    i18n._t = function () {
        var args = Array.prototype.slice.call(arguments);
        args[0] = costCenterI18nKey(args[0], store);
        return i18nT.apply(i18n, args);
    };
    Vue.prototype.$costCenterText = function (value) {
        return costCenterText(value, store);
    };
}

/***/ }),
/* 189 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 190 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(548)

var Component = __webpack_require__(20)(
  /* script */
  __webpack_require__(245),
  /* template */
  __webpack_require__(561),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(558)

var Component = __webpack_require__(20)(
  /* script */
  __webpack_require__(246),
  /* template */
  __webpack_require__(570),
  /* scopeId */
  "data-v-d37c1512",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(553)

var Component = __webpack_require__(20)(
  /* script */
  __webpack_require__(248),
  /* template */
  __webpack_require__(566),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(20)(
  /* script */
  __webpack_require__(251),
  /* template */
  __webpack_require__(563),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(20)(
  /* script */
  __webpack_require__(252),
  /* template */
  null,
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(551)

var Component = __webpack_require__(20)(
  /* script */
  __webpack_require__(253),
  /* template */
  __webpack_require__(564),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(556)

var Component = __webpack_require__(20)(
  /* script */
  __webpack_require__(254),
  /* template */
  __webpack_require__(568),
  /* scopeId */
  "data-v-b3e5e66a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(552)

var Component = __webpack_require__(20)(
  /* script */
  __webpack_require__(256),
  /* template */
  __webpack_require__(565),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 199 */
/***/ (function(module, exports) {

module.exports = window.$;

/***/ }),
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_categorys_js__ = __webpack_require__(63);

var data = {};
data.ServiceDate = [{
    ServiceName: '国内机票服务',
    ServiceCode: 'flight',
    ServiceType: __WEBPACK_IMPORTED_MODULE_0_utils_categorys_js__["a" /* default */].types.ServiceType.FlightService,
    ApplyArea: __WEBPACK_IMPORTED_MODULE_0_utils_categorys_js__["a" /* default */].types.ApplyArea.Internal,
    ServiceID: 'S00000000009'
}, {
    ServiceName: '国际机票服务',
    ServiceCode: 'flight',
    ServiceType: __WEBPACK_IMPORTED_MODULE_0_utils_categorys_js__["a" /* default */].types.ServiceType.FlightService,
    ApplyArea: __WEBPACK_IMPORTED_MODULE_0_utils_categorys_js__["a" /* default */].types.ApplyArea.Overseas,
    ServiceID: 'S00000000011'
}, {
    ServiceName: '国内酒店服务',
    ServiceCode: 'hotel',
    ServiceType: __WEBPACK_IMPORTED_MODULE_0_utils_categorys_js__["a" /* default */].types.ServiceType.HotelService,
    ApplyArea: __WEBPACK_IMPORTED_MODULE_0_utils_categorys_js__["a" /* default */].types.ApplyArea.Internal,
    ServiceID: 'S00000000013'
}, {
    ServiceName: '国际酒店服务',
    ServiceCode: 'hotel',
    ServiceType: __WEBPACK_IMPORTED_MODULE_0_utils_categorys_js__["a" /* default */].types.ServiceType.HotelService,
    ApplyArea: __WEBPACK_IMPORTED_MODULE_0_utils_categorys_js__["a" /* default */].types.ApplyArea.Overseas,
    ServiceID: 'S00000000015'
}, {
    ServiceName: '国内旅游服务',
    ServiceCode: 'tour',
    ServiceType: __WEBPACK_IMPORTED_MODULE_0_utils_categorys_js__["a" /* default */].types.ServiceType.TourService,
    ApplyArea: __WEBPACK_IMPORTED_MODULE_0_utils_categorys_js__["a" /* default */].types.ApplyArea.Internal,
    ServiceID: 'S00000000005'
}, {
    ServiceName: '国际旅游服务',
    ServiceCode: 'tour',
    ServiceType: __WEBPACK_IMPORTED_MODULE_0_utils_categorys_js__["a" /* default */].types.ServiceType.TourService,
    ApplyArea: __WEBPACK_IMPORTED_MODULE_0_utils_categorys_js__["a" /* default */].types.ApplyArea.Overseas,
    ServiceID: 'S00000000007'
}, {
    ServiceName: '国内火车票服务',
    ServiceCode: 'train',
    ServiceType: __WEBPACK_IMPORTED_MODULE_0_utils_categorys_js__["a" /* default */].types.ServiceType.TrainService,
    ApplyArea: __WEBPACK_IMPORTED_MODULE_0_utils_categorys_js__["a" /* default */].types.ApplyArea.Internal,
    ServiceID: 'S00000000017'
}, {
    ServiceName: '保险服务',
    ServiceCode: 'insurance',
    ServiceType: __WEBPACK_IMPORTED_MODULE_0_utils_categorys_js__["a" /* default */].types.ServiceType.InsuranceService,
    ApplyArea: __WEBPACK_IMPORTED_MODULE_0_utils_categorys_js__["a" /* default */].types.ApplyArea.Internal,
    ServiceID: 'S00000000025'
}, {
    ServiceName: '增值服务',
    ServiceCode: 'charge',
    ServiceType: __WEBPACK_IMPORTED_MODULE_0_utils_categorys_js__["a" /* default */].types.ServiceType.ChargeService,
    ApplyArea: __WEBPACK_IMPORTED_MODULE_0_utils_categorys_js__["a" /* default */].types.ApplyArea.Internal,
    ServiceID: 'S00000000043'
}, {
    ServiceName: '用车服务',
    ServiceCode: 'traffic',
    ServiceType: __WEBPACK_IMPORTED_MODULE_0_utils_categorys_js__["a" /* default */].types.ServiceType.TrafficService,
    ApplyArea: __WEBPACK_IMPORTED_MODULE_0_utils_categorys_js__["a" /* default */].types.ApplyArea.Internal,
    ServiceID: 'S00000000029'
}];
data.service = function (ServiceType, ApplyArea) {
    var ServiceID = "";

    for (var s = 0; s < data.ServiceDate.length; s++) {
        var element = data.ServiceDate[s];
        if (ServiceType == element.ServiceCode && ApplyArea == element.ApplyArea || ServiceType == element.ServiceType && ApplyArea == element.ApplyArea) {
            ServiceID = element.ServiceID;
            break;
        }
    }
    return ServiceID;
};
/* harmony default export */ __webpack_exports__["a"] = (data);

/***/ }),
/* 206 */,
/* 207 */,
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(1);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "btrip",
  getUrl: function getUrl(url) {
    return __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].getUrl(this.name, url);
  },
  getTripRuleList: function getTripRuleList(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/TripRule/List"), data);
  },
  getTripRuleDetails: function getTripRuleDetails(RuleID) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/TripRule/Details/" + RuleID));
  },
  saveTripRule: function saveTripRule(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/TripRule/Update"), data);
  },
  deleteTripRule: function deleteTripRule(RuleID) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/TripRule/Delete/" + RuleID));
  },
  getBtripTask: function getBtripTask(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/BtripTask/GetBtripTask"), data);
  },
  getBtripTextList: function getBtripTextList(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/BtripText/list"), data);
  },
  getBtripTextDetails: function getBtripTextDetails(TextID) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/BtripText/Details/" + TextID));
  },
  getBtripTextUpdate: function getBtripTextUpdate(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/BtripText/Update"), data);
  },
  getBtripTexts: function getBtripTexts(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/BtripText/BtripTexts/" + id));
  },
  getBtripTextDelete: function getBtripTextDelete(TextID) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/BtripText/Delete/" + TextID));
  },
  getTripFlowList: function getTripFlowList(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/TripFlow/List"), data);
  },
  getTripFlowDetail: function getTripFlowDetail(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/TripFlow/Details/" + id));
  },
  getTripFlowUpdate: function getTripFlowUpdate(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/TripFlow/TripFlowUpdate"), data);
  },
  getTripDelete: function getTripDelete(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/TripFlow/Delete/" + id));
  },
  saveTripRejectReason: function saveTripRejectReason(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/BtripTask/Update"), data);
  },
  sendMsg: function sendMsg(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/BtripTask/sendmsg?UnionID=" + id));
  },
  getProjectList: function getProjectList(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/Project/List"), data);
  },
  saveProject: function saveProject(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/Project/save"), data);
  },
  deleteProject: function deleteProject(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/Project/delete?id=" + id));
  },
  getList: function getList(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/BtripPolicy/List"), data);
  },
  getRulePosition: function getRulePosition(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/ApprovalRule/GetRulePosition"), data);
  },
  getQueryTravelRuleDetaile: function getQueryTravelRuleDetaile(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/OperatePolicy/QueryTravelRuleDetaile/" + id));
  },
  getCreateTravelRule: function getCreateTravelRule(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/OperatePolicy/CreateTravelRule"), data);
  },
  getDeleteTravelRule: function getDeleteTravelRule(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/OperatePolicy/DeleteTravelRule/" + id));
  },
  getApprovalRuleList: function getApprovalRuleList(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/OperatePolicy/QueryApprovalRuleList"), data);
  },
  ApprovalRuleList: function ApprovalRuleList(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/ApprovalRule/List"), data);
  },
  ApprovalDetail: function ApprovalDetail(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/ApprovalRule/ApprovalDetail/" + id));
  },
  ApprovalSave: function ApprovalSave(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/ApprovalRule/ApprovalSave"), data);
  },
  getDeleteApprovalRule: function getDeleteApprovalRule(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/OperatePolicy/DeleteApprovalRule/" + id));
  },
  getCreateApprovalRule: function getCreateApprovalRule(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/OperatePolicy/CreateApprovalRule"), data);
  },
  getQueryApprovalRuleDetaile: function getQueryApprovalRuleDetaile(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/OperatePolicy/QueryApprovalRuleDetaile/" + id));
  },
  getQueryApprovalPeople: function getQueryApprovalPeople(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/OperatePolicy/QueryApprovalPeople/" + id));
  },
  GetApprovalProgress: function GetApprovalProgress(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/OperatePolicy/GetApprovalProgressByorderId/" + id));
  },
  getServiceFeeInfoList: function getServiceFeeInfoList(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/ServiceFeeInfo/List"), data);
  },
  getCreateServiceFee: function getCreateServiceFee(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/ManagementServices/CreateServiceFee"), data);
  },
  getQueryServiceFeeDetaile: function getQueryServiceFeeDetaile(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/ManagementServices/QueryServiceFeeDetaile/" + id));
  },
  getDeleteServiceFee: function getDeleteServiceFee(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/ManagementServices/DeleteServiceFee/" + id));
  },
  getUpdateClientServiceFee: function getUpdateClientServiceFee(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/ClientServiceFee/UpdateClientServiceFee"), data);
  },
  getClientServiceFeeList: function getClientServiceFeeList(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/ClientServiceFee/List"), data);
  },
  Approver: function Approver(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/OperatePolicy/IsEnableApproval/" + id));
  },
  getTripRule: function getTripRule(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/TripRule/GetTripRule"), data);
  },
  getCostCenter: function getCostCenter(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/BtripTask/GetCostCenter?TaskID=" + id));
  },
  updatebtrip: function updatebtrip(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/btriptask/updatebtrip"), data);
  },
  getApprovalOrderInfo: function getApprovalOrderInfo(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/approval/ResolveOrder?id=" + id));
  },
  approvalResolve: function approvalResolve(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/approval/resolve?id=" + id));
  },
  approvalReject: function approvalReject(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/approval/reject?id=" + id));
  },
  saveTask: function saveTask(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("Task/save"), data);
  },
  getQueryApplicationList: function getQueryApplicationList(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("Task/list"), data);
  },
  QueryTripList: function QueryTripList(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("trip/list"), data);
  },
  QueryProjectList: function QueryProjectList(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("project/list"), data);
  },
  getTripCityLabelList: function getTripCityLabelList(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/TripCityLabel/List"), data);
  },
  saveCityLabel: function saveCityLabel(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/TripCityLabel/Save"), data);
  },
  deleteCityLabel: function deleteCityLabel(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/TripCityLabel/Delete?id=" + id));
  },
  getProjectRoleList: function getProjectRoleList(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/ProjectRole/List"), data);
  },
  saveProjectRole: function saveProjectRole(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/ProjectRole/save"), data);
  },
  SearchUserProjects: function SearchUserProjects(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/Project/SearchUserProjects"), data);
  }
});

/***/ }),
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(557)

var Component = __webpack_require__(20)(
  /* script */
  __webpack_require__(249),
  /* template */
  __webpack_require__(569),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(20)(
  /* script */
  __webpack_require__(247),
  /* template */
  __webpack_require__(571),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var dateUtils = {};
dateUtils.DateFormat = function (date, fmt) {
    fmt = fmt ? fmt : "yyyy-MM-dd HH:mm:ss";
    var o = {
        "M+": date.getMonth() + 1,
        "d+": date.getDate(),
        "h+": date.getHours(),
        "H+": date.getHours(),
        "m+": date.getMinutes(),
        "s+": date.getSeconds(),
        "q+": Math.floor((date.getMonth() + 3) / 3),
        "S": date.getMilliseconds() };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
    }return fmt;
};
dateUtils.toTimeString = function (time, fmt) {
    var dTime = 60 * 60 * 24;
    var hTime = 60 * 60;
    var mTime = 60;
    var o = {
        "d+": Math.floor(time / dTime),
        "H+": Math.floor(time % dTime / hTime),
        "h+": Math.floor(time % dTime / hTime),
        "m+": Math.floor(time % dTime % hTime / mTime),
        "s+": Math.floor(time % dTime % hTime % mTime)
    };
    fmt = fmt ? fmt : "dd.HH:mm:ss";
    var isTrim = true;
    for (var k in o) {
        var iscTrim = false;
        if (isTrim) {
            if (o[k] != 0) {
                isTrim = false;
                iscTrim = true;
            }
        }
        if (!isTrim && iscTrim) {
            var rx = new RegExp("(" + k + ")").exec(fmt);
            if (rx != null && rx.length > 0) {
                fmt = fmt.substr(rx.index, fmt.length - rx.index);
            }
        }
        if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
    }
    return fmt;
};
dateUtils.JsonToDate = function (jsonDate) {
    try {
        return new Date(parseInt(jsonDate.replace("/Date(", "").replace(")/", ""), 10));
    } catch (ex) {
        return "";
    }
};
dateUtils.JsonDateFormat = function (jsonDate, format) {
    return dateUtils.DateFormat(dateUtils.JsonToDate(jsonDate), format);
};
dateUtils.DateToString = function (date, format) {
    try {
        return dateUtils.DateFormat(date, format);
    } catch (ex) {
        return "";
    }
};
/* harmony default export */ __webpack_exports__["a"] = (dateUtils);

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(555)
__webpack_require__(554)

var Component = __webpack_require__(20)(
  /* script */
  __webpack_require__(255),
  /* template */
  __webpack_require__(567),
  /* scopeId */
  "data-v-4e044a66",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },
    mounted: function mounted() {},

    methods: {}
});

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            ContactList: {
                ContactPhone: '',
                ContactEmail: ''
            },
            Services: []
        };
    },

    computed: {
        CompanyID: function CompanyID() {
            return this.$store.getters.ticketInfo.CompanyID;
        },
        UserID: function UserID() {
            return this.$store.getters.ticketInfo.UserID;
        },
        UserName: function UserName() {
            return this.$store.getters.ticketInfo.UserName;
        },
        CompanyName: function CompanyName() {
            return this.$store.getters.ticketInfo.CompanyName;
        },
        RoleTypes: function RoleTypes() {
            return this.$store.getters.categorys.types.RoleType;
        }
    },
    watch: {
        'UserID': function UserID() {
            var __self = this;
            if (__self.UserID && __self.UserID != '') {
                __self.__init();
            }
        }
    },
    methods: {
        getContactList: function getContactList() {
            var __self = this;
            var data = {
                RoleID: __self.UserID
            };
            __self.$api.system.getContactList(data).then(function (json) {
                if (json.data.isSucc) {
                    var result = _.find(json.data.result.entities, function (o) {
                        return o.IsDefault == 1150;
                    });
                    if (result) {
                        __self.ContactList = result;
                    }
                }
            });
        },
        __init: function __init() {
            var __self = this;
            if (__self.CompanyID) {
                var model = {
                    PageSize: 99999,
                    RoleType: __self.RoleTypes.Company,
                    RoleID: __self.CompanyID,
                    Superior: {
                        RoleType: __self.RoleTypes.User,
                        RootID: "S00000000120"
                    }
                };
                __self.$api.system.getOwners(model).then(function (o) {
                    if (o.data.isSucc) {
                        __self.Services = o.data.result;
                    }
                });
            } else {
                __self.Services = [];
            }
            __self.getContactList();
        },
        udInit: function udInit() {
            var __self = this;
            var Tags = __self.Services.map(function (o) {
                return o.UserName;
            });
            (function (a, h, c, b, f, g) {
                a["UdeskApiObject"] = f;
                a[f] = a[f] || function () {
                    (a[f].d = a[f].d || []).push(arguments);
                };
                g = h.createElement(c);
                g.async = 1;
                g.charset = "utf-8";
                g.src = b;
                c = h.getElementsByTagName(c)[0];
                c.parentNode.insertBefore(g, c);
            })(window, document, "script", "https://assets-cli.s2.udesk.cn/im_client/js/udeskApi.js", "ud");
            var timestamp = new Date().getTime();
            function getNonceStr() {
                return Math.random().toString(36).substr(2, 15);
            }
            var nonce = getNonceStr();
            var sign_str = 'nonce=' + nonce + '&timestamp=' + timestamp + '&web_token=' + (__self.UserID ? __self.UserID : '') + '&22d39dbf4792d4e66ea5d0b0308b5983';
            sign_str = sha1(sign_str);
            sign_str = sign_str.toUpperCase();
            ud({
                "code": "5b464e8",
                "link": "https://lichengtrip.s2.udesk.cn/im_client/?web_plugin_id=4981",
                "mode": "inner",
                "color": "#307AE8",
                "pos_flag": "srb",
                "language": "zh-cn",
                "session_key": "afeoqe",
                "onlineText": "联系客服，在线咨询",
                "offlineText": "客服下班，请留言",
                "targetSelector": "#btn_udesk_im",
                "selector": "#btn_udesk_im"
            });
            ud({
                "customer": {
                    "nonce": nonce,
                    "signature": sign_str,
                    "timestamp": timestamp,
                    "c_name": __self.UserName ? __self.UserName : '',
                    "web_token": __self.UserID ? __self.UserID : '',
                    "customer_token": __self.UserID ? __self.UserID : '',
                    "c_org": __self.CompanyName ? __self.CompanyName : '',
                    "c_tags": Tags.join(','),
                    "c_phone": __self.ContactList.ContactPhone,
                    "c_email": __self.ContactList.ContactEmail
                }
            });
            ud({
                "panel": {
                    "css": {
                        "bottom": "0",
                        "right": "180px"
                    },
                    "onToggle": function onToggle(data) {
                        if (data.visible) {
                            console.log('窗口打开');
                        } else {
                            console.log('窗口关闭');
                        }
                    }
                }
            });
        },
        OpenCustomerServices: function OpenCustomerServices() {
            var __self = this;
            __self.udInit();
        }
    }
});

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apis_config_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex__);





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            date: new Date().getFullYear(),
            config: __WEBPACK_IMPORTED_MODULE_1__apis_config_js__["a" /* default */]
        };
    },
    mounted: function mounted() {
        window.config = this.config;
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])(['siteInfo']))
});

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },
    mounted: function mounted() {},

    methods: {}
});

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuex__);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            menus: [{
                path: '/',
                title: 'mall.home'
            }, {
                path: '/mall/booking',
                title: 'mall.bookingcenter'
            }, {
                path: '/btripplatform/main',
                title: 'mall.btripplateform'
            }, {
                path: '/meeting/index',
                title: 'mall.tourism'
            }, {
                path: '/system/serve/contact',
                title: 'mall.contactUs'
            }, {
                path: '/train',
                title: 'mall.appdownload'
            }]
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])(['ticketInfo'])),
    mounted: function mounted() {
        var __self = this;
        var userStore = __self.$store.getters.getTicket;
    },

    methods: {
        exit: function exit() {
            var __self = this;
            __self.$store.dispatch("logout").then(function () {
                location.href = "/";
            }).catch(function () {
                location.href = "/";
            });
        },
        login: function login() {
            this.$router.push({
                path: '/login',
                query: {
                    redirect: this.$route.fullPath
                }
            });
        },
        changelang: function changelang(value) {
            window.localStorage.setItem('lang', value);
            this.$i18n.locale = value;
        }
    }
});

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_categorys_js__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex__);





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            categorys: __WEBPACK_IMPORTED_MODULE_1_utils_categorys_js__["a" /* default */],
            languages: [{
                value: '1',
                label: '中文'
            }, {
                value: '2',
                label: '英文'
            }],
            BookType: __WEBPACK_IMPORTED_MODULE_1_utils_categorys_js__["a" /* default */].types.BookingType.OnBusiness,
            language: '中文'
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])(['ticketInfo'])),
    methods: {
        changeBookType: function changeBookType(value) {
            this.$emit('BookTypes', value);
        },
        exit: function exit() {
            var __self = this;
            __self.$store.dispatch("logout").then(function () {
                location.href = "/";
            }).catch(function () {
                location.href = "/";
            });
        },
        login: function login() {
            this.$router.push({
                path: '/login',
                query: {
                    redirect: this.$route.fullPath
                }
            });
        }
    }
});

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'icon',
    props: ['name'],
    mounted: function mounted() {}
});

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__keep_alive_js__ = __webpack_require__(327);



/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__keep_alive_js__["a" /* default */]);

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__header__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_categorys_js__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__footer__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hearder1__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hearder1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__hearder1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils__ = __webpack_require__(13);







/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },
    mounted: function mounted() {},

    computed: {},
    methods: {},
    components: {
        'l-header': __WEBPACK_IMPORTED_MODULE_0__header___default.a,
        'l-footer': __WEBPACK_IMPORTED_MODULE_2__footer___default.a
    }
});

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils__ = __webpack_require__(13);



/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            nowTime: __WEBPACK_IMPORTED_MODULE_0_utils__["a" /* default */].DateFormat(new Date(), "yyyy-MM-dd HH:mm:ss")
        };
    },

    props: ['menus', 'showBack'],
    methods: {
        Back: function Back() {
            history.back();
        }
    },
    computed: {
        isShowBack: function isShowBack() {
            return this.showBack == undefined || this.showBack != false && this.showBack != "false";
        }
    },
    mounted: function mounted() {
        var __self = this;
        setInterval(function () {
            __self.nowTime = __WEBPACK_IMPORTED_MODULE_0_utils__["a" /* default */].DateFormat(new Date(), "yyyy-MM-dd HH:mm:ss");
        }, 1000);
    }
});

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__manage_order_service_js__ = __webpack_require__(205);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'sidebar',
    props: ['name'],
    filters: {
        ComponentName: function ComponentName(value) {
            return value.children && !value.ActionURL ? 'el-menu-item-group' : 'el-menu-item';
        },
        IconName: function IconName(value) {
            return value + ' menuIcon';
        }
    },
    data: function data() {
        return {
            changes: [],
            sms: [],
            exportList: []
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])(['roots', 'actions']), {
        CompanyID: function CompanyID() {

            return this.$store.getters.ticketInfo.CompanyID;
        },
        UserID: function UserID() {
            return this.$store.getters.ticketInfo.UserID;
        },
        isSupply: function isSupply() {
            return this.$store.getters.isSupply;
        },
        WorkTaskLists: function WorkTaskLists() {
            if (this.$store.getters.WorkTask) {
                return this.$store.getters.WorkTask;
            }
        },
        ServiceCode: function ServiceCode() {
            return this.$route.params.service;
        },
        ApplyArea: function ApplyArea() {
            return this.$route.query.ApplyArea;
        },
        ServiceTypes: function ServiceTypes() {
            return this.$store.getters.categorys.ServiceType;
        },
        ApplyAreas: function ApplyAreas() {
            return this.$store.getters.categorys.ApplyArea;
        },
        BusinessTypeTypes: function BusinessTypeTypes() {
            return this.$store.getters.categorys.types.BusinessType;
        }
    }),
    watch: {
        'actions': function actions() {
            var __self = this;
            _.forEach(__self.actions, function (ent) {
                ent.ActionURL = ent.ActionCode.replace(/:CompanyID/g, __self.CompanyID).replace(/:UserID/g, __self.UserID);
            });
        }
    },
    mounted: function mounted() {
        var __self = this;
        __self.$store.dispatch('loadconferService').then(function () {
            __self.$store.dispatch('loadWorkTask');

            __self.loadExportList();
            setInterval(function () {
                __self.$store.dispatch('loadWorkTask');
                __self.$store.dispatch('loadAdviseList');

                __self.loadExportList();
            }, 300000);
        });
    },

    methods: {
        loadExportList: function loadExportList() {
            var __self = this;
            __self.$api.bill.getExportList().then(function (json) {
                if (json.data.isSucc && json.data.result) {
                    __self.exportList = json.data.result.filter(function (o) {
                        return o.Downloaded == false;
                    });
                }
            });
        },
        smslist: function smslist() {
            var __self = this;
            __self.$api.adapter.smsList({ PageSize: 9999, SmsStatus: 1151 }).then(function (p) {
                if (p.data.isSucc) {
                    __self.sms = p.data.result.entities;
                }
            });
        },
        flightchanges: function flightchanges() {
            var __self = this;
            __self.$api.flight.getflightchanges({ ChangeStatues: [10301, 10303], PageSize: 9999 }).then(function (p) {
                if (p.data.isSucc) {
                    __self.changes = p.data.result.entities;
                }
            });
        },
        filterWorkTaskLists: function filterWorkTaskLists(url) {
            var __self = this;
            var WorkTaskLists = [];
            if (__self.WorkTaskLists) {
                if (url.indexOf('order') > -1) {
                    WorkTaskLists = _.filter(__self.WorkTaskLists, function (o) {
                        return o.BusinessType == __self.BusinessTypeTypes.Sales || o.BusinessType == __self.BusinessTypeTypes.Change;
                    });
                }
                if (url.indexOf('amend') > -1) {
                    WorkTaskLists = _.filter(__self.WorkTaskLists, function (o) {
                        return o.BusinessType == __self.BusinessTypeTypes.Amend;
                    });
                }
                var ServiceType = _.find(__self.ServiceTypes, function (o) {
                    var CategoryCode = _.toLower(o.CategoryCode.replace('Service', ''));
                    return url.indexOf(CategoryCode) > -1;
                });
                var ApplyArea = _.find(__self.ApplyAreas, function (o) {
                    var CategoryID = o.CategoryID;
                    return url.indexOf(CategoryID) > -1;
                });
                if (ServiceType && ApplyArea) {
                    var result = _.find(__WEBPACK_IMPORTED_MODULE_2__manage_order_service_js__["a" /* default */].ServiceDate, function (o) {
                        return o.ServiceCode == _.toLower(ServiceType.CategoryCode.replace('Service', '')) && o.ApplyArea == ApplyArea.CategoryID;
                    });
                    if (result) {
                        var data = _.filter(WorkTaskLists, function (o) {
                            return o.FlowCode == _.upperFirst(ServiceType.CategoryCode.replace('Service', '')) && o.ServiceID == result.ServiceID;
                        });
                        return data.length;
                    }
                }
            }
        },
        ChaneUrl: function ChaneUrl(url) {
            var __self = this;
            __self.$router.replace({
                path: url
            });
        },
        handleOpen: function handleOpen(key, keyPath) {},
        handleClose: function handleClose(key, keyPath) {},
        DefaultOpeneds: function DefaultOpeneds(roots) {
            var __self = this;
            var Opened = false;
            var root = _.find(roots, function (o) {
                return o.ActionName == "服务管理";
            });
            if (root) {
                Opened = true;
            }
            var DefaultOpeneds = [];
            for (var i = 0; i < roots.length; i++) {
                if (Opened && roots[i].ActionName == "订单管理") {
                    continue;
                }
                DefaultOpeneds.push("i" + i);
            }

            if (roots && roots.length > 0) {
                __self.billromove(__self.roots);
            }

            return DefaultOpeneds;
        },
        billromove: function billromove(data) {
            var __self = this;
            for (var c = 0; c < data.length; c++) {
                data[c].showbool = true;

                if (data[c].children && data[c].children.length > 0) {
                    __self.billromove(data[c].children);
                }
            }
        }
    }

});

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sidebar__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__sidebar__);



/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },
    mounted: function mounted() {},

    methods: {},
    components: {
        'l-sidebar': __WEBPACK_IMPORTED_MODULE_0__sidebar___default.a
    }
});

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'activity',
    getUrl: function getUrl(url) {
        return __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].getUrl(this.name, url);
    },
    getActiveList: function getActiveList(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/ActiveInfo/List"), data);
    },
    getActiveInfo: function getActiveInfo(ActiveId) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/ActiveInfo/Details?id=" + ActiveId));
    },
    getSaveActive: function getSaveActive(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/ActiveInfo/Save"), data);
    },
    getSearchAccount: function getSearchAccount(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/activeinfo/SearchAccount"), data);
    },
    enterInto: function enterInto(data, options) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/ActiveInfo/EnterInto"), data, options);
    },
    getRecordList: function getRecordList(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/RecordInfo/List"), data);
    },
    getInsulation: function getInsulation(depart, arrive) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/common/gelizhengce?depart=" + (depart || "").replace("市", "") + "&arrive=" + (arrive || "").replace("市", "")), { failTips: false });
    },
    getCommonList: function getCommonList() {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/common/list'));
    },
    commonupdate: function commonupdate(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/common/update'), data);
    },
    commondelete: function commondelete(id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/common/delete?companyid=' + id));
    }
});

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "adapter",
  getUrl: function getUrl(url) {
    return __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].getUrl(this.name, url);
  },
  getExtraList: function getExtraList(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/ExtraInfo/List"), data);
  },
  getExtraInfo: function getExtraInfo(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/ExtraInfo/Details/" + id));
  },
  saveExtraInfo: function saveExtraInfo(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/ExtraInfo/Save"), data);
  },
  getTransform: function getTransform(user_id, redirect_uri) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("Tunnel/transform?user_id=" + user_id + "&redirect_uri=" + redirect_uri));
  },
  delete: function _delete(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/ExtraInfo/Delete?id=" + id));
  },
  getSceneInfoList: function getSceneInfoList(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/sceneinfo/list"), data);
  },
  getSceneInfo: function getSceneInfo(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/sceneinfo/details/" + id));
  },
  saveSceneInfo: function saveSceneInfo(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/sceneinfo/save"), data);
  },
  deleteSceneInfo: function deleteSceneInfo(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/sceneinfo/delete" + id));
  },
  getAdviseUpdate: function getAdviseUpdate(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/advise/update"), data);
  },
  getAdviseList: function getAdviseList(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/advise/List"), data);
  },
  getAdviseDetails: function getAdviseDetails(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/advise/Details/" + id));
  },
  deleteExtraInfo: function deleteExtraInfo(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/ExtraInfo/Delete/" + id));
  },
  getSettingList: function getSettingList(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/settinginfo/list"), data);
  },
  getSettingInfo: function getSettingInfo(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/settinginfo/details?id=" + id));
  },
  saveSettingInfo: function saveSettingInfo(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/settinginfo/Save"), data);
  },
  deleteSettingInfo: function deleteSettingInfo(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/settinginfo/Delete/" + id));
  },
  smsList: function smsList(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/smsinfo/list'), data);
  },
  getSmsInfo: function getSmsInfo(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/smsinfo/Details?id=' + id));
  },
  saveSmsInfo: function saveSmsInfo(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/smsinfo/save'), data);
  },
  quantityUpdate: function quantityUpdate(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/smsinfo/QuantityUpdate'), data);
  },
  runrule: function runrule() {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/smsinfo/RunRule'));
  },
  checkapproval: function checkapproval(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/EmailProject/detail'), data, {
      failTips: false
    });
  },
  getTaskplanlist: function getTaskplanlist(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/TaskPlan/List'), data);
  },
  saveTaskplan: function saveTaskplan(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/TaskPlan/Save'), data);
  },
  saveAppinfo: function saveAppinfo(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/appinfomodel/save'), data);
  },
  getAppinfo: function getAppinfo(code) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/appinfomodel/Details?appcode=' + code), { failTips: false });
  },
  sendCode: function sendCode(phone) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/auth/SendCode?phone=' + phone));
  },
  updateouterId: function updateouterId(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/auth/AcountVaild'), data);
  },
  searchUserBudgetInfo: function searchUserBudgetInfo(certNo) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/budget/SearchUserBudgetInfo?certNo=" + certNo));
  }
});

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(1);



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'analyse',
    getUrl: function getUrl(url) {
        return __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].getUrl(this.name, url);
    },
    tableList: function tableList() {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/Analyse/TableList'));
    },
    saveTable: function saveTable(filePath, tableName) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/Analyse/SaveTableInfo?filePath=' + filePath + '&tableName=' + tableName));
    },
    getColumnsByTable: function getColumnsByTable(id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/analyse/GetColumnsByTable?id=' + id));
    },
    getList: function getList(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/Analyse/List'), data);
    },
    update: function update(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/Analyse/Update'), data);
    },
    deleteData: function deleteData(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/Analyse/DeleteData'), data);
    },
    deleteTable: function deleteTable(tableId) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/Analyse/DeleteTable?tableId=' + tableId));
    },
    getLogList: function getLogList(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/Analyse/LogList'), data);
    },
    changecolumn: function changecolumn(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/Analyse/ChangeColumnType'), data);
    }
});

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'base',
    getUrl: function getUrl(url) {
        return __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].getUrl(this.name, url);
    },
    getZoneList: function getZoneList(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/ZoneInfo/List'), data);
    },
    getZoneInfo: function getZoneInfo(ZoneID) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/ZoneInfo/Details/' + ZoneID));
    },
    saveZoneInfo: function saveZoneInfo(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/ZoneInfo/Save'), data);
    },
    deleteZoneInfo: function deleteZoneInfo(ZoneID) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/ZoneInfo/Delete/' + ZoneID));
    },
    getContinentInfoList: function getContinentInfoList(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/ContinentInfo/List'), data);
    },
    getContinentInfo: function getContinentInfo(id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/ContinentInfo/Details/' + id));
    },
    saveContinentInfo: function saveContinentInfo(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/ContinentInfo/Save'), data);
    },
    getAreaInfoList: function getAreaInfoList(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/AreaInfo/List'), data);
    },
    getAreaInfo: function getAreaInfo(id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/AreaInfo/Details' + id));
    },
    saveAreaInfo: function saveAreaInfo(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/AreaInfo/Save'), data);
    },
    getCountryInfoList: function getCountryInfoList(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/CountryInfo/List'), data);
    },
    getCountryInfo: function getCountryInfo(id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/CountryInfo/Details/' + id));
    },
    saveCountryInfo: function saveCountryInfo(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/CountryInfo/Save"), data);
    },
    getProvinceInfoList: function getProvinceInfoList(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/ProvinceInfo/List'), data);
    },
    getProvinceInfo: function getProvinceInfo(id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/ProvinceInfo/Details/' + id));
    },
    saveProvinceInfo: function saveProvinceInfo(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('ProvinceInfo/Save'), data);
    },
    getCityInfoList: function getCityInfoList(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/CityInfo/List'), data);
    },
    getCityInfo: function getCityInfo(id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/CityInfo/List/' + id));
    },
    saveCityInfo: function saveCityInfo(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/CityInfo/Save'), data);
    },
    getDistrictInfoList: function getDistrictInfoList(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/DistrictInfo/List'), data);
    },
    saveDistrictInfo: function saveDistrictInfo(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/DistrictInfo/Save'), data);
    },
    getAirportInfoList: function getAirportInfoList(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/AirportInfo/List'), data);
    },
    saveAirportInfo: function saveAirportInfo(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/AirportInfo/Save'), data);
    },
    getScenicInfoList: function getScenicInfoList(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/ScenicInfo/List'), data);
    },
    saveScenicInfo: function saveScenicInfo(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/ScenicInfo/Save'), data);
    },
    getStationInfoList: function getStationInfoList(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/StationInfo/List'), data);
    },
    saveStationInfo: function saveStationInfo(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/StationInfo/Save'), data);
    },
    getAirwayInfoList: function getAirwayInfoList(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/AirwayInfo/List'), data);
    },
    saveAirwayInfo: function saveAirwayInfo(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/AirwayInfo/Save'), data);
    },
    getBerthInfoList: function getBerthInfoList(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/BerthInfo/List'), data);
    },
    saveBerthInfo: function saveBerthInfo(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/BerthInfo/Save'), data);
    },
    delBerthInfo: function delBerthInfo(id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/BerthInfo/Delete/' + id));
    },
    getExtraInfoList: function getExtraInfoList(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/ExtraInfo/List'), data);
    },
    saveExtraInfo: function saveExtraInfo(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/ExtraInfo/Save'), data);
    },
    deleteExtraInfo: function deleteExtraInfo(id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/ExtraInfo/Delete?id=' + id));
    },
    gettripcom: function gettripcom() {
        var reg = /^www./g;
        var hostname = window.location.hostname;
        if (!reg.test(hostname)) {
            hostname = 'www.lchtrip.com';
        }
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/static/' + hostname.replace(/\./g, '') + '/' + hostname.replace(/\./g, '') + '.json').replace('/api/base', ''));
    },
    getMapInfoList: function getMapInfoList(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/mapInfo/List'), data);
    },
    DetailsMapInfo: function DetailsMapInfo(id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/mapInfo/Details?id=' + id));
    },
    saveMapInfo: function saveMapInfo(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/mapInfo/Save'), data);
    },
    deleteMapInfo: function deleteMapInfo(id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/mapinfo/delete?id=' + id));
    }
});

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(1);



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'bill',
    getUrl: function getUrl(url) {
        return __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].getUrl(this.name, url);
    },
    CreateTrade: function CreateTrade(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/TradeDeal/CreateTrade'), data);
    },
    SubmitTrade: function SubmitTrade(TradeID) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/TradeDeal/SubmitTrade?TradeID=' + TradeID));
    },
    getTradeDeals: function getTradeDeals(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/TradeDeal/GetTradeDeals'), data);
    },
    saveTradeDeal: function saveTradeDeal(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/tradedeal/update'), data);
    },
    ConfirmTrade: function ConfirmTrade(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/TradeDeal/ConfirmTrade'), data);
    },
    CreateInvoice: function CreateInvoice(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/TradeDeal/CreateInvoice'), data);
    },
    TradeStatusStatistics: function TradeStatusStatistics(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/TradeDeal/TradeStatusStatistics'), data);
    },
    UpdateTradeDetailPrice: function UpdateTradeDetailPrice(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/TradeDetail/UpdateTradeDetailPrice'), data);
    },
    GetUserPayment: function GetUserPayment(orderid, unionid) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/TradeDeal/GetUserPayment?OrderID=' + orderid + '&UnionID=' + unionid));
    },
    UpdateTradeOrder: function UpdateTradeOrder(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/TradeOrder/Update'), data);
    },
    getTradeOrder: function getTradeOrder(id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/TradeOrder/details/' + id));
    },
    CancelTrade: function CancelTrade(id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/TradeDeal/CancelTrade/' + id));
    },
    CheckPaymentResult: function CheckPaymentResult(id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/TradeOrder/CheckPaymentResult/' + id));
    },
    getBankAccount: function getBankAccount(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/BankAccount/List'), data);
    },
    saveBankAccount: function saveBankAccount(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/BankAccount/BankAccountSave'), data);
    },
    deleteBankAccount: function deleteBankAccount(id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/BankAccount/Delete?id=' + id));
    },
    updateAccountStatus: function updateAccountStatus(id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/BankAccount/AccountStatusUpdate/' + id));
    },
    getTradeDealList: function getTradeDealList(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/TradeDeal/List'), data);
    },
    Receivabledetail: function Receivabledetail(id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/TradeDeal/Details/' + id));
    },
    TradeAccounts: function TradeAccounts(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/TradeAccount/List'), data);
    },
    TradeAccountState: function TradeAccountState(id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/TradeAccount/TradeAccountStatus/' + id));
    },
    TradeAccountAdd: function TradeAccountAdd(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/TradeAccount/TradeAccountAdd'), data);
    },
    CreditMoeuleQuery: function CreditMoeuleQuery(id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/CreditModule/CreditMoeuleQuery/' + id));
    },
    CreditMoeuleSave: function CreditMoeuleSave(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/CreditModule/CreditMoeuleSave'), data);
    },
    TradeFreeze: function TradeFreeze(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/TradeFreeze/List'), data);
    },
    TradeFlow: function TradeFlow(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/TradeFlow/List'), data);
    },
    RechargeTrade: function RechargeTrade(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/TradeDeal/RechargeTrade'), data);
    },
    uploadImage: function uploadImage(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post('/uploadfile/images/Upload/Tour/bill', data);
    },
    uploadfile: function uploadfile(data, filetype) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post('/uploadfile/files/upload/uploadFile/bill?filetype=' + filetype + '&', data);
    },
    applytable: function applytable(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/PaymentApply/List'), data);
    },
    Applydetail: function Applydetail(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/PaymentApply/MergePayApply'), data);
    },
    ConfirmReturn: function ConfirmReturn(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/TradeDeal/Confirmed/'), data);
    },
    PaymentDetails: function PaymentDetails(id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/TradeDeal/PaymentDetails/' + id));
    },
    Approvels: function Approvels(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/TradeDeal/AuditDeal'), data);
    },
    Payment: function Payment(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/TradeDeal/Payment'), data);
    },
    PayOrder: function PayOrder(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/TradeDeal/PayforOrder'), data);
    },
    PaymentInfo: function PaymentInfo(orderid) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/PaymentApply/PaymentInfo?OrderID=' + orderid));
    },
    getTrades: function getTrades(id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/TradeDeal/GetTrades/' + id));
    },
    BankAccountList: function BankAccountList(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/BankAccount/List'), data);
    },
    BankAccountUpdate: function BankAccountUpdate(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/BankAccount/Save'), data);
    },
    IsEnable: function IsEnable(id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/BankAccount/IsEnable/' + id));
    },
    Account: function Account(id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/BankAccount/GetStatus/' + id));
    },
    searchpayment: function searchpayment(id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/BillService/GetPayment/' + id));
    },
    getloglist: function getloglist(id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/BillLog/GetLogList/' + id));
    },
    updatetrade: function updatetrade(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('TradeDeal/updateVocher'), data);
    },
    RefusePay: function RefusePay(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/tradedeal/RefusePay'), data);
    },
    Export: function Export(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/TradeDeal/Export'), data);
    },
    exporttradedetail: function exporttradedetail(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/tradedetail/export'), data);
    },
    deleteExportFile: function deleteExportFile(id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/tradedetail/DeleteExportFile?id=' + id));
    },
    getUserTicketStatus: function getUserTicketStatus(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/tradedetail/SearchUserTicket'), data);
    },
    getTradeDetailList: function getTradeDetailList(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/TradeDetail/List'), data);
    },
    getTradeDetailUpdate: function getTradeDetailUpdate(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/TradeDetail/TradeDetailUpdate'), data);
    },
    getTradeDetailGroupBy: function getTradeDetailGroupBy(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/TradeBill/TradeDetailGroupBy'), data);
    },
    getLossCauseUpdate: function getLossCauseUpdate(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/TradeDetail/LossCauseUpdate'), data);
    },
    getCostCenterUpdate: function getCostCenterUpdate(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/TradeDetail/CostCenterUpdate'), data);
    },
    getInvoiceSave: function getInvoiceSave(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/TradeDetail/InvoiceSave'), data);
    },
    getTemplateList: function getTemplateList(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/TradeTemplate/TemplateList'), data);
    },
    getTemplateField: function getTemplateField(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/TradeTemplate/TemplateField'), data);
    },
    getTemplateDetail: function getTemplateDetail(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/TradeTemplate/TemplateDetail'), data);
    },
    getTemplateSave: function getTemplateSave(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/TradeTemplate/TemplateSave'), data);
    },
    getTradeBillList: function getTradeBillList(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/TradeBill/List'), data);
    },
    getTradePayBillList: function getTradePayBillList(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/TradeBill/Paymentlist'), data);
    },
    getBillList: function getBillList(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/TradeBill/BillList'), data);
    },
    getTradeBillUpdate: function getTradeBillUpdate(id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/TradeBill/TradeBillUpdate/' + id));
    },
    getProfitStatistics: function getProfitStatistics(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/TradeDetail/ProfitStatistics'), data);
    },
    getSalesComparison: function getSalesComparison(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/TradeDetail/SalesComparison'), data);
    },
    SalesComparisonUpdates: function SalesComparisonUpdates() {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/TradeDetail/SalesComparisonUpdates'));
    },
    getPaymentConfirm: function getPaymentConfirm(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/tradeOrder/PaymentConfirm'), data);
    },
    getExportList: function getExportList() {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/tradedetail/exportlist'));
    },
    gettradeconfiglist: function gettradeconfiglist() {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/tradeconfig/list'));
    },
    savetradeconfig: function savetradeconfig(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/tradeconfig/save'), data, { failTips: false });
    },
    getbankcardlist: function getbankcardlist(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/bankcard/list'), data);
    },
    savebankcard: function savebankcard(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/bankcard/save'), data);
    },
    delbankcard: function delbankcard(id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/bankcard/delete?id=' + id));
    },
    tradeReceiveStatistics: function tradeReceiveStatistics(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/tradedeal/TradeReceiveStatistics'), data);
    },
    getAllAccounts: function getAllAccounts() {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/tradeaccount/GetAllAccounts'));
    }
});

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'charge',
    getUrl: function getUrl(url) {
        return __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].getUrl(this.name, url);
    },
    OrderDetails: function OrderDetails(UniqueID) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/ChargeOrder/OrderDetails?UniqueID=' + UniqueID));
    },
    getOrderList: function getOrderList(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/ChargeOrder/List'), data);
    },
    OrderResolve: function OrderResolve(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/ChargeOrder/OrderResolve'), data);
    },
    OrderUnLock: function OrderUnLock(id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/ChargeOrder/OrderUnLock?UniqueID=' + id));
    },
    UpdateOrderPrice: function UpdateOrderPrice(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/ChargeOrder/UpdateOrderPrice'), data);
    }
});

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'chargepolicy',
    getUrl: function getUrl(url) {
        return __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].getUrl(this.name, url);
    },
    getChargeList: function getChargeList(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/ChargeInfo/List'), data);
    },
    getChargeDetails: function getChargeDetails(id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/ChargeInfo/Details/' + id));
    },
    saveChargeInfo: function saveChargeInfo(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/ChargeInfo/Save'), data);
    },
    getProductInfo: function getProductInfo(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/PolicyInfo/ProductInfo'), data, { failTips: false });
    },
    CreatePolicy: function CreatePolicy(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/PolicyInfo/CreatePolicy'), data);
    },
    getPolicyInfoList: function getPolicyInfoList(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/PolicyInfo/List'), data);
    },
    getPolicyDetails: function getPolicyDetails(id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/PolicyInfo/Details/' + id));
    },
    savePolicyInfo: function savePolicyInfo(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/PolicyInfo/Save'), data);
    },
    deletePolicyInfo: function deletePolicyInfo(id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/PolicyInfo/Delete/' + id));
    },
    copyPolicyInfo: function copyPolicyInfo(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/PolicyInfo/CopyPolicyInfo'), data);
    },
    getThrowInfoList: function getThrowInfoList(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/throwinfo/list'), data);
    }
});

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'dingding',
    getUrl: function getUrl(url) {
        return __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].getUrl(this.name, url);
    },
    synccompany: function synccompany() {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/common/SyncCompany'));
    }
});

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(1);



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'express',
    getUrl: function getUrl(url) {
        return __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].getUrl(this.name, url);
    },
    getExpressList: function getExpressList(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/ExpressOrder/List'), data);
    },
    getExpressOrder: function getExpressOrder(TaskID) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/ExpressOrder/Details/' + TaskID));
    },
    saveExpressOrder: function saveExpressOrder(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/ExpressOrder/Update'), data);
    },
    deleteExpressOrder: function deleteExpressOrder(TaskID) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/ExpressOrder/Delete/' + TaskID));
    },
    getExpressState: function getExpressState(TaskID) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/ExpressOrder/ExpressState/' + TaskID));
    }
});

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "flight",
  getUrl: function getUrl(url) {
    return __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].getUrl(this.name, url);
  },
  CheckRepeatOrder: function CheckRepeatOrder(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/FlightOrder/CheckRepeatOrder"), data, {
      failTips: false
    });
  },
  CreateOrder: function CreateOrder(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/FlightOrder/CreateOrderByProduct"), data);
  },
  OrderDetails: function OrderDetails(UniqueID) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/FlightOrder/OrderDetails?UniqueID=" + UniqueID));
  },
  OrderSubmit: function OrderSubmit(UniqueID) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/FlightOrder/OrderSubmit/" + UniqueID));
  },
  OrderCannot: function OrderCannot(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/FlightOrder/OrderCannot?UniqueID=" + id));
  },
  OrderDrawer: function OrderDrawer(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/FlightOrder/OrderDrawer?UniqueID=" + id));
  },
  OrderReject: function OrderReject(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/FlightOrder/OrderReject?UniqueID=" + id));
  },
  OrderResolve: function OrderResolve(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/FlightOrder/OrderResolve"), data);
  },
  UpdateGoods: function UpdateGoods(goods) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/FlightOrder/UpdateGoods"), goods);
  },
  CreateAmend: function CreateAmend(amend) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/FlightOrder/CreateAmend"), amend);
  },
  SubmitAmend: function SubmitAmend(UniqueID) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/FlightOrder/SubmitAmend/" + UniqueID));
  },
  AmendDetails: function AmendDetails(UniqueID) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/FlightOrder/AmendDetails?UniqueID=" + UniqueID));
  },
  ClientOrderResolve: function ClientOrderResolve(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/FlightOrder/ClientOrderResolve"), data);
  },
  ReplenishOrderInfomation: function ReplenishOrderInfomation(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/FlightOrder/ReplenishOrderInfomation"), data);
  },
  ConfirmClientAmendPrice: function ConfirmClientAmendPrice(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/FlightOrder/ConfirmClientAmendPrice"), data);
  },
  ConfirmSupplyAmendPrice: function ConfirmSupplyAmendPrice(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/FlightOrder/ConfirmSupplyAmendPrice"), data);
  },
  CreateRefundRequest: function CreateRefundRequest(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/FlightOrder/CreateRefundRequest"), data);
  },
  RefundJudge: function RefundJudge(UniqueID) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/FlightOrder/RefundJudge?UniqueID=" + UniqueID));
  },
  UpdateOrder: function UpdateOrder(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/FlightOrder/UpdateOrder"), data);
  },
  OrderCancel: function OrderCancel(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/FlightOrder/OrderCancel?UniqueID=" + id), {
      failTips: false
    });
  },
  CreateDemandOrder: function CreateDemandOrder(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/FlightOrder/CreateSupplyDemandOrder?UnqiueId=" + id));
  },
  OrderUnLock: function OrderUnLock(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/FlightOrder/OrderUnLock?UniqueID=" + id));
  },
  CreateB2GOrder: function CreateB2GOrder(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/FlightOrder/CreateB2GOrder?UniqueID=" + id));
  },
  CreateSupplyOrder: function CreateSupplyOrder(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/FlightOrder/CreateSupplyOrder"), data);
  },
  SearchSupply: function SearchSupply(id, data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/FlightOrder/SearchSupply?channelCode=" + id), data);
  },
  OrderLock: function OrderLock(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/FlightOrder/OrderLock?UniqueID=" + id));
  },
  OrderRefund: function OrderRefund(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/FlightOrder/OrderRefund"), data);
  },
  MessageSend: function MessageSend(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/FlightOrder/MessageSend"), data);
  },
  OrderRefundCancel: function OrderRefundCancel(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/FlightOrder/OrderRefundCancel?UniqueID=" + id));
  },
  ConfirmOrderPrice: function ConfirmOrderPrice(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/FlightOrder/ConfirmOrderPrice"), data);
  },
  UpdateOrderStatus: function UpdateOrderStatus(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/FlightOrder/UpdateOrderStatus?UniqueID=" + id));
  },
  UpdateOrderPrice: function UpdateOrderPrice(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/FlightOrder/UpdateOrderPrice"), data);
  },
  AmendStatusBack: function AmendStatusBack(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/FlightOrder/AmendStatusBack?UniqueID=" + id));
  },
  CreateTrade: function CreateTrade(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/FlightOrder/CreateTrade"), data);
  },
  getOrderList: function getOrderList(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/FlightOrder/List"), data);
  },
  FlightChange: function FlightChange(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/FlightOrder/FlightOrderChange"), data);
  },
  updatepnr: function updatepnr(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/FlightOrder/updatepnr"), data);
  },
  createamend: function createamend(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/flightamend/createamend/" + id));
  },
  updatepassinfo: function updatepassinfo(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/FlightConsumer/updatepass"), data);
  },
  ConfirmPrice: function ConfirmPrice(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/FlightOrder/ConfirmPrice"), data);
  },
  CreateOrderByPreference: function CreateOrderByPreference(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/FlightOrder/CreateOrderByPreference"), data);
  },
  SearchOrders: function SearchOrders(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/FlightOrder/SearchOrders?UniqueID=" + id));
  },
  SupplyOrderPayment: function SupplyOrderPayment(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/FlightOrder/SupplyOrderPayment?UniqueId=" + id));
  },
  flightchangeSave: function flightchangeSave(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/flightchange/save"), data);
  },
  getflightchanges: function getflightchanges(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/flightchange/list"), data);
  },
  sendChangeMsg: function sendChangeMsg(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/flightchange/SendMsg"), data);
  },
  getChangeMsg: function getChangeMsg(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/flightchange/GetChangeMsg"), data);
  },
  changeSolve: function changeSolve(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/flightchange/solve"), data);
  },
  submitbychangereason: function submitbychangereason(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/flightorder/subamendorder?UniqueId=" + id));
  },
  searchndcamendprice: function searchndcamendprice(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/FlightOrder/SearchAmendPriceAgain?UniqueID=" + id));
  },
  CreateAmendTradeDeal: function CreateAmendTradeDeal(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/flightorder/CreateAmendTradeDeal?UniqueID=" + id));
  },
  PaymentSupplyOrder: function PaymentSupplyOrder(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/flightorder/PaymentSupplyOrder?UniqueId=" + id));
  },
  saveCompanyEmailConfig: function saveCompanyEmailConfig(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/flightorder/saveCompanyEmailConfig"), data);
  },
  deleteCompanyEmailConfig: function deleteCompanyEmailConfig(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/flightorder/deleteCompanyEmailConfig?id=" + id));
  },
  companyEmailConfigList: function companyEmailConfigList(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/flightorder/CompanyEmailConfigList"), data);
  },
  SubmitUmsChange: function SubmitUmsChange(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/flightorder/CreateSupplyChangeOrder?UniqueId=" + id));
  },
  SubmitUmsAmend: function SubmitUmsAmend(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/flightorder/CreateSupplyAmendOrder?UniqueId=" + id));
  },
  SearchExtras: function SearchExtras(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/FlightOrder/SearchExtras"), data);
  },
  CreateExtras: function CreateExtras(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/FlightOrder/CreateExtras"), data);
  },
  SendEmail: function SendEmail(orderId, unionId, email) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/FlightOrder/SendEmail?orderId=" + orderId + "&UnionId=" + unionId + "&email=" + email));
  },
  getFlightOrderID: function getFlightOrderID(ClientUniqueID) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/flightorder/GetOrderIDByClientUniqueID?ClientUniqueID=" + ClientUniqueID), { failTips: false });
  },
  SearchEsById: function SearchEsById(id, starttime, endtime) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/FlightOrder/SearchEsById?id=" + id + "&starttime=" + starttime + "&endtime=" + endtime));
  },
  UpdateOrderClientUniqueId: function UpdateOrderClientUniqueId(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/FlightOrder/UpdateOrderClientUniqueId"), data);
  },
  UpdateOrderSupplyStatus: function UpdateOrderSupplyStatus(UniqueID) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/flightorder/UpdateOrderSupplyStatus?UniqueID=" + UniqueID));
  }
});

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(1);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "flightpolicy",
  getUrl: function getUrl(url) {
    return __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].getUrl(this.name, url);
  },
  GDSRT: function GDSRT(pnr, applyarea) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/PolicyInfo/GDSRT?pnr=" + pnr + "&applyarea=" + applyarea));
  },
  searchndcProduct: function searchndcProduct(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/PolicyInfo/SearchNdcProduct"), data, {
      failTips: false
    });
  },
  getLevelInfoList: function getLevelInfoList(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/LevelInfo/List"), data);
  },
  getLevelInfo: function getLevelInfo(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/LevelInfo/Details/" + id));
  },
  saveLevelInfo: function saveLevelInfo(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/LevelInfo/Save"), data);
  },
  getCustomerLevelList: function getCustomerLevelList(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/CustomerLevel/List"), data);
  },
  delCustomerLevel: function delCustomerLevel(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/CustomerLevel/Delete"), data);
  },
  FlightSearch: function FlightSearch(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/FlightSearch/Search"), data);
  },
  searchPolicyRate: function searchPolicyRate(id, data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/AmendPolicy/CalcPrice/" + id), data);
  },
  getPolicyInfoList: function getPolicyInfoList(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/PolicyInfo/List"), data);
  },
  PolicyInfoDetails: function PolicyInfoDetails(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/PolicyInfo/Details/" + id));
  },
  savePolicyInfo: function savePolicyInfo(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/PolicyInfo/Update"), data);
  },
  getExtraInfoList: function getExtraInfoList(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/ExtraInfo/List"), data);
  },
  UpdatePolicyInfoState: function UpdatePolicyInfoState(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/PolicyInfo/UpdatePolicyState"), data);
  },
  deletePolicyInfo: function deletePolicyInfo(policyId) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/PolicyInfo/delete?id=" + policyId), {});
  },
  SaveBatch: function SaveBatch(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/PolicyInfo/SaveBatch"), data);
  },
  CopyPolicyInfo: function CopyPolicyInfo(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/PolicyInfo/CopyFlightPolicy/" + id));
  },
  getFileContent: function getFileContent(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/AmendPolicy/Uploadfile"), data, {
      failTips: false
    });
  },
  deleteFlightPolicy: function deleteFlightPolicy(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/PolicyInfo/Delete?id=" + id));
  },
  getsetting: function getsetting(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/TradeSetting/GetAllSet/" + id));
  },
  savetradeset: function savetradeset(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/TradeSetting/Add"), data);
  },
  changetimelist: function changetimelist(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/AmendTime/List"), data);
  },
  Changetimedelete: function Changetimedelete(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/AmendTime/Delete/" + id));
  },
  changetimeDetail: function changetimeDetail(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/AmendTime/ChangeTimeDetails/" + id));
  },
  changetimeupdate: function changetimeupdate(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/AmendTime/ChangeTimeUpdate"), data);
  },
  RulsList: function RulsList(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/AmendPolicy/List"), data);
  },
  rulesDetail: function rulesDetail(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/AmendPolicy/RulesDetails/" + id));
  },
  rulesupdate: function rulesupdate(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/AmendPolicy/RulesUpdate"), data);
  },
  RuelsDisable: function RuelsDisable(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/AmendPolicy/RuelsDisable/" + id));
  },
  classruleslist: function classruleslist(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/AmendRate/List"), data);
  },
  classrulesdeatel: function classrulesdeatel(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/AmendRate/ClassRulesDetails"), data);
  },
  classrulesdelete: function classrulesdelete(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/AmendRate/Delete"), data);
  },
  classrulesupdate: function classrulesupdate(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/AmendRate/ClassRulesUpdate"), data);
  },
  customerLevel: function customerLevel() {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("Policy/customerLevel"));
  },
  Uploadfile: function Uploadfile(data, id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/AmendPolicy/Uploadfile/" + id), data);
  },
  BathUploadfile: function BathUploadfile(data, id, AmendID) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/AmendRate/BathUploadfile?id=" + id + "&AmendID=" + AmendID), data);
  },
  CreatePolicy: function CreatePolicy(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/FlightPolicy/CreatePolicy"), data);
  },
  ProductInfo: function ProductInfo(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/FlightPolicy/ProductInfo"), data);
  },
  PriceVerify: function PriceVerify(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/FlightPolicy/PriceVerify"), data);
  },
  ClientUserList: function ClientUserList(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/ClientUser/list"), data);
  },
  ClientUserSave: function ClientUserSave(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/ClientUser/ClientUserSave"), data);
  },
  ClientUserDetails: function ClientUserDetails(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/ClientUser/Details/" + id));
  },
  ClientUserDelete: function ClientUserDelete(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/ClientUser/Delete/" + id));
  },
  ClientUserUploadfile: function ClientUserUploadfile(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/ClientUser/Uploadfile"), data);
  },
  ClientCodeList: function ClientCodeList(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/ClientCode/list"), data);
  },
  ClientCodeDetails: function ClientCodeDetails(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/ClientCode/Details/" + id));
  },
  ClientCodeSave: function ClientCodeSave(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/ClientCode/Save"), data);
  },
  ClientCodeDelete: function ClientCodeDelete(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/ClientCode/Delete/" + id));
  },
  getSalesRuleList: function getSalesRuleList(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/SalesRule/List"), data);
  },
  getSalesRuleDetails: function getSalesRuleDetails(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/SalesRule/Details/" + id));
  },
  saveSalesRule: function saveSalesRule(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/SalesRule/Save"), data);
  },
  deleteSalesRule: function deleteSalesRule(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/SalesRule/Delete/" + id));
  },
  SearchAmendPolicy: function SearchAmendPolicy(id, applyarea) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/Product/RuleInfo?id=" + id + "&ApplyArea=" + applyarea), {
      failTips: false
    });
  },
  getProductList: function getProductList(data, failTips) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/product/list"), data, {
      failTips: failTips
    });
  },
  SearchProductList: function SearchProductList(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/product/SearchProductList"), data);
  },
  SearchItineraryList: function SearchItineraryList(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/product/SearchItineraryList"), data);
  },
  getProductGoods: function getProductGoods(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/product/GetGoods"), data);
  },
  GetChangeOrderPrice: function GetChangeOrderPrice(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/amendpolicy/GetChangeOrderPrice"), data);
  },
  getRobotInfo: function getRobotInfo(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/robotinfo/details?id=" + id));
  },
  getRobotList: function getRobotList(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/robotinfo/list"), data);
  },
  saveRobotInfo: function saveRobotInfo(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/robotinfo/save"), data);
  },
  deleteRobotInfo: function deleteRobotInfo(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/robotinfo/delete?id=" + id));
  },
  getBerthList: function getBerthList(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/StandardBerthInfo/list"), data);
  },
  updateBerthInfo: function updateBerthInfo(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/StandardBerthInfo/updateBerthInfo"), data);
  },
  getCompanyUnionList: function getCompanyUnionList(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/CompanyUnion/list"), data);
  },
  saveCompanyUnion: function saveCompanyUnion(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/CompanyUnion/Save"), data);
  },
  delCompanyUnion: function delCompanyUnion(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/CompanyUnion/delete?id=" + id));
  },
  getRulepolicylist: function getRulepolicylist(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/RulesPolicy/list"), data);
  },
  delrulepolicy: function delrulepolicy(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/rulespolicy/delete?id=" + id));
  },
  saverulepolicy: function saverulepolicy(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/rulespolicy/save"), data);
  },
  runrule: function runrule(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/rulespolicy/RunRule"), data);
  },
  SaveTime: function SaveTime(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/StandardBerthInfo/SaveTime"), data);
  },
  getSaveModel: function getSaveModel() {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/StandardBerthInfo/SearchSaveModel"));
  },
  runberth: function runberth() {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/Service/RunStandardBerth"));
  },
  ErrorRunAgain: function ErrorRunAgain() {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/StandardBerthInfo/ErrorRunAgain"));
  },
  getBaggagelist: function getBaggagelist(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/BaggageRule/list"), data);
  },
  saveBaggage: function saveBaggage(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/BaggageRule/save"), data);
  },
  getBaggage: function getBaggage(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/BaggageRule/Details/" + id));
  },
  searchbagbyproduct: function searchbagbyproduct(id, applyarea) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/Product/baggage?id=" + id + "&ApplyArea=" + applyarea), {
      failTips: false
    });
  },
  getBagFileContent: function getBagFileContent(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/BaggageRule/Uploadfile"), data, {
      failTips: false
    });
  },
  bagdel: function bagdel(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/baggagerule/delete"), data);
  },
  getNotifylist: function getNotifylist(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/NotifyRule/list"), data);
  },
  saveNotify: function saveNotify(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/NotifyRule/save"), data);
  },
  getNotify: function getNotify(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/NotifyRule/Details/" + id));
  },
  delNotify: function delNotify(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/notifyrule/delete"), data);
  },
  getndcamendprice: function getndcamendprice(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/amendpolicy/GetOrderAmendPrice?id=" + id), {
      failTips: false
    });
  }
});

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__http__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(1);



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'hotel',
    getUrl: function getUrl(url) {
        return __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].getUrl(this.name, url);
    },
    CheckRepeatOrder: function CheckRepeatOrder(data) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(this.getUrl('/HotelOrder/CheckRepeatOrder'), data, {
            failTips: false
        });
    },
    CreateOrder: function CreateOrder(data) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(this.getUrl('/HotelOrder/CreateOrder'), data);
    },
    OrderDetails: function OrderDetails(UniqueID) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].get(this.getUrl('/HotelOrder/OrderDetails?UniqueID=' + UniqueID));
    },
    OrderSubmit: function OrderSubmit(UniqueID) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].get(this.getUrl('/HotelOrder/OrderSubmit/' + UniqueID));
    },
    OrderCannot: function OrderCannot(id) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].get(this.getUrl('/HotelOrder/OrderCannot?UniqueID=' + id));
    },
    OrderDrawer: function OrderDrawer(id) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].get(this.getUrl('/HotelOrder/OrderDrawer?UniqueID=' + id));
    },
    OrderReject: function OrderReject(id) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].get(this.getUrl('/HotelOrder/OrderReject?UniqueID=' + id));
    },
    OrderResolve: function OrderResolve(data) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(this.getUrl('/HotelOrder/OrderResolve'), data);
    },
    UpdateGoods: function UpdateGoods(goods) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(this.getUrl('/HotelOrder/UpdateGoods'), goods);
    },
    CreateAmend: function CreateAmend(amend) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(this.getUrl('/HotelOrder/CreateAmend'), amend);
    },
    SubmitAmend: function SubmitAmend(UniqueID) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].get(this.getUrl('/HotelOrder/SubmitAmend/' + UniqueID));
    },
    AmendDetails: function AmendDetails(UniqueID) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].get(this.getUrl('/HotelOrder/AmendDetails?UniqueID=' + UniqueID));
    },
    OrderCancel: function OrderCancel(id) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].get(this.getUrl('/HotelOrder/OrderCancel?UniqueID=' + id), {
            failTips: false
        });
    },
    OrderUnLock: function OrderUnLock(id) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].get(this.getUrl('/HotelOrder/OrderUnLock?UniqueID=' + id));
    },
    OrderLock: function OrderLock(id) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].get(this.getUrl('/HotelOrder/OrderLock?UniqueID=' + id));
    },
    OrderRefund: function OrderRefund(data) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(this.getUrl('/HotelOrder/OrderRefund'), data);
    },
    ClientOrderResolve: function ClientOrderResolve(data) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(this.getUrl('/HotelOrder/ClientOrderResolve'), data);
    },
    HotelPay: function HotelPay(id) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].get(this.getUrl('/HotelOrder/HotelPay?UniqueID=' + id));
    },
    RefundSubmit: function RefundSubmit(id) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].get(this.getUrl('/HotelOrder/RefundSubmit?UniqueID=' + id));
    },
    OrderRefundCancel: function OrderRefundCancel(id) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].get(this.getUrl('/HotelOrder/OrderRefundCancel?UniqueID=' + id));
    },
    ConfirmOrderPrice: function ConfirmOrderPrice(data) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(this.getUrl('/HotelOrder/ConfirmOrderPrice'), data);
    },
    UpdateOrderStatus: function UpdateOrderStatus(id) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].get(this.getUrl('/HotelOrder/UpdateOrderStatus?UniqueID=' + id));
    },
    UpdateOrderPrice: function UpdateOrderPrice(data) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(this.getUrl('/HotelOrder/UpdateOrderPrice'), data);
    },
    AmendStatusBack: function AmendStatusBack(id) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].get(this.getUrl('/HotelOrder/AmendStatusBack?UniqueID=' + id));
    },
    CreateTrade: function CreateTrade(data) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(this.getUrl('/HotelOrder/CreateTrade'), data);
    },
    ConfirmClientAmendPrice: function ConfirmClientAmendPrice(data) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(this.getUrl('/HotelOrder/ConfirmClientAmendPrice'), data);
    },
    ConfirmSupplyAmendPrice: function ConfirmSupplyAmendPrice(data) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(this.getUrl('/HotelOrder/ConfirmSupplyAmendPrice'), data);
    },
    getOrderList: function getOrderList(data) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(this.getUrl('/HotelOrder/List'), data);
    },
    AmendList: function AmendList(data) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(this.getUrl('/HotelAmend/List'), data);
    },
    CreateRefundRequest: function CreateRefundRequest(data) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(this.getUrl('/HotelOrder/CreateRefundRequest'), data);
    },
    RefundJudge: function RefundJudge(UniqueID) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].get(this.getUrl('/HotelOrder/RefundJudge?UniqueID=' + UniqueID));
    },
    UpdateOrder: function UpdateOrder(data) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(this.getUrl('/HotelOrder/UpdateOrder'), data);
    },
    MessageSend: function MessageSend(data) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(this.getUrl('/HotelOrder/MessageSend'), data);
    },
    HotelOrder: function HotelOrder(data) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(this.getUrl('/HotelOrder/HotelOrder'), data);
    },
    HotelDetail: function HotelDetail(id) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].get(this.getUrl('/HotelOrder/HotelDetail/' + id));
    },
    CreateOrderByPreference: function CreateOrderByPreference(data) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(this.getUrl('/HotelOrder/CreateOrderByPreference'), data);
    },
    SearchOrders: function SearchOrders(id) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].get(this.getUrl('/HotelOrder/SearchOrders?UniqueID=' + id));
    },
    getRefundPrice: function getRefundPrice(id) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].get(this.getUrl('/hotelorder/RefundPrice?id=' + id));
    },
    CreateAmendTradeDeal: function CreateAmendTradeDeal(id) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].get(this.getUrl('/hotelorder/CreateAmendTradeDeal?UniqueID=' + id));
    },
    ConfirmPay: function ConfirmPay(id, smscode) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].get(this.getUrl('/hotelorder/ConfirmPay?UniqueId=' + id + '&smscode=' + smscode));
    },
    SearchExtras: function SearchExtras(data) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(this.getUrl('/HotelOrder/SearchExtras'), data);
    },
    CreateExtras: function CreateExtras(data) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(this.getUrl('/HotelOrder/CreateExtras'), data);
    },
    SendEmail: function SendEmail(orderId, unionId, email) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].get(this.getUrl('/HotelOrder/SendEmail?orderId=' + orderId + '&UnionId=' + unionId + '&email=' + email));
    },
    getHotelOrderID: function getHotelOrderID(ClientUniqueID) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].get(this.getUrl('/hotelorder/GetOrderIDByClientUniqueID?ClientUniqueID=' + ClientUniqueID), { failTips: false });
    },
    UpdateOrderClientUniqueId: function UpdateOrderClientUniqueId(data) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(this.getUrl('/hotelorder/UpdateOrderClientUniqueId'), data);
    },
    downLoadPdf: function downLoadPdf(UniqueID) {
        var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].get(this.getUrl('/hotelorder/downLoadPdf?UniqueID=' + UniqueID), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ failTips: false }, config));
    },
    UpdateOrderSupplyStatus: function UpdateOrderSupplyStatus(UniqueID) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].get(this.getUrl('/hotelorder/UpdateOrderSupplyStatus?UniqueID=' + UniqueID));
    }
});

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "hotelpolicy",
  getUrl: function getUrl(url) {
    return __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].getUrl(this.name, url);
  },
  Citylist: function Citylist(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/HotelPolicy/Citylist/" + id));
  },
  ProductList: function ProductList(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/Product/list"), data);
  },
  ProductSpecs: function ProductSpecs(data, failTips) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/Product/ProductDetail"), data, { failTips: failTips });
  },
  ProductInfo: function ProductInfo(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/HotelPolicy/ProductInfo"), data);
  },
  IHotelList: function IHotelList(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/IHotelPolicy/IHotelList"), data);
  },
  IHotelDetail: function IHotelDetail(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/IHotelPolicy/IHotelDetail"), data);
  },
  IProductInfo: function IProductInfo(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/IHotelPolicy/ProductInfo"), data);
  },
  CreatePolicy: function CreatePolicy(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/HotelPolicy/CreatePolicy"), data);
  },
  saveHotelInfo: function saveHotelInfo(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/HotelPolicy/SaveHotelInfo/" + id));
  },
  getSalesRuleList: function getSalesRuleList(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/SalesRule/List"), data);
  },
  getSalesRuleDetails: function getSalesRuleDetails(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/SalesRule/Details/" + id));
  },
  saveSalesRule: function saveSalesRule(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/SalesRule/Save"), data);
  },
  deleteSalesRule: function deleteSalesRule(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/SalesRule/Delete/" + id));
  },
  ServiceFee: function ServiceFee(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/HotelPolicy/ServiceFee"), data);
  },
  getProductinfoList: function getProductinfoList(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/productinfo/List"), data);
  },
  saveProductinfo: function saveProductinfo(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/productinfo/Save"), data);
  },
  getProductinfoDetails: function getProductinfoDetails(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/productinfo/Details/" + id));
  },
  deleteProductInfo: function deleteProductInfo(productId) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/productinfo/delete?ProductId=" + productId), {});
  },
  getSpecinfoList: function getSpecinfoList(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/specinfo/List"), data);
  },
  getSpecinfoDetails: function getSpecinfoDetails(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/specinfo/Details/" + id));
  },
  getSaveSpecinfo: function getSaveSpecinfo(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/specinfo/Save"), data);
  },
  deleteSpecInfo: function deleteSpecInfo(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/specinfo/delete?id=" + id));
  },
  getExtraList: function getExtraList(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/extrainfo/list"), data);
  },
  getPolicyinfoList: function getPolicyinfoList(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/policyInfo/list"), data);
  },
  savePolicyinfo: function savePolicyinfo(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/policyinfo/save"), data);
  },
  getThrowinfoDetail: function getThrowinfoDetail(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/throwinfo/details/" + id));
  },
  getPolicyThrowinfoList: function getPolicyThrowinfoList(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/policyinfo/PolicyInfoList"), data);
  },
  deletePolicyInfo: function deletePolicyInfo(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/policyinfo/delete/" + id));
  },
  getPolicyinfoDetail: function getPolicyinfoDetail(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/policyinfo/details"), data);
  },
  getThemeFacilityList: function getThemeFacilityList(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/product/SearchFacilities?filterCode=" + data));
  },
  getHotelDisposePolicyList: function getHotelDisposePolicyList(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/disposepolicy/list"), data);
  },
  saveHotelDisposePolicy: function saveHotelDisposePolicy(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/disposepolicy/save"), data);
  },
  getHotelDisposePolicyDetail: function getHotelDisposePolicyDetail(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/disposepolicy/details?id=" + id));
  },
  deleteHotelDisposePolicy: function deleteHotelDisposePolicy(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/disposepolicy/delete?id=" + id));
  },
  exchangeInterface: function exchangeInterface(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/product/ChangSupply?SupplyCode=" + data), { failTips: false });
  },
  getCityBusiness: function getCityBusiness(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/product/CityBusiness"), data);
  },
  getRiskInfoList: function getRiskInfoList(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/riskinfo/list'), data);
  },
  saveRiskInfo: function saveRiskInfo(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/riskinfo/save'), data);
  },
  getRiskInfoDetail: function getRiskInfoDetail(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/riskinfo/details?id=' + id));
  },
  getRiskInfos: function getRiskInfos(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/riskinfo/SearchRiskInfo'), data, { failTips: false });
  },
  deleteRiskInfo: function deleteRiskInfo(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/riskinfo/delete?id=' + id));
  },
  getKeyword: function getKeyword(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/product/ComplateKeyword"), data, { failTips: false });
  },
  getHotelPaytype: function getHotelPaytype(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/policyinfo/SearchHotelPay?companyid=' + id));
  },
  savehotelpaytype: function savehotelpaytype(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/policyinfo/SaveHotelPayType'), data);
  }
});

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'huilianyi',
    getUrl: function getUrl(url) {
        return __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].getUrl(this.name, url);
    },
    searchapprovals: function searchapprovals() {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/huilianyi/searchApproval?status='), {}, { failTips: false });
    },
    booking: function booking(id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/huilianyi/booking?id=' + id));
    },
    OrderNotify: function OrderNotify(UniqueID, orderservice) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/service/OrderNotify?id=' + UniqueID + '&orderservice=' + orderservice), { failTips: false });
    },
    PushTradeList: function PushTradeList(OrderID, serviceType) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/service/PushTradeList?OrderID=' + OrderID + '&serviceType=' + serviceType), { failTips: false });
    }
});

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(1);



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'insurance',
    getUrl: function getUrl(url) {
        return __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].getUrl(this.name, url);
    },
    OrderDetails: function OrderDetails(UniqueID) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/InsuranceOrder/OrderDetails?UniqueID=' + UniqueID));
    },
    getOrderList: function getOrderList(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/InsuranceOrder/List'), data);
    },
    OrderResolve: function OrderResolve(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/InsuranceOrder/OrderResolve'), data);
    },
    OrderUnLock: function OrderUnLock(id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/InsuranceOrder/OrderUnLock?UniqueID=' + id));
    },
    OrderLock: function OrderLock(id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/InsuranceOrder/OrderLock?UniqueID=' + id));
    },
    UpdateOrderPrice: function UpdateOrderPrice(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/InsuranceOrder/UpdateOrderPrice'), data);
    }
});

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(1);



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'insurancepolicy',
    getUrl: function getUrl(url) {
        return __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].getUrl(this.name, url);
    },
    getInsuranceProductList: function getInsuranceProductList(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/InsuranceProduct/List'), data);
    },
    getInsuranceProductDetails: function getInsuranceProductDetails(ProductID) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/InsuranceProduct/Details/' + ProductID));
    },
    getInsuranceProductDelete: function getInsuranceProductDelete(ProductID) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/InsuranceProduct/Delete/' + ProductID));
    },
    saveInsuranceProduct: function saveInsuranceProduct(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/InsuranceProduct/SaveInsuranceProduct'), data);
    },
    getInsuranceThrowList: function getInsuranceThrowList(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/PolicyThrow/List'), data);
    },
    getInsuranceThrowDetails: function getInsuranceThrowDetails(ThrowID) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/PolicyThrow/Details/' + ThrowID));
    },
    getInsuranceThrowDelete: function getInsuranceThrowDelete(ThrowID) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/PolicyThrow/Delete/' + ThrowID));
    },
    saveInsuranceThrow: function saveInsuranceThrow(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/PolicyThrow/SaveInsuranceThrow'), data);
    },
    getInsuranceMatching: function getInsuranceMatching(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/PolicyThrow/InsuranceMatching'), data);
    },
    getProductInfo: function getProductInfo(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/PolicyInfo/productInfo'), data, { failTips: false });
    },
    getPolicyInfo: function getPolicyInfo(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/PolicyInfo/GetPolicyInfo'), data);
    },
    getPolicyInfoList: function getPolicyInfoList(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/PolicyInfo/List'), data);
    },
    getPolicyInfoDetail: function getPolicyInfoDetail(id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/PolicyInfo/Details?id=' + id));
    },
    getPolicyInfoDelete: function getPolicyInfoDelete(id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/PolicyInfo/Delete?id=' + id));
    },
    savePolicyInfo: function savePolicyInfo(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/PolicyInfo/Save'), data);
    },
    getProductInfoList: function getProductInfoList(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/ProductInfo/List'), data);
    },
    getProductInfoDetail: function getProductInfoDetail(id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/ProductInfo/Details?id=' + id));
    },
    getProductInfoDelete: function getProductInfoDelete(id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/ProductInfo/Delete?id=' + id));
    },
    saveProductInfo: function saveProductInfo(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/ProductInfo/Save'), data);
    },
    getThrowInfoList: function getThrowInfoList(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/ThrowInfo/List'), data);
    },
    getThrowInfoDetails: function getThrowInfoDetails(id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/ThrowInfo/Details?id=' + id));
    },
    getThrowInfoDelete: function getThrowInfoDelete(id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/ThrowInfo/Delete?id=' + id));
    },
    saveThrowInfo: function saveThrowInfo(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/ThrowInfo/Save'), data);
    },
    getRobotList: function getRobotList(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/robotinfo/list'), data);
    },
    saveRobotInfo: function saveRobotInfo(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/robotinfo/save'), data);
    },
    getRobotInfo: function getRobotInfo(id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/robotinfo/details?id=' + id));
    },
    deleteRobotInfo: function deleteRobotInfo(id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/robotinfo/delete?id=' + id));
    }
});

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(1);



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'invoice',
    getUrl: function getUrl(url) {
        return __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].getUrl(this.name, url);
    },
    getInvoiceList: function getInvoiceList(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/InvoiceOrder/List'), data);
    },
    getInvoiceOrder: function getInvoiceOrder(TaskID) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/InvoiceOrder/Details?TaskID=' + TaskID));
    },
    saveInvoiceOrder: function saveInvoiceOrder(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/InvoiceOrder/Update'), data);
    },
    deleteInvoiceOrder: function deleteInvoiceOrder(TaskID) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/InvoiceOrder/Delete?TaskID=' + TaskID));
    },
    getInvoiceItemList: function getInvoiceItemList(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/InvoiceItem/List'), data);
    },
    getInvoiceSplit: function getInvoiceSplit(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/InvoiceOrder/InvoiceSplit'), data);
    },
    getInvoiceState: function getInvoiceState(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/InvoiceOrder/InvoiceState'), data);
    },
    OrderLock: function OrderLock(id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/InvoiceOrder/OrderLock?UniqueID=' + id));
    },
    getInvoiceCostGroupBy: function getInvoiceCostGroupBy(InvoiceID) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/InvoiceOrder/InvoiceCostGroupBy?InvoiceID=' + InvoiceID));
    },
    createSupplyOrder: function createSupplyOrder(taskId) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/InvoiceOrder/CreateSupplyOrder?taskId=' + taskId));
    },
    confirmOrder: function confirmOrder(taskId) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/InvoiceOrder/ConfirmOrder?taskId=' + taskId));
    },
    flushOrder: function flushOrder(taskId) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/InvoiceOrder/FlushOrder?taskId=' + taskId));
    },
    getDownloadUrl: function getDownloadUrl(taskId) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/InvoiceOrder/GetDownloadUrl?taskId=' + taskId));
    }
});

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(1);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "logs",
  getUrl: function getUrl(url) {
    return __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].getUrl(this.name, url);
  },
  getLogInfo: function getLogInfo(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/LogInfo/List"), data);
  },
  getLogs: function getLogs(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/LogInfo/Logs"), data);
  },
  add: function add(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/LogInfo/Added"), data);
  },
  count: function count(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/LogInfo/count"), data);
  }
});

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(1);



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'mall',
    getUrl: function getUrl(url) {
        return __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].getUrl(this.name, url);
    },
    getOrderList: function getOrderList(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/mallorder/List'), data);
    },
    OrderUnLock: function OrderUnLock(id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/mallorder/OrderUnLock?UniqueID=' + id));
    },
    OrderLock: function OrderLock(id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/mallorder/OrderLock?UniqueID=' + id));
    },
    ConfirmOrderPrice: function ConfirmOrderPrice(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/mallorder/ConfirmOrderPrice'), data);
    },
    UpdateOrderStatus: function UpdateOrderStatus(id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/mallorder/UpdateOrderStatus?UniqueID=' + id));
    },
    OrderResolve: function OrderResolve(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/mallorder/OrderResolve'), data);
    }
});

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(1);



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'message',
    getUrl: function getUrl(url) {
        return __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].getUrl(this.name, url);
    },
    getmessage: function getmessage(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/message/getmessages'), data);
    },
    savemessage: function savemessage(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/message/added'), data);
    },
    readmsg: function readmsg(id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/message/ReadMsg/' + id));
    }
});

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(1);



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'order',
    getUrl: function getUrl(url) {
        return __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].getUrl(this.name, url);
    },
    OrderList: function OrderList(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/Order/List'), data);
    }
});

/***/ }),
/* 278 */
/***/ (function(module, exports) {



/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(1);



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'side',
    getUrl: function getUrl(url) {
        return __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].getUrl(this.name, url);
    },
    getFileContent: function getFileContent(url) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(url, { failTips: false });
    },
    location: function location(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/Common/Location'), data);
    },
    getValidImageUrl: function getValidImageUrl() {
        return this.getUrl("/Common/ValidCode") + '?' + Math.random();
    }
});

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(1);



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'statistics',
    getUrl: function getUrl(url) {
        return __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].getUrl(this.name, url);
    },
    getStatisticsList: function getStatisticsList(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/TradeStatistics/List'), data);
    },
    getTradesDetail: function getTradesDetail(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/TradeDetail/List'), data);
    },
    TradeStatisticsList: function TradeStatisticsList(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/TradeStatistics/TradeStatisticsList'), data);
    },
    getTotalCompanyByUser: function getTotalCompanyByUser(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/TradeStatistics/GetTotalCompanyByUser'), data);
    },
    searchtrades: function searchtrades(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/TradeDetail/SearchTradeList"), data);
    },
    savetrades: function savetrades(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/UserStatistics/Save"), data);
    }
});

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(1);



var ConferInfo = {
  RoleID: "",

  RoleWith: 1311,

  OwnerID: "",

  OwnerWith: 1311,

  SpaceID: "",

  ConferDate: new Date(),

  ExpiryDate: "2018-12-04 09:00:00" };

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "system",

  getUrl: function getUrl(url) {
    return __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].getUrl(this.name, url);
  },
  login: function login(loginInfo) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/Security/Login"), loginInfo);
  },
  logout: function logout() {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/Security/Logout"), "");
  },
  getTicketInfo: function getTicketInfo(options) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/Security/GetTicketInfo"), "", options);
  },
  register: function register(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/Security/Register"), data);
  },
  saveSupplier: function saveSupplier(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/Security/saveSupplier"), data);
  },
  getSiteInfo: function getSiteInfo() {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/Security/GetSiteInfo"));
  },
  sendValidCode: function sendValidCode(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/Security/SendValidCode"), data);
  },
  checkAccount: function checkAccount(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/Security/CheckAccount"), data);
  },
  sendCode: function sendCode(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/Security/SendCode"), data);
  },
  checkCode: function checkCode(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/Security/checkCode"), data);
  },
  resetPwd: function resetPwd(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/Security/ResetPwd"), data);
  },
  getUserActions: function getUserActions(options) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/Security/getUserActions"), options);
  },
  getMobileUser: function getMobileUser(mobile) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/Security/GetMobileUser?mobile=" + mobile));
  },
  authSendCode: function authSendCode(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/auth/SendCode"), data);
  },
  authBind: function authBind(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/auth/Bind"), data);
  },
  getAccountList: function getAccountList(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/UserAccount/List"), data);
  },
  initializePassword: function initializePassword(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/UserAccount/InitializePassword"), data);
  },
  getAccountInfo: function getAccountInfo(UserAct) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/UserAccount/Details?UserAct=" + UserAct));
  },
  getNameList: function getNameList(data, tip) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/RoleInfo/NameList"), data, tip);
  },
  getRoleList: function getRoleList(data, tip) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/RoleInfo/List"), data, tip);
  },
  getRoleInfo: function getRoleInfo(data, options) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/RoleInfo/Details"), data, options);
  },
  saveRoleInfo: function saveRoleInfo(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/RoleInfo/Update"), data);
  },
  getConsumers: function getConsumers(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/RoleInfo/getConsumers"), data);
  },
  deleteRoleInfo: function deleteRoleInfo(id, spaceID, ownerType) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/RoleInfo/Delete/" + id + "?spaceID=" + spaceID + "&ownerType=" + ownerType));
  },
  getRoleOwners: function getRoleOwners(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/RoleInfo/GetRoleOwners"), data);
  },
  getConferList: function getConferList(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/ConferInfo/List"), data);
  },
  getConferInfo: function getConferInfo(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/ConferInfo/Details"), data);
  },
  saveConferInfo: function saveConferInfo(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/ConferInfo/Save"), data);
  },
  deleteConferInfo: function deleteConferInfo(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/ConferInfo/Delete"), data);
  },
  UpdateSuperUser: function UpdateSuperUser(UserID) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/ConferInfo/UpdateSuperUser?UserID=" + UserID));
  },
  getConferService: function getConferService(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/ConferInfo/GetConferService"), data);
  },
  getServiceList: function getServiceList(companyID) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/ConferInfo/GetServiceList?companyID=" + companyID));
  },
  disptachService: function disptachService(companyID, serviceID) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/ConferInfo/DisptachService?customerID=" + companyID + "&serviceID=" + serviceID));
  },
  revokeService: function revokeService(companyID, serviceID) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/ConferInfo/RevokeService?customerID=" + companyID + "&serviceID=" + serviceID));
  },
  getFlowList: function getFlowList(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/FlowInfo/List"), data);
  },
  getFlowInfo: function getFlowInfo(FlowID) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/FlowInfo/Details/" + FlowID), { failTips: false });
  },
  saveFlowInfo: function saveFlowInfo(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/FlowInfo/Update"), data);
  },
  deleteFlowInfo: function deleteFlowInfo(FlowID) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/FlowInfo/Delete/" + FlowID));
  },
  getContactList: function getContactList(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/ContactInfo/List"), data);
  },
  getContactInfo: function getContactInfo(ContactID) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/ContactInfo/Details/" + ContactID));
  },
  saveContactInfo: function saveContactInfo(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/ContactInfo/Update"), data);
  },
  deleteContactInfo: function deleteContactInfo(ContactID) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/ContactInfo/Delete/" + ContactID));
  },
  getInvoiceList: function getInvoiceList(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/InvoiceInfo/List"), data);
  },
  getInvoiceInfo: function getInvoiceInfo(InvoiceID) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/InvoiceInfo/Details/" + InvoiceID));
  },
  saveInvoiceInfo: function saveInvoiceInfo(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/InvoiceInfo/Update"), data);
  },
  deleteInvoiceInfo: function deleteInvoiceInfo(InvoiceID) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/InvoiceInfo/Delete/" + InvoiceID));
  },
  getConfigInfoList: function getConfigInfoList(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/ConfigInfo/list"), data);
  },
  getConfigInfoUpdate: function getConfigInfoUpdate(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/ConfigInfo/Update"), data);
  },
  getMessageList: function getMessageList(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/MessageTemplate/list"), data);
  },
  getMessageStatus: function getMessageStatus(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/MessageTemplate/MessageStatus/" + id));
  },
  getMessageDetail: function getMessageDetail(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/MessageTemplate/Details/" + id));
  },
  getMessageSave: function getMessageSave(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/MessageTemplate/MessageSave"), data);
  },
  saveConfigInfo: function saveConfigInfo(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("configinfo/ConfigInfoSave"), data);
  },
  getConfigInfoLists: function getConfigInfoLists(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("configinfo/ConfigInfoList"), data);
  },
  getCompanyConfigs: function getCompanyConfigs(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("configinfo/CompanyConfigs"), data);
  },
  getClearRoleInfo: function getClearRoleInfo(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/RoleInfo/ClearRoleInfo?SpaceID=" + data.SpaceID + "&RoleName=" + data.RoleName));
  },
  getOwners: function getOwners(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/RoleInfo/Owners"), data);
  },
  subscribe: function subscribe(supplyid, serviceid) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/RoleInfo/subscribe?SupplyID=" + supplyid + "&ServiceID=" + serviceid));
  },
  getUserinfoDetails: function getUserinfoDetails() {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/userinfo/details"));
  },
  saveUserinfo: function saveUserinfo(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/userinfo/save"), data);
  },
  getInviteInfo: function getInviteInfo(inviteCode) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/security/InviteInfo?inviteCode=" + inviteCode));
  },
  getInviteMatch: function getInviteMatch(targetId, deptId, activeCode) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/InviteInfo/match?targetId=" + targetId + "&deptId=" + deptId + "&activeCode=" + activeCode), {});
  },
  saveInviteInfo: function saveInviteInfo(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/InviteInfo/save"), data);
  },
  inviteNotify: function inviteNotify(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/InviteInfo/notify"), data);
  },
  activate: function activate(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/security/activate"), data);
  },
  SMSCode: function SMSCode(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/security/SMSCode"), data);
  },
  approval: function approval(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/roleInfo/approval"), data);
  },
  getCompanyExtra: function getCompanyExtra(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/extrainfo/SearchExtraInfo"), data, {
      failTips: false
    });
  },
  saveCompanyExtra: function saveCompanyExtra(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/extrainfo/Save"), data);
  }
});

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(1);



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'tour',
    getUrl: function getUrl(url) {
        return __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].getUrl(this.name, url);
    },
    CreateOrder: function CreateOrder(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/TourOrder/CreateOrder'), data);
    },
    OrderDetails: function OrderDetails(UniqueID) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/TourOrder/OrderDetails?UniqueID=' + UniqueID));
    },
    OrderSubmit: function OrderSubmit(UniqueID) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/TourOrder/OrderSubmit/' + UniqueID));
    },
    OrderCannot: function OrderCannot(id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/TourOrder/OrderCannot?UniqueID=' + id));
    },
    OrderDrawer: function OrderDrawer(id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/TourOrder/OrderDrawer?UniqueID=' + id));
    },
    OrderReject: function OrderReject(id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/TourOrder/OrderReject?UniqueID=' + id));
    },
    OrderResolve: function OrderResolve(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/TourOrder/OrderResolve'), data);
    },
    UpdateGoods: function UpdateGoods(goods) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/TourOrder/UpdateGoods'), goods);
    },
    CreateAmend: function CreateAmend(amend) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/TourOrder/CreateAmend'), amend);
    },
    RefundJudge: function RefundJudge(UniqueID) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/TourOrder/RefundJudge?UniqueID=' + UniqueID));
    },
    MessageSend: function MessageSend(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/TourOrder/MessageSend'), data);
    },
    UpdateOrder: function UpdateOrder(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/TourOrder/UpdateOrder'), data);
    },
    CheckChang: function CheckChang(id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/TrainOrder/CheckChang/' + id));
    },
    OrderCancel: function OrderCancel(id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/TourOrder/OrderCancel?UniqueID=' + id), {
            failTips: false
        });
    },
    OrderUnLock: function OrderUnLock(id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/TourOrder/OrderUnLock?UniqueID=' + id));
    },
    OrderLock: function OrderLock(id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/TourOrder/OrderLock?UniqueID=' + id));
    },
    OrderRefund: function OrderRefund(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/TourOrder/OrderRefund'), data);
    },
    ConfirmOrderPrice: function ConfirmOrderPrice(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/TourOrder/ConfirmOrderPrice'), data);
    },
    UpdateOrderStatus: function UpdateOrderStatus(id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/TourOrder/UpdateOrderStatus?UniqueID=' + id));
    },
    UpdateTourOrderStatus: function UpdateTourOrderStatus(id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/TourOrder/UpdateTourOrderStatus?UniqueID=' + id));
    },
    AmendStatusBack: function AmendStatusBack(id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/TourOrder/AmendStatusBack?UniqueID=' + id));
    },
    CreateTrade: function CreateTrade(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/TourOrder/CreateTrade'), data);
    },
    TradeStatusStatistics: function TradeStatusStatistics(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/TourOrder/TradeStatusStatistics'), data);
    },
    getOrderList: function getOrderList(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/TourOrder/List'), data);
    },
    Canceled: function Canceled(id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/TourOrder/Cancel/' + id));
    },
    createdemandorder: function createdemandorder(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/tourorder/createdemandorder'), data);
    },
    CreateOrderByPreference: function CreateOrderByPreference(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/demand/CreateOrderByPreference'), data);
    },
    SearchOrders: function SearchOrders(id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/TourOrder/SearchOrders?UniqueID=' + id));
    },
    SearchExtras: function SearchExtras(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/TourOrder/SearchExtras'), data);
    },
    CreateExtras: function CreateExtras(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/TourOrder/CreateExtras'), data);
    },
    TeamStatistics: function TeamStatistics(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/TourOrder/TeamStatistics'), data);
    }
});

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__http__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(1);


var _name$getUrl$CreatePo;




/* harmony default export */ __webpack_exports__["a"] = (_name$getUrl$CreatePo = {
    name: 'tourpolicy',
    getUrl: function getUrl(url) {
        return __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].getUrl(this.name, url);
    },
    CreatePolicy: function CreatePolicy(data) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(this.getUrl('/policyinfo/CreatePolicy'), data);
    },
    getProductinfoSave: function getProductinfoSave(data) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(this.getUrl('/productinfo/save'), data);
    },
    getProductinfoDetails: function getProductinfoDetails(id) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].get(this.getUrl('/productinfo/Details?id=' + id));
    },
    getThrowinfoList: function getThrowinfoList(data) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(this.getUrl('/throwinfo/List'), data);
    },
    getThrowinfoSave: function getThrowinfoSave(data) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(this.getUrl('/throwinfo/save'), data);
    },
    getThrowinfoDetails: function getThrowinfoDetails(id) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(this.getUrl('/throwinfo/details?id=' + id));
    },
    getProductinfoList: function getProductinfoList(data) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(this.getUrl('/productinfo/list'), data);
    }
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$getUrl$CreatePo, 'getProductinfoSave', function getProductinfoSave(data) {
    return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(this.getUrl('/productinfo/save'), data);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$getUrl$CreatePo, 'getSpecInfoList', function getSpecInfoList(data) {
    return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(this.getUrl('/specInfo/list'), data);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$getUrl$CreatePo, 'getSpecInfoSave', function getSpecInfoSave(data) {
    return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(this.getUrl('/specInfo/save'), data);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$getUrl$CreatePo, 'getSpecInfoDetails', function getSpecInfoDetails(id) {
    return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(this.getUrl('/specInfo/details?id=' + id));
}), _name$getUrl$CreatePo);

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(1);



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'bill',
    getUrl: function getUrl(url) {
        return __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].getUrl(this.name, url);
    },
    cashier: function cashier(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/trade/cashier'), data);
    },
    redirect: function redirect(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/trade/redirect'), data);
    }
});

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__http__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(1);


var _name$getUrl$getOrder;



/* harmony default export */ __webpack_exports__["a"] = (_name$getUrl$getOrder = {
    name: 'traffic',
    getUrl: function getUrl(url) {
        return __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].getUrl(this.name, url);
    },
    getOrderList: function getOrderList(data) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(this.getUrl('/trafficorder/list'), data);
    },
    OrderUnLock: function OrderUnLock(id) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].get(this.getUrl('/trafficorder/OrderUnLock?UniqueID=' + id));
    },
    OrderLock: function OrderLock(id) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].get(this.getUrl('/trafficorder/OrderLock?UniqueID=' + id));
    },
    OrderDetails: function OrderDetails(UniqueID) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].get(this.getUrl('/trafficorder/OrderDetails?UniqueID=' + UniqueID));
    },
    OrderSubmit: function OrderSubmit(UniqueID) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].get(this.getUrl('/trafficorder/OrderSubmit/' + UniqueID));
    },
    OrderCannot: function OrderCannot(id) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].get(this.getUrl('/trafficorder/OrderCannot?UniqueID=' + id));
    },
    OrderDrawer: function OrderDrawer(id) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].get(this.getUrl('/trafficorder/OrderDrawer?UniqueID=' + id));
    },
    OrderReject: function OrderReject(id) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].get(this.getUrl('/trafficorder/OrderReject?UniqueID=' + id));
    },
    OrderResolve: function OrderResolve(data) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(this.getUrl('/trafficorder/OrderResolve'), data);
    },
    OrderCancel: function OrderCancel(id) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].get(this.getUrl('/trafficorder/OrderCancel?UniqueID=' + id), {
            failTips: false
        });
    },
    ClientOrderResolve: function ClientOrderResolve(data) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(this.getUrl('/trafficorder/ClientOrderResolve'), data);
    },
    ConfirmOrderPrice: function ConfirmOrderPrice(data) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(this.getUrl('/trafficorder/ConfirmOrderPrice'), data);
    },
    UpdateOrderStatus: function UpdateOrderStatus(id) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].get(this.getUrl('/trafficorder/UpdateOrderStatus?UniqueID=' + id));
    },
    UpdateOrderPrice: function UpdateOrderPrice(data) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(this.getUrl('/trafficorder/UpdateOrderPrice'), data);
    },
    AmendStatusBack: function AmendStatusBack(id) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].get(this.getUrl('/trafficorder/AmendStatusBack?UniqueID=' + id));
    },
    CreateTrade: function CreateTrade(data) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(this.getUrl('/trafficorder/CreateTrade'), data);
    },
    ConfirmClientAmendPrice: function ConfirmClientAmendPrice(data) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(this.getUrl('/trafficorder/ConfirmClientAmendPrice'), data);
    },
    ConfirmSupplyAmendPrice: function ConfirmSupplyAmendPrice(data) {
        return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(this.getUrl('/trafficorder/ConfirmSupplyAmendPrice'), data);
    }
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$getUrl$getOrder, 'getOrderList', function getOrderList(data) {
    return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(this.getUrl('/trafficorder/List'), data);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$getUrl$getOrder, 'CreateRefundRequest', function CreateRefundRequest(data) {
    return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(this.getUrl('/trafficorder/CreateRefundRequest'), data);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$getUrl$getOrder, 'RefundJudge', function RefundJudge(UniqueID) {
    return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].get(this.getUrl('/trafficorder/RefundJudge?UniqueID=' + UniqueID));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$getUrl$getOrder, 'UpdateOrder', function UpdateOrder(data) {
    return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(this.getUrl('/trafficorder/UpdateOrder'), data);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$getUrl$getOrder, 'SearchOrders', function SearchOrders(id) {
    return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].get(this.getUrl('/trafficorder/SearchOrders?UniqueID=' + id));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$getUrl$getOrder, 'CreateOrder', function CreateOrder(data) {
    return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(this.getUrl('/trafficorder/CreateOrder'), data);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$getUrl$getOrder, 'traffictest', function traffictest(data) {
    return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(this.getUrl('/Callback/Notify/Yuexing'), data);
}), _name$getUrl$getOrder);

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'trafficpolicy',
    getUrl: function getUrl(url) {
        return __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].getUrl(this.name, url);
    },
    getAddress: function getAddress(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/product/QueryAddress'), data);
    },
    CreatePolicy: function CreatePolicy(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/trafficPolicy/CreatePolicy'), data);
    }
});

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(1);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "train",
  getUrl: function getUrl(url) {
    return __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].getUrl(this.name, url);
  },
  CheckRepeatOrder: function CheckRepeatOrder(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/TrainOrder/CheckRepeatOrder"), data, {
      failTips: false
    });
  },
  CreateOrder: function CreateOrder(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/TrainOrder/CreateOrder"), data);
  },
  OrderDetails: function OrderDetails(UniqueID) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/TrainOrder/OrderDetails?UniqueID=" + UniqueID));
  },
  OrderSubmit: function OrderSubmit(UniqueID) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/TrainOrder/OrderSubmit/" + UniqueID));
  },
  OrderCannot: function OrderCannot(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/TrainOrder/OrderCannot?UniqueID=" + id));
  },
  OrderDrawer: function OrderDrawer(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/TrainOrder/OrderDrawer?UniqueID=" + id));
  },
  OrderReject: function OrderReject(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/TrainOrder/OrderReject?UniqueID=" + id));
  },
  OrderResolve: function OrderResolve(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/TrainOrder/OrderResolve"), data);
  },
  ClientOrderResolve: function ClientOrderResolve(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/TrainOrder/ClientOrderResolve"), data);
  },
  UpdateGoods: function UpdateGoods(goods) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/TrainOrder/UpdateGoods"), goods);
  },
  CreateAmend: function CreateAmend(amend) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/TrainOrder/CreateAmend"), amend);
  },
  RefundJudge: function RefundJudge(UniqueID) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/TrainOrder/RefundJudge?UniqueID=" + UniqueID));
  },
  MessageSend: function MessageSend(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/TrainOrder/MessageSend"), data);
  },
  UpdateOrder: function UpdateOrder(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/TrainOrder/UpdateOrder"), data);
  },
  CalcPrice: function CalcPrice(price, date) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/TrainFixInAdvance/CalcPrice?price=" + price + "&date=" + date));
  },
  TrainOrderChange: function TrainOrderChange(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/TrainOrder/TrainOrderChange"), data);
  },
  OrderCancel: function OrderCancel(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/TrainOrder/OrderCancel?UniqueID=" + id), {
      failTips: false
    });
  },
  OrderUnLock: function OrderUnLock(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/TrainOrder/OrderUnLock?UniqueID=" + id));
  },
  OrderLock: function OrderLock(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/TrainOrder/OrderLock?UniqueID=" + id));
  },
  OrderRefund: function OrderRefund(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/TrainOrder/OrderRefund"), data);
  },
  OrderRefundCancel: function OrderRefundCancel(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/TrainOrder/OrderRefundCancel?UniqueID=" + id));
  },
  ConfirmOrderPrice: function ConfirmOrderPrice(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/TrainOrder/ConfirmOrderPrice"), data);
  },
  UpdateOrderStatus: function UpdateOrderStatus(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/TrainOrder/UpdateOrderStatus?UniqueID=" + id));
  },
  UpdateOrderPrice: function UpdateOrderPrice(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/TrainOrder/UpdateOrderPrice"), data);
  },
  AmendStatusBack: function AmendStatusBack(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/TrainOrder/AmendStatusBack?UniqueID=" + id));
  },
  CreateTrade: function CreateTrade(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/TrainOrder/CreateTrade"), data);
  },
  ConfirmClientAmendPrice: function ConfirmClientAmendPrice(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/TrainOrder/ConfirmClientAmendPrice"), data);
  },
  ConfirmSupplyAmendPrice: function ConfirmSupplyAmendPrice(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/TrainOrder/ConfirmSupplyAmendPrice"), data);
  },
  getTrainLodinInfos: function getTrainLodinInfos(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/TrainFixInAdvance/checkOfficialAccount"), data);
  },
  getTrainInfos: function getTrainInfos(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/TrainFixInAdvance/checkPassCard"), data);
  },
  getOrderList: function getOrderList(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/TrainOrder/List"), data);
  },
  getRefundTicket: function getRefundTicket(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/TrainFixInAdvance/RefundTickets/" + id));
  },
  getTrainAmend: function getTrainAmend(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/TrainFixInAdvance/TrainAmend"), data);
  },
  getDetails: function getDetails(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/TrainOrder/Details/" + id));
  },
  ConsumerVerification: function ConsumerVerification(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/TrainOrder/ConsumerVerification"), data, { failTips: false });
  },
  AmendList: function AmendList(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/TrainAmend/List"), data);
  },
  AmendDetails: function AmendDetails(UniqueID) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/TrainOrder/AmendDetails/?UniqueID=" + UniqueID));
  },
  OrderPayment: function OrderPayment(UniqueID) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/TrainOrder/OrderPayment/" + UniqueID));
  },
  SearchOrders: function SearchOrders(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/TrainOrder/SearchOrders?UniqueID=" + id));
  },
  GetSimpleOrder: function GetSimpleOrder(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/TrainOrder/GetSimpleOrder?UniqueID=" + id));
  },
  trainaccountlogin: function trainaccountlogin(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/TrainAccount/AccountLogin'), data);
  },
  validaccount: function validaccount(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/TrainAccount/ValidAccount'), data, { failTips: false });
  },
  resetvalid: function resetvalid(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/trainaccount/ResetValid'), data);
  },
  resetpassword: function resetpassword(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/trainaccount/ResetPassword'), data);
  },
  trainbooking: function trainbooking(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/trainorder/TrainBooking?UniqueId=' + id));
  },
  deleteaccount: function deleteaccount(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/trainaccount/delete?id=' + id));
  },
  accountlist: function accountlist() {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/trainaccount/list'));
  },
  checkamend: function checkamend(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/trainorder/CheckAmend?UniqueId=' + id), { failTips: false });
  },
  validaccountById: function validaccountById(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/trainorder/ValidAccountById'), data);
  },
  CreateAmendTradeDeal: function CreateAmendTradeDeal(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/trainorder/CreateAmendTradeDeal?UniqueID=' + id));
  },
  SearchExtras: function SearchExtras(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/TrainOrder/SearchExtras'), data);
  },
  CreateExtras: function CreateExtras(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/TrainOrder/CreateExtras'), data);
  },
  SendEmail: function SendEmail(orderId, unionId, email) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/TrainOrder/SendEmail?orderId=' + orderId + '&UnionId=' + unionId + '&email=' + email));
  },
  UpdateOrderSupplyStatus: function UpdateOrderSupplyStatus(UniqueID) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/trainorder/UpdateOrderSupplyStatus?UniqueID=" + UniqueID));
  },
  CheckPaymentAvailable: function CheckPaymentAvailable(contactPhone, contactName) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl("/TrainOrder/CheckPaymentAvailable?contactPhone=" + contactPhone + "&contactName=" + contactName), { failTips: false });
  }
});

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(1);



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'trainpolicy',
    getUrl: function getUrl(url) {
        return __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].getUrl(this.name, url);
    },
    getTrainNumber: function getTrainNumber(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/TrainSearch/Search'), data);
    },
    getStationList: function getStationList(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/TrainSearch/Station'), data);
    },
    CreatePolicy: function CreatePolicy(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/TrainPolicy/CreatePolicy'), data);
    },
    ProductInfo: function ProductInfo(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/TrainPolicy/ProductInfo'), data);
    },
    ServiceFee: function ServiceFee(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/TrainPolicy/ServiceFee'), data);
    },
    validaccount: function validaccount(act, pwd) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/TrainSearch/ValidAccount?account=' + act + '&password=' + pwd));
    }
});

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(1);



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'wechat',
    getUrl: function getUrl(url) {
        return __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].getUrl(this.name, url);
    },
    getAdapterList: function getAdapterList(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/proxy/GetAdapterList'), data);
    },
    getMenuList: function getMenuList(id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/proxy/GetMenuList?appid=' + id));
    },
    getUpdateMenu: function getUpdateMenu(id, data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/proxy/UpdateMenu?appid=' + id), data);
    },
    getDeleteMenu: function getDeleteMenu(id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/proxy/DeleteMenu?appid=' + id));
    },
    synccompany: function synccompany() {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/workwechat/SyncCompany'));
    }
});

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(1);



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'work',
    getUrl: function getUrl(url) {
        return __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].getUrl(this.name, url);
    },
    List: function List(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/WorkTask/List'), data);
    },
    getWorkTasks: function getWorkTasks(data, options) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/WorkTask/GetWorkTasks'), data, options);
    },
    TaskResolve: function TaskResolve(id, options) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/WorkTask/Resolve/' + id), options);
    },
    TaskReject: function TaskReject(id, options) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/WorkTask/Reject/' + id), options);
    }
});

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__apis__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_costCenterI18n__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_main_css__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_main_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_main_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_layout_css__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_layout_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_layout_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_store__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_modules_icon__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_modules_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__views_modules_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_modules_layout__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_modules_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__views_modules_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_modules_back_main__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_modules_back_main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__views_modules_back_main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_modules_front_main__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_modules_front_main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__views_modules_front_main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_modules_wrapper__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_modules_wrapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__views_modules_wrapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_modules_page_nav__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_modules_page_nav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__views_modules_page_nav__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_modules_keep_status_vue__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_modules_keep_status_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__views_modules_keep_status_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__lang_CN__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__lang_EN__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__lang_JP__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__filter_js__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__views_modules_customer_services_vue__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__views_modules_customer_services_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__views_modules_customer_services_vue__);




























window.$ = window.jquery = __WEBPACK_IMPORTED_MODULE_3_jquery___default.a;
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.prototype.$api = __WEBPACK_IMPORTED_MODULE_2__apis__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.config.productionTip = true;
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.config.devtools = true;
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.prototype.getImgs = function (path, type) {
    var reg = /^www./g;
    var hostname = window.location.hostname;
    if (!reg.test(hostname)) {
        hostname = 'www.lchtrip.com';
    }
    if (!type || type == 'img') {
        return '/static/' + hostname.replace(/\./g, '') + '/imgs/' + path;
    } else {
        return 'url(/static/' + hostname.replace(/\./g, '') + '/imgs/' + path + ')';
    }
};

__WEBPACK_IMPORTED_MODULE_1_vue___default.a.component("icon", __WEBPACK_IMPORTED_MODULE_11__views_modules_icon___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.component("l-layout", __WEBPACK_IMPORTED_MODULE_12__views_modules_layout___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.component("b-main", __WEBPACK_IMPORTED_MODULE_13__views_modules_back_main___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.component("f-main", __WEBPACK_IMPORTED_MODULE_14__views_modules_front_main___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.component("wrapper", __WEBPACK_IMPORTED_MODULE_15__views_modules_wrapper___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.component("pagenav", __WEBPACK_IMPORTED_MODULE_16__views_modules_page_nav___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.component("keep-status", __WEBPACK_IMPORTED_MODULE_17__views_modules_keep_status_vue___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.component("customer-services", __WEBPACK_IMPORTED_MODULE_22__views_modules_customer_services_vue___default.a);

var home = __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].options.routes[0];
var historys = [{
    path: home.path,
    name: home.name
}];

function checkState(isTips, store, to, callback) {
    var requiresAuth = _.find(to.matched, function (o) {
        return o.meta.requiresAuth;
    });
    var isRedirect = requiresAuth !== undefined;
    if (document.cookie.indexOf("SfsSes") == -1 && !sessionStorage.getItem("SfsSes")) {
        callback(isRedirect);
        return;
    } else if (store.getters.ticketInfo.UserID !== undefined) {
        callback(false);
        return;
    }
    if (!isRedirect) {
        callback(false);
    }
    return store.dispatch('loadTicketInfo', {
        failTips: false
    }).then(function (response) {
        if (response.data.isSucc === true) {
            if (isRedirect) callback(false);
            return response;
        }
        return store.dispatch("logout").then(function () {
            if (isRedirect) callback(isRedirect);
        });
    }).catch(function (response) {
        if (isRedirect) callback(isRedirect);
    });
}

__WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].beforeEach(function (to, from, next) {
    checkState(false, __WEBPACK_IMPORTED_MODULE_10__store_store__["a" /* default */], to, function (isRedirect) {
        if (isRedirect === true) {
            next({
                path: '/login',
                query: {
                    redirect: to.fullPath
                }
            });
            return;
        }
        var lastHistory = historys[historys.length - 1];
        if (from.path == lastHistory.path) {
            lastHistory.scrollTop = $(".page").scrollTop();
        }
        next();
    });
});
var i18n = new VueI18n({
    locale: window.localStorage.getItem('lang') ? window.localStorage.getItem('lang') : 'cn',
    messages: {
        en: __WEBPACK_IMPORTED_MODULE_19__lang_EN__["a" /* default */],
        cn: __WEBPACK_IMPORTED_MODULE_18__lang_CN__["a" /* default */],
        jp: __WEBPACK_IMPORTED_MODULE_20__lang_JP__["a" /* default */]
    }
});

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_costCenterI18n__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1_vue___default.a, i18n, __WEBPACK_IMPORTED_MODULE_10__store_store__["a" /* default */]);

var app = new __WEBPACK_IMPORTED_MODULE_1_vue___default.a({
    router: __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */],
    store: __WEBPACK_IMPORTED_MODULE_10__store_store__["a" /* default */],
    i18n: i18n,
    data: function data() {
        return {
            transitionName: "slide-left",
            TriptList: {},
            FeatureCodes: null
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["mapGetters"])(['actions', 'siteInfo']), {
        keepAlive: function keepAlive() {
            var keepAlive = historys.map(function (router) {
                return (router.name || router.path).replace('/', '');
            }).join(',');
            return keepAlive;
        },
        HideHearder: function HideHearder() {
            return this.$route.query;
        }
    }),
    watch: {
        '$route': function $route(to, from) {
            if (historys[historys.length - 1].path == to.path) return;
            var isBack = historys.length < 2 ? false : to.path == historys[historys.length - 2].path;
            if (isBack) {
                historys.pop();
            } else {
                historys.push({
                    path: to.path,
                    name: to.name
                });
            }
            this.transitionName = isBack ? 'slide-right' : 'slide-left';

            this.changeAction(to.matched, to);
        },
        'actions': function actions() {
            this.changeAction(this.$route.matched, this.$route);
        },
        'siteInfo': function siteInfo() {
            if (!document.title && document.title == '') {
                document.title = this.siteInfo && this.siteInfo.SystemName || document.title;
            }
        },
        '$i18n.locale': function $i18nLocale(newVal) {
            if (newVal) {
                this.SaveCookie(newVal);
            }
        }
    },
    methods: {
        SaveCookie: function SaveCookie(value) {
            document.cookie = 'lang=' + value + ';path=/;';
        },
        changeAction: function changeAction(matched, target) {
            var route = _.last(matched);
            var clears = __WEBPACK_IMPORTED_MODULE_10__store_store__["a" /* default */].getters.clears;
            var path = target.fullPath;
            var acts = _(clears).filter(function (o) {
                return o.IdentifyPath.toUpperCase() == route.path.toUpperCase();
            }).orderBy(function (o) {
                try {
                    var matchs = __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].compare(o.IdentifyCode.toUpperCase(), path.toUpperCase());

                    return matchs;
                } catch (e) {
                    console.log(path.toUpperCase() + ' ' + o.IdentifyCode.toUpperCase() + ' exception');
                }
                return path.toUpperCase().indexOf(o.IdentifyCode.toUpperCase());
            });

            __WEBPACK_IMPORTED_MODULE_10__store_store__["a" /* default */].dispatch("changeCurrentAction", acts.first());
        }
    },
    mounted: function mounted() {
        var __self = this;

        __self.FeatureCodes = location.search.indexOf('HideHeader');

        this.SaveCookie(this.$i18n.locale);

        __WEBPACK_IMPORTED_MODULE_10__store_store__["a" /* default */].dispatch("loadSiteInfo").then(function (json) {});
        $("link[rel=icon]").attr("href", __self.getImgs('icon.ico'));
    }
});
app.$mount('#app');

Date.prototype.toJSON = function () {
    return __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].DateFormat(this, "yyyy-MM-dd HH:mm:ss");
};
window.DefaultCompanyID = "S00000010159";
window.$app = app;

document.body.ontouchmove = function (e) {
    e.preventDefault();
};
$(".page").on("touchmove", function (e) {
    e.stopPropagation();
});

$(document).on("mousewheel", ".el-scrollbar__wrap", function (e) {
    var t = e.currentTarget;
    if (t.scrollHeight < t.scrollWidth + 5 || e.originalEvent.deltaY > 0 && t.scrollWidth == t.scrollTop || e.originalEvent.deltaY < 0 && t.scrollTop == 0) {
        return false;
    }
});

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apis__ = __webpack_require__(36);


var action = {
    actions: [],
    clears: [],
    roots: [],
    groups: []
};
/* harmony default export */ __webpack_exports__["a"] = ({
    state: {
        action: action,
        current: {}
    },
    getters: {
        action: function action(state) {
            return state.action;
        },
        actions: function actions(state) {
            return state.action.actions;
        },
        clears: function clears(state) {
            return state.action.clears;
        },
        roots: function roots(state) {
            return state.action.roots;
        },
        currentAction: function currentAction(state) {
            return state.current;
        },
        sitePath: function sitePath(state) {
            if (!state.current) {
                return [];
            }
            var act = state.current;
            var menus = [];
            while (act != undefined) {
                if (act.ActionURL && act.ActionURL != '') {
                    menus.push(act);
                }
                act = act.upper;
            }
            return menus.reverse();
        },
        childActions: function childActions(state) {
            if (!state.current) {
                return state.current;
            }
            return state.current.children;
        },
        groups: function groups(state) {
            return state.action.groups;
        }
    },
    mutations: {
        setActionInfo: function setActionInfo(state, acts) {
            state.action = acts;
        },
        removeActionInfo: function removeActionInfo(state) {
            state.action = action;
        },
        changeAction: function changeAction(state, action) {
            state.current = action;
        }
    },
    actions: {
        removeActionInfo: function removeActionInfo(_ref) {
            var commit = _ref.commit;

            commit('removeActionInfo');
        },
        changeCurrentAction: function changeCurrentAction(_ref2, action) {
            var commit = _ref2.commit;

            commit("changeAction", action);
        },
        loadActionInfo: function loadActionInfo(_ref3, UserID, CompanyID) {
            var commit = _ref3.commit;

            return __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].system.getUserActions({
                failTips: false
            }).then(function (json) {
                if (!json.data.isSucc) {
                    return json;
                }
                var result = json.data.result;
                var ents = result.UserActions;
                var acts = _.clone(ents);
                _.remove(acts, function (o) {
                    return o.ActionCode == '';
                });
                var actions = _.groupBy(ents, 'UpperAction');
                _.forEach(ents, function (ent) {
                    if (actions[ent.ActionID]) {
                        ent.children = _.orderBy(actions[ent.ActionID], 'OrderBy');
                        _.forEach(ent.children, function (a) {
                            a.upper = ent;
                        });
                    }
                    ent.IdentifyPath = ent.ActionPath || ent.ActionCode;
                });

                commit('setActionInfo', {
                    actions: ents,
                    clears: acts,
                    roots: actions[0],
                    groups: actions
                });
                return json;
            });
        }
    }
});

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_categorys_js__ = __webpack_require__(63);


/* harmony default export */ __webpack_exports__["a"] = ({
    state: {
        categorys: __WEBPACK_IMPORTED_MODULE_1__utils_categorys_js__["a" /* default */]
    },
    getters: {
        categorys: function categorys(state) {
            return state.categorys;
        }
    },
    mutations: {},
    actions: {}
});

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apis__ = __webpack_require__(36);


/* harmony default export */ __webpack_exports__["a"] = ({
    state: {
        conferService: {}
    },
    getters: {
        conferService: function conferService(state) {
            return state.conferService;
        }
    },
    mutations: {
        setconferService: function setconferService(state, conferService) {
            state.conferService = conferService;
        },
        removeconferService: function removeconferService(state) {
            state.conferService = {};
        }
    },
    actions: {
        removeconferService: function removeconferService(_ref) {
            var commit = _ref.commit;

            commit('removeconferService');
        },
        loadconferService: function loadconferService(_ref2, UserID, CompanyID) {
            var commit = _ref2.commit;

            return __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].system.getConferService({
                failTips: false
            }).then(function (json) {
                if (!json.data.isSucc) {
                    return json;
                }
                commit('setconferService', json.data.result);
                return json;
            });
        }
    }
});

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__apis__ = __webpack_require__(36);




/* harmony default export */ __webpack_exports__["a"] = ({
    state: {
        scheduleList: [],
        itineraryNote: ''
    },
    getters: {
        getPreviewStore: function getPreviewStore() {
            return JSON.parse(localStorage.getItem('Preview'));
        }
    },
    mutations: {
        setPreview: function setPreview(state, Preview) {
            state = localStorage.setItem('Preview', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(Preview));
        },
        removePreview: function removePreview() {
            localStorage.removeItem('Preview');
        }
    },
    actions: {
        insertPreview: function insertPreview(_ref, Preview) {
            var commit = _ref.commit;

            commit('setPreview', Preview);
        },
        deletePreview: function deletePreview(_ref2) {
            var commit = _ref2.commit;

            commit('removePreview');
        }
    }
});

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apis__ = __webpack_require__(36);


/* harmony default export */ __webpack_exports__["a"] = ({
    state: {
        siteInfo: {}
    },
    getters: {
        siteInfo: function siteInfo(state) {
            return state.siteInfo;
        }
    },
    mutations: {
        setSiteInfo: function setSiteInfo(state, siteInfo) {
            state.siteInfo = siteInfo;
        },
        removeSiteInfo: function removeSiteInfo(state) {
            state.siteInfo = {};
        }
    },
    actions: {
        removeSiteInfo: function removeSiteInfo(_ref) {
            var commit = _ref.commit;

            commit('removeSiteInfo');
        },
        loadSiteInfo: function loadSiteInfo(_ref2, UserID, CompanyID) {
            var commit = _ref2.commit;

            return __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].system.getSiteInfo({
                failTips: false
            }).then(function (json) {
                if (!json.data.isSucc) {
                    return json;
                }
                commit('setSiteInfo', json.data.result);
                return json;
            });
        }
    }
});

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apis__ = __webpack_require__(36);


var cacheKey = 'loginState';
/* harmony default export */ __webpack_exports__["a"] = ({
    state: {
        loginState: __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].cache(cacheKey),
        ticket: {}
    },
    getters: {
        isLogin: function isLogin(state) {
            return state.loginState;
        },
        isSupply: function isSupply(state) {
            var supply = state.ticket && state.ticket.FeatureCodes && state.ticket.FeatureCodes.indexOf("business.supply") > -1;
            return supply;
        },
        ticketInfo: function ticketInfo(state) {
            return state.ticket;
        }
    },
    mutations: {
        loginSucc: function loginSucc(state) {
            state.loginState = true;
            __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].cache(cacheKey, true);
        },
        logoutSucc: function logoutSucc(state) {
            __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].cache(cacheKey, false);
            state.loginState = false;
            window.localStorage.removeItem('login_repair_info');
            state.ticket = {};
        },
        setTicketInfo: function setTicketInfo(state, ticketInfo) {
            state.ticket = ticketInfo;
        }
    },
    actions: {
        logout: function logout(_ref) {
            var commit = _ref.commit;

            return __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].system.logout().then(function (response) {
                commit('logoutSucc');
                return response;
            }).catch(function () {
                commit('logoutSucc');
                return response;
            });
        },
        login: function login(_ref2, loginInfo) {
            var commit = _ref2.commit;

            return __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].system.login(loginInfo).then(function (response) {
                if (response.data.isSucc) {
                    commit('setTicketInfo', response.data.result);
                    commit('loginSucc');
                }
                return response;
            });
        },
        loadTicketInfo: function loadTicketInfo(_ref3, options) {
            var commit = _ref3.commit;

            return __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].system.getTicketInfo(options).then(function (response) {
                if (response.data.isSucc) {
                    commit('setTicketInfo', response.data.result);
                }
                return response;
            });
        }
    }
});

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__apis__ = __webpack_require__(36);




/* harmony default export */ __webpack_exports__["a"] = ({
    state: {
        viaLists: []
    },
    getters: {
        getViaInfosStore: function getViaInfosStore() {
            return JSON.parse(localStorage.getItem('ViaInfos'));
        }
    },
    mutations: {
        setViaInfos: function setViaInfos(state, ViaInfos) {
            state = localStorage.setItem('ViaInfos', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(ViaInfos));
        },
        removeViaInfos: function removeViaInfos() {
            localStorage.removeItem('ViaInfos');
        }
    },
    actions: {
        insertViaInfos: function insertViaInfos(_ref, ViaInfos) {
            var commit = _ref.commit;

            commit('setViaInfos', ViaInfos);
        },
        deleteViaInfos: function deleteViaInfos(_ref2) {
            var commit = _ref2.commit;

            commit('removeViaInfos');
        }
    }
});

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apis__ = __webpack_require__(36);


/* harmony default export */ __webpack_exports__["a"] = ({
    state: {
        WorkTask: {},
        AdviseList: []
    },
    getters: {
        WorkTask: function WorkTask(state) {
            return state.WorkTask;
        },
        AdviseList: function AdviseList(state) {
            return state.AdviseList;
        }
    },
    mutations: {
        setWorkTask: function setWorkTask(state, WorkTask) {
            state.WorkTask = WorkTask;
        },
        setAdviseList: function setAdviseList(state, AdviseList) {
            state.AdviseList = AdviseList;
        }
    },
    actions: {
        loadWorkTask: function loadWorkTask(context) {
            var commit = context.commit;
            var isSupply = context.getters.isSupply;
            if (isSupply) {
                var getWorkTasks = function getWorkTasks() {
                    var data = {
                        "KeyWords": "",
                        "CreateTime": "",
                        "CreateTimeEnd": "",
                        "OrderStatus": "",
                        "ProductType": "",
                        "PageNo": 1,
                        "PageSize": 999999999,
                        "RecordCount": 0,
                        "ServiceType": "",
                        "BusinessStatus": '',
                        "BusinessStatuss": [10107, 10105, 10109, 10203],
                        "BusinessTypes": [1797, 1789, 1799],
                        "BusinessType": "",
                        "ServiceTypes": [1407, 1409, 1470] };
                    __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].work.getWorkTasks(data, {
                        failTips: false
                    }).then(function (json) {
                        if (!json || !json.data || !json.data.isSucc) {
                            return json;
                        }
                        commit('setWorkTask', json.data.result);
                        return json;
                    });
                };

                getWorkTasks();
            }
        },
        loadAdviseList: function loadAdviseList(context) {
            var commit = context.commit;
            var isSupply = context.getters.isSupply;
            if (isSupply) {
                var getAdviseList = function getAdviseList() {
                    var data = {
                        PageNo: 1,
                        PageSize: 9999999999,
                        RecordCount: 0,
                        AdviseID: '',
                        AdviseType: '',
                        ContactPhone: ''
                    };
                    __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].adapter.getAdviseList(data).then(function (json) {
                        if (!json.data.isSucc) {
                            return json;
                        }
                        commit('setAdviseList', json.data.result.entities);
                        return json;
                    });
                };

                getAdviseList();
            }
        }
    }
});

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

var cacheUtils = {};
cacheUtils.cache = function (key, value) {
    if (value === undefined) return JSON.parse(localStorage.getItem(key));
    localStorage.setItem(key, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(value));
};
/* harmony default export */ __webpack_exports__["a"] = (cacheUtils);

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var noticeUtils = {};
noticeUtils.succ = function (msg, fn) {
    if (fn == null || fn == undefined) {
        $app.$message({
            message: msg,
            type: 'success'
        });
        return;
    }
    if (fn === true) {
        fn = function fn() {};
    }
    var __self = $app;
    var args = arguments;
    $app.$confirm(msg, '提示', {
        confirmButtonText: '确定',
        showCancelButton: false,
        type: 'success'
    }).then(function () {
        fn.apply(__self, args);
    }).catch(function () {
        $app.$message({
            type: 'info',
            message: '操作异常'
        });
    });
};

noticeUtils.fail = function (msg, fn) {
    var __self = $app;
    var args = arguments;
    $app.$confirm(msg, '提示', {
        confirmButtonText: '确定',
        showCancelButton: false,
        lockScroll: true,
        type: 'error'
    }).then(function () {
        if (fn != null && fn != undefined) fn.apply(__self, args);
    });
};

noticeUtils.tips = function (msg, timer) {
    return $app.$message(msg, {
        duration: timer
    });
};
/* harmony default export */ __webpack_exports__["a"] = (noticeUtils);

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var utils = {};
utils.extends = function (anyUtils) {
    for (var k in anyUtils) {
        utils[k] = anyUtils[k];
    }
};
utils.Group = function (strArr, fn) {
    var groups = {};
    if (fn == undefined) fn = function fn(item) {
        return item;
    };
    strArr.map(function (item) {
        var key = fn(item);
        var arr = groups[key];
        if (arr === undefined) {
            groups[key] = [];
            arr = groups[key];
        }
        arr.push(item);
    });
    return groups;
};
utils.PropertyToArray = function (obj) {
    var result = [];
    for (var key in obj) {
        var s = {};
        s["key"] = key;
        s["value"] = obj[key];
        result.push(s);
    }
    return result;
};
utils.each = function (arr, fn) {
    for (var i = 0; i < arr.length; i++) {
        fn(arr[i], i);
    }
};
utils.loadScript = function () {
    var cb = {};
    return function (src, callback) {
        var callbacks = cb[src];
        if (callbacks) {
            callbacks.push(callback);
            return;
        }
        callbacks = cb[src] = [callback];

        var ele = document.createElement("script");
        ele.src = src;
        ele.onload = function () {
            while (callbacks.length > 0) {
                var _callback = callbacks.pop();
                _callback();
            }
        };
        document.body.appendChild(ele);
    };
}();
utils.findCategorysCode = function (datas, value) {
    var reusult = _.find(datas, function (o) {
        return o.CategoryID == value;
    });
    if (reusult) {
        return reusult.CategoryCode;
    } else {
        return undefined;
    }
};

utils.parseNumber = function (value) {
    var n = parseFloat(value);
    return isFinite(n) ? n : 0;
};
/* harmony default export */ __webpack_exports__["a"] = (utils);

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var regulars = {};
regulars.mobile = /^1\d{10}$/;

/* harmony default export */ __webpack_exports__["a"] = (regulars);

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var stringUtils = {};
stringUtils.getLastTimeStr = function (time, isFromNow) {
    var date = new Date(time);
    var fmt = "yyyy-MM-dd hh:mm";
    var o = {
        "M+": date.getMonth() + 1,
        "d+": date.getDate(),
        "h+": date.getHours(),
        "m+": date.getMinutes(),
        "s+": date.getSeconds(),
        "q+": Math.floor((date.getMonth() + 3) / 3),
        S: date.getMilliseconds() };
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    }
    for (var k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
            fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
        }
    }
    return fmt;
};

stringUtils.append = function (_self, str) {
    return _self.concat(str);
};

stringUtils.deleteCharAt = function (_self, index) {
    if (index < 0 || index >= _self.length) {
        return _self.valueOf();
    } else if (index == 0) {
        return _self.substring(1, _self.length);
    } else if (index == _self.length - 1) {
        return _self.substring(0, _self.length - 1);
    } else {
        return _self.substring(0, index) + _self.substring(index + 1);
    }
};

stringUtils.deleteString = function (_self, start, end) {
    if (start == end) {
        return _self.deleteCharAt(start);
    } else {
        if (start > end) {
            var temp = start;
            start = end;
            end = temp;
        }
        if (start < 0) {
            start = 0;
        }
        if (end > _self.length - 1) {
            end = _self.length - 1;
        }
        return _self.substring(0, start) + _self.substring(end + 1, _self.length);
    }
};

stringUtils.endWith = function (_self, subStr) {
    if (subStr.length > _self.length) {
        return false;
    } else {
        return _self.lastIndexOf(subStr) == _self.length - subStr.length ? true : false;
    }
};

stringUtils.equal = function (_self, str) {
    if (_self.length != str.length) {
        return false;
    } else {
        for (var i = 0; i < _self.length; i++) {
            if (_self.charAt(i) != str.charAt(i)) {
                return false;
            }
        }
        return true;
    }
};

stringUtils.equalIgnoreCase = function (_self, str) {
    var temp1 = _self.toLowerCase();
    var temp2 = str.toLowerCase();
    return temp1.equal(temp2);
};

stringUtils.insert = function (_self, ofset, subStr) {
    if (ofset < 0 || ofset >= _self.length - 1) {
        return _self.append(subStr);
    }
    return _self.substring(0, ofset + 1) + subStr + _self.substring(ofset + 1);
};

stringUtils.isAllNumber = function (_self) {
    for (var i = 0; i < _self.length; i++) {
        if (_self.charAt(i) < "0" || _self.charAt(i) > "9") {
            return false;
        }
    }
    return true;
};

stringUtils.reserve = function (_self) {
    var temp = "";
    for (var i = _self.length - 1; i >= 0; i--) {
        temp = temp.concat(_self.charAt(i));
    }
    return temp;
};

stringUtils.setCharAt = function (_self, index, subStr) {
    if (index < 0 || index > _self.length - 1) {
        return _self.valueOf();
    }
    return _self.substring(0, index) + subStr + _self.substring(index + 1);
};

stringUtils.startWith = function (_self, subStr) {
    if (subStr.length > _self.length) {
        return false;
    }
    return _self.indexOf(subStr) == 0 ? true : false;
};

stringUtils.charLength = function (_self) {
    var temp = 0;
    for (var i = 0; i < _self.length; i++) {
        if (_self.charCodeAt(i) > 255) {
            temp += 2;
        } else {
            temp += 1;
        }
    }
    return temp;
};
stringUtils.charLengthReg = function (_self) {
    return _self.replace(/[^\x00-\xff]/g, "**").length;
};

stringUtils.trim = function (_self) {
    return _self.replace(/(^\s*)|(\s*$)/g, "");
};

stringUtils.isNumeric = function (_self) {
    var tmpFloat = parseFloat(this);
    if (isNaN(tmpFloat)) return false;
    var tmpLen = _self.length - tmpFloat.toString().length;
    return tmpFloat + "0".Repeat(tmpLen) == this;
};

stringUtils.isInt = function (_self) {
    if (this == "NaN") return false;
    return this == parseInt(this).toString();
};

stringUtils.Repeat = function (_self, num) {
    var tmpArr = [];
    for (var i = 0; i < num; i++) {
        tmpArr.push(this);
    }return tmpArr.join("");
};

stringUtils.resetBlank = function (_self) {
    return _self.replace(/s+/g, " ");
};

stringUtils.LTrim = function (_self) {
    return _self.replace(/^s+/g, "");
};

stringUtils.RTrim = function (_self) {
    return _self.replace(/s+$/g, "");
};

stringUtils.trim = function (_self) {
    return _self.replace(/(^s+)|(s+$)/g, "");
};

stringUtils.getNum = function (_self) {
    return _self.replace(/[^d]/g, "");
};

stringUtils.getEn = function (_self) {
    return _self.replace(/[^A-Za-z]/g, "");
};

stringUtils.getCn = function (_self) {
    return _self.replace(/[^u4e00-u9fa5uf900-ufa2d]/g, "");
};

stringUtils.getRealLength = function (_self) {
    return _self.replace(/[^x00-xff]/g, "--").length;
};

stringUtils.left = function (_self, n) {
    return _self.slice(0, n);
};

stringUtils.right = function (_self, n) {
    return _self.slice(_self.length - n);
};

stringUtils.compare = function (source, target) {
    var n = source.length;
    var m = target.length;
    if (n == 0) {
        return m;
    }

    if (m == 0) {
        return n;
    }

    var d = [];
    var max = m > n ? m : n;
    for (var i = 0; i < max + 1; i++) {
        d.push([]);
    }
    for (var _i = 0; _i <= n; _i++) {
        d[_i][0] = _i;
    }
    for (var j = 0; j <= m; j++) {
        d[0][j] = j;
    }
    for (var _i2 = 1; _i2 <= n; _i2++) {
        var ch1 = source[_i2 - 1];
        for (var _j = 1; _j <= m; _j++) {
            var ch2 = target[_j - 1];

            var temp = 1;
            if (ch1 == ch2) {
                temp = 0;
            }
            d[_i2][_j] = Math.min(d[_i2 - 1][_j] + 1, d[_i2][_j - 1] + 1, d[_i2 - 1][_j - 1] + temp);
        }
    }
    return d[n][m];
};

/* harmony default export */ __webpack_exports__["a"] = (stringUtils);

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    name: 'dashboard',
    children: [{
        path: '/adapter/smslist',
        components: {
            default: function _default(resolve) {
                return __webpack_require__.e/* require */(42).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(589)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            }
        }
    }, {
        path: '/adapter/smsdetail',
        components: {
            default: function _default(resolve) {
                return __webpack_require__.e/* require */(219).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(588)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            }
        }
    }]
}]);

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    name: 'dashboard',
    children: [{
        path: '/admin/notifyinfo/list',
        name: 'NotifyInfoList',
        components: {

            default: function _default(resolve) {
                return __webpack_require__.e/* require */(83).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(592)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            }
        }
    }, {
        path: '/admin/notifyinfo/update',
        name: 'NotifyInfoUpdate',
        components: {

            default: function _default(resolve) {
                return __webpack_require__.e/* require */(161).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(593)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            }
        }
    }, {
        path: '/admin/feedBack/list',
        name: 'FeedBackList',
        components: {

            default: function _default(resolve) {
                return __webpack_require__.e/* require */(92).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(591)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            }
        }
    }, {
        path: '/admin/feedBack/detail',
        name: 'FeedBackDetail',
        components: {

            default: function _default(resolve) {
                return __webpack_require__.e/* require */(53).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(590)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            }
        }
    }, {
        path: '/admin/settinginfo/list',
        components: {
            default: function _default(resolve) {
                return __webpack_require__.e/* require */(82).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(594)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            }
        }
    }, {
        path: '/admin/settinginfo/details',
        name: 'settingupdate',
        components: {
            default: function _default(resolve) {
                return __webpack_require__.e/* require */(160).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(595)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            }
        }
    }]
}]);

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  name: 'dashboard',
  children: [{
    name: 'test',
    path: '/test/demo',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(122).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(610)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    name: 'baselist',
    path: '/System/Base/Baselist',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(28).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(640)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    name: 'citybaseList',
    path: '/base/citybase/citybaseList',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(74).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(609)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    name: 'citybaseDetail',
    path: '/base/citybase/citybaseDetail',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(75).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(608)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    name: 'airlineList',
    path: '/base/airlinebase/airlineList',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(80).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(597)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    name: 'airlineDetail',
    path: '/base/airlinebase/airlineDetail',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(81).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(596)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    name: 'airspaceDetail',
    path: '/base/airspacebase/airspaceDetail',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(79).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(598)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    name: 'airspaceList',
    path: '/base/airspacebase/airspaceList',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(78).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(599)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    name: 'airspanceRank',
    path: '/base/airspacebase/airspanceRank',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(77).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(600)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/base/flgihtBase/flightBaseDate',
    name: 'flightBaseflightBaseDate',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(211).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(612)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/base/flightBase/airportDetail',
    name: 'flightBaseairportDetail',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(147).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(611)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/base/hotelBaseDate/hotelBaseDate',
    name: 'hotelBaseDatehotelBaseDate',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(146).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(622)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/base/hotelBaseDate/hotelBaseDetail',
    name: 'hotelBaseDatehotelBaseDetail',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(145).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(625)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    name: 'alliance',
    path: '/base/alliance/alliance',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(76).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(601)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    name: 'addVisa',
    path: '/base/hotelBaseDate/basicConfigurat/addVisa',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(210).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(614)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    name: 'basicConfigurat',
    path: '/base/hotelBaseDate/basicConfigurat/basicConfigurat',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(209).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(615)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    name: 'facilityAttribute',
    path: '/base/hotelBaseDate/basicConfigurat/facilityAttribute',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(71).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(618)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    name: 'configurat',
    path: '/base/hotelBaseDate/basicConfigurat/configurat',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(72).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(617)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    name: 'BusinessDistrict',
    path: '/base/hotelBaseDate/basicConfigurat/BusinessDistrict',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(73).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(613)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    name: 'servicesAdd',
    path: '/base/hotelBaseDate/basicConfigurat/servicesAdd',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(68).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(621)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    name: 'leisureFacility',
    path: '/base/hotelBaseDate/basicConfigurat/leisureFacility',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(69).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(620)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    name: 'infrastructure',
    path: '/base/hotelBaseDate/basicConfigurat/infrastructure',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(70).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(619)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    name: 'creditChoose',
    path: '/base/hotelBaseDate/creditChoose',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(208).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(623)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    name: 'detailFacilityChoose',
    path: '/base/hotelBaseDate/detailFacilityChoose',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(207).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(624)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    name: 'roomList',
    path: '/base/hotelBaseDate/roomList',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(144).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(639)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    name: 'pictureSet',
    path: '/base/hotelBaseDate/pictureSet',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(196).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(636)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    name: 'roomDetail',
    path: '/base/hotelBaseDate/roomDetail',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(143).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(637)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    name: 'roomFacilitySet',
    path: '/base/hotelBaseDate/roomFacilitySet',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(195).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(638)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    name: 'hotelPicture',
    path: '/base/hotelPicture/hotelPicture',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(204).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(628)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    name: 'hotelPictureappearance',
    path: '/base/hotelPicture/appearance',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(206).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(626)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    name: 'hotelPicturemeetingRoom',
    path: '/base/hotelPicture/meetingRoom',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(202).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(630)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    name: 'hotelPicturerelaxation',
    path: '/base/hotelPicture/relaxation',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(198).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(634)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    name: 'hotelPicturerestaurant',
    path: '/base/hotelPicture/restaurant',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(197).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(635)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    name: 'hotelPicturelobby',
    path: '/base/hotelPicture/lobby',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(203).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(629)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    name: 'hotelPictureguestRoom',
    path: '/base/hotelPicture/guestRoom',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(205).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(627)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    name: 'hotelPicturepublicArea',
    path: '/base/hotelPicture/publicArea',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(199).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(633)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    name: 'hotelPicturerestaurant',
    path: '/base/hotelPicture/nearby',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(201).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(631)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    name: 'hotelPictureother',
    path: '/base/hotelPicture/other',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(200).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(632)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    name: 'brandList',
    path: '/base/hotelBaseDate/basicConfigurat/brandList',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(47).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(616)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/base/backtorule/changetimelist',
    name: 'changetimelist',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(212).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(606)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/base/backtorule/changetimeupdate',
    name: 'changetimeupdate',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(148).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(607)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/base/backtorule/RulesList',
    name: 'RulesList',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(159).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(604)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/base/backtorule/RulesUpdate',
    name: 'RulesUpdate',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(149).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(605)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/base/backtorule/ClassRulesList',
    name: 'ClassRulesList',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(213).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(602)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/base/backtorule/ClassRulesUpdate',
    name: 'ClassRulesUpdate',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(150).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(603)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }]
}]);

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  path: "/dashboard",
  name: "dashboard",
  meta: {
    requiresAuth: true
  },
  children: [{
    path: "/bill/:CompanyID/TradeAccountList",
    name: "TradeAccountList",
    components: {
      default: function _default(resolve) {
        return __webpack_require__.e/* require */(112).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(645)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }
  }, {
    path: "/bill/:CompanyID/TradeAccountAdd",
    name: "TradeAccountAdd",
    components: {
      default: function _default(resolve) {
        return __webpack_require__.e/* require */(164).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(644)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }
  }, {
    path: "/bill/:CompanyID/TradeFlowList",
    name: "TradeFlowList",
    components: {
      default: function _default(resolve) {
        return __webpack_require__.e/* require */(111).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(650)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }
  }, {
    path: "/bill/BankAccount/:CompanyID/list",
    name: "BankAccountList",
    components: {
      default: function _default(resolve) {
        return __webpack_require__.e/* require */(121).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(641)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }
  }, {
    path: "/bill/BillPayment/:CompanyID/list",
    name: "BillPaymentList",
    components: {
      default: function _default(resolve) {
        return __webpack_require__.e/* require */(67).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(647)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }
  }, {
    path: "/bill/BillPayment/detail",
    name: "BillPaymentDetail",
    components: {
      default: function _default(resolve) {
        return __webpack_require__.e/* require */(141).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(646)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }
  }, {
    path: "/bill/TradeInfo/:CompanyID/TradePayment",
    name: "TradePayment",
    components: {
      default: function _default(resolve) {
        return __webpack_require__.e/* require */(46).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(651)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }
  }, {
    path: "/bill/company/tradedetails",
    components: {
      default: function _default(resolve) {
        return __webpack_require__.e/* require */(140).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(654)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }
  }, {
    path: "/bill/bankcard/list",
    components: {
      default: function _default(resolve) {
        return __webpack_require__.e/* require */(110).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(653)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }
  }, {
    path: "/bill/TradeStatistics/:CompanyID/list",
    name: "TradeStatisticsList",
    components: {
      default: function _default(resolve) {
        return __webpack_require__.e/* require */(119).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(649)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }
  }]
}, {
  path: "/fullscreen",
  name: "fullscreen",
  meta: {
    requiresAuth: true
  },
  children: [{
    path: "/bill/BillReceive/:CompanyID/list",
    name: "BillReceiveList",
    components: {
      default: function _default(resolve) {
        return __webpack_require__.e/* require */(120).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(648)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }
  }, {
    path: "/bill/TradeInfo/:CompanyID/TradeReceive",
    name: "TradeReceive",
    components: {
      default: function _default(resolve) {
        return __webpack_require__.e/* require */(27).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(652)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }
  }, {
    path: "/bill/BillStatistics/:CompanyID/ProfitStatistics",
    name: "ProfitStatistics",
    components: {
      default: function _default(resolve) {
        return __webpack_require__.e/* require */(113).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(642)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }
  }, {
    path: "/bill/BillStatistics/:CompanyID/SalesComparison",
    name: "SalesComparison",
    components: {
      default: function _default(resolve) {
        return __webpack_require__.e/* require */(142).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(643)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }
  }, {
    path: "/bill/BillStatistics/:CompanyID/ClientStatistics",
    name: "ClientStatistics",
    components: {
      default: function _default(resolve) {
        return __webpack_require__.e/* require */(132).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(741)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }
  }]
}]);

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/btripplatform/main',
  name: 'btripplatform',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(91).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(655)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}]);

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
  name: "btrip",
  path: "/btrip",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(41).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(656)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  children: [{
    name: 'register',
    path: '/btrip/outgoing/register',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(139).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(579)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    name: 'List',
    path: '/btrip/outgoing/list',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(193).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(578)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    name: 'Application-form',
    path: '/btrip/outgoing/Applicationform',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(194).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(577)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    name: 'Correct',
    path: '/btrip/outgoing/Correct',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(138).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(657)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }]
}]);

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    path: '/dashboard',
    name: 'dashboard',
    meta: {
        requiresAuth: true
    },
    children: [{
        path: '/express/list',
        name: 'ExpressList',
        components: {

            default: function _default(resolve) {
                return __webpack_require__.e/* require */(66).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(658)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            }
        }
    }, {
        path: '/express/update',
        name: 'ExpressUpdate',
        components: {

            default: function _default(resolve) {
                return __webpack_require__.e/* require */(177).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(659)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            }
        }
    }]
}]);

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    name: 'dashboard',
    children: [{
        name: 'InsuranceList',
        path: '/insurance/list',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(32).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(667)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        name: 'InsuranceThrowList',
        path: '/insurance/InsuranceThrow/throwList',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(65).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(665)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        name: 'InsurancePolicyUpdate',
        path: '/insurance/InsurancePolicy/update',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(176).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(662)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        name: 'InsuranceProductUpdate',
        path: '/insurance/InsuranceProduct/update',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(175).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(663)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        name: 'InsuranceThrowUpdate',
        path: '/insurance/InsuranceThrow/update',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(174).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(666)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        name: 'InsuranceRobotInfoDetail',
        path: '/insurance/robotInfo/detail',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(192).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(664)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/Invisible/Invisible/list',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(123).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(585)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        name: 'analyseList',
        path: '/analyse/list',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(114).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(586)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/analyse/log',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(102).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(587)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }]
}]);

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    path: '/dashboard',
    name: 'dashboard',
    meta: {
        requiresAuth: true
    },
    children: [{
        path: '/invoice/list',
        name: 'InvoiceList',
        components: {

            default: function _default(resolve) {
                return __webpack_require__.e/* require */(64).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(668)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            }
        }
    }, {
        path: '/invoice/update',
        name: 'InvoiceUpdate',
        components: {

            default: function _default(resolve) {
                return __webpack_require__.e/* require */(151).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(669)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            }
        }
    }]
}]);

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  name: "fullscreen",
  children: [{
    path: "/manage/demandorder",
    name: "demandorder",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(8).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(671)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }]
}]);

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    meta: {
        requiresAuth: true
    },
    name: 'flightCNList',
    path: '/mall/flightCN/flightList',
    component: function component(resolve) {
        return __webpack_require__.e/* require */(11).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(674)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}]);

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    meta: {
        requiresAuth: true
    },
    name: 'flightGJList',
    path: '/mall/flightGJ/flightList',
    component: function component(resolve) {
        return __webpack_require__.e/* require */(17).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(675)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}]);

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    meta: {
        requiresAuth: true
    },
    name: 'hotelCNList',
    path: '/mall/hotelCN/hotelList',
    component: function component(resolve) {
        return __webpack_require__.e/* require */(18).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(676)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    meta: {
        requiresAuth: true
    },
    name: 'HotelReserve',
    path: '/mall/hotelCN/HotelReserve',
    component: function component(resolve) {
        return __webpack_require__.e/* require */(16).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(580)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}]);

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    name: 'hotelGJList',
    path: '/mall/hotelGJ/hotelList',
    component: function component(resolve) {
        return __webpack_require__.e/* require */(23).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(677)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}]);

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    name: 'dashboard',
    children: [{
        path: '/manage/traffic/updateorder',
        name: 'trafficorder',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(36).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(681)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/manage/:ServiceType?/updateorder',
        name: 'updateorder',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(12).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(680)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }]
}]);

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  meta: {
    requiresAuth: true
  },
  path: "/mall/list",
  name: "list",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(13).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(679)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  meta: {
    requiresAuth: true
  },
  path: "/mall/feedBack",
  name: "feedBack",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(191).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(673)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  meta: {
    requiresAuth: true
  },
  path: "/mall/approvals",
  name: "approvals",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(190).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(678)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  meta: {
    requiresAuth: true
  },
  name: "booking",
  path: "/mall/booking",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(14).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(670)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  meta: {
    requiresAuth: true
  },
  name: "extendServices",
  path: "/mall/:service/extendServices",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(37).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(672)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  meta: {
    requiresAuth: true
  },
  name: "mallOrder",
  path: "/mall/:service/order",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(7).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(682)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  meta: {
    requiresAuth: true
  },
  name: "flightInternalList",
  path: "/mall/flight/Internal/list",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(221)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  meta: {
    requiresAuth: true
  },
  name: "flightOverseasList",
  path: "/mall/flight/Overseas/list",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(0/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(221)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}]);

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    meta: {
        requiresAuth: true
    },
    name: 'MallTrainList',
    path: '/mall/train/list',
    component: function component(resolve) {
        return __webpack_require__.e/* require */(19).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(581)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    meta: {
        requiresAuth: true
    },
    path: '/order/train/Change/:UniqueID?',
    name: 'ChangeTicket',
    component: function component(resolve) {
        return __webpack_require__.e/* require */(35).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(684)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    meta: {
        requiresAuth: true
    },
    path: '/train/refundTicket',
    name: 'refundTicket',
    component: function component(resolve) {
        return __webpack_require__.e/* require */(137).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(685)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    meta: {
        requiresAuth: true
    },
    path: '/order/orderSeat',
    name: 'orderSeat',
    component: function component(resolve) {
        return __webpack_require__.e/* require */(189).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(683)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}]);

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    name: 'dashboard',
    children: [{
        name: 'ManageFlightflightticket',
        path: '/manage/flight/policy/flightticket',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(51).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(696)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        name: 'ManageFlightPolicyUpdate',
        path: '/manage/flight/policy/update',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(56).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(699)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        name: 'ManageFlightPolicyUpdate',
        path: '/manage/:service?/salesStrategy/list',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(89).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(698)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        name: 'ManageFlightPolicyUpdate',
        path: '/manage/:service?/salesStrategy/detail',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(90).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(697)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        name: 'rulepolicy',
        path: '/manage/flight/rulepolicy',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(136).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(700)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        name: 'notifyrulepolicy',
        path: '/manage/flightpolicy/notifyrule',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(95).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(694)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        name: 'notifyrulepolicyupdate',
        path: '/manage/flightpolicy/flightnotifyupdate',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(157).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(695)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }]
}]);

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  name: "dashboard",
  children: [{
    name: "levelinfolist",
    path: "/manage/flightpolicy/levelinfolist",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(156).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(702)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    name: "levelinfoupdate",
    path: "/manage/flightpolicy/levelupdate",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(218).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(703)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    name: "bigcustomerdetail",
    path: "/manage/bigcustomer/detail",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(45).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(704)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    name: "PolicyDetails",
    path: "/manage/flightCN/policys",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(43).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(705)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    name: "salepolicy",
    path: "/manage/salepolicy/list",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(63).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(708)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    name: "salepolicydetial",
    path: "/manage/salepolicy/detail",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(118).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(709)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    name: "flightRobotList",
    path: "/manage/flight/robot/list",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(94).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(707)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    name: "flightRobotInfo",
    path: "/manage/flight/robot/detail",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(171).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(706)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    name: "ibeCount",
    path: "/manage/flight/ibeCount",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(188).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(701)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: "/manage/companyunion/list",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(40).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(710)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }]
}]);

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  name: "dashboard",
  children: [{
    name: "TourThrowDetail",
    path: "/manage/tour/throw/detail",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(184).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(731)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    name: "TourThrowList",
    path: "/manage/tour/throw/list",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(59).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(733)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    name: "TourThrowEdit",
    path: "/manage/tour/throw/edit",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(183).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(732)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    name: "TourProductDetail",
    path: "/manage/tour/product/detail",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(116).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(728)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    name: "TourRoomList",
    path: "/manage/tour/room/list",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(133).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(730)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    name: "TourRoomDetail",
    path: "/manage/tour/room/detail",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(185).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(729)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    name: "HotelProductDetail",
    path: "/manage/hotel/product/detail",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(54).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(720)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    name: "HotelThrowList",
    path: "/manage/hotel/throw/list",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(86).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(726)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    name: "HotelThrowDetail",
    path: "/manage/hotel/throw/detail",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(186).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(725)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    name: "HotelPolicyList",
    path: "/manage/hotel/dispose/list",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(61).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(717)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    name: "HotelPolicyDetail",
    path: "/manage/hotel/dispose/detail",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(170).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(716)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: "/manage/hotel/room/list",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(134).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(724)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: "/manage/hotel/room/detail",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(187).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(723)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: "/manage/hotel/risk/detail",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(169).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(721)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: "/manage/hotel/risk/list",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(60).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(722)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: "/manage/hotel/filter/detail",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(155).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(719)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: "/manage/hotel/filter/list",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(50).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(718)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: "/manage/flight/berth/list",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(117).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(715)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }]
}]);

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  name: "TeamStatus",
  path: "/manage/tour/TeamStatus",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(135).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(582)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  name: "dashboard",
  children: [{
    name: "orderList",
    path: "/manage/:service?/order/list/:state?",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(21).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(713)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    name: "orderDetail",
    path: "/manage/:service?/order/detail",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(9).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(714)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    name: "amendList",
    path: "/manage/:service?/amend/list/:state?",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(31).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(687)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    name: "amendDetail",
    path: "/manage/:service?/amend/detail",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(15).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(686)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    name: "policyList",
    path: "/manage/:service/policy/list/:state?",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(22).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(727)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    name: "ClientUserList",
    path: "/manage/flight/clientuser/list",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(97).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(690)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    name: "ClientCodeList",
    path: "/manage/flight/clientcode/list",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(98).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(688)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    name: "ClientUserUpdate",
    path: "/manage/flight/clientuser/update",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(172).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(691)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    name: "ClientCodeUpdate",
    path: "/manage/flight/clientcode/update",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(173).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(689)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    name: 'flightchangelist',
    path: "/manage/:service?/flightchangelist",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(44).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(711)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    name: 'flightsmssettinglist',
    path: '/manage/flight/flightsmssettinglist',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(62).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(712)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    name: 'baggageList',
    path: '/manage/flight/flightbaggagelist',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(96).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(692)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    name: 'flightbagupdate',
    path: '/manage/flight/flightbaggageupdate',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(158).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(693)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }]
}]);

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/meeting/index',
  name: 'meeting',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(101).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(734)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}]);

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create__);

var _toString = Object.prototype.toString;

function isRegExp(v) {
    return _toString.call(v) === '[object RegExp]';
}

function isDef(v) {
    return v !== undefined && v !== null;
}

function getFirstComponentChild(children) {
    if (Array.isArray(children)) {
        for (var i = 0; i < children.length; i++) {
            var c = children[i];
            if (isDef(c) && isDef(c.componentOptions)) {
                return c;
            }
        }
    }
}

var patternTypes = [String, RegExp, Array];

function getComponentName(opts) {
    return opts && (opts.Ctor.options.name || opts.tag);
}

function matches(pattern, name) {
    if (Array.isArray(pattern)) {
        return pattern.indexOf(name) > -1;
    } else if (typeof pattern === 'string') {
        return pattern.split(',').indexOf(name) > -1;
    } else if (isRegExp(pattern)) {
        return pattern.test(name);
    }

    return false;
}

function pruneCache(cache, current, filter) {
    for (var key in cache) {
        var cachedNode = cache[key];
        if (cachedNode) {
            var name = key;
            if (name && !filter(name)) {
                if (cachedNode !== current) {
                    pruneCacheEntry(cachedNode);
                }
                cache[key] = null;
            }
        }
    }
}

function pruneCacheEntry(vnode) {
    if (vnode) {
        vnode.componentInstance.$destroy();
        vnode.keepAlive = false;
    }
}

function GetDefaultComponentName(to) {
    return _.last(to.matched).components.default.name;
}

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'm-keepalive',
    data: function data() {
        return {
            historys: []
        };
    },

    abstract: true,

    props: {
        include: patternTypes,
        exclude: patternTypes
    },

    created: function created() {
        this.cache = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default()(null);
    },
    destroyed: function destroyed() {
        for (var key in this.cache) {
            pruneCacheEntry(this.cache[key]);
        }
    },
    mounted: function mounted() {
        if (this.historys.length == 0) {
            this.historys.push({
                path: '/',
                name: 'root',
                fullPath: '/'
            });
            var path = this.$route.path;
            if (this.$route.matched.length <= 0) {
                return;
            }

            var name = GetDefaultComponentName(this.$route);
            var __route = this.$route;
            this.historys.push({
                path: path,
                name: name,
                fullPath: __route.fullPath
            });
        }
        window.__cache = this;
    },


    watch: {
        include: function include(val) {},
        exclude: function exclude(val) {},
        '$route': function $route(to, from) {

            var historys = this.historys;
            var last = _.last(historys);
            if (last.fullPath == to.fullPath) return;

            var name = GetDefaultComponentName(to);
            var historyCount = historys.length;


            var keepAlive = historys.map(function (router) {
                return router.fullPath.replace(/[^\w|\d]/gi, '');
            }).join(',');

            if (historys.length != historyCount) {
                pruneCache(this.cache, this._vnode, function (name) {
                    return matches(keepAlive, name);
                });
            }

            var isBack = historys.length >= 2 && to.fullPath == _.first(_.takeRight(historys, 2)).fullPath;
            var isReplace = historys.length == 2 && _.startsWith(from.fullPath, to.fullPath);
            if (isBack || isReplace) {
                historys.pop();
            }

            if (!isBack || isReplace) {
                historys.push({
                    path: to.path,
                    name: name,
                    fullPath: to.fullPath
                });
            }
            keepAlive = historys.map(function (router) {
                return router.fullPath.replace(/[^\w|\d]/gi, '');
            }).join(',');


            if (to.fullPath.indexOf("/list") >= 0 && from.fullPath.indexOf("/list") >= 0 || /role\/\w+$/gi.test(to.fullPath) && /role\/\w+$/gi.test(from.fullPath)) {
                var key = from.fullPath.replace(/[^\w|\d]/gi, '');
            }

            if (to.fullPath == "/" || to.fullPath == "") {
                pruneCache(this.cache, this._vnode, function (name) {
                    return false;
                });
            } else {
                pruneCache(this.cache, this._vnode, function (name) {
                    return matches(keepAlive, name);
                });
            }
        }
    },

    render: function render() {
        var vnode = getFirstComponentChild(this.$slots.default);
        var componentOptions = vnode && vnode.componentOptions;
        if (componentOptions) {
            var name = getComponentName(componentOptions);
            if (name && (this.include && !matches(this.include, name) || this.exclude && matches(this.exclude, name))) {
                return vnode;
            }

            var path = this.$route.fullPath;
            if (path.indexOf("/list") <= 0 && !/role\/\w+$/gi.test(path)) {
                return vnode;
            }

            var key = path.replace(/[^\w|\d]/gi, '');
            if (this.cache[key]) {
                vnode.componentInstance = this.cache[key].componentInstance;
            } else {
                this.cache[key] = vnode;
            }
            vnode.data.keepAlive = true;
        }
        return vnode;
    }
});

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
  path: "/approval/:inviteCode",

  component: function component(resolve) {
    return __webpack_require__.e/* require */(154).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(735)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  name: "dashboard",
  children: [{
    path: "/order/flight/Change",
    name: "OrderFlightCNChange",
    meta: {
      requiresAuth: true
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(29).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(737)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: "/order/flightGJ/Change/:OrderID?",
    name: "OrderFlightGJChange",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(93).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(738)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: "/order/detail",
    name: "OrderDetails",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(20).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(736)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: "/order/:service?/list/:state?",
    name: "OrderList",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(30).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(739)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: "/oldorder/:service?/detail/:applyarea?/:id?/:demand?",
    name: "olddetail",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(217).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(740)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }]
}]);

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
    name: 'dashboard',
    children: [{
        path: '/statistics/statistical',
        name: 'statistical',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(25).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(742)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }]
}]);

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var main = function main(resolve) {
    return __webpack_require__.e/* require */(39).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(781)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var login = function login(resolve) {
    return __webpack_require__.e/* require */(33).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(780)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var invite = function invite(resolve) {
    return __webpack_require__.e/* require */(152).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(779)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var userRegister = function userRegister(resolve) {
    return __webpack_require__.e/* require */(48).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(782)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var reset = function reset(resolve) {
    return __webpack_require__.e/* require */(103).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(783)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var dashboard = function dashboard(resolve) {
    return __webpack_require__.e/* require */(5/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(217)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var UserInfo = function UserInfo(resolve) {
    return __webpack_require__.e/* require */(179).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(576)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var about = function about(resolve) {
    return __webpack_require__.e/* require */(131).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(758)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var contactUs = function contactUs(resolve) {
    return __webpack_require__.e/* require */(99).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(776)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
/* harmony default export */ __webpack_exports__["a"] = ([{
    path: '/System/about',
    component: about
}, {
    path: '/invite/:inviteCode',
    component: invite
}, {
    path: '/login',
    component: login
}, {
    path: '/User/Register',
    component: userRegister
}, {
    path: '/Company/Register',
    component: userRegister
}, {
    path: '/reset',
    component: reset
}, {
    path: '/System/serve/contact',
    component: contactUs
}, {
    path: '/System/serve/guideline',
    components: {
        default: function _default(resolve) {
            return __webpack_require__.e/* require */(178).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(777)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }
}, {
    path: '/crm/user/display',
    components: {
        default: function _default(resolve) {
            return __webpack_require__.e/* require */(180).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(763)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }
}, {
    path: '/dinglogin',
    component: function component(resolve) {
        return __webpack_require__.e/* require */(166).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(769)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: '/dashboard',
    name: 'dashboard',
    component: dashboard,
    meta: {
        requiresAuth: true
    },
    children: [{
        path: '/System/User/:UserID/Security',
        name: 'UserSecurity',
        components: {
            top: UserInfo,
            default: function _default(resolve) {
                return __webpack_require__.e/* require */(100).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(784)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            }
        }
    }, {
        path: '/System/User/Main',
        name: 'UserMain',
        components: {
            top: UserInfo,
            default: main
        }
    }, {
        path: '/System/Company/:CompanyID/ContactInfo',
        components: {

            default: function _default(resolve) {
                return __webpack_require__.e/* require */(3).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(223)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            }
        }
    }, {
        path: '/System/User/:UserID/ContactInfo',
        components: {

            default: function _default(resolve) {
                return __webpack_require__.e/* require */(3/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(223)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            }
        }
    }, {
        path: '/System/User/:UserID/InvoiceInfo',
        components: {
            top: UserInfo,
            default: function _default(resolve) {
                return __webpack_require__.e/* require */(4).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(224)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            }
        }
    }, {
        path: '/System/Company/:CompanyID/InvoiceInfo',
        components: {
            top: UserInfo,
            default: function _default(resolve) {
                return __webpack_require__.e/* require */(4/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(224)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            }
        }
    }, {
        path: '/System/User/:UserID/Role/:RoleCode',
        name: 'UserRoleList',
        components: {
            top: UserInfo,
            default: function _default(resolve) {
                return __webpack_require__.e/* require */(2).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(226)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            }
        }
    }, {
        path: '/System/User/:UserID/Role/:RoleCode/:RoleID',
        name: 'UserRoleDetails',
        components: {
            top: UserInfo,
            default: function _default(resolve) {
                return __webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(225)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            }
        }
    }, {
        path: '/System/Company/:CompanyID/Role/:RoleCode',
        name: 'RoleList',
        components: {

            default: function _default(resolve) {
                return __webpack_require__.e/* require */(2/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(226)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            }
        }
    }, {
        path: '/System/Company/:CompanyID/Role/:RoleCode/:RoleID',
        name: 'RoleDetails',
        components: {

            default: function _default(resolve) {
                return __webpack_require__.e/* require */(1/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(225)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            }
        }
    }, {
        path: '/System/Company/:CompanyID/Main',
        name: 'Main',
        components: {

            default: function _default(resolve) {
                return __webpack_require__.e/* require */(153).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(761)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            }
        }
    }, {
        path: '/System/Company/:CompanyID/CustomerLevel',
        name: 'customerlevel',
        components: {

            default: function _default(resolve) {
                return __webpack_require__.e/* require */(128).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(764)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            }
        }
    }, {
        path: '/System/Company/TradeLevelAdd',
        name: 'TradeLevelAdd',
        components: {

            default: function _default(resolve) {
                return __webpack_require__.e/* require */(105).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(766)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            }
        }
    }, {
        path: '/System/Company/TradeFlightServiceSetting',
        name: 'TradeFlightServiceSetting',
        components: {

            default: function _default(resolve) {
                return __webpack_require__.e/* require */(57).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(765)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            }
        }
    }, {
        path: '/System/Company/TradeTourServiceSetting',
        name: 'TradeTourServiceSetting',
        components: {

            default: function _default(resolve) {
                return __webpack_require__.e/* require */(125).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(767)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            }
        }
    }, {
        path: '/System/Company/:CompanyID/TripRule/:RuleID',
        name: 'TripRuleUpdate',
        components: {

            default: function _default(resolve) {
                return __webpack_require__.e/* require */(26).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(754)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            }
        }
    }, {
        path: '/System/Company/:CompanyID/Flow/:FlowID',
        name: 'FlowUpdate',
        components: {

            default: function _default(resolve) {
                return __webpack_require__.e/* require */(55).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(772)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            }
        }
    }, {
        path: '/System/Company/:CompanyID/Flow',
        name: 'FlowList',
        components: {

            default: function _default(resolve) {
                return __webpack_require__.e/* require */(115).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(771)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            }
        }
    }, {
        path: '/Service/Btrip/:CompanyID/list',
        name: 'BusinessConfiguration',
        components: {

            default: function _default(resolve) {
                return __webpack_require__.e/* require */(24).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(747)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            }
        }
    }, {
        path: '/System/Charge/:CompanyID/ChargeList',
        name: 'ChargeList',
        components: {

            default: function _default(resolve) {
                return __webpack_require__.e/* require */(10).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(748)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            }
        }
    }, {
        path: '/System/Charge/:CompanyID/ChargeUpdate',
        name: 'ChargeUpdate',
        components: {

            default: function _default(resolve) {
                return __webpack_require__.e/* require */(168).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(749)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            }
        }
    }, {
        path: '/System/ContraryReason/:CompanyID/ContraryUpdate',
        name: 'ContraryUpdate',
        components: {

            default: function _default(resolve) {
                return __webpack_require__.e/* require */(6).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(222)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            }
        }
    }, {
        path: '/System/TravePurpose/:CompanyID/TravePurposeUpdate',
        name: 'TravePurposeUpdate',
        components: {

            default: function _default(resolve) {
                return __webpack_require__.e/* require */(6/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(222)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            }
        }
    }, {
        path: '/System/TripFlow/:CompanyID/Detail',
        name: 'TripFlowUpdate',
        components: {

            default: function _default(resolve) {
                return __webpack_require__.e/* require */(167).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(753)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            }
        }
    }, {
        path: '/System/ConfigInfo/:CompanyID/detail',
        name: 'ConfigInfoDetail',
        components: {

            default: function _default(resolve) {
                return __webpack_require__.e/* require */(38).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(751)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            }
        }
    }, {
        path: '/System/message/:CompanyID/list',
        name: 'MessageList',
        components: {

            default: function _default(resolve) {
                return __webpack_require__.e/* require */(107).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(775)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            }
        }
    }, {
        path: '/System/message/:CompanyID/detail',
        name: 'MessageDetail',
        components: {

            default: function _default(resolve) {
                return __webpack_require__.e/* require */(162).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(774)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            }
        }
    }, {
        path: '/System/approvalSet/:CompanyID/list',
        name: 'approvalSetList',
        components: {

            default: function _default(resolve) {
                return __webpack_require__.e/* require */(84).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(760)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            }
        }
    }, {
        path: '/System/approvalSet/detail',
        name: 'approvalSetDetail',
        components: {

            default: function _default(resolve) {
                return __webpack_require__.e/* require */(106).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(759)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            }
        }
    }, {
        path: '/System/Confer/:ConferID/detail',
        name: 'ConferDetail',
        components: {

            default: function _default(resolve) {
                return __webpack_require__.e/* require */(126).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(762)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            }
        }
    }, {
        path: '/System/WeChat/menu',
        name: 'WeChatMenu',
        components: {

            default: function _default(resolve) {
                return __webpack_require__.e/* require */(163).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(755)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            }
        }
    }, {
        path: '/System/ConfigInfo/configManagement',
        name: 'configManagement',
        components: {

            default: function _default(resolve) {
                return __webpack_require__.e/* require */(181).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(750)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            }
        }
    }, {
        path: '/System/ActivityManager/list',
        name: 'ActivityManagerList',
        components: {

            default: function _default(resolve) {
                return __webpack_require__.e/* require */(129).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(745)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            }
        }
    }, {
        path: '/System/ActivityManager/detail',
        name: 'ActivityManagerDetail',
        components: {

            default: function _default(resolve) {
                return __webpack_require__.e/* require */(182).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(744)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            }
        }
    }, {
        path: '/System/ActivityManager/IntegralRecord',
        name: 'IntegralRecord',
        components: {

            default: function _default(resolve) {
                return __webpack_require__.e/* require */(88).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(743)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            }
        }
    }, {
        path: '/System/ActivityManager/use',
        name: 'ActivityManagerUse',
        components: {

            default: function _default(resolve) {
                return __webpack_require__.e/* require */(87).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(746)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            }
        }
    }, {
        path: '/System/Employee/CustomersFree',
        name: 'CustomersFree',
        components: {

            default: function _default(resolve) {
                return __webpack_require__.e/* require */(85).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(752)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            }
        }
    }, {
        path: '/system/scene/list',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(215).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(757)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/system/scene/detail',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(216).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(756)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/system/interfaceManage',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(127).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(773)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/system/bill/exportlist',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(130).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(770)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/system/dingding/detail',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(104).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(768)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/system/supply/list',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(58).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(778)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/system/cityCategory/list',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(52).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(583)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }]
}]);

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    path: '/trade/cashier',
    name: 'cashier',
    component: function component(resolve) {
        return __webpack_require__.e/* require */(124).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(785)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: '/dashboard',
    name: 'dashboard',
    meta: {
        requiresAuth: true
    },
    children: [{
        path: '/System/Company/:CompanyID/trade/list',
        name: 'tradelist',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(49).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(788)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/System/Company/:CompanyID/trade/details',

        component: function component(resolve) {
            return __webpack_require__.e/* require */(34).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(787)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/System/Company/:CompanyID/tradeorder/detail',
        name: 'tradeorderdetail',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(165).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(786)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }]
}]);

/***/ }),
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 549 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 550 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 551 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 552 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 553 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 554 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 555 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 556 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 557 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 558 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 559 */,
/* 560 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(550)
__webpack_require__(549)

var Component = __webpack_require__(20)(
  /* script */
  __webpack_require__(250),
  /* template */
  __webpack_require__(562),
  /* scopeId */
  "data-v-18524494",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 561 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pageView"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 562 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "header_top"
  }, [_c('div', {
    staticClass: "wrapper-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "wrapper-right"
  }, [_c('span', [_c('el-select', {
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.language),
      callback: function($$v) {
        _vm.language = $$v
      },
      expression: "language"
    }
  }, _vm._l((_vm.languages), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [(_vm.ticketInfo.UserName) ? _c('div', {
    staticClass: "nav-menu",
    staticStyle: {
      "padding-top": "20px",
      "height": "60px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "20px",
      "line-height": "20px"
    }
  }, [_c('router-link', {
    staticClass: " menu-li",
    attrs: {
      "to": {
        name: 'UserMain'
      }
    }
  }, [_c('span', {
    staticClass: "index_exit",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_vm._v(_vm._s(_vm.ticketInfo.UserName))])]), _vm._v(" "), _c('span', {
    staticClass: " index_exit",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.exit
    }
  }, [_vm._v("  退出")])], 1), _vm._v(" "), _c('div', [_vm._v("我的订单")])]) : _c('div', {
    staticClass: "nav-menu",
    staticStyle: {
      "height": "40px",
      "line-height": "40px"
    }
  }, [_c('span', {
    staticClass: "index_login",
    staticStyle: {
      "cursor": "pointer",
      "padding": "10px"
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("登录")]), _vm._v(" "), _c('span', [_vm._v("/")]), _vm._v(" "), _c('router-link', {
    staticClass: "index_exit",
    staticStyle: {
      "cursor": "pointer",
      "padding": "10px"
    },
    attrs: {
      "to": "/User/Register"
    }
  }, [_vm._v("注册")])], 1)]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#4f83cc",
      "padding-top": "40px",
      "display": "inline-block",
      "height": "60px"
    }
  }, [_vm._v("App下载")])])]), _vm._v(" "), _c('div', {
    staticClass: "header-botton"
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.changeBookType
    },
    model: {
      value: (_vm.BookType),
      callback: function($$v) {
        _vm.BookType = $$v
      },
      expression: "BookType"
    }
  }, _vm._l((_vm.categorys.BookingType), function(item) {
    return _c('el-radio', {
      key: item.CategoryID,
      staticClass: "BookType",
      class: {
        'radioBg': item.CategoryID == _vm.BookType ? true : false
      },
      attrs: {
        "value": item.CategoryID,
        "label": item.CategoryID
      }
    }, [_vm._v(_vm._s(item.CategoryTitle) + "\n                "), (item.CategoryID == _vm.BookType) ? _c('a', {
      staticClass: "test1"
    }) : _vm._e()])
  }))], 1)])
},staticRenderFns: []}

/***/ }),
/* 563 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', {
    class: 'fa ' + _vm.name,
    attrs: {
      "aria-hidden": "true"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 564 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('l-header'), _vm._v(" "), _c('div', {
    staticClass: "main",
    style: ({
      'background-color': _vm.$route.path != '/mall/booking' ? '#F2F2F2' : _vm.none
    })
  }, [_vm._t("default")], 2), _vm._v(" "), _c('l-footer')], 1)
},staticRenderFns: []}

/***/ }),
/* 565 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 566 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('l-layout', [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 567 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "sideBar"
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px",
      "padding-left": "20px",
      "height": "40px",
      "line-height": "40px",
      "color": "#fff"
    }
  }, [_c('b', [_c('i', {
    staticClass: "fa fa-reorder menuIcon"
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/mall/booking"
    }
  }, [_vm._v(_vm._s(_vm.$t('mall.bookingcenter')))])], 1)]), _vm._v(" "), _c('el-col', [_c('el-menu', {
    staticClass: "el-menu-vertical-demo",
    attrs: {
      "default-active": "2",
      "router": true,
      "default-openeds": _vm.DefaultOpeneds(_vm.roots)
    },
    on: {
      "open": _vm.handleOpen,
      "close": _vm.handleClose
    }
  }, _vm._l((_vm.roots), function(rt, i) {
    return _c('el-submenu', {
      key: rt.ActionID,
      attrs: {
        "index": 'i' + i
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('b', [_c('icon', {
      staticStyle: {
        "color": "#fff"
      },
      attrs: {
        "name": _vm._f("IconName")(rt.IconName)
      }
    }), _vm._v("\n                            " + _vm._s(_vm.$t('webdata.' + rt.ActionNick)) + "\n\n                        ")], 1)]), _vm._v(" "), _vm._l((rt.children), function(ch) {
      return (ch.showbool) ? _c(_vm._f("ComponentName")(ch), {
        key: ch.ActionID,
        tag: "component",
        attrs: {
          "route": {
            path: ch.ActionURL
          },
          "index": ch.ActionID
        }
      }, [(ch.children && !ch.ActionURL) ? _c('div', {
        staticStyle: {
          "color": "#fff"
        },
        slot: "title"
      }, [_c('icon', {
        attrs: {
          "name": _vm._f("IconName")(ch.IconName)
        }
      }), _vm._v(_vm._s(_vm.$t('webdata.' + ch.ActionNick)) + "\n                        ")], 1) : _c('div', {
        staticStyle: {
          "color": "#fff"
        }
      }, [_c('icon', {
        staticStyle: {
          "color": "#fff"
        },
        attrs: {
          "name": _vm._f("IconName")(ch.IconName)
        }
      }), _vm._v("\n                            " + _vm._s(_vm.$t('webdata.' + ch.ActionNick)) + "\n                            "), (ch.ActionNick == 'tradereceive') ? _c('span', {
        class: {
          'badge': _vm.exportList.length > 0
        }
      }, [_vm._v("\n                            " + _vm._s((_vm.exportList.length > 0 ? _vm.exportList.length : null)))]) : _vm._e()], 1), _vm._v(" "), _vm._l((ch.children), function(th) {
        return (ch.children && !ch.ActionURL) ? _c('el-menu-item', {
          key: th.ActionID,
          staticStyle: {
            "color": "#fff"
          },
          attrs: {
            "index": th.ActionID,
            "route": {
              path: th.ActionURL
            }
          }
        }, [_c('icon', {
          attrs: {
            "name": _vm._f("IconName")(th.IconName)
          }
        }), _vm._v(_vm._s(_vm.$t('webdata.' + th.ActionNick)) + "\n                            "), (_vm.filterWorkTaskLists(th.ActionURL) > 0) ? _c('span', {
          class: {
            'badge': _vm.filterWorkTaskLists(th.ActionURL) > 0
          }
        }, [_vm._v(_vm._s(_vm.filterWorkTaskLists(th.ActionURL)))]) : _vm._e(), _vm._v(" "), (th.ActionNick == 'orderchange') ? _c('span', {
          class: {
            'badge': _vm.changes.length > 0
          }
        }, [_vm._v(_vm._s((_vm.changes.length > 0 ? _vm.changes.length : null)))]) : _vm._e(), _vm._v(" "), (th.ActionNick == 'smsnotify') ? _c('span', {
          class: {
            'badge': _vm.sms.length > 0
          }
        }, [_vm._v(_vm._s((_vm.sms.length > 0 ? _vm.sms.length : null)))]) : _vm._e()], 1) : _vm._e()
      })], 2) : _vm._e()
    })], 2)
  }))], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 568 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-nav page-card"
  }, [_c('div', {
    staticClass: "header-left"
  }, [_c('ul', {
    staticClass: "nav-menu"
  }, [_c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowBack),
      expression: "isShowBack"
    }],
    staticClass: "menu-item"
  }, [_c('span', {
    staticClass: "icon back",
    on: {
      "click": _vm.Back
    }
  }, [_vm._v("返回")])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowBack),
      expression: "isShowBack"
    }],
    staticClass: "menu-item",
    staticStyle: {
      "padding": "0",
      "width": "1px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "42px",
      "width": "1px",
      "background-color": "#DDD"
    }
  })]), _vm._v(" "), _vm._l((_vm.menus), function(menu) {
    return _c('li', {
      key: menu,
      staticClass: "menu-item"
    }, [_vm._v(_vm._s(menu.title))])
  }), _vm._v(" "), _c('li', {
    staticClass: "menu-item",
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v(_vm._s(_vm.nowTime))])], 2)])])
},staticRenderFns: []}

/***/ }),
/* 569 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header",
    class: {
      'isIndex': _vm.$route.path == '/', 'isJapanese': _vm.$i18n.locale == 'jp'
    }
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "header-nav"
  }, [_c('div', {
    staticClass: "header-nav-left"
  }, [(_vm.$route.path == '/') ? _c('img', {
    attrs: {
      "src": _vm.getImgs('logo2.png')
    }
  }) : _c('img', {
    attrs: {
      "src": _vm.getImgs('logo.png')
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "header-nav-center"
  }, [_c('div', {
    staticClass: "nav-menu"
  }, _vm._l((_vm.menus), function(menu) {
    return _c('router-link', {
      key: menu.path,
      staticClass: "menu-item menu-li",
      attrs: {
        "to": menu.title == 'mall.home' || menu.title == 'mall.bookingcenter' || menu.title == 'mall.btripplateform' || menu.title == 'mall.tourism' || menu.title == 'mall.contactUs' ? menu.path : ''
      }
    }, [_vm._v(_vm._s(_vm.$t(menu.title)))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "header-nav-right"
  }, [_c('el-dropdown', {
    style: ({
      'color': _vm.$route.path != '/' ? '#fff' : '#323232'
    }),
    on: {
      "command": _vm.changelang
    }
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_vm._v(_vm._s(_vm.$t('system.langsetting')))]), _vm._v(" "), _c('el-dropdown-menu', {
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": "cn"
    }
  }, [_vm._v(_vm._s(_vm.$t('system.china')))]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "en"
    }
  }, [_vm._v(_vm._s(_vm.$t('system.english')))]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "jp"
    }
  }, [_vm._v(_vm._s(_vm.$t('system.japan')))])], 1)], 1), _vm._v(" "), (_vm.ticketInfo.UserName) ? _c('div', {
    staticClass: "ticketInfo"
  }, [_c('router-link', {
    staticClass: "menu-item menu-li",
    attrs: {
      "to": {
        name: 'UserMain'
      }
    }
  }, [_c('span', {
    staticClass: "index_exit"
  }, [_vm._v(_vm._s(_vm.ticketInfo.UserName))])]), _vm._v(" "), _c('div'), _vm._v(" "), _c('div', {
    staticClass: "menu-item index_exit",
    on: {
      "click": _vm.exit
    }
  }, [_vm._v(_vm._s(_vm.$t('system.loginout')))])], 1) : _c('div', {
    staticClass: "ticketInfo"
  }, [_c('div', {
    staticClass: "index_login",
    on: {
      "click": _vm.login
    }
  }, [_vm._v(_vm._s(_vm.$t('system.login')))]), _vm._v(" "), _c('div'), _vm._v(" "), _c('router-link', {
    staticClass: "index_exit",
    attrs: {
      "to": "/Company/Register",
      "tag": "div"
    }
  }, [_vm._v(_vm._s(_vm.$t('system.registernow')))])], 1)], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 570 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "customer-services"
  }, [_c('img', {
    attrs: {
      "id": "btn_udesk_im",
      "src": "/static/images/kefu1.png"
    },
    on: {
      "click": _vm.OpenCustomerServices
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 571 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_vm._v("\n    关于我们|联系我们|联系客服|友情链接\n    "), _c('br'), _vm._v(" 京公网安备 11000002000088号|京ICP证070359号\n    "), _c('br'), _vm._v(" 互联网出版许可证编号新出网证(京)字150号|出版物经营许可证|网络文化经营许可证京网文[2014]2148-348号|违法和不良信息举报电话：4006561155\n    "), _c('br'), _vm._v(" Copyright © 2004 - " + _vm._s(_vm.date) + " " + _vm._s(_vm.siteInfo.SystemName) + " " + _vm._s(_vm.siteInfo.SystemDomain) + " 版权所有|消费者维权热线：4006067733经营证照\n    "), _c('br'), _vm._v(" 经营性网站备案中心可信网站信用评估网络警察提醒你诚信网站中国互联网举报中心网络举报APP下载\n    "), _c('br'), _vm._v(" "), (_vm.config.isProxy) ? _c('div', {
    staticStyle: {
      "position": "fixed",
      "right": "1%",
      "top": "20%",
      "line-height": "30px",
      "z-index": "2"
    }
  }, [_vm._v("\n        线上模式:\n        "), _c('el-switch', {
    attrs: {
      "active-text": "线上模式",
      "inactive-text": "线上模式"
    },
    model: {
      value: (_vm.config.isOnline),
      callback: function($$v) {
        _vm.config.isOnline = $$v
      },
      expression: "config.isOnline"
    }
  }), _vm._v(" "), _c('br'), _vm._v("代理模式:\n        "), _c('el-switch', {
    attrs: {
      "active-text": "代理模式",
      "inactive-text": "代理模式"
    },
    model: {
      value: (_vm.config.isProxy),
      callback: function($$v) {
        _vm.config.isProxy = $$v
      },
      expression: "config.isProxy"
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 572 */,
/* 573 */
/***/ (function(module, exports) {

module.exports = VueRouter;

/***/ })
],[291]);


// WEBPACK FOOTER //
// static/js/app.4d897f1fba7e5538b832.js